// Generated by KlangScriptProcessor, DO NOT EDIT
@file:Suppress("UnusedImport")

package io.peekandpoke.klang.script.generated

import io.peekandpoke.klang.script.annotations.KlangScope
import io.peekandpoke.klang.script.types.*

private val kt0 = KlangType(simpleName = "SprudelPattern", fqcn = "io.peekandpoke.klang.sprudel.SprudelPattern")
private val kt1 = KlangType(simpleName = "KlangPattern", fqcn = "io.peekandpoke.klang.audio_bridge.KlangPattern")
private val kt2 = KlangType(simpleName = "SprudelPattern", fqcn = "io.peekandpoke.klang.sprudel.SprudelPattern", supertypes = listOf(kt1))
private val kt3 = KlangType(simpleName = "String", fqcn = "io.peekandpoke.klang.script.runtime.StringValue")
private val kt4 = KlangType(simpleName = "Function1", fqcn = "kotlin.Function1")
private val kt5 = KlangType(simpleName = "PatternMapperFn", fqcn = "io.peekandpoke.klang.sprudel.lang.PatternMapperFn", isTypeAlias = true, functionParams = listOf(kt2), functionReturn = kt2)
private val kt6 = KlangType(simpleName = "PatternLike", fqcn = "io.peekandpoke.klang.sprudel.lang.PatternLike", isTypeAlias = true, isNullable = true)
private val kt7 = KlangType(simpleName = "PatternLike", fqcn = "io.peekandpoke.klang.sprudel.lang.PatternLike", isTypeAlias = true)
private val kt8 = KlangType(simpleName = "PatternMapperProvider", fqcn = "io.peekandpoke.klang.sprudel.lang.PatternMapperProvider")
private val kt9 = KlangType(simpleName = "Number", fqcn = "kotlin.Number")
private val kt10 = KlangType(simpleName = "Number", fqcn = "io.peekandpoke.klang.script.runtime.NumberValue")
private val kt11 = KlangType(simpleName = "Boolean", fqcn = "io.peekandpoke.klang.script.runtime.BooleanValue")
private val kt12 = KlangType(simpleName = "Function1", fqcn = "kotlin.Function1", functionParams = listOf(kt10), functionReturn = kt11)
private val kt13 = KlangType(simpleName = "IgnitorSlotLike", fqcn = "io.peekandpoke.klang.script.stdlib.IgnitorSlotLike", isTypeAlias = true, isNullable = true)
private val kt14 = KlangType(simpleName = "KatalystDsl", fqcn = "io.peekandpoke.klang.audio_bridge.KatalystDsl")
private val kt15 = KlangType(simpleName = "KatalystSlotLike", fqcn = "io.peekandpoke.klang.script.stdlib.KatalystSlotLike", isTypeAlias = true, isNullable = true)
private val kt16 = KlangType(simpleName = "Function2", fqcn = "kotlin.Function2", functionParams = listOf(kt2, kt10), functionReturn = kt2)
private val kt17 = KlangType(simpleName = "Function1", fqcn = "kotlin.Function1", functionParams = listOf(kt10), functionReturn = kt10)
private val kt18 = KlangType(simpleName = "Object", fqcn = "io.peekandpoke.klang.script.runtime.ObjectValue")
private val kt19 = KlangType(simpleName = "SprudelSignal", fqcn = "io.peekandpoke.klang.sprudel.lang.SprudelSignal")
private val kt20 = KlangType(simpleName = "sine", fqcn = "io.peekandpoke.klang.sprudel.lang.sine", supertypes = listOf(kt19, kt0, kt1))
private val kt21 = KlangType(simpleName = "Number", fqcn = "kotlin.Number", isNullable = true)
private val kt22 = KlangType(simpleName = "cosine", fqcn = "io.peekandpoke.klang.sprudel.lang.cosine", supertypes = listOf(kt19, kt0, kt1))
private val kt23 = KlangType(simpleName = "saw", fqcn = "io.peekandpoke.klang.sprudel.lang.saw", supertypes = listOf(kt19, kt0, kt1))
private val kt24 = KlangType(simpleName = "tri", fqcn = "io.peekandpoke.klang.sprudel.lang.tri", supertypes = listOf(kt19, kt0, kt1))
private val kt25 = KlangType(simpleName = "square", fqcn = "io.peekandpoke.klang.sprudel.lang.square", supertypes = listOf(kt19, kt0, kt1))
private val kt26 = KlangType(simpleName = "perlin", fqcn = "io.peekandpoke.klang.sprudel.lang.perlin", supertypes = listOf(kt19, kt0, kt1))
private val kt27 = KlangType(simpleName = "berlin", fqcn = "io.peekandpoke.klang.sprudel.lang.berlin", supertypes = listOf(kt19, kt0, kt1))
private val kt28 = KlangType(simpleName = "adsr", fqcn = "io.peekandpoke.klang.sprudel.lang.adsr")
private val kt29 = KlangType(simpleName = "adsrCurves", fqcn = "io.peekandpoke.klang.sprudel.lang.adsrCurves")
private val kt30 = KlangType(simpleName = "compressor", fqcn = "io.peekandpoke.klang.sprudel.lang.compressor")
private val kt31 = KlangType(simpleName = "FieldAccessor", fqcn = "io.peekandpoke.klang.sprudel.lang.FieldAccessor")
private val kt32 = KlangType(simpleName = "cull", fqcn = "io.peekandpoke.klang.sprudel.lang.cull", supertypes = listOf(kt31, kt8))
private val kt33 = KlangType(simpleName = "gain", fqcn = "io.peekandpoke.klang.sprudel.lang.gain", supertypes = listOf(kt31, kt8))
private val kt34 = KlangType(simpleName = "pregain", fqcn = "io.peekandpoke.klang.sprudel.lang.pregain", supertypes = listOf(kt31, kt8))
private val kt35 = KlangType(simpleName = "pan", fqcn = "io.peekandpoke.klang.sprudel.lang.pan", supertypes = listOf(kt31, kt8))
private val kt36 = KlangType(simpleName = "velocity", fqcn = "io.peekandpoke.klang.sprudel.lang.velocity", supertypes = listOf(kt31, kt8))
private val kt37 = KlangType(simpleName = "orbit", fqcn = "io.peekandpoke.klang.sprudel.lang.orbit", supertypes = listOf(kt31, kt8))
private val kt38 = KlangType(simpleName = "duck", fqcn = "io.peekandpoke.klang.sprudel.lang.duck")
private val kt39 = KlangType(simpleName = "unison", fqcn = "io.peekandpoke.klang.sprudel.lang.unison")
private val kt40 = KlangType(simpleName = "density", fqcn = "io.peekandpoke.klang.sprudel.lang.density", supertypes = listOf(kt31, kt8))
private val kt41 = KlangType(simpleName = "body", fqcn = "io.peekandpoke.klang.sprudel.lang.body")
private val kt42 = KlangType(simpleName = "delay", fqcn = "io.peekandpoke.klang.sprudel.lang.delay")
private val kt43 = KlangType(simpleName = "distort", fqcn = "io.peekandpoke.klang.sprudel.lang.distort")
private val kt44 = KlangType(simpleName = "crush", fqcn = "io.peekandpoke.klang.sprudel.lang.crush")
private val kt45 = KlangType(simpleName = "coarse", fqcn = "io.peekandpoke.klang.sprudel.lang.coarse")
private val kt46 = KlangType(simpleName = "phaser", fqcn = "io.peekandpoke.klang.sprudel.lang.phaser")
private val kt47 = KlangType(simpleName = "tremolo", fqcn = "io.peekandpoke.klang.sprudel.lang.tremolo")
private val kt48 = KlangType(simpleName = "reverb", fqcn = "io.peekandpoke.klang.sprudel.lang.reverb")
private val kt49 = KlangType(simpleName = "vowel", fqcn = "io.peekandpoke.klang.sprudel.lang.vowel")
private val kt50 = KlangType(simpleName = "bpf", fqcn = "io.peekandpoke.klang.sprudel.lang.bpf")
private val kt51 = KlangType(simpleName = "bpfCurves", fqcn = "io.peekandpoke.klang.sprudel.lang.bpfCurves")
private val kt52 = KlangType(simpleName = "hpf", fqcn = "io.peekandpoke.klang.sprudel.lang.hpf")
private val kt53 = KlangType(simpleName = "hpfCurves", fqcn = "io.peekandpoke.klang.sprudel.lang.hpfCurves")
private val kt54 = KlangType(simpleName = "lpf", fqcn = "io.peekandpoke.klang.sprudel.lang.lpf")
private val kt55 = KlangType(simpleName = "lpfCurves", fqcn = "io.peekandpoke.klang.sprudel.lang.lpfCurves")
private val kt56 = KlangType(simpleName = "notch", fqcn = "io.peekandpoke.klang.sprudel.lang.notch")
private val kt57 = KlangType(simpleName = "notchCurves", fqcn = "io.peekandpoke.klang.sprudel.lang.notchCurves")
private val kt58 = KlangType(simpleName = "rand", fqcn = "io.peekandpoke.klang.sprudel.lang.rand", supertypes = listOf(kt19, kt0, kt1))
private val kt59 = KlangType(simpleName = "begin", fqcn = "io.peekandpoke.klang.sprudel.lang.begin", supertypes = listOf(kt31, kt8))
private val kt60 = KlangType(simpleName = "end", fqcn = "io.peekandpoke.klang.sprudel.lang.end", supertypes = listOf(kt31, kt8))
private val kt61 = KlangType(simpleName = "speed", fqcn = "io.peekandpoke.klang.sprudel.lang.speed", supertypes = listOf(kt31, kt8))
private val kt62 = KlangType(simpleName = "cut", fqcn = "io.peekandpoke.klang.sprudel.lang.cut", supertypes = listOf(kt31, kt8))
private val kt63 = KlangType(simpleName = "fm", fqcn = "io.peekandpoke.klang.sprudel.lang.fm")
private val kt64 = KlangType(simpleName = "analog", fqcn = "io.peekandpoke.klang.sprudel.lang.analog", supertypes = listOf(kt31, kt8))
private val kt65 = KlangType(simpleName = "duty", fqcn = "io.peekandpoke.klang.sprudel.lang.duty", supertypes = listOf(kt31, kt8))
private val kt66 = KlangType(simpleName = "onepole", fqcn = "io.peekandpoke.klang.sprudel.lang.onepole", supertypes = listOf(kt31, kt8))
private val kt67 = KlangType(simpleName = "legato", fqcn = "io.peekandpoke.klang.sprudel.lang.legato", supertypes = listOf(kt31, kt8))
private val kt68 = KlangType(simpleName = "freq", fqcn = "io.peekandpoke.klang.sprudel.lang.freq", supertypes = listOf(kt31, kt8))
private val kt69 = KlangType(simpleName = "vibrato", fqcn = "io.peekandpoke.klang.sprudel.lang.vibrato")
private val kt70 = KlangType(simpleName = "penv", fqcn = "io.peekandpoke.klang.sprudel.lang.penv")
private val kt71 = KlangType(simpleName = "penvCurves", fqcn = "io.peekandpoke.klang.sprudel.lang.penvCurves")
private val kt72 = KlangType(simpleName = "accelerate", fqcn = "io.peekandpoke.klang.sprudel.lang.accelerate", supertypes = listOf(kt31, kt8))
private val kt73 = KlangType(simpleName = "FieldAccessor", fqcn = "io.peekandpoke.klang.sprudel.lang.FieldAccessor", supertypes = listOf(kt8))

private fun generatedSprudelDocsChunk0() = mapOf(

    "abs" to KlangSymbol(
        name = "abs",
        category = "arithmetic",
        tags = listOf("abs", "absolute", "value", "arithmetic"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "abs",
                receiver = kt0,
                params = emptyList(),
                returnType = kt2,
                description = """Returns the absolute value of each event's numeric data.

 Negative values become positive; positive values and zero are unchanged.
 Useful for ensuring non-negative modulation signals or working with bipolar sources.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """seq("-3 -1 0 2").abs()   // becomes: 3 1 0 2""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """sine.range(-1, 1).abs()  // fold negative half of sine to positive""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "abs",
                receiver = kt3,
                params = emptyList(),
                returnType = kt2,
                description = """Returns the absolute value of each event's numeric data in a string pattern.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """"-3 -1 0 2".abs()   // becomes: 3 1 0 2""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "abs",
                receiver = kt4,
                params = emptyList(),
                returnType = kt5,
                description = """Chains an absolute-value operation onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """seq("1 -2").apply(add(-4).abs())  // abs(1-4)=abs(-3)=3, abs(-2-4)=abs(-6)=6""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "accelerate" to KlangSymbol(
        name = "accelerate",
        category = "tonal",
        tags = listOf("accelerate", "pitch ramp", "pitch bend", "playback speed"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "accelerate",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "semitones", type = kt6, isOptional = true, defaultDoc = """null""", description = """Pitch bend in semitones. Typically -24 to 24."""),
                ),
                returnType = kt2,
                description = """Sets the playback acceleration (pitch ramp) for each event, in SEMITONES over the event's
 duration: `accelerate(12)` glides one octave up, `accelerate(-12)` one octave down. The glide
 runs from the onset to the end of the note (the gate) and holds its target through the release.

 A continuous pitch change during sample playback, good for pitched percussion and sweeps. With
 no argument it reinterprets the current event value as the semitone amount. (The unit changed
 from octaves to semitones in the pitch-param unification, 2026-08-24, so old scripts' values are
 12× subtler now.)

 The door fills the accelerate stage of `classic()` (the flat `accelerate` slot), the Ignitor `accelerate` node; an
 instrument without `classic()` ignores it, like the other `classic()` doors.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """s("cr").accelerate(24)             // crash pitches two octaves up during playback""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("hh").accelerate("<0 -24 24>")   // alternate: no ramp, down, up per cycle""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "accelerate",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "semitones", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt2,
                description = """Sets the playback acceleration on a string pattern.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "accelerate",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "semitones", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt5,
                description = """Chains an accelerate operation onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "add" to KlangSymbol(
        name = "add",
        category = "arithmetic",
        tags = listOf("add", "arithmetic", "math", "offset"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "add",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "amount", type = kt7, description = """The value to add. May be a number, string mini-notation, or a [SprudelPattern]."""),
                ),
                returnType = kt2,
                description = """Adds [amount] to every numeric value in the pattern.

 Only the raw event `value` is affected — `note`, `soundIndex`, and all other voice properties
 remain unchanged. Supports control patterns: pass a mini-notation string or another
 [SprudelPattern] as [amount] to modulate the offset per cycle or event.""",
                returnDoc = """A new pattern with each numeric value increased by [amount].""",
                samples = listOf(
                    KlangCodeSample(code = """seq("0 2").add(5).scale("c3:major").n()  // n values become 5 and 7""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """seq("0 2").add("<0 12>").scale("c3:major").n()  // add 0 or 12 alternately each cycle""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "add",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "amount", type = kt7, description = """The value to add. May be a number, string mini-notation, or a [SprudelPattern]."""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern, then adds [amount] to every numeric value.

 Only the raw event `value` is affected — `note`, `soundIndex`, and other voice properties
 remain unchanged.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """"0 2".add(5).scale("c3:major").n()  // n values become 5 and 7""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "add",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "amount", type = kt7, description = """The value to subtract. May be a number, string mini-notation, or a [SprudelPattern]."""),
                ),
                returnType = kt5,
                description = """Chains a PatternMapperFn to this pattern, adding [amount] to every numeric value in the result.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """seq("10 20").apply(mul(2).add(3)).scale("c1:major").n()  // (10*2)+3=23, (20*2)+3=43""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "add",
                receiver = kt8,
                params = listOf(
                    KlangParam(name = "amount", type = kt7, description = """The operand. May be a number, string mini-notation, or a [SprudelPattern]."""),
                ),
                returnType = kt5,
                description = """First step of a mapper chain on a field accessor: `freq.add(...)` reads the field, then adds [amount].""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c e g a").bpf(freq.add(50))""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "add",
                params = listOf(
                    KlangParam(name = "amount", type = kt7, description = """The value to add. May be a number, string mini-notation, or a [SprudelPattern]."""),
                ),
                returnType = kt5,
                description = """Creates a [PatternMapperFn] that adds [amount] to every numeric value in a pattern.

 Only the raw event `value` is affected — `note`, `soundIndex`, and other voice properties
 remain unchanged. Use with [SprudelPattern.apply] to apply the addition to an existing pattern.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """seq("0 2").apply(add(5)).scale("c3:major").n()  // n values become 5 and 7""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "adsr" to KlangSymbol(
        name = "adsr",
        category = "dynamics",
        tags = listOf("adsr", "attack", "decay", "sustain", "release", "envelope"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "adsr",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null""", description = """Attack in seconds, silence to full volume.""", uitools = listOf("SprudelAdsrEditor", "SprudelAdsrSequenceEditor")),
                    KlangParam(name = "decay", type = kt6, isOptional = true, defaultDoc = """null""", description = """Decay in seconds, peak down to the sustain level."""),
                    KlangParam(name = "sustain", type = kt6, isOptional = true, defaultDoc = """null""", description = """Sustain level, 0 to 1, held while the note is on."""),
                    KlangParam(name = "release", type = kt6, isOptional = true, defaultDoc = """null""", description = """Release in seconds, the fade after note-off."""),
                ),
                returnType = kt2,
                description = """The amplitude envelope: attack, decay, sustain and release.

 The envelope shapes the loudness of one note per voice. Attack, decay
 and release are times in seconds, sustain is a level from 0 to 1.



 Every slot is independent and patternable: an omitted slot keeps its value, a mapper on a slot
 applies to that slot alone, and the slots read back as `adsr.attack`, `adsr.decay`,
 `adsr.sustain`, `adsr.release`.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3 e3 g3").s("sine").adsr(0.01, 0.2, 0.7, 0.5)          // standard ADSR""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c3*4").adsr("<0.01 0.5>", "<0.1 0.5>", "<0.5 0.8>", "<0.2 1.0>")  // alternate envelopes""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c3 e3").s("saw").adsr(0.01, 0.2, 0.7, 0.5).adsr(attack = mul("1 10"))   // the second note swells""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c3 e3").s("saw").adsr("0.05 0.3", 0.2, 0.7).adsr(release = adsr.attack)   // symmetric envelope""", type = KlangCodeSampleType.PLAYABLE)
                ),
                uitools = listOf("SprudelAdsrEditor"),
                library = "sprudel"
            ),
            KlangCallable(
                name = "adsr",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null""", description = """Attack time in seconds.""", uitools = listOf("SprudelAdsrEditor", "SprudelAdsrSequenceEditor")),
                    KlangParam(name = "decay", type = kt6, isOptional = true, defaultDoc = """null""", description = """Decay time in seconds."""),
                    KlangParam(name = "sustain", type = kt6, isOptional = true, defaultDoc = """null""", description = """Sustain level, 0 to 1."""),
                    KlangParam(name = "release", type = kt6, isOptional = true, defaultDoc = """null""", description = """Release time in seconds."""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern and sets the ADSR envelope parameters.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """"c3*4".adsr(0.01, 0.1, 0.5, 0.2).note()""", type = KlangCodeSampleType.PLAYABLE)
                ),
                uitools = listOf("SprudelAdsrEditor"),
                library = "sprudel"
            ),
            KlangCallable(
                name = "adsr",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null""", description = """Attack time in seconds.""", uitools = listOf("SprudelAdsrEditor", "SprudelAdsrSequenceEditor")),
                    KlangParam(name = "decay", type = kt6, isOptional = true, defaultDoc = """null""", description = """Decay time in seconds."""),
                    KlangParam(name = "sustain", type = kt6, isOptional = true, defaultDoc = """null""", description = """Sustain level, 0 to 1."""),
                    KlangParam(name = "release", type = kt6, isOptional = true, defaultDoc = """null""", description = """Release time in seconds."""),
                ),
                returnType = kt5,
                description = """Creates a chained [PatternMapperFn] that sets all ADSR parameters after the previous mapper.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3*4").s("sine").apply(gain(0.8).adsr(0.01, 0.2, 0.7, 0.5))  // gain + adsr chained""", type = KlangCodeSampleType.PLAYABLE)
                ),
                uitools = listOf("SprudelAdsrEditor"),
                library = "sprudel"
            )
        )
    ),

    "adsrCurves" to KlangSymbol(
        name = "adsrCurves",
        category = "dynamics",
        tags = listOf("adsr", "curve", "envelope", "shape"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "adsrCurves",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the attack stage."""),
                    KlangParam(name = "decay", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the decay stage."""),
                    KlangParam(name = "release", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the release stage."""),
                ),
                returnType = kt2,
                description = """Sets the shape of each ADSR stage. Each stage is independent; an omitted stage keeps its
 current curve, so `adsrCurves(release = "scurve")` changes only the release.

 Available curves (aliases in parentheses):
  - `linear` (`lin`): straight ramp.
  - `square` (`sq`, `quad`, `quadratic`): convex, a slow-in rise, a fast initial drop, long tail.
  - `cube` (`cb`, `cubic`): a more pronounced `square`.
  - `scurve` (`s`, `smooth`, `sigmoid`): ease-in-out with **zero slope at both ends**, no onset
    snap and no release "plop" (smoothest).
  - `invsquare` (`inv`, `isquare`, `concave`): concave mirror of `square`, a strong start, easing
    gently into the endpoint.
  - `exponential` (`exp`, `expo`): a true exponential (convex, long tail).

 Default when unset: `exp` on EVERY stage, the engine-wide default on every door
 (maintainer decision, 2026-08-24).""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3 e3 g3").s("supersaw").adsr(0.01, 0.2, 0.7, 0.5).adsrCurves("square", "exponential", "scurve")""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "adsrCurves",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the attack stage."""),
                    KlangParam(name = "decay", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the decay stage."""),
                    KlangParam(name = "release", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the release stage."""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern and sets per-stage ADSR shape curves.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "adsrCurves",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the attack stage. Omit to keep the current curve."""),
                    KlangParam(name = "decay", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the decay stage. Omit to keep the current curve."""),
                    KlangParam(name = "release", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the release stage. Omit to keep the current curve."""),
                ),
                returnType = kt5,
                description = """Creates a chained [PatternMapperFn] that sets per-stage ADSR shape curves after the previous mapper.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "adsrOff" to KlangSymbol(
        name = "adsrOff",
        category = "dynamics",
        tags = listOf("adsr", "envelope", "vca", "gate"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "adsrOff",
                receiver = kt0,
                params = emptyList(),
                returnType = kt2,
                description = """Switches the voice's own amplitude envelope (the VCA) OFF, so the instrument shapes its own
 amplitude. The counterpart of [adsrOn]; see there for the full story.

 With the voice envelope off, the voice's `release` window becomes a full-level HOLD rather than
 a decay, so the instrument really does have to shape its own tail. The voice ends on the instrument's
 own envelope when its `.adsr(...)` (with a fixed release) is the last thing built before `.classic()`;
 anything built after it, a stage of the instrument's own or a filter or other stage the pattern writes,
 hands the note-off to a short teardown fade. Either way the note ends cleanly (the one home of the
 rule: `BuiltIgnitor.endsInEnvelope`).""",
                returnDoc = """A pattern with the VCA switched off.""",
                samples = listOf(
                    KlangCodeSample(code = """let pluck = Ignitor.saw().lowpass(2500).adsr(0.005, 0.35, 0.0, 0.08).classic()
note("c3 e3 g3 c4").sound(pluck).adsrOff().gain(0.4)""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "adsrOff",
                receiver = kt3,
                params = emptyList(),
                returnType = kt2,
                description = """Parses this string as a pattern and switches the voice's amplitude envelope off (see [adsrOff]).""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "adsrOff",
                receiver = kt4,
                params = emptyList(),
                returnType = kt5,
                description = """Chains onto an existing mapper, switching the voice's amplitude envelope off (see [adsrOff]).""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "adsrOff",
                params = emptyList(),
                returnType = kt5,
                description = """Creates a [PatternMapperFn] that switches the voice's amplitude envelope off (see [adsrOff]).""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "adsrOn" to KlangSymbol(
        name = "adsrOn",
        category = "dynamics",
        tags = listOf("adsr", "envelope", "vca", "gate"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "adsrOn",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "flag", type = kt7, isOptional = true, defaultDoc = """true""", description = """Truthy keeps the voice envelope. Default `true`."""),
                ),
                returnType = kt2,
                description = """Switches the voice's own amplitude envelope (the VCA) ON or OFF.

 Use [adsrOff] when the instrument already carries its own envelope: an ignitor built with
 `.adsr(...)` and ending in `.classic()` shapes amplitude itself, and without this `classic()`'s envelope
 applies on top, so the two multiply and every curve comes out twice as steep in dB. The switch is
 `classic()`'s slot `adsr.on`: an instrument that does not end in `.classic()` has no voice envelope to switch.

 Switching it off does NOT throw the numbers away: `.adsr(0.005, 1.0, 1.0, 0.05).adsrOff()` keeps
 them, so you can flip back with [adsrOn] and compare. Note lifetime is unaffected either way, the
 engine covers an ignitor's release tail. The exception is an ignitor whose release time is itself
 modulated, which has no single static value: there the voice's own `release` still governs and is
 worth setting even with the envelope off.

 When unset, the voice envelope is on.


 The built-in sounds carry no envelope of their own, so they WANT the voice envelope. `adsrOff`
 is for instruments you build with their own `.adsr(...)`.""",
                returnDoc = """A pattern with the VCA switched on.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3 e3 g3").s("supersaw").adsrOn()   // shape the note here, whatever the engine defaults to""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "adsrOn",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "flag", type = kt7, isOptional = true, defaultDoc = """true"""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern and switches the voice's amplitude envelope on (see [adsrOn]).""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "adsrOn",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "flag", type = kt7, isOptional = true, defaultDoc = """true"""),
                ),
                returnType = kt5,
                description = """Chains onto an existing mapper, switching the voice's amplitude envelope on (see [adsrOn]).""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "adsrOn",
                params = listOf(
                    KlangParam(name = "flag", type = kt7, isOptional = true, defaultDoc = """true"""),
                ),
                returnType = kt5,
                description = """Creates a [PatternMapperFn] that switches the voice's amplitude envelope on (see [adsrOn]).""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "almostAlways" to KlangSymbol(
        name = "almostAlways",
        category = "random",
        tags = listOf("almostAlways", "random", "probability", "conditional", "frequent"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "almostAlways",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "mapper", type = kt5, description = """The transformation to apply 90% of the time."""),
                ),
                returnType = kt2,
                description = """Applies `transform` with 90% probability per event. Shorthand for `sometimesBy(0.9, fn)`.""",
                returnDoc = """A pattern with `mapper` applied to ~90% of events.""",
                samples = listOf(
                    KlangCodeSample(code = """s("hh*8").almostAlways(x => x.gain(0.2)).seed(3)   // 90% of hi-hats at 20% gain""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "almostAlways",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "mapper", type = kt5),
                ),
                returnType = kt2,
                description = """Applies `transform` with 90% probability per event. Shorthand for `sometimesBy(0.9, fn)`.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "almostAlways",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "mapper", type = kt5),
                ),
                returnType = kt5,
                description = """Chains an almostAlways (90% per event) onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "almostAlways",
                params = listOf(
                    KlangParam(name = "mapper", type = kt5),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that applies `mapper` with 90% probability per event.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    )
)

private fun generatedSprudelDocsChunk1() = mapOf(

    "almostNever" to KlangSymbol(
        name = "almostNever",
        category = "random",
        tags = listOf("almostNever", "random", "probability", "conditional", "rare"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "almostNever",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "mapper", type = kt5, description = """The transformation to apply 10% of the time."""),
                ),
                returnType = kt2,
                description = """Applies `transform` with 10% probability per event. Shorthand for `sometimesBy(0.1, fn)`.""",
                returnDoc = """A pattern with `mapper` applied to ~10% of events.""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd hh sd oh").almostNever(x => x.speed(0.5))   // very rarely at half sample speed""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "almostNever",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "mapper", type = kt5),
                ),
                returnType = kt2,
                description = """Applies `transform` with 10% probability per event. Shorthand for `sometimesBy(0.1, fn)`.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "almostNever",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "mapper", type = kt5),
                ),
                returnType = kt5,
                description = """Chains an almostNever (10% per event) onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "almostNever",
                params = listOf(
                    KlangParam(name = "mapper", type = kt5),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that applies `mapper` with 10% probability per event.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "always" to KlangSymbol(
        name = "always",
        category = "random",
        tags = listOf("always", "unconditional", "transform", "conditional"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "always",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "mapper", type = kt5, description = """The transformation to always apply."""),
                ),
                returnType = kt2,
                description = """Always applies `transform` — shorthand for `sometimesBy(1, fn)`. Equivalent to calling
 `fn` directly, but useful for consistency when toggling between probability variants.""",
                returnDoc = """A pattern with `mapper` unconditionally applied.""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd hh hh sd hh hh").always(x => x.rev())    // rev is always applied""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "always",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "mapper", type = kt5),
                ),
                returnType = kt2,
                description = """Always applies `transform`. Shorthand for `sometimesBy(1, fn)`.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "always",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "mapper", type = kt5),
                ),
                returnType = kt5,
                description = """Chains an always (unconditional apply) onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "always",
                params = listOf(
                    KlangParam(name = "mapper", type = kt5),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that always applies `mapper` unconditionally.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "analog" to KlangSymbol(
        name = "analog",
        category = "tonal",
        tags = listOf("analog", "drift", "oscillator", "warmth", "vco"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "analog",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "character", type = kt6, isOptional = true, defaultDoc = """null""", description = """How analog, a character scale: 0 is ideal, 1 to 8 usual, 10 strong (an oscillator drifts about a cent per unit)."""),
                ),
                returnType = kt2,
                description = """Adds analog oscillator drift to the sound.

 Simulates the micro-pitch instabilities of real analog VCOs by adding tiny random
 perturbations to the oscillator's phase increment. For unison/super oscillators,
 each voice drifts independently, creating lush analog-like chorusing.

 The character is **how analog**, one unitless scale, not a unit: `0` is ideal (off, and costs
 nothing), `1` to `8` is usual (the built-in songs live in that band), `10` is strong. Each part of the
 instrument maps it through its own multipliers and has its own tells per unit: an oscillator drifts about
 a cent of peak pitch per unit (`analog(8)` up to about eight either side of the note); in the built-in
 instruments the lowpass and highpass saturate their resonance, and every filter takes a per-voice cutoff
 tolerance and wanders its cutoff.

 Two layers make it up: a fast jitter (~50 ms) and a slow wander (~10 s). The slow
 layer starts CENTRED, so notes attack in tune and the wander only develops on notes
 held long enough to hear it: short plucks stay put, pads breathe.""",
                returnDoc = """A new pattern with analog drift applied.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3 e3 g3").s("supersaw").analog(4)   // lush analog supersaw""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c3*4").s("sine").analog("<0 2 6>")   // cycle through drift amounts""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "analog",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "character", type = kt6, isOptional = true, defaultDoc = """null""", description = """How analog, a character scale: 0 is ideal, 1 to 8 usual, 10 strong (an oscillator drifts about a cent per unit)."""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern and sets how analog the sound is.""",
                returnDoc = """A new pattern with analog drift applied.""",
                samples = listOf(
                    KlangCodeSample(code = """"c3 e3".analog(4).s("supersaw").note()""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "analog",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "character", type = kt6, isOptional = true, defaultDoc = """null""", description = """How analog, a character scale: `0` is ideal, `1` to `8` usual, `10` strong."""),
                ),
                returnType = kt5,
                description = """Chains an analog-drift-set onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3 e3").apply(gain(0.8).analog(4))""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "and" to KlangSymbol(
        name = "and",
        category = "arithmetic",
        tags = listOf("and", "logical", "boolean", "arithmetic"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "and",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "other", type = kt7, description = """The right-hand operand. May be a number, string mini-notation, or a [SprudelPattern]."""),
                ),
                returnType = kt2,
                description = """Applies logical AND between every value in the pattern and [other].""",
                returnDoc = """A new pattern where each value is `value && other`.""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "and",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "other", type = kt7),
                ),
                returnType = kt2,
                description = """""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "and",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "other", type = kt7),
                ),
                returnType = kt5,
                description = """""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "and",
                params = listOf(
                    KlangParam(name = "other", type = kt7),
                ),
                returnType = kt5,
                description = """""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "apply" to KlangSymbol(
        name = "apply",
        category = "structural",
        tags = listOf("layer", "stack", "transform", "apply"),
        aliases = listOf("layer"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "apply",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "transforms", type = kt5, isVararg = true, description = """One or more functions to apply; results are stacked."""),
                ),
                returnType = kt2,
                description = """Alias for [layer] — applies multiple transformation functions and stacks the results.""",
                returnDoc = """All transformed copies stacked as a single pattern.""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd hh sd oh").apply(x => x.fast(2), x => x.rev())   // two layers stacked""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c e").apply(x => x.transpose(7))                  // fifth layer stacked""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "apply",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "transforms", type = kt5, isVararg = true),
                ),
                returnType = kt2,
                description = """Alias for [layer] on a string pattern.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "apply",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "transforms", type = kt5, isVararg = true),
                ),
                returnType = kt5,
                description = """Chains an apply (alias for [layer]) onto this [PatternMapperFn]; stacks the transformed copies.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "apply",
                params = listOf(
                    KlangParam(name = "transforms", type = kt5, isVararg = true, description = """One or more functions; results are stacked."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] — alias for [layer] — that applies transforms and stacks results.""",
                returnDoc = """A [PatternMapperFn] that stacks the transformed copies.""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd").apply(layer(x => x.fast(2), x => x.rev()))   // apply the layer mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "applyN" to KlangSymbol(
        name = "applyN",
        category = "structural",
        tags = listOf("applyN", "apply", "repeat", "transform", "function", "iterate"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "applyN",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "n", type = kt7, description = """Number of times to apply `transform`."""),
                    KlangParam(name = "transform", type = kt5, description = """Function applied repeatedly to the pattern."""),
                ),
                returnType = kt2,
                description = """Applies a mapper function to this pattern `n` times.

 Supports control patterns for `n`, so the repetition count can vary each cycle.""",
                returnDoc = """A pattern with `transform` applied `n` times.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c d e f").applyN(2, x => x.fast(2))      // fast(2) applied twice""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("bd sd").applyN(3, x => x.echo(2, 0.25, 0.5)) // echo applied 3 times""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "applyN",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "n", type = kt7),
                    KlangParam(name = "transform", type = kt5),
                ),
                returnType = kt2,
                description = """Applies `transform` to this string pattern `n` times.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "applyN",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "n", type = kt7),
                    KlangParam(name = "transform", type = kt5),
                ),
                returnType = kt5,
                description = """Chains an applyN onto this [PatternMapperFn]; applies `transform` `n` times.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "applyN",
                params = listOf(
                    KlangParam(name = "n", type = kt7, description = """Number of times to apply `transform`."""),
                    KlangParam(name = "transform", type = kt5, description = """Function applied repeatedly."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that applies `transform` to the source `n` times.""",
                returnDoc = """A [PatternMapperFn] that applies `transform` `n` times.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c d e f").apply(applyN(2, x => x.fast(2)))  // via mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "arrange" to KlangSymbol(
        name = "arrange",
        category = "structural",
        tags = listOf("arrange", "sequence", "timing", "duration", "loop"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "arrange",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "segments", type = kt7, isVararg = true),
                ),
                returnType = kt2,
                description = """Prepends this pattern (duration 1) and plays it followed by the given segments.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c e g").arrange([2, note("f a c")]).s("piano")  // 1 cycle chord, then 2 cycles""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "arrange",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "segments", type = kt7, isVararg = true),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern (duration 1) and arranges it together with the given segments.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """"c e g".arrange([2, "f a c"]).note()  // 1 cycle, then 2 cycles of second chord""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "arrange",
                params = listOf(
                    KlangParam(name = "segments", type = kt7, isVararg = true, description = """Pairs of `[duration, pattern]`, or bare patterns (duration defaults to 1)."""),
                ),
                returnType = kt2,
                description = """Plays each segment for a specified number of cycles, forming a repeating arrangement.

 Each segment is a `[duration, pattern]` pair where `duration` is the number of cycles that
 pattern plays at its natural speed. A bare pattern without a duration defaults to 1 cycle.
 The whole arrangement repeats after the sum of all durations.

 Unlike [stepcat], which compresses all patterns into a single cycle, `arrange` keeps each
 pattern's internal tempo — a 2-cycle segment genuinely plays the pattern for 2 full cycles.""",
                returnDoc = """A pattern that plays each segment for its specified number of cycles, then repeats""",
                samples = listOf(
                    KlangCodeSample(code = """arrange([2, "a b"], [1, "c"]).note()  // "a b" for 2 cycles, "c" for 1""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """arrange([3, note("c e g")], [1, note("f a c")]).s("piano")  // chord changes over 4 cycles""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """arrange(note("c e g"), [2, note("f a c")]).s("piano")  // Pattern without weight""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "bandpass" to KlangSymbol(
        name = "bandpass",
        category = "effects",
        tags = listOf("bandpass", "bpf.freq", "filter"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "bandpass",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "freq", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "q", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "env", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "decay", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "sustain", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "release", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt2,
                description = """Applies a bandpass filter, the long name of [bpf]; both are the same door, use whichever
 reads better in the line you are writing.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3").s("saw").bandpass(800)""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "bandpass",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "freq", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "q", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "env", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "decay", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "sustain", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "release", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern, then applies [bandpass].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "bandpass",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "freq", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "q", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "env", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "decay", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "sustain", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "release", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt5,
                description = """Chains a bandpass step onto this [PatternMapperFn] (see [SprudelPattern.bandpass]).""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    )
)

private fun generatedSprudelDocsChunk2() = mapOf(

    "bank" to KlangSymbol(
        name = "bank",
        category = "tonal",
        tags = listOf("bank", "sample bank", "instrument"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "bank",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "name", type = kt6, isOptional = true, defaultDoc = """null""", description = """The sample bank name, e.g. `"RolandTR808"`. Default: none (uses default bank)."""),
                ),
                returnType = kt2,
                description = """Sets the sample bank for each event, overriding which collection of samples is used.

 The bank determines where samples are loaded from, independently of the sound name.
 Useful when you want to switch sample collections without changing sound identifiers.
 When called with no argument, reinterprets the current event value as a bank name.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd hh").bank("RolandTR808")     // load all sounds from the TR-808 bank""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("bd sd").bank("<TR808 TR909>")      // alternate sample banks each cycle""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "bank",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "name", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt2,
                description = """Sets the sample bank on a string pattern.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "bank",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "name", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt5,
                description = """Chains a bank operation onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "bank",
                params = listOf(
                    KlangParam(name = "name", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that sets the sample bank for each event.
 When called with no argument, reinterprets the current event value as a bank name.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd").apply(bank("RolandTR808"))   // mapper form""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "beatRate" to KlangSymbol(
        name = "beatRate",
        category = "continuous",
        tags = listOf("beatRate", "beats", "tempo", "bpm", "cps", "rate", "hz", "lfo", "continuous"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "beatRate",
                params = listOf(
                    KlangParam(name = "n", type = kt7, description = """How many beats one cycle of the LFO lasts; a number or a pattern."""),
                    KlangParam(name = "base", type = kt9, isOptional = true, defaultDoc = """4""", description = """How many beats make one cycle, default 4. A value of 0 or less counts in fours."""),
                ),
                returnType = kt2,
                description = """One cycle every `n` beats, in Hz, at the tempo that is playing right now.

 The rate twin of [beats]: the LFO doors take a rate in Hz (the `rate` of `tremolo`, `vibrato` and
 `phaser`), and `beatRate` turns a musical length into that rate, following every tempo change while playing.
 It takes the same argument as [beats], so `delay(0.3, beats(0.5))` and `tremolo(0.6, beatRate(0.5))` both
 mean "every half beat". It is exactly `pure(1).div(beats(n, base))`: at cps 0.5 (120 bpm) `beatRate(1)`
 is 2 Hz and `beatRate(0.5)` is 4 Hz. `base` is how many beats make a cycle, 4 unless you say otherwise.

 A number gives a signal. A pattern keeps its own rhythm, and each of its values becomes Hz.
 `beatRate(0)` is not a finite rate, and no door turns it into one: the tremolo and the vibrato stand still,
 and the phaser keeps the rate it had.""",
                returnDoc = """One cycle every `n` beats, in Hz, following the tempo.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3").s("saw").tremolo(0.6, beatRate(0.5))          // one wobble every half beat, at any tempo""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c3 e3 g3 e3").s("saw").vibrato(beatRate(1), 0.3)   // one vibrato cycle per beat""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c3").s("saw").tremolo(0.6, beatRate(1, 3))         // three beats to the cycle: a wobble per beat""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "beats" to KlangSymbol(
        name = "beats",
        category = "continuous",
        tags = listOf("beats", "tempo", "bpm", "cps", "seconds", "delay time", "continuous"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "beats",
                params = listOf(
                    KlangParam(name = "n", type = kt7, description = """How many beats; a number or a pattern."""),
                    KlangParam(name = "base", type = kt9, isOptional = true, defaultDoc = """4""", description = """How many beats make one cycle, default 4. A value of 0 or less counts in fours."""),
                ),
                returnType = kt2,
                description = """The length of `n` beats in seconds, at the tempo that is playing right now.

 The sound doors take a time in seconds (`delay.time`, the envelope stages). `beats` turns a musical length
 into those seconds and follows every tempo change while playing, like [cps]. The pattern doors that shift
 time (`late`, `early`) take cycles, not seconds, so `beats` is not for them. `base` is how many
 beats make a cycle, 4 unless you say otherwise, the same 4/4 that [bpm] assumes: at cps 0.5 (120 bpm)
 `beats(1)` is 0.5 s and `beats(0.5)` is 0.25 s, an eighth note. In a waltz, `beats(1, 3)` is a third of
 a cycle.

 It is a duration, not a rate: a door that takes Hz (the `rate` of `tremolo`, `vibrato` and `phaser`)
 takes [beatRate].

 A number gives a signal. A pattern keeps its own rhythm, and each of its values becomes seconds.
 Write fractions as decimals in a string: in mini-notation `"1/8"` means slow down by 8, not one eighth.""",
                returnDoc = """The length of `n` beats in seconds, following the tempo.""",
                samples = listOf(
                    KlangCodeSample(code = """s("sd ~ ~ ~").delay(0.4, beats(0.75), 0.5)             // a dotted-eighth echo at any tempo""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("sd ~ ~ ~").delay(0.4, beats("<0.5 0.75>"), 0.5)     // eighth, then dotted eighth, every other cycle""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("bd sd sd").delay(0.4, beats(1, 3), 0.5)             // three beats to the cycle: echo one beat later""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "begin" to KlangSymbol(
        name = "begin",
        category = "sampling",
        tags = listOf("begin", "start", "sample", "position", "offset"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "begin",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "pos", type = kt6, isOptional = true, defaultDoc = """null""", description = """Start position in [0, 1]; 0 = beginning, 1 = end."""),
                ),
                returnType = kt2,
                description = """Sets the sample start position as a fraction of the total sample length (0–1).

 `0` starts playback from the very beginning; `1` would start at the very end (silence).
 Useful for skipping intros or targeting specific sections of a longer sample. Combine
 with [end] to play only a segment.""",
                returnDoc = """A pattern with the sample start position set.""",
                samples = listOf(
                    KlangCodeSample(code = """s("breaks").begin(0.5)            // start halfway through the sample""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("breaks").begin("<0 0.25 0.5>") // cycle through three start positions""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "begin",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "pos", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt2,
                description = """Sets the sample start position (0–1) on a string pattern.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "begin",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "pos", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt5,
                description = """Chains a begin onto this [PatternMapperFn]; sets the sample start position (0–1).""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "binary" to KlangSymbol(
        name = "binary",
        category = "structural",
        tags = listOf("binary", "binaryN", "bits", "structure", "pattern"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "binary",
                params = listOf(
                    KlangParam(name = "n", type = kt10, description = """The integer to convert to binary."""),
                ),
                returnType = kt2,
                description = """Creates a binary pattern from a number, with bit length calculated automatically.""",
                returnDoc = """A sequential pattern of 0s and 1s with minimal bit width.""",
                samples = listOf(
                    KlangCodeSample(code = """s("hh").struct(binary(5))  // 1 0 1 — 3 bits""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("hh").struct(binary(13))  // 1 1 0 1 — 4 bits""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "binaryL" to KlangSymbol(
        name = "binaryL",
        category = "structural",
        tags = listOf("binaryL", "binaryNL", "binary", "bits", "list", "structure"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "binaryL",
                params = listOf(
                    KlangParam(name = "n", type = kt10, description = """The integer to convert to binary."""),
                ),
                returnType = kt2,
                description = """Creates a binary list pattern from a number, with bit length calculated automatically.

 Like [binary] but returns bits as a list value in a single event.""",
                returnDoc = """A single-event pattern whose value is a list of 0s and 1s with minimal bit width.""",
                samples = listOf(
                    KlangCodeSample(code = """s("hh").struct(binaryL(5))  // list [1, 0, 1]""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("hh").struct(binaryL(13))  // list [1, 1, 0, 1]""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "binaryN" to KlangSymbol(
        name = "binaryN",
        category = "structural",
        tags = listOf("binaryN", "binary", "bits", "structure", "pattern"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "binaryN",
                params = listOf(
                    KlangParam(name = "n", type = kt10, description = """The integer to convert to binary."""),
                    KlangParam(name = "bits", type = kt10, isOptional = true, defaultDoc = """16""", description = """Total pattern length in bits (default 16)."""),
                ),
                returnType = kt2,
                description = """Creates a binary pattern from a number, padded to `bits` bits long (MSB first).""",
                returnDoc = """A sequential pattern of 0s and 1s representing the binary value.""",
                samples = listOf(
                    KlangCodeSample(code = """s("hh").struct(binaryN(9, 4))  // 1 0 0 1 — binary 9 in 4 bits""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("hh").struct(binaryN(146, 8))  // 1 0 0 1 0 0 1 0 - binary 146 in 8 bits""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "binaryNL" to KlangSymbol(
        name = "binaryNL",
        category = "structural",
        tags = listOf("binaryNL", "binary", "bits", "list", "structure"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "binaryNL",
                params = listOf(
                    KlangParam(name = "n", type = kt10, description = """The integer to convert to binary."""),
                    KlangParam(name = "bits", type = kt10, isOptional = true, defaultDoc = """16""", description = """Total length in bits (default 16)."""),
                ),
                returnType = kt2,
                description = """Creates a binary list pattern from a number, padded to `bits` bits long.

 Like [binaryN] but returns the bits as a single event containing a list value rather than
 a sequence of discrete events.""",
                returnDoc = """A single-event pattern whose value is a list of 0s and 1s.""",
                samples = listOf(
                    KlangCodeSample(code = """s("hh").struct(binaryNL(5, 4))  // list [0, 1, 0, 1]""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("hh").struct(binaryNL(255, 8))  // list [1, 1, 1, 1, 1, 1, 1, 1]""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    )
)

private fun generatedSprudelDocsChunk3() = mapOf(

    "bitAnd" to KlangSymbol(
        name = "bitAnd",
        category = "arithmetic",
        tags = listOf("bitAnd", "bitwise", "and", "arithmetic", "binary"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "bitAnd",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "mask", type = kt7, description = """The bitmask. May be a number, string mini-notation, or a [SprudelPattern]."""),
                ),
                returnType = kt2,
                description = """Applies bitwise AND of [mask] to every integer value in the pattern.

 Only the raw event `value` is affected — `note`, `soundIndex`, and all other voice properties
 remain unchanged. Values are truncated to integers before the operation.""",
                returnDoc = """A new pattern where each value is replaced by `value & mask`.""",
                samples = listOf(
                    KlangCodeSample(code = """"12 15".bitAnd(10).scale("c3:major").n()  // 12&10=8, 15&10=10""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """"127".bitAnd("<15 63>").scale("c3:major").n()  // mask low or high nibble alternately""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "bitAnd",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "mask", type = kt7, description = """The bitmask. May be a number, string mini-notation, or a [SprudelPattern]."""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern, then applies bitwise AND with [mask] to every integer value.

 Only the raw event `value` is affected — `note`, `soundIndex`, and other voice properties
 remain unchanged.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """"12 15".bitAnd(10).scale("c3:major").n()  // 12&10=8, 15&10=10""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "bitAnd",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "mask", type = kt7, description = """The bitmask. May be a number, string mini-notation, or a [SprudelPattern]."""),
                ),
                returnType = kt5,
                description = """Chains a bitwise AND onto this [PatternMapperFn], applying [mask] to every integer value.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """seq("12 15").apply(add(3).bitAnd(10)).scale("c2:major").n()  // (12+3)&10=10, (15+3)&10=2""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "bitAnd",
                params = listOf(
                    KlangParam(name = "mask", type = kt7, description = """The bitmask. May be a number, string mini-notation, or a [SprudelPattern]."""),
                ),
                returnType = kt5,
                description = """Creates a [PatternMapperFn] that applies bitwise AND of [mask] to every integer value in a pattern.

 Only the raw event `value` is affected — `note`, `soundIndex`, and other voice properties
 remain unchanged. Use with [SprudelPattern.apply] to apply the mask to an existing pattern.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """seq("12 15").apply(bitAnd(10)).scale("c3:major").n()  // 12&10=8, 15&10=10""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "bitOr" to KlangSymbol(
        name = "bitOr",
        category = "arithmetic",
        tags = listOf("bitOr", "bitwise", "or", "arithmetic", "binary"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "bitOr",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "mask", type = kt7, description = """The bitmask. May be a number, string mini-notation, or a [SprudelPattern]."""),
                ),
                returnType = kt2,
                description = """Applies bitwise OR of [mask] to every integer value in the pattern.

 Only the raw event `value` is affected — `note`, `soundIndex`, and all other voice properties
 remain unchanged. Values are truncated to integers before the operation.""",
                returnDoc = """A new pattern where each value is replaced by `value | mask`.""",
                samples = listOf(
                    KlangCodeSample(code = """"8 4".bitOr(2).scale("c3:major").n()  // 8|2=10, 4|2=6""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """"0".bitOr("<1 2 4 8>").scale("c3:major").n()  // set individual bits each cycle""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "bitOr",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "mask", type = kt7, description = """The bitmask. May be a number, string mini-notation, or a [SprudelPattern]."""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern, then applies bitwise OR with [mask] to every integer value.

 Only the raw event `value` is affected — `note`, `soundIndex`, and other voice properties
 remain unchanged.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """"8 4".bitOr(2).scale("c3:major").n()  // 8|2=10, 4|2=6""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "bitOr",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "mask", type = kt7, description = """The bitmask. May be a number, string mini-notation, or a [SprudelPattern]."""),
                ),
                returnType = kt5,
                description = """Chains a bitwise OR onto this [PatternMapperFn], applying [mask] to every integer value.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """seq("8 4").apply(add(1).bitOr(2)).scale("c2:major").n()  // (8+1)|2=11, (4+1)|2=7""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "bitOr",
                params = listOf(
                    KlangParam(name = "mask", type = kt7, description = """The bitmask. May be a number, string mini-notation, or a [SprudelPattern]."""),
                ),
                returnType = kt5,
                description = """Creates a [PatternMapperFn] that applies bitwise OR of [mask] to every integer value in a pattern.

 Only the raw event `value` is affected — `note`, `soundIndex`, and other voice properties
 remain unchanged. Use with [SprudelPattern.apply] to apply the mask to an existing pattern.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """seq("8 4").apply(bitOr(2)).scale("c3:major").n()  // 8|2=10, 4|2=6""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "bitShl" to KlangSymbol(
        name = "bitShl",
        category = "arithmetic",
        tags = listOf("bitShl", "bitwise", "shift", "left shift", "arithmetic", "binary"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "bitShl",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "bits", type = kt7, description = """The number of bit positions to shift. May be a number, string mini-notation, or a [SprudelPattern]."""),
                ),
                returnType = kt2,
                description = """Shifts every integer value in the pattern left by [bits] bits (equivalent to multiplying by 2^n).

 Only the raw event `value` is affected — `note`, `soundIndex`, and all other voice properties
 remain unchanged. Values are truncated to integers before the operation.""",
                returnDoc = """A new pattern where each value is replaced by `value << bits`.""",
                samples = listOf(
                    KlangCodeSample(code = """"1 2".bitShl(2).scale("c3:major").n()  // 1<<2=4, 2<<2=8""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """"1".bitShl("<0 1 2 3>").scale("c3:major").n()  // 1, 2, 4, 8 over four cycles""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "bitShl",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "bits", type = kt7, description = """The number of bit positions to shift. May be a number, string mini-notation, or a [SprudelPattern]."""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern, then shifts every integer value left by [bits] bits.

 Only the raw event `value` is affected — `note`, `soundIndex`, and other voice properties
 remain unchanged.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """"1 2".bitShl(2).scale("c3:major").n()  // 1<<2=4, 2<<2=8""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "bitShl",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "bits", type = kt7, description = """The number of bit positions to shift. May be a number, string mini-notation, or a [SprudelPattern]."""),
                ),
                returnType = kt5,
                description = """Chains a bitwise left-shift onto this [PatternMapperFn], shifting every integer value left by [bits] bits.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """seq("1 2").apply(add(1).bitShl(2)).scale("c2:major").n()  // (1+1)<<2=8, (2+1)<<2=12""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "bitShl",
                params = listOf(
                    KlangParam(name = "bits", type = kt7, description = """The number of bit positions to shift. May be a number, string mini-notation, or a [SprudelPattern]."""),
                ),
                returnType = kt5,
                description = """Creates a [PatternMapperFn] that shifts every integer value in a pattern left by [bits] bits.

 Only the raw event `value` is affected — `note`, `soundIndex`, and other voice properties
 remain unchanged. Use with [SprudelPattern.apply] to apply the shift to an existing pattern.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """seq("1 2").apply(bitShl(2)).scale("c3:major").n()  // 1<<2=4, 2<<2=8""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "bitShr" to KlangSymbol(
        name = "bitShr",
        category = "arithmetic",
        tags = listOf("bitShr", "bitwise", "shift", "right shift", "arithmetic", "binary"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "bitShr",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "bits", type = kt7, description = """The number of bit positions to shift. May be a number, string mini-notation, or a [SprudelPattern]."""),
                ),
                returnType = kt2,
                description = """Shifts every integer value in the pattern right by [bits] bits (equivalent to integer-dividing by 2^n).

 Only the raw event `value` is affected — `note`, `soundIndex`, and all other voice properties
 remain unchanged. Values are truncated to integers before the operation.""",
                returnDoc = """A new pattern where each value is replaced by `value >> bits`.""",
                samples = listOf(
                    KlangCodeSample(code = """"8 12".bitShr(2).scale("c3:major").n()  // 8>>2=2, 12>>2=3""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """"16".bitShr("<0 1 2 3>").scale("c3:major").n()  // 16, 8, 4, 2 over four cycles""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "bitShr",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "bits", type = kt7, description = """The number of bit positions to shift. May be a number, string mini-notation, or a [SprudelPattern]."""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern, then shifts every integer value right by [bits] bits.

 Only the raw event `value` is affected — `note`, `soundIndex`, and other voice properties
 remain unchanged.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """"8 12".bitShr(2).scale("c3:major").n()  // 8>>2=2, 12>>2=3""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "bitShr",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "bits", type = kt7, description = """The number of bit positions to shift. May be a number, string mini-notation, or a [SprudelPattern]."""),
                ),
                returnType = kt5,
                description = """Chains a bitwise right-shift onto this [PatternMapperFn], shifting every integer value right by [bits] bits.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """seq("8 16").apply(mul(2).bitShr(3)).scale("c3:major").n()  // (8*2)>>3=2, (16*2)>>3=4""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "bitShr",
                params = listOf(
                    KlangParam(name = "bits", type = kt7, description = """The number of bit positions to shift. May be a number, string mini-notation, or a [SprudelPattern]."""),
                ),
                returnType = kt5,
                description = """Creates a [PatternMapperFn] that shifts every integer value in a pattern right by [bits] bits.

 Only the raw event `value` is affected — `note`, `soundIndex`, and other voice properties
 remain unchanged. Use with [SprudelPattern.apply] to apply the shift to an existing pattern.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """seq("8 12").apply(bitShr(2)).scale("c3:major").n()  // 8>>2=2, 12>>2=3""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "bitXor" to KlangSymbol(
        name = "bitXor",
        category = "arithmetic",
        tags = listOf("bitXor", "bitwise", "xor", "arithmetic", "binary"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "bitXor",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "mask", type = kt7, description = """The bitmask. May be a number, string mini-notation, or a [SprudelPattern]."""),
                ),
                returnType = kt2,
                description = """Applies bitwise XOR of [mask] to every integer value in the pattern.

 Only the raw event `value` is affected — `note`, `soundIndex`, and all other voice properties
 remain unchanged. Values are truncated to integers before the operation. XOR is useful for
 toggling specific bits.""",
                returnDoc = """A new pattern where each value is replaced by `value ^ mask`.""",
                samples = listOf(
                    KlangCodeSample(code = """"12 10".bitXor(6).scale("c3:major").n()  // 12^6=10, 10^6=12""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """"5".bitXor("<3 5>").scale("c3:major").n()  // toggle bits each cycle""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "bitXor",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "mask", type = kt7, description = """The bitmask. May be a number, string mini-notation, or a [SprudelPattern]."""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern, then applies bitwise XOR with [mask] to every integer value.

 Only the raw event `value` is affected — `note`, `soundIndex`, and other voice properties
 remain unchanged.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """"12 10".bitXor(6).scale("c3:major").n()  // 12^6=10, 10^6=12""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "bitXor",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "mask", type = kt7, description = """The bitmask. May be a number, string mini-notation, or a [SprudelPattern]."""),
                ),
                returnType = kt5,
                description = """Chains a bitwise XOR onto this [PatternMapperFn], applying [mask] to every integer value.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """seq("12 10").apply(add(2).bitXor(6)).scale("c2:major").n()  // (12+2)^6=8, (10+2)^6=10""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "bitXor",
                params = listOf(
                    KlangParam(name = "mask", type = kt7, description = """The bitmask. May be a number, string mini-notation, or a [SprudelPattern]."""),
                ),
                returnType = kt5,
                description = """Creates a [PatternMapperFn] that applies bitwise XOR of [mask] to every integer value in a pattern.

 Only the raw event `value` is affected — `note`, `soundIndex`, and other voice properties
 remain unchanged. Use with [SprudelPattern.apply] to apply the mask to an existing pattern.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """seq("12 10").apply(bitXor(6)).scale("c3:major").n()  // 12^6=10, 10^6=12""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "bite" to KlangSymbol(
        name = "bite",
        category = "structural",
        tags = listOf("bite", "slice", "rearrange", "index", "stutter"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "bite",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "n", type = kt7, description = """Number of equal slices to cut each cycle into."""),
                    KlangParam(name = "indices", type = kt7, description = """Pattern of slice indices (0-based). Can be a mini-notation string or a pattern."""),
                ),
                returnType = kt2,
                description = """Splits the pattern into `n` equal slices and plays them in the order given by `indices`.

 Each event in the `indices` pattern selects a slice by number and plays it scaled to fit that event's
 duration. This allows reordering, repeating, or otherwise rearranging slices of any pattern.""",
                returnDoc = """A new pattern built by playing slices in the order specified by `indices`.""",
                samples = listOf(
                    KlangCodeSample(code = """n("0 1 2 3").bite(4, "3 2 1 0").scale("c3:major")  // reverse the pattern""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """n("0 1 2 3").bite(4, "0!2 1").scale("c3:major")  // play slice 0 twice then slice 1""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "bite",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "n", type = kt7, description = """Number of equal slices to cut each cycle into."""),
                    KlangParam(name = "indices", type = kt7, description = """Pattern of slice indices (0-based). Can be a mini-notation string or a pattern."""),
                ),
                returnType = kt2,
                description = """Like [bite] applied to a mini-notation string.""",
                returnDoc = """A new pattern built by playing slices in the order specified by `indices`.""",
                samples = listOf(
                    KlangCodeSample(code = """"0 1 2 3".bite(4, "3 2 1 0").n().scale("c3:major")  // reverse the pattern""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "bite",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "n", type = kt7),
                    KlangParam(name = "indices", type = kt7),
                ),
                returnType = kt5,
                description = """Chains a bite onto this [PatternMapperFn]; rearranges slices of the result in `indices` order.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "bite",
                params = listOf(
                    KlangParam(name = "n", type = kt7, description = """Number of equal slices to cut each cycle into."""),
                    KlangParam(name = "indices", type = kt7, description = """Pattern of slice indices (0-based). Can be a mini-notation string or a pattern."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that splits the source into `n` equal slices and plays them in `indices` order.""",
                returnDoc = """A [PatternMapperFn] that rearranges slices of the source pattern.""",
                samples = listOf(
                    KlangCodeSample(code = """n("0 1 2 3").apply(bite(4, "3 2 1 0")).scale("c3:major")  // via mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "bjork" to KlangSymbol(
        name = "bjork",
        category = "structural",
        tags = listOf("bjork", "euclid", "rhythm", "rotation"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "bjork",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "pulses", type = kt10, description = """Number of onsets (beats)."""),
                    KlangParam(name = "steps", type = kt10, description = """Total number of steps."""),
                    KlangParam(name = "rotation", type = kt10, isOptional = true, defaultDoc = """0""", description = """Number of steps to rotate (default 0)."""),
                ),
                returnType = kt2,
                description = """Applies a Euclidean rhythm specified as individual parameters (pulses, steps, rotation).

 Alternative to [euclidRot] that bundles parameters together. Named after Björk's use of
 Euclidean rhythms in music.""",
                returnDoc = """A pattern with the Euclidean rhythm applied.""",
                samples = listOf(
                    KlangCodeSample(code = """s("hh").bjork(3, 8, 0)  // equivalent to euclid(3, 8)""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("bd").bjork(5, 16, 2)  // 5-over-16 with rotation 2""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "bjork",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "pulses", type = kt10),
                    KlangParam(name = "steps", type = kt10),
                    KlangParam(name = "rotation", type = kt10, isOptional = true, defaultDoc = """0"""),
                ),
                returnType = kt2,
                description = """Like [bjork] applied to a mini-notation string.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "bjork",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "pulses", type = kt10),
                    KlangParam(name = "steps", type = kt10),
                    KlangParam(name = "rotation", type = kt10, isOptional = true, defaultDoc = """0"""),
                ),
                returnType = kt5,
                description = """Chains a bjork onto this [PatternMapperFn]; applies a Euclidean rhythm (pulses, steps, rotation).""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "bjork",
                params = listOf(
                    KlangParam(name = "pulses", type = kt10, description = """Number of onsets (beats)."""),
                    KlangParam(name = "steps", type = kt10, description = """Total number of steps."""),
                    KlangParam(name = "rotation", type = kt10, isOptional = true, defaultDoc = """0""", description = """Number of steps to rotate (default 0)."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that applies a Euclidean rhythm specified as (pulses, steps, rotation).""",
                returnDoc = """A [PatternMapperFn] that restructures the source as a bjork Euclidean rhythm.""",
                samples = listOf(
                    KlangCodeSample(code = """s("hh").apply(bjork(3, 8, 0))  // via mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "body" to KlangSymbol(
        name = "body",
        category = "effects",
        tags = listOf("body", "wet", "material", "floor"),
        aliases = listOf(),
        scope = KlangScope.ORBIT,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "body",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "wet", type = kt6, isOptional = true, defaultDoc = """null""", description = """How much of the orbit runs through the body, 0 to 1."""),
                    KlangParam(name = "material", type = kt6, isOptional = true, defaultDoc = """null""", description = """Material name. See the list above.""", uitools = listOf("SprudelBodyEditor", "SprudelBodySequenceEditor")),
                    KlangParam(name = "floor", type = kt6, isOptional = true, defaultDoc = """null""", description = """Minimum dry share kept in the mix, 0 to 1."""),
                ),
                returnType = kt2,
                description = """The resonant body: the material, its mix and its dry floor.

 Runs the orbit through a resonating body, the way a guitar top or a drum shell colours what passes
 through it. One body per orbit bus, so ALL of it, `material`
 included, is set once for everyone by the orbit's owning voice.

 `wet` here is a mix (and `floor` how much of the dry stays under it): the body processes the whole
 orbit mix. The `wet` of `reverb` and `delay` reads differently: it is how much of the orbit goes
 INTO them, a send, and their sound is added on top of the dry. Give a
 pattern its own body by giving it its own orbit.

 Materials: woods `wood`, `cedar`, `spruce`, `mahogany`, `rosewood`, `maple`, `oak`; bowed string
 `violin`; voice `croon`; pipe and glass `tube`, `glass`; skin `membrane`; metals `brass`, `steel`,
 `bell`. `none` removes the body. One name at a time: `body(material = "wood glass")` is mini-notation, so it
 is wood for the first half of the cycle and glass for the second, not a blend of the two.

 Every slot is independent and patternable; an omitted slot keeps its value, a named slot takes
 a mapper (`body(floor = mul(2))`), and the numeric slots read back as `body.wet`, `body.floor`. `material` is a name and has no reader.
 With no argument at all, the pattern's own values are reinterpreted as `wet`
 (`seq("<0.2 0.5>").body()`); a value that is not a number writes nothing.

 `wet` comes first, as on every door that has one. The material is the second parameter, so a
 material alone is written by name: `body(material = "wood")`.

 Naming a material sets the whole stage: `wet` and `floor` take their shared defaults, 0.5 and 0.4,
 unless an earlier call already set them, so `body(material = "wood")` is as audible as it always
 was. Naming `wet` or `floor` alone does NOT invent a material, because the material is what
 switches the body on. `body(material = "none")` switches it off again.

 Slots apply in order, `wet` first. A wet MAPPER in the same call as the material therefore maps a
 wet that is not set yet, which does nothing: `body(mul(2), "wood")` on a fresh note is wet 0.5,
 the material's default. To double the wet, map it in a later call, once it is set:
 `body(material = "wood").body(wet = mul(2))` is wet 1.0.

 All three reach a DECLARED orbit chain as chain slots, `material` as the index of its name in the
 material catalogue (`body.material`, 0 = none), so the same call works whether the orbit declares
 a chain or runs the historical one, down to the sample. Guarded by
 `KatalystDoorFillRenderSpec`, which renders the short and the long spelling and compares samples.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3 e3").s("saw").body(0.7, "wood")                                 // a wooden box around the tone""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c3 e3").s("saw").body(0.7, "wood glass").body(wet = mul("<1 0.5>"))   // wood then glass, half as boxy every other bar""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c3 e3").s("saw").body("<0.2 0.9>", "tube").reverb(wet = body.wet, size = 4)   // as much reverb as body""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "body",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "wet", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "material", type = kt6, isOptional = true, defaultDoc = """null""", uitools = listOf("SprudelBodyEditor", "SprudelBodySequenceEditor")),
                    KlangParam(name = "floor", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern, then applies [body].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "body",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "wet", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "material", type = kt6, isOptional = true, defaultDoc = """null""", uitools = listOf("SprudelBodyEditor", "SprudelBodySequenceEditor")),
                    KlangParam(name = "floor", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt5,
                description = """Chains a [body] step onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    )
)

private fun generatedSprudelDocsChunk4() = mapOf(

    "bpf" to KlangSymbol(
        name = "bpf",
        category = "effects",
        tags = listOf("bpf", "freq", "q", "env", "attack", "decay", "sustain", "release", "bandf", "band pass filter", "filter", "envelope"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "bpf",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "freq", type = kt6, isOptional = true, defaultDoc = """null""", description = """Centre frequency in Hz.""", uitools = listOf("SprudelBpFilterEditor", "SprudelBpFilterSequenceEditor")),
                    KlangParam(name = "q", type = kt6, isOptional = true, defaultDoc = """null""", description = """Resonance, higher narrows the band.""", uitools = listOf("SprudelBpQEditor", "SprudelBpQSequenceEditor")),
                    KlangParam(name = "env", type = kt6, isOptional = true, defaultDoc = """null""", description = """Envelope depth in semitones.""", uitools = listOf("SprudelBpEnvEditor", "SprudelBpEnvSequenceEditor")),
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null""", description = """Envelope attack in seconds."""),
                    KlangParam(name = "decay", type = kt6, isOptional = true, defaultDoc = """null""", description = """Envelope decay in seconds."""),
                    KlangParam(name = "sustain", type = kt6, isOptional = true, defaultDoc = """null""", description = """Envelope sustain, 0 to 1."""),
                    KlangParam(name = "release", type = kt6, isOptional = true, defaultDoc = """null""", description = """Envelope release in seconds."""),
                ),
                returnType = kt2,
                description = """The bandpass filter: centre, resonance and the centre envelope.

 Only a band around the centre passes, and the resonance sets its width: higher `q` is a narrower
 band. Every note carries its own centre, width and envelope, per voice.

 The envelope sweeps `freq` up by `env` semitones: attack is the time to reach full depth, decay
 the fall to the sustain share, release the fall back to `freq` after the note ends. `env = 12`
 doubles the centre, a negative `env` sweeps down, and without `env` the filter rests at `freq`.

 Every slot is independent and patternable; an omitted slot keeps its value, a named slot takes
 a mapper (`bpf(q = mul(2))`), and every slot reads back as a child: `bpf.freq`, `bpf.q`, `bpf.env`, `bpf.attack`, `bpf.decay`, `bpf.sustain`, `bpf.release`.
 With no argument at all, the pattern's own values are reinterpreted as `freq`.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3 e3").s("saw").bpf(1000, 4)                                         // centre and width""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c3*4").s("saw").bpf(freq = 500, q = 6, env = 24, attack = 0.01, decay = 0.3, sustain = 0.1)   // a wah on every note""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c3 e3").s("saw").bpf(freq.mul(4), 3)                                 // a band two octaves above each note""", type = KlangCodeSampleType.PLAYABLE)
                ),
                uitools = listOf("SprudelBpFilterEditor"),
                library = "sprudel"
            ),
            KlangCallable(
                name = "bpf",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "freq", type = kt6, isOptional = true, defaultDoc = """null""", uitools = listOf("SprudelBpFilterEditor", "SprudelBpFilterSequenceEditor")),
                    KlangParam(name = "q", type = kt6, isOptional = true, defaultDoc = """null""", uitools = listOf("SprudelBpQEditor", "SprudelBpQSequenceEditor")),
                    KlangParam(name = "env", type = kt6, isOptional = true, defaultDoc = """null""", uitools = listOf("SprudelBpEnvEditor", "SprudelBpEnvSequenceEditor")),
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "decay", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "sustain", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "release", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern, then applies [bpf].""",
                returnDoc = """""",
                samples = emptyList(),
                uitools = listOf("SprudelBpFilterEditor"),
                library = "sprudel"
            ),
            KlangCallable(
                name = "bpf",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "freq", type = kt6, isOptional = true, defaultDoc = """null""", uitools = listOf("SprudelBpFilterEditor", "SprudelBpFilterSequenceEditor")),
                    KlangParam(name = "q", type = kt6, isOptional = true, defaultDoc = """null""", uitools = listOf("SprudelBpQEditor", "SprudelBpQSequenceEditor")),
                    KlangParam(name = "env", type = kt6, isOptional = true, defaultDoc = """null""", uitools = listOf("SprudelBpEnvEditor", "SprudelBpEnvSequenceEditor")),
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "decay", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "sustain", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "release", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt5,
                description = """Chains a [bpf] step onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                uitools = listOf("SprudelBpFilterEditor"),
                library = "sprudel"
            )
        )
    ),

    "bpfCurves" to KlangSymbol(
        name = "bpfCurves",
        category = "effects",
        tags = listOf("bpf", "curve", "envelope", "shape", "filter envelope"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "bpfCurves",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the attack stage."""),
                    KlangParam(name = "decay", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the decay stage."""),
                    KlangParam(name = "release", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the release stage."""),
                ),
                returnType = kt2,
                description = """Sets the shape of each stage of the bandpass filter's cutoff envelope ([bpf]'s `env`, `attack`,
 `decay`, `sustain`, `release`), the way [adsrCurves] shapes the amplitude envelope. Each stage is
 independent; an omitted stage, or an unknown curve name, keeps its current curve, so
 `bpfCurves(decay = "linear")` changes only the decay.

 The curves are the same six as `adsrCurves`: `linear`, `square`, `cube`, `scurve`, `invsquare`,
 `exponential`, with the same aliases. Unset, every stage is `exponential`, the default of every
 modulation envelope on every surface (decision D3). A curve alone switches nothing on: without an
 envelope on the `bpf` there is no sweep to shape. The Ignitor filters name the same curves inside
 their envelope: `x => x.adsr(a, d, s, r, e => e.curves(...))`.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3*4").s("saw").bpf(freq = 600, q = 4, env = 24, decay = 0.25, sustain = 0).bpfCurves(decay = "linear")   // a straight glide in semitones""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "bpfCurves",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the attack stage."""),
                    KlangParam(name = "decay", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the decay stage."""),
                    KlangParam(name = "release", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the release stage."""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern and sets the bandpass filter envelope's stage curves (see [bpfCurves]).""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "bpfCurves",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the attack stage. Omit to keep the current curve."""),
                    KlangParam(name = "decay", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the decay stage. Omit to keep the current curve."""),
                    KlangParam(name = "release", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the release stage. Omit to keep the current curve."""),
                ),
                returnType = kt5,
                description = """Creates a chained [PatternMapperFn] that sets the bandpass filter envelope's stage curves after the previous mapper.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "brak" to KlangSymbol(
        name = "brak",
        category = "tempo",
        tags = listOf("brak", "breakbeat", "syncopation", "rhythm", "offset", "amen"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "brak",
                receiver = kt0,
                params = emptyList(),
                returnType = kt2,
                description = """Makes every other cycle syncopated — a classic breakbeat effect.

 Cycle 0, 2, 4, … play normally. Cycle 1, 3, 5, … compress the pattern into the first half
 and delay it by a quarter cycle, creating an off-beat syncopation reminiscent of amen
 break-style patterns.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd hh cp").brak()             // alternating straight and syncopated cycles""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c d e f").brak()              // melodic pattern with every-other-cycle offset""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "brak",
                receiver = kt3,
                params = emptyList(),
                returnType = kt2,
                description = """Makes every other cycle syncopated — a classic breakbeat effect.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "brak",
                receiver = kt4,
                params = emptyList(),
                returnType = kt5,
                description = """Chains a brak operation onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "brak",
                params = emptyList(),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that makes every other cycle syncopated.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "brandBy" to KlangSymbol(
        name = "brandBy",
        category = "random",
        tags = listOf("brandBy", "binary", "random", "gate", "probability"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "brandBy",
                params = listOf(
                    KlangParam(name = "prob", type = kt7, description = """Probability of returning 1 (vs 0). Range: 0.0–1.0. Default: 0.5."""),
                ),
                returnType = kt2,
                description = """Binary random pattern: outputs 0 or 1 with the given probability of returning 1.

 At each point in time, `brandBy(p)` produces 1 with probability `p` and 0 otherwise.
 Useful for random gate or switch patterns.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """s("hh*10").pan(brandBy(0.2))        // 20% chance of value 1, else 0""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c d e f").gain(brandBy(0.5))  // random full/zero gain on each event""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "bypass" to KlangSymbol(
        name = "bypass",
        category = "structural",
        tags = listOf("silence", "mute", "bypass", "control"),
        aliases = listOf("hush", "mute"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "bypass",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true, description = """Optional condition pattern. When truthy the pattern is silenced."""),
                ),
                returnType = kt2,
                description = """Alias for [hush]. Silences this pattern. Without arguments, unconditionally returns silence.""",
                returnDoc = """Silence, or the original pattern gated by the condition.""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd").bypass()          // Unconditional silence""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("bd sd").bypass("<1 0>")   // Silent on odd cycles, audible on even""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "bypass",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true),
                ),
                returnType = kt2,
                description = """Alias for [hush] on a string pattern. Without arguments, unconditionally returns silence.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "bypass",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true),
                ),
                returnType = kt5,
                description = """Chains a bypass (alias for [hush]) onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "bypass",
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true, description = """Optional condition pattern. When truthy the source pattern is silenced."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] — alias for [hush] — that silences the source pattern.""",
                returnDoc = """A [PatternMapperFn] that silences or conditionally gates the source pattern.""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd").apply(bypass())   // Unconditional silence via mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "cat" to KlangSymbol(
        name = "cat",
        category = "structural",
        tags = listOf("cat", "sequence", "concatenate", "timing"),
        aliases = listOf("slowcat"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "cat",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "patterns", type = kt7, isVararg = true),
                ),
                returnType = kt2,
                description = """Appends patterns to this pattern, each playing for its natural cycle duration.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c d").cat(note("e f g"))  // "c d" then "e f g" in sequence""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "cat",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "patterns", type = kt7, isVararg = true),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern and concatenates it with the given patterns in sequence.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """"c d".cat("e f g").note()  // "c d" then "e f g" in sequence""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "cat",
                params = listOf(
                    KlangParam(name = "patterns", type = kt7, isVararg = true, description = """Patterns to concatenate. Each plays for its natural duration."""),
                ),
                returnType = kt2,
                description = """Concatenates patterns in sequence, each playing for its natural cycle duration before the next begins.

 Unlike [seq], which squeezes all patterns into one cycle, `cat` plays each pattern for its full
 natural duration. A 2-cycle pattern takes 2 cycles, then the next pattern begins.""",
                returnDoc = """A pattern that plays each input in turn for its natural duration""",
                samples = listOf(
                    KlangCodeSample(code = """cat(note("c d"), note("e f g")).s("piano")  // 2-step then 3-step pattern in sequence""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """cat(s("bd sd"), s("hh hh hh hh"))  // alternates between patterns each cycle""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "ceil" to KlangSymbol(
        name = "ceil",
        category = "arithmetic",
        tags = listOf("ceil", "ceiling", "rounding", "arithmetic", "math"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "ceil",
                receiver = kt0,
                params = emptyList(),
                returnType = kt2,
                description = """Ceils every numeric value in the pattern to the smallest integer greater than or equal to the value.""",
                returnDoc = """A new pattern with each value ceiled to an integer.""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "ceil",
                receiver = kt3,
                params = emptyList(),
                returnType = kt2,
                description = """""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "ceil",
                receiver = kt4,
                params = emptyList(),
                returnType = kt5,
                description = """""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "ceil",
                params = emptyList(),
                returnType = kt5,
                description = """""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "choose" to KlangSymbol(
        name = "choose",
        category = "random",
        tags = listOf("choose", "selector", "random", "chooseOut", "selection", "values"),
        aliases = listOf("chooseOut"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "choose",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true, description = """Values or patterns to choose from using the receiver as selector."""),
                ),
                returnType = kt2,
                description = """Uses this pattern (range 0–1) as a selector to choose from the given list.

 The receiver pattern controls the index into the list. Structure comes from the
 selector pattern (`chooseOut` mode).""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """sine.choose("c", "e", "g", "b")     // sine wave selects among chord tones""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "choose",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true),
                ),
                returnType = kt2,
                description = """Uses this string pattern as a selector to choose from the given list.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "choose",
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true, description = """Values or patterns to randomly choose from at each event."""),
                ),
                returnType = kt2,
                description = """Chooses randomly from the given values or patterns at each event.

 Uses `rand` as the selector, so the choice varies continuously in time. Structure comes
 from the selector (`chooseOut` mode). For cycle-level choices use `chooseCycles`.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c2 g2 d2 f1").s(choose("sine", "triangle", "bd:6"))   // random synth each note""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s(choose("bd", "sd", "hh")).fast(8)    // random drum sound every eighth-note""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    )
)

private fun generatedSprudelDocsChunk5() = mapOf(

    "chooseCycles" to KlangSymbol(
        name = "chooseCycles",
        category = "random",
        tags = listOf("chooseCycles", "random", "cycle", "randcat", "selection"),
        aliases = listOf("randcat"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "chooseCycles",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true),
                ),
                returnType = kt2,
                description = """Picks one of the given values at random, changing once per cycle.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "chooseCycles",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true),
                ),
                returnType = kt2,
                description = """Picks one of the given values at random, changing once per cycle.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "chooseCycles",
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true, description = """Values or patterns to randomly pick from; one is chosen per cycle."""),
                ),
                returnType = kt2,
                description = """Picks one of the given values or patterns at random, changing once per cycle.

 The entire cycle plays the same chosen pattern. Unlike `choose`, which can vary within a
 cycle, `chooseCycles` makes a fresh random choice only at cycle boundaries.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """chooseCycles("bd", "hh", "sd").s().fast(8)   // entire cycle uses one random drum sound""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("bd | hh | sd").fast(8)                    // mini-notation equivalent using |""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "chooseIn" to KlangSymbol(
        name = "chooseIn",
        category = "random",
        tags = listOf("chooseIn", "random", "selection", "structure"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "chooseIn",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true),
                ),
                returnType = kt2,
                description = """Uses this pattern as a selector; structure comes from the chosen value.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "chooseIn",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true),
                ),
                returnType = kt2,
                description = """Uses this string pattern as a selector; structure comes from the chosen value.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "chooseIn",
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true, description = """Values or patterns to randomly choose from; structure comes from the chosen value."""),
                ),
                returnType = kt2,
                description = """Like `choose`, but structure comes from the chosen values rather than the selector.

 Uses `rand` as the selector. The timing structure is inherited from the selected value
 pattern (`chooseIn` mode), so the chosen pattern's own rhythm determines the events.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """chooseIn("c d", "e f g", "a b c d")   // random pattern; its timing determines structure""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "chooseInWith" to KlangSymbol(
        name = "chooseInWith",
        category = "random",
        tags = listOf("chooseInWith", "chooseWith", "selector", "random", "structure"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "chooseInWith",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true),
                ),
                returnType = kt2,
                description = """Uses this pattern as a selector to choose from the given list (structure from chosen).""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "chooseInWith",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true),
                ),
                returnType = kt2,
                description = """Uses this string pattern as a selector to choose from the given list (structure from chosen).""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "chooseInWith",
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true, description = """First argument is the selector pattern (values 0–1); remaining arguments are the values to choose from."""),
                ),
                returnType = kt2,
                description = """Like `chooseWith` but structure comes from the chosen values, not the selector pattern.

 The selector pattern (values 0–1) controls which value is chosen. The timing structure is
 taken from the selected value pattern (`chooseIn` mode).""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """chooseInWith(sine, "c d", "e f g", "a b c d")   // selector picks pattern; its timing wins""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "chooseOut" to KlangSymbol(
        name = "chooseOut",
        category = "random",
        tags = listOf("chooseOut", "choose", "random", "selection"),
        aliases = listOf("choose"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "chooseOut",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true),
                ),
                returnType = kt2,
                description = """Alias for [choose].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "chooseOut",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true),
                ),
                returnType = kt2,
                description = """Alias for [choose].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "chooseOut",
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true, description = """Values or patterns to randomly choose from at each event."""),
                ),
                returnType = kt2,
                description = """Alias for [choose].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "chooseWith" to KlangSymbol(
        name = "chooseWith",
        category = "random",
        tags = listOf("chooseWith", "choose", "selector", "random", "values"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "chooseWith",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true),
                ),
                returnType = kt2,
                description = """Uses this pattern (range 0–1) as a selector to choose from the given list.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "chooseWith",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true),
                ),
                returnType = kt2,
                description = """Uses this string pattern as a selector to choose from the given list.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "chooseWith",
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true, description = """First argument is the selector pattern (values 0–1); remaining arguments are the values to choose from."""),
                ),
                returnType = kt2,
                description = """Chooses from the given list of values using a selector pattern (values 0–1).

 The selector pattern controls which value is chosen at each point in time. A value of 0
 picks the first element, 1 picks the last, and values in between interpolate as an index.
 Structure comes from the selector pattern (`chooseOut` mode).""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c2 g2 d2 f1").s(chooseWith(sine.fast(2), "sawtooth", "triangle", "bd:6"))""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s(chooseWith(rand, "bd", "sd", "hh"))    // random instrument selection per event""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "chord" to KlangSymbol(
        name = "chord",
        category = "tonal",
        tags = listOf("chord", "harmony", "chords", "voicing", "progression"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "chord",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "name", type = kt7),
                ),
                returnType = kt2,
                description = """Sets the chord name on this pattern for use with [voicing] and [rootNotes].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "chord",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "name", type = kt7),
                ),
                returnType = kt2,
                description = """Sets the chord name on a string pattern.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "chord",
                params = listOf(
                    KlangParam(name = "name", type = kt7, description = """Chord type name, e.g. "major", "minor", "7", "m7", "dim", "aug". 112 types available. Default: none."""),
                ),
                returnType = kt2,
                description = """Sets the chord name for each event, establishing harmonic context for [voicing].

 Chord names follow the format `"root quality"` (e.g. `"C"`, `"Am"`, `"Gmaj7"`).
 The chord root is also set as the event's note. Use [voicing] to expand into voiced
 notes, or [rootNotes] to extract just the bass note.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """chord("<C Am F G>").voicing()         // voiced I-vi-IV-V""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """chord("<Cmaj7 Am7>").voicing()        // jazzy chord alternation per cycle""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "chunk" to KlangSymbol(
        name = "chunk",
        category = "structural",
        tags = listOf("chunk", "cycle", "transform", "rotate", "slice"),
        aliases = listOf("slowchunk", "slowChunk"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "chunk",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "n", type = kt10, description = """Number of chunks to divide the pattern into."""),
                    KlangParam(name = "transform", type = kt5, description = """Function applied to the currently active chunk each cycle."""),
                    KlangParam(name = "back", type = kt11, isOptional = true, defaultDoc = """false""", description = """If `true`, cycles backward through chunks (default `false`)."""),
                    KlangParam(name = "fast", type = kt11, isOptional = true, defaultDoc = """false""", description = """If `true`, the source pattern is not repeated — it runs at natural speed (default `false`)."""),
                ),
                returnType = kt2,
                description = """Divides the pattern into `n` chunks and cycles through them, applying [transform] to one chunk per cycle.

 Over `n` cycles the whole pattern plays `n` times, with each cycle highlighting one of the `n` equal
 segments via [transform]. Use `back = true` to cycle backward, and `fast = true` to let the pattern
 progress at its natural speed (without the `n`-times repetition).""",
                returnDoc = """A new pattern with the transform cycling through chunks.""",
                samples = listOf(
                    KlangCodeSample(code = """seq("0 1 2 3").chunk(4, x => x.add(7)).scale("c:minor").n()  // one chunk transformed per cycle""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("bd sd ht lt").chunk(4, x => x.gain(1.5))  // one hit louder, cycling forward""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "chunk",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "n", type = kt10),
                    KlangParam(name = "transform", type = kt5),
                    KlangParam(name = "back", type = kt11, isOptional = true, defaultDoc = """false"""),
                    KlangParam(name = "fast", type = kt11, isOptional = true, defaultDoc = """false"""),
                ),
                returnType = kt2,
                description = """Like [chunk] applied to a mini-notation string.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "chunkBack" to KlangSymbol(
        name = "chunkBack",
        category = "structural",
        tags = listOf("chunk", "cycle", "transform", "reverse", "rotate"),
        aliases = listOf("chunkback"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "chunkBack",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "n", type = kt10, description = """Number of chunks."""),
                    KlangParam(name = "transform", type = kt5, description = """Function applied to the active chunk each cycle."""),
                ),
                returnType = kt2,
                description = """Like [chunk], but cycles through the parts in reverse order (known as `chunk'` in TidalCycles).

 Divides the pattern into `n` chunks and cycles backward through them — starting from chunk 0,
 then chunk n-1, n-2, …, 1 — applying [transform] to one chunk per cycle.""",
                returnDoc = """Pattern cycling backward through transformed chunks.""",
                samples = listOf(
                    KlangCodeSample(code = """seq("0 1 2 3").chunkBack(4, x => x.add(7)).scale("c:minor").n()  // backward: 0, 3, 2, 1""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("bd sd ht lt").chunkBack(4, x => x.gain(0.1))  // one hit less gain, cycling back""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "chunkBack",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "n", type = kt10),
                    KlangParam(name = "transform", type = kt5),
                ),
                returnType = kt2,
                description = """Like [chunk] on a string-parsed pattern, but cycles backward through parts.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """"bd sd ht lt".chunkBack(4, x => x.gain(0.1)).s()  // one hit less gain, cycling back""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    )
)

private fun generatedSprudelDocsChunk6() = mapOf(

    "chunkBackInto" to KlangSymbol(
        name = "chunkBackInto",
        category = "structural",
        tags = listOf("chunk", "slice", "backward", "transform", "cycle"),
        aliases = listOf("chunkbackinto"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "chunkBackInto",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "n", type = kt10, description = """Number of chunks to divide the pattern into."""),
                    KlangParam(name = "transform", type = kt5, description = """Function applied to the currently active chunk."""),
                ),
                returnType = kt2,
                description = """Divides a pattern into `n` chunks and applies a transform to the active chunk, cycling backwards.

 Like [chunkInto], but advances through chunks in reverse order each cycle.""",
                returnDoc = """A new pattern with the transform cycling backwards through chunks.""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd ht lt").chunkBackInto(4, x => x.hurry(2))  // transform cycles backward""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c d e f g h").chunkBackInto(3, x => x.transpose(7))  // 3 chunks, reversed order""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "chunkBackInto",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "n", type = kt10),
                    KlangParam(name = "transform", type = kt5),
                ),
                returnType = kt2,
                description = """Like [chunkBackInto] applied to a mini-notation string.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "chunkInto" to KlangSymbol(
        name = "chunkInto",
        category = "structural",
        tags = listOf("chunkInto", "chunk", "cycle", "transform", "fast", "slice"),
        aliases = listOf("chunkinto"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "chunkInto",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "n", type = kt10, description = """Number of chunks to divide the pattern into."""),
                    KlangParam(name = "transform", type = kt5, description = """Function applied to the active chunk each cycle."""),
                ),
                returnType = kt2,
                description = """Like [chunk], but applies [transform] to a fast-looped subcycle instead of repeating the pattern `n` times.

 Equivalent to `fastChunk` — the source pattern plays at its natural speed while the transformed
 chunk cycles through the `n` parts independently each cycle.""",
                returnDoc = """A pattern at natural speed with the transform cycling through chunks.""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd ht lt").chunkInto(4, x => x.hurry(2))  // transform cycles, no repeat""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c d e f g h").chunkInto(3, x => x.transpose(7))  // 3 chunks, each transposed""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "chunkInto",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "n", type = kt10),
                    KlangParam(name = "transform", type = kt5),
                ),
                returnType = kt2,
                description = """Like [chunkInto] applied to a mini-notation string.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "chunkback" to KlangSymbol(
        name = "chunkback",
        category = "structural",
        tags = listOf("chunk", "cycle", "transform", "reverse", "rotate"),
        aliases = listOf("chunkBack"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "chunkback",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "n", type = kt10, description = """Number of chunks."""),
                    KlangParam(name = "transform", type = kt5, description = """Function applied to the active chunk each cycle."""),
                ),
                returnType = kt2,
                description = """Alias for [chunkBack] — cycles backward through transformed chunks.""",
                returnDoc = """Pattern cycling backward through transformed chunks.""",
                samples = listOf(
                    KlangCodeSample(code = """seq("0 1 2 3").chunkback(4, x => x.add(7))  // backward: 0, 3, 2, 1""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("bd sd ht lt").chunkback(4, x => x.gain(0.1))  // one hit less gain, cycling back""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "chunkback",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "n", type = kt10),
                    KlangParam(name = "transform", type = kt5),
                ),
                returnType = kt2,
                description = """Alias for [chunkBack] on a string-parsed pattern.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """"bd sd ht lt".chunkback(4, x => x.gain(0.8)).s()  // one hit boosted, cycling back""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "chunkbackinto" to KlangSymbol(
        name = "chunkbackinto",
        category = "structural",
        tags = listOf("chunk", "slice", "backward", "transform", "cycle"),
        aliases = listOf("chunkBackInto"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "chunkbackinto",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "n", type = kt10, description = """Number of chunks to divide the pattern into."""),
                    KlangParam(name = "transform", type = kt5, description = """Function applied to the currently active chunk."""),
                ),
                returnType = kt2,
                description = """Alias for [chunkBackInto] — divides the pattern into `n` chunks, applying a transform cycling backwards.""",
                returnDoc = """A new pattern with the transform cycling backwards through chunks.""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd ht lt").chunkbackinto(4, x => x.hurry(2))  // backwards chunk transform""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c d e f").chunkbackinto(4, x => x.rev())  // reversed active chunk""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "chunkbackinto",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "n", type = kt10),
                    KlangParam(name = "transform", type = kt5),
                ),
                returnType = kt2,
                description = """Alias for [chunkBackInto].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "chunkinto" to KlangSymbol(
        name = "chunkinto",
        category = "structural",
        tags = listOf("chunkinto", "chunkInto", "chunk", "cycle", "transform", "fast", "slice"),
        aliases = listOf("chunkInto"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "chunkinto",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "n", type = kt10, description = """Number of chunks to divide the pattern into."""),
                    KlangParam(name = "transform", type = kt5, description = """Function applied to the active chunk each cycle."""),
                ),
                returnType = kt2,
                description = """Alias for [chunkInto] — applies [transform] to a fast-looped subcycle.""",
                returnDoc = """A pattern at natural speed with the transform cycling through chunks.""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd ht lt").chunkinto(4, x => x.hurry(2))  // lowercase alias""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c d e f").chunkinto(4, x => x.rev())  // reversed active chunk""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "chunkinto",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "n", type = kt10),
                    KlangParam(name = "transform", type = kt5),
                ),
                returnType = kt2,
                description = """Alias for [chunkInto].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "clamp" to KlangSymbol(
        name = "clamp",
        category = "arithmetic",
        tags = listOf("clamp", "clip", "limit", "bounds", "range", "min", "max", "arithmetic", "value"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "clamp",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "min", type = kt7, description = """The lower bound. May be a number, string mini-notation, or a [SprudelPattern]."""),
                    KlangParam(name = "max", type = kt7, description = """The upper bound. May be a number, string mini-notation, or a [SprudelPattern]."""),
                ),
                returnType = kt2,
                description = """Clamps each event's numeric value into the inclusive range `[min, max]`.

 Values below [min] become [min]; values above [max] become [max]. Useful for confining
 modulation to a safe range. Supports control patterns: both [min] and [max] may be
 mini-notation strings or other [SprudelPattern]s to vary the bounds over time.

 Behaviour with `min > max` is undefined — the engine does not swap or validate bounds.""",
                returnDoc = """A new pattern with each numeric value clamped to `[min, max]`.""",
                samples = listOf(
                    KlangCodeSample(code = """seq("-1 0 0.5 1 2").clamp(0, 1)   // becomes: 0 0 0.5 1 1""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """sine.range(-1, 2).clamp("<0 -0.5>", 1)   // alternate lower bound each cycle""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "clamp",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "min", type = kt7),
                    KlangParam(name = "max", type = kt7),
                ),
                returnType = kt2,
                description = """Clamps each numeric value of a string pattern into `[min, max]`.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """"-1 0 0.5 1 2".clamp(0, 1)   // becomes: 0 0 0.5 1 1""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "clamp",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "min", type = kt7),
                    KlangParam(name = "max", type = kt7),
                ),
                returnType = kt5,
                description = """Chains a `clamp` onto this [PatternMapperFn], clamping every numeric value to `[min, max]`.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """seq("0 1 2 3").apply(mul(2).clamp(1, 4))  // clamp(0*2,1,4)=1, clamp(1*2,1,4)=2, ...""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "clamp",
                params = listOf(
                    KlangParam(name = "min", type = kt7),
                    KlangParam(name = "max", type = kt7),
                ),
                returnType = kt5,
                description = """Creates a [PatternMapperFn] that clamps each numeric value into `[min, max]`.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """seq("-1 0 0.5 1 2").apply(clamp(0, 1))   // becomes: 0 0 0.5 1 1""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "clip" to KlangSymbol(
        name = "clip",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "clip",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "amount", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt2,
                description = """Alias for [legato] on this pattern. Sets the duration scaling factor.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "clip",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "amount", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt2,
                description = """Alias for [legato] on a string pattern.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "clip",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "amount", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt5,
                description = """Chains a clip operation onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "coarse" to KlangSymbol(
        name = "coarse",
        category = "effects",
        tags = listOf("coarse", "factor"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "coarse",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "factor", type = kt6, isOptional = true, defaultDoc = """null""", description = """Sample rate divisor, 1 is off, higher is coarser."""),
                ),
                returnType = kt2,
                description = """Sample rate reduction, a decimator, per voice.

 The divisor throws away samples: 1 is off, 4 runs the voice at a quarter of the rate.

 The slot is patternable; a named slot takes a mapper (`coarse(factor = mul(2))`), and it reads back as
 `coarse.factor`. With no argument at all, the pattern's own values are reinterpreted as `factor`.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """s("hh*8").coarse(4).coarse(factor = mul(perlin.seg(8).range(1, 3)))   // a decimator that wanders""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("hh*4").coarse("2 8").lpf(coarse.factor.mul(1000))                    // coarser, but brighter""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "coarse",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "factor", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern, then applies [coarse].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "coarse",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "factor", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt5,
                description = """Chains a [coarse] step onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    )
)

private fun generatedSprudelDocsChunk7() = mapOf(

    "comp" to KlangSymbol(
        name = "comp",
        category = "dynamics",
        tags = listOf("comp", "compressor"),
        aliases = listOf(),
        scope = KlangScope.ORBIT,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "comp",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "threshold", type = kt6, isOptional = true, defaultDoc = """null""", uitools = listOf("SprudelCompressorEditor", "SprudelCompressorSequenceEditor")),
                    KlangParam(name = "ratio", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "knee", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "release", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt2,
                description = """`comp`, the short name of [compressor]: the same door, use whichever reads better.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd hh sd").comp(-20, 4, 6, 0.003, 0.1)""", type = KlangCodeSampleType.PLAYABLE)
                ),
                uitools = listOf("SprudelCompressorEditor"),
                library = "sprudel"
            ),
            KlangCallable(
                name = "comp",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "threshold", type = kt6, isOptional = true, defaultDoc = """null""", uitools = listOf("SprudelCompressorEditor", "SprudelCompressorSequenceEditor")),
                    KlangParam(name = "ratio", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "knee", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "release", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern, then applies [comp].""",
                returnDoc = """""",
                samples = emptyList(),
                uitools = listOf("SprudelCompressorEditor"),
                library = "sprudel"
            ),
            KlangCallable(
                name = "comp",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "threshold", type = kt6, isOptional = true, defaultDoc = """null""", uitools = listOf("SprudelCompressorEditor", "SprudelCompressorSequenceEditor")),
                    KlangParam(name = "ratio", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "knee", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "release", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt5,
                description = """Chains a [comp] step onto this [PatternMapperFn] (see [SprudelPattern.comp]).""",
                returnDoc = """""",
                samples = emptyList(),
                uitools = listOf("SprudelCompressorEditor"),
                library = "sprudel"
            )
        )
    ),

    "compress" to KlangSymbol(
        name = "compress",
        category = "tempo",
        tags = listOf("compress", "squeeze", "timespan", "gap", "range"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "compress",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "start", type = kt7, description = """Beginning of the time window as a cycle fraction. Default: 0. Range: 0–1."""),
                    KlangParam(name = "end", type = kt7, description = """End of the time window as a cycle fraction. Default: 1. Range: 0–1. Must be greater than start."""),
                ),
                returnType = kt2,
                description = """Compresses the pattern into a sub-range of each cycle, leaving silence outside that range.

 `compress(start, end)` squeezes the full pattern into the window `[start, end]` within
 each cycle and leaves a gap everywhere else. Both values are in the range 0–1.""",
                returnDoc = """A pattern compressed into `[start, end]` with silence elsewhere.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c d e f").compress(0, 0.5)        // all 4 events fit into first half of each cycle""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("bd sd").compress(0.25, 0.75)         // pattern compressed into middle 50% of each cycle""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "compress",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "start", type = kt7),
                    KlangParam(name = "end", type = kt7),
                ),
                returnType = kt2,
                description = """Compresses the pattern into `[start, end]` within each cycle, leaving silence outside.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "compress",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "start", type = kt7),
                    KlangParam(name = "end", type = kt7),
                ),
                returnType = kt5,
                description = """Chains a compress operation onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "compress",
                params = listOf(
                    KlangParam(name = "start", type = kt7, description = """Beginning of the time window as a cycle fraction. Range: 0–1."""),
                    KlangParam(name = "end", type = kt7, description = """End of the time window as a cycle fraction. Range: 0–1."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that compresses a pattern into `[start, end]` per cycle.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c d e f").apply(compress(0, 0.5))  // mapper form""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "compressor" to KlangSymbol(
        name = "compressor",
        category = "dynamics",
        tags = listOf("compressor", "threshold", "ratio", "knee", "attack", "release"),
        aliases = listOf(),
        scope = KlangScope.ORBIT,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "compressor",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "threshold", type = kt6, isOptional = true, defaultDoc = """null""", description = """Level in dB where compression starts, such as -20.""", uitools = listOf("SprudelCompressorEditor", "SprudelCompressorSequenceEditor")),
                    KlangParam(name = "ratio", type = kt6, isOptional = true, defaultDoc = """null""", description = """Compression ratio. 4 means 4:1 above the threshold."""),
                    KlangParam(name = "knee", type = kt6, isOptional = true, defaultDoc = """null""", description = """Knee width in dB. 0 is hard, 6 and above soft."""),
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null""", description = """Attack in seconds."""),
                    KlangParam(name = "release", type = kt6, isOptional = true, defaultDoc = """null""", description = """Release in seconds."""),
                ),
                returnType = kt2,
                description = """The orbit compressor: threshold, ratio, knee, attack and release.

 Levels above the threshold are turned down by the ratio, the knee softens the onset, and attack
 and release set how fast it moves.

 One compressor per orbit bus, so it hears the whole orbit summed
 and its settings come from the orbit's owning voice. That is what makes it a drum-bus compressor
 rather than a per-note one: give a pattern its own orbit to compress it on its own.

 The call sets every slot: the ones you leave out take the shared defaults, threshold -20 dB,
 ratio 4:1, knee 6 dB, attack 3 ms and release 100 ms, unless an earlier call already set them. So
 `compressor(ratio = 8)` is a working compressor at -20 dB, and `compressor.threshold` reads -20
 after it. Any of the five switches the stage on, because a compressor has no on-knob. Slots apply
 in order, threshold first, so a mapper on a later slot sees a default an earlier slot of the same
 call filled in (`compressor(-15, ratio = mul(2))` is ratio 8).

 Every slot is independent and patternable; an omitted slot keeps its value, a named slot takes
 a mapper (`compressor(ratio = mul(2))`), and the numeric slots read back as `compressor.threshold`, `compressor.ratio`, `compressor.knee`, `compressor.attack`, `compressor.release`.
 With no argument at all, the pattern's own values are reinterpreted as `threshold`.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd hh sd").compressor(-20, 4, 6, 0.003, 0.1)                     // a firm hand on the drum bus""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("bd sd hh sd").compressor(-20, 4).compressor(ratio = mul("<1 2>"))   // twice the ratio every other bar""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("bd sd hh sd").compressor(-20, 4).gain(compressor.threshold.mul(-0.02).add(1))       // make-up gain from the threshold""", type = KlangCodeSampleType.PLAYABLE)
                ),
                uitools = listOf("SprudelCompressorEditor"),
                library = "sprudel"
            ),
            KlangCallable(
                name = "compressor",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "threshold", type = kt6, isOptional = true, defaultDoc = """null""", uitools = listOf("SprudelCompressorEditor", "SprudelCompressorSequenceEditor")),
                    KlangParam(name = "ratio", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "knee", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "release", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern, then applies [compressor].""",
                returnDoc = """""",
                samples = emptyList(),
                uitools = listOf("SprudelCompressorEditor"),
                library = "sprudel"
            ),
            KlangCallable(
                name = "compressor",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "threshold", type = kt6, isOptional = true, defaultDoc = """null""", uitools = listOf("SprudelCompressorEditor", "SprudelCompressorSequenceEditor")),
                    KlangParam(name = "ratio", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "knee", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "release", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt5,
                description = """Chains a [compressor] step onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                uitools = listOf("SprudelCompressorEditor"),
                library = "sprudel"
            )
        )
    ),

    "crush" to KlangSymbol(
        name = "crush",
        category = "effects",
        tags = listOf("crush", "bits"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "crush",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "bits", type = kt6, isOptional = true, defaultDoc = """null""", description = """Bit depth. Fewer bits are harsher, typically 1 to 16."""),
                ),
                returnType = kt2,
                description = """Bit crusher: the bit depth, per voice.

 Fewer bits means a coarser, grittier signal.

 The slot is patternable; a named slot takes a mapper (`crush(bits = mul(2))`), and it reads back as `crush.bits`.
 With no argument at all, the pattern's own values are reinterpreted as `bits`.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd*4").crush(8).crush(bits = mul("1 0.5 1 0.5"))                  // every second hit coarser""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("hh*4").crush("4 12").lpf(crush.bits.mul(500))                      // fewer bits, darker""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "crush",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "bits", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern, then applies [crush].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "crush",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "bits", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt5,
                description = """Chains a [crush] step onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "cull" to KlangSymbol(
        name = "cull",
        category = "dynamics",
        tags = listOf("cull", "voice", "silence", "release", "cpu"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "cull",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "seconds", type = kt6, isOptional = true, defaultDoc = """null""", description = """The window in seconds; the release must stay silent this long before the voice ends."""),
                ),
                returnType = kt2,
                description = """Sets the silence-culling window of each voice, in seconds.

 A voice normally renders until its scheduled release tail has run out, even after it has
 decayed to silence. With culling, once a voice is in its release and its output has stayed
 inaudible (under -100 dBFS) for [seconds], it ends there instead. The held part of the note
 is never culled, and neither is a voice that has not sounded yet, so a slow attack, a silent
 lead-in or a sample with leading silence is safe; reverb and delay tails live on
 the orbit and keep ringing. A RELEASE that goes silent and comes back is cut at its first
 gap: a voice with a `tremolo` is therefore never culled unless you set this door, and a sparse
 source inside an ignitor (`Ignitor.dust`, `Ignitor.crackle`) ringing through its release wants a wider
 window or [noCull].

 Every voice is culled with a 50 ms window by default; this door changes the window, [noCull]
 turns culling off for a voice. Accepts control patterns.""",
                returnDoc = """A pattern with the cull window assigned.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3 e3").sound("supersaw").adsr(0.01, 0.2, 0, 2).cull(0.2)   // a wider window before a tail is cut""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("hh*8").adsr(0.001, 0.1, 0.7, 2.0).cull(0.02)                    // short samples, long release: cull fast""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "cull",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "seconds", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern and sets its silence-culling window (see [cull]).""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "cull",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "seconds", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt5,
                description = """Chains a cull window onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "cut" to KlangSymbol(
        name = "cut",
        category = "sampling",
        tags = listOf("cut", "choke", "group", "hi-hat", "sample"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "cut",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "group", type = kt6, isOptional = true, defaultDoc = """null""", description = """Cut group number; 0 = no choke."""),
                ),
                returnType = kt2,
                description = """Assigns the sample to a cut group (choke group) by number.

 Samples in the same cut group cut each other off when a new sample in the group triggers.
 This is useful for hi-hats: an open hi-hat stops when the closed hi-hat hits. The choked
 sound fades out over 4 ms from the new sound's start instead of stopping dead, so the
 choke does not click. Group `0` means no choke.""",
                returnDoc = """A pattern with the cut group assigned.""",
                samples = listOf(
                    KlangCodeSample(code = """stack(s("hh*4").cut(1), s("~ oh ~").cut(1))  // open hh choked by closed hh""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("bd sd").cut("<0 1>")                        // alternate between no-cut and cut-group-1""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "cut",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "group", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt2,
                description = """Assigns the sample to a cut group (choke group) on a string pattern.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "cut",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "group", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt5,
                description = """Chains a cut onto this [PatternMapperFn]; assigns the sample to the given cut group.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "cylinder" to KlangSymbol(
        name = "cylinder",
        category = "dynamics",
        tags = listOf("cylinder", "orbit", "routing", "effects", "bus", "channel"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "cylinder",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "index", type = kt6, isOptional = true, defaultDoc = """null""", description = """The cylinder index to route events to."""),
                ),
                returnType = kt2,
                description = """Routes events to a specific audio output cylinder (alias for [orbit]).

 In the Klangmotor, a Cylinder is an independent parallel audio channel
 (called "orbit" in Strudel/Tidal Cycles). Each cylinder has its own effect pipeline (Katalyst).""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3 e3").cylinder(2).reverb(wet = 0.8, size = 4)  // melodic line on cylinder 2 with reverb""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "cylinder",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "index", type = kt6, isOptional = true, defaultDoc = """null""", description = """The cylinder index to route events to."""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern and routes it to the given audio output cylinder (alias for [orbit]).""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """"bd sd".cylinder(1).s()   // send drums to cylinder 1""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "cylinder",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "index", type = kt6, isOptional = true, defaultDoc = """null""", description = """The cylinder index to route events to."""),
                ),
                returnType = kt5,
                description = """Creates a chained [PatternMapperFn] that routes events to the given cylinder after the previous mapper
 (alias for [orbit]).""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd").apply(gain(0.8).cylinder(1))  // gain + cylinder chained""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "cylinder",
                params = listOf(
                    KlangParam(name = "index", type = kt6, isOptional = true, defaultDoc = """null""", description = """The cylinder index to route events to."""),
                ),
                returnType = kt5,
                description = """Creates a [PatternMapperFn] that routes events to the given audio output cylinder (alias for [orbit]).""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd").apply(cylinder(1))   // send drums to cylinder 1""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "d" to KlangSymbol(
        name = "d",
        category = "dynamics",
        tags = listOf("d", "density", "dust", "noise"),
        aliases = listOf("density"),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "d",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "amount", type = kt6, isOptional = true, defaultDoc = """null""", description = """Impulse rate for `dust`, 0 to 1."""),
                ),
                returnType = kt2,
                description = """Alias for [density]. Sets the impulse rate of the `dust` generator.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("a").s("dust").d(0.2)   // 40 impulses per second""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("a").s("dust").d("<0.1 0.6>")   // sparse, then busy""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "d",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "amount", type = kt6, isOptional = true, defaultDoc = """null""", description = """The oscillator density."""),
                ),
                returnType = kt2,
                description = """Alias for [density]. Parses this string as a pattern and sets the oscillator or noise density.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """"a".d(0.2).s("dust").note()   // 40 noise events per second""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "d",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "amount", type = kt6, isOptional = true, defaultDoc = """null""", description = """The oscillator density."""),
                ),
                returnType = kt5,
                description = """Alias for [density]. Creates a chained [PatternMapperFn] that sets the oscillator or noise density after the
 previous mapper.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("a").s("dust").apply(gain(0.8).d(0.5))  // gain + density chained""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    )
)

private fun generatedSprudelDocsChunk8() = mapOf(

    "degrade" to KlangSymbol(
        name = "degrade",
        category = "random",
        tags = listOf("degrade", "degradeBy", "random", "remove", "probability"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "degrade",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "prob", type = kt7, isOptional = true, defaultDoc = """0.5""", description = """Removal probability; defaults to `0.5`."""),
                ),
                returnType = kt2,
                description = """Randomly removes events with a 50% probability. Shorthand for `degradeBy(0.5)`.""",
                returnDoc = """A pattern with roughly half its events removed each cycle.""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd hh cp").degrade()          // ~half the events play per cycle""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "degrade",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "prob", type = kt7, isOptional = true, defaultDoc = """0.5"""),
                ),
                returnType = kt2,
                description = """Randomly removes events with a 50% probability. Shorthand for `degradeBy(0.5)`.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "degrade",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "prob", type = kt7, isOptional = true, defaultDoc = """0.5"""),
                ),
                returnType = kt5,
                description = """Chains a degrade onto this [PatternMapperFn] with the given probability (default 0.5).""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "degrade",
                params = listOf(
                    KlangParam(name = "prob", type = kt7, isOptional = true, defaultDoc = """0.5"""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that randomly removes events at the given probability (default 0.5).""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd hh cp").apply(degrade())   // ~half the events play via mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "degradeBy" to KlangSymbol(
        name = "degradeBy",
        category = "random",
        tags = listOf("degradeBy", "random", "remove", "probability", "drop"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "degradeBy",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "prob", type = kt7, description = """Removal probability in [0, 1]; 0 = keep all, 1 = remove all."""),
                ),
                returnType = kt2,
                description = """Randomly removes events from the pattern with the given probability.

 `degradeBy(x)` keeps each event with probability `(1 - x)`. At `0` nothing is removed;
 at `1` every event is removed. The randomness is deterministic per cycle (seeded).""",
                returnDoc = """A pattern with events randomly removed at the given probability.""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd hh cp").degradeBy(0.3)     // ~30% of hits are silenced randomly""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c d e f").degradeBy(0.5)      // roughly half the notes play each cycle""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "degradeBy",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "prob", type = kt7),
                ),
                returnType = kt2,
                description = """Randomly removes events with the given probability (0 = none removed, 1 = all removed).""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "degradeBy",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "prob", type = kt7),
                ),
                returnType = kt5,
                description = """Chains a degradeBy onto this [PatternMapperFn]; randomly removes events at the given probability.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "degradeBy",
                params = listOf(
                    KlangParam(name = "prob", type = kt7, description = """Removal probability in [0, 1]."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that randomly removes events with the given probability.""",
                returnDoc = """A [PatternMapperFn] that drops events randomly at the given probability.""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd hh cp").apply(degradeBy(0.3))     // ~30% of hits silenced via mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "degradeByWith" to KlangSymbol(
        name = "degradeByWith",
        category = "random",
        tags = listOf("degradeByWith", "random", "remove", "custom", "probability"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "degradeByWith",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "withPat", type = kt7, description = """Custom random-value pattern (values in [0, 1])."""),
                    KlangParam(name = "prob", type = kt7, description = """Threshold; event kept when `withPat > prob`."""),
                ),
                returnType = kt2,
                description = """Randomly removes events using a custom random-value pattern as the randomness source.

 `degradeByWith(withPat, x)` keeps an event when `withPat > x` at that point in time.
 By supplying your own randomness source (e.g. `rand.segment(1)` for cycle-level decisions)
 you can control exactly how the randomness is sampled.""",
                returnDoc = """A pattern with events removed where the custom source falls below the threshold.""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd*8").degradeByWith(rand.segment(1), 0.5)   // whole cycle either plays or drops""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("hh*16").degradeByWith(sine.range(0, 1), 0.5) // sine-wave controlled removal""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "degradeByWith",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "withPat", type = kt7),
                    KlangParam(name = "prob", type = kt7),
                ),
                returnType = kt2,
                description = """Randomly removes events using a custom random-value pattern as the randomness source.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "degradeByWith",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "withPat", type = kt7),
                    KlangParam(name = "prob", type = kt7),
                ),
                returnType = kt5,
                description = """Chains a degradeByWith onto this [PatternMapperFn] using a custom randomness source.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "degradeByWith",
                params = listOf(
                    KlangParam(name = "withPat", type = kt7, description = """Custom random-value pattern (values in [0, 1])."""),
                    KlangParam(name = "prob", type = kt7, description = """Threshold; event kept when `withPat > prob`."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that removes events using a custom random-value pattern.""",
                returnDoc = """A [PatternMapperFn] that filters events via the custom randomness source.""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd*8").apply(degradeByWith(rand.segment(1), 0.5))  // cycle-level drops via mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "delay" to KlangSymbol(
        name = "delay",
        category = "effects",
        tags = listOf("delay", "wet", "time", "feedback", "cap"),
        aliases = listOf(),
        scope = KlangScope.ORBIT,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "delay",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "wet", type = kt6, isOptional = true, defaultDoc = """null""", description = """How much of the orbit goes into the delay, 0 to 1, default 0.25. Orbit-wide.""", uitools = listOf("SprudelDelayEditor", "SprudelDelaySequenceEditor")),
                    KlangParam(name = "time", type = kt6, isOptional = true, defaultDoc = """null""", description = """Delay time in seconds, default 0.25. Orbit-wide.""", uitools = listOf("SprudelDelayTimeEditor", "SprudelDelayTimeSequenceEditor")),
                    KlangParam(name = "feedback", type = kt6, isOptional = true, defaultDoc = """null""", description = """Feedback, 0 to 1, default 0.3. Above 1 builds up. Orbit-wide.""", uitools = listOf("SprudelDelayFeedbackEditor", "SprudelDelayFeedbackSequenceEditor")),
                    KlangParam(name = "cap", type = kt6, isOptional = true, defaultDoc = """null""", description = """Ceiling the repeats may not exceed, default 1. Orbit-wide."""),
                ),
                returnType = kt2,
                description = """The orbit delay: how much of the orbit is echoed, the time, the feedback and the feedback cap.

 One delay per orbit bus, and all four are set once for everyone by
 the orbit's owning voice. `wet` is how much of the orbit goes into the delay: the echoes are
 added on top of the dry sound, and every voice on the orbit is echoed alike. So a pattern that
 should stay dry, or echo by a different amount, goes on an orbit of its own. When another pattern
 with a delay takes the orbit over, `wet` and `feedback` move smoothly to its values, and a new
 time crossfades to the new echo; a pattern without one switches the delay off: its feed fades
 out over 50 ms and the echoes already sent ring out.

 The call sets every slot: the ones you leave out take the same default as on the master delay,
 wet 0.25, time 0.25 s, feedback 0.3 and cap 1, unless an earlier call already set them. So a bare
 `delay(0.4)` already echoes a quarter second later, and `delay.time` reads 0.25 after it. Slots
 apply in order, wet first, so a mapper on a later slot sees a default an earlier slot of the same
 call filled in. A call whose only slot rests in its control pattern writes nothing on that event,
 and fills nothing.

 Every slot is independent and patternable; an omitted slot keeps its value, a named slot takes
 a mapper (`delay(time = mul(2))`), and the numeric slots read back as `delay.wet`, `delay.time`, `delay.feedback`, `delay.cap`.
 With no argument at all, the pattern's own values are reinterpreted as `wet`.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """s("hh*4").delay(0.3, 0.25, 0.4)                                        // wet, time, feedback""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """stack(s("hh ~ hh ~").delay(0.3, 0.25), s("~ hh ~ hh").orbit(1))        // delay on every other hat only""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("sd sd").delay("<0.1 0.4>", 0.25).reverb(wet = delay.wet, size = 4)     // as much reverb as delay""", type = KlangCodeSampleType.PLAYABLE)
                ),
                uitools = listOf("SprudelDelayEditor"),
                library = "sprudel"
            ),
            KlangCallable(
                name = "delay",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "wet", type = kt6, isOptional = true, defaultDoc = """null""", uitools = listOf("SprudelDelayEditor", "SprudelDelaySequenceEditor")),
                    KlangParam(name = "time", type = kt6, isOptional = true, defaultDoc = """null""", uitools = listOf("SprudelDelayTimeEditor", "SprudelDelayTimeSequenceEditor")),
                    KlangParam(name = "feedback", type = kt6, isOptional = true, defaultDoc = """null""", uitools = listOf("SprudelDelayFeedbackEditor", "SprudelDelayFeedbackSequenceEditor")),
                    KlangParam(name = "cap", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern, then applies [delay].""",
                returnDoc = """""",
                samples = emptyList(),
                uitools = listOf("SprudelDelayEditor"),
                library = "sprudel"
            ),
            KlangCallable(
                name = "delay",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "wet", type = kt6, isOptional = true, defaultDoc = """null""", uitools = listOf("SprudelDelayEditor", "SprudelDelaySequenceEditor")),
                    KlangParam(name = "time", type = kt6, isOptional = true, defaultDoc = """null""", uitools = listOf("SprudelDelayTimeEditor", "SprudelDelayTimeSequenceEditor")),
                    KlangParam(name = "feedback", type = kt6, isOptional = true, defaultDoc = """null""", uitools = listOf("SprudelDelayFeedbackEditor", "SprudelDelayFeedbackSequenceEditor")),
                    KlangParam(name = "cap", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt5,
                description = """Chains a [delay] step onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                uitools = listOf("SprudelDelayEditor"),
                library = "sprudel"
            )
        )
    ),

    "density" to KlangSymbol(
        name = "density",
        category = "dynamics",
        tags = listOf("density", "d", "dust", "noise"),
        aliases = listOf("d"),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "density",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "amount", type = kt6, isOptional = true, defaultDoc = """null""", description = """Impulse rate for `dust`, 0 to 1."""),
                ),
                returnType = kt2,
                description = """Sets the impulse rate of the `dust` generator.

 The value is 0 to 1 and scales a 200 per second ceiling, so 0.2 is 40 impulses per second.

 `dust` is the only generator that reads it: the super oscillators take `voices`, `spread` and
 `analog`, so reach for `spread` to tighten a supersaw, and `crackle` is driven by `chaos`.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("a").s("dust").density(0.2)   // 40 impulses per second""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("a").s("dust").density("<0.1 0.6>")   // sparse, then busy""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "density",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "amount", type = kt6, isOptional = true, defaultDoc = """null""", description = """The oscillator density."""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern and sets the oscillator or noise density.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """"a".density(0.2).s("dust").note()   // 40 noise events per second""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "density",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "amount", type = kt6, isOptional = true, defaultDoc = """null""", description = """The oscillator density."""),
                ),
                returnType = kt5,
                description = """Creates a chained [PatternMapperFn] that sets the oscillator or noise density after the previous mapper.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("a").s("dust").apply(gain(0.8).density(0.5))  // gain + density chained""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "densityGap" to KlangSymbol(
        name = "densityGap",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "densityGap",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "factor", type = kt7),
                ),
                returnType = kt2,
                description = """Alias for [fastGap].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "densityGap",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "factor", type = kt7),
                ),
                returnType = kt2,
                description = """Alias for [fastGap].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "densityGap",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "factor", type = kt7),
                ),
                returnType = kt5,
                description = """Alias for [PatternMapperFn.fastGap].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "densityGap",
                params = listOf(
                    KlangParam(name = "factor", type = kt7),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that is an alias for [fastGap].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "distort" to KlangSymbol(
        name = "distort",
        category = "effects",
        tags = listOf("distort", "amount", "shape"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "distort",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "amount", type = kt6, isOptional = true, defaultDoc = """null""", description = """Drive, 0 is clean, 1 is heavy. Higher is allowed.""", uitools = listOf("SprudelDistortEditor", "SprudelDistortSequenceEditor")),
                    KlangParam(name = "shape", type = kt6, isOptional = true, defaultDoc = """null""", description = """Transfer curve by name, for example `tube`.""", uitools = listOf("SprudelDistortShapeEditor", "SprudelDistortShapeSequenceEditor")),
                ),
                returnType = kt2,
                description = """Waveshaper distortion: drive and shape, per voice.

 This is not a bus effect. Unlike reverb and delay, distortion runs inside each voice's own chain,
 so two voices sharing an orbit can be driven differently.

 `shape` picks the transfer curve. Symmetric and soft: `soft` (tanh), `gentle`, `softsat`,
 `cubic`, `exp`, `sineshaper`. Symmetric and hard, plus wavefolding: `hard`, `zerosquare`,
 `chebyshev`, `fold`, `linearfold`. Asymmetric, so with even harmonics: `diode`, `tube`, `asym`,
 `stompbox`, `rectify`. It runs at the voice's base rate, so a hard drive keeps some aliased grit.

 Every slot is independent and patternable; an omitted slot keeps its value, a named slot takes
 a mapper (`distort(amount = mul(2))`), and the numeric slot reads back as `distort.amount`.
 With no argument at all, the pattern's own values are reinterpreted as `amount`.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd*4").distort(0.4).distort(amount = mul("1 2 1 2"))                // every second hit harder""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("bd*4").distort("0.2 0.8", "tube").pan(distort.amount)               // more drive, further right""", type = KlangCodeSampleType.PLAYABLE)
                ),
                uitools = listOf("SprudelDistortEditor"),
                library = "sprudel"
            ),
            KlangCallable(
                name = "distort",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "amount", type = kt6, isOptional = true, defaultDoc = """null""", uitools = listOf("SprudelDistortEditor", "SprudelDistortSequenceEditor")),
                    KlangParam(name = "shape", type = kt6, isOptional = true, defaultDoc = """null""", uitools = listOf("SprudelDistortShapeEditor", "SprudelDistortShapeSequenceEditor")),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern, then applies [distort].""",
                returnDoc = """""",
                samples = emptyList(),
                uitools = listOf("SprudelDistortEditor"),
                library = "sprudel"
            ),
            KlangCallable(
                name = "distort",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "amount", type = kt6, isOptional = true, defaultDoc = """null""", uitools = listOf("SprudelDistortEditor", "SprudelDistortSequenceEditor")),
                    KlangParam(name = "shape", type = kt6, isOptional = true, defaultDoc = """null""", uitools = listOf("SprudelDistortShapeEditor", "SprudelDistortShapeSequenceEditor")),
                ),
                returnType = kt5,
                description = """Chains a [distort] step onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                uitools = listOf("SprudelDistortEditor"),
                library = "sprudel"
            )
        )
    ),

    "div" to KlangSymbol(
        name = "div",
        category = "arithmetic",
        tags = listOf("div", "divide", "arithmetic", "math", "scale"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "div",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "divisor", type = kt7, description = """The divisor. May be a number, string mini-notation, or a [SprudelPattern]."""),
                ),
                returnType = kt2,
                description = """Divides every numeric value in the pattern by [divisor].

 Only the raw event `value` is affected — `note`, `soundIndex`, and all other voice properties
 remain unchanged. Supports control patterns: pass a mini-notation string or another
 [SprudelPattern] as [divisor] to modulate the division per cycle or event.""",
                returnDoc = """A new pattern with each numeric value divided by [divisor].""",
                samples = listOf(
                    KlangCodeSample(code = """seq("10 20").div(2).scale("c3:major").n()  // values become 5 and 10""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """seq("10 20").div("<1 2>").scale("c3:major").n()  // halve every other cycle""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "div",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "divisor", type = kt7, description = """The divisor. May be a number, string mini-notation, or a [SprudelPattern]."""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern, then divides every numeric value by [divisor].

 Only the raw event `value` is affected — `note`, `soundIndex`, and other voice properties
 remain unchanged.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """"10 20".div(2).scale("c3:major").n()  // values become 5 and 10""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "div",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "divisor", type = kt7, description = """The divisor. May be a number, string mini-notation, or a [SprudelPattern]."""),
                ),
                returnType = kt5,
                description = """Chains a division onto this [PatternMapperFn], dividing every numeric value by [divisor].""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """seq("10 20").apply(mul(2).div(4)).scale("c2:major").n()  // (10*2)/4=5, (20*2)/4=10""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "div",
                receiver = kt8,
                params = listOf(
                    KlangParam(name = "divisor", type = kt7, description = """The operand. May be a number, string mini-notation, or a [SprudelPattern]."""),
                ),
                returnType = kt5,
                description = """First step of a mapper chain on a field accessor: `freq.div(...)` reads the field, then divides by [divisor].""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c e g a").bpf(freq.div(2))""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "div",
                params = listOf(
                    KlangParam(name = "divisor", type = kt7, description = """The divisor. May be a number, string mini-notation, or a [SprudelPattern]."""),
                ),
                returnType = kt5,
                description = """Creates a [PatternMapperFn] that divides every numeric value in a pattern by [divisor].

 Only the raw event `value` is affected — `note`, `soundIndex`, and other voice properties
 remain unchanged. Use with [SprudelPattern.apply] to apply the division to an existing pattern.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """seq("10 20").apply(div(2)).scale("c3:major").n()  // values become 5 and 10""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    )
)

private fun generatedSprudelDocsChunk9() = mapOf(

    "drop" to KlangSymbol(
        name = "drop",
        category = "structural",
        tags = listOf("drop", "skip", "slice", "steps", "cycle"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "drop",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "n", type = kt7, description = """Number of steps to skip from the start (negative = skip from end)."""),
                ),
                returnType = kt2,
                description = """Skips the first `n` steps of this pattern and stretches the remainder to fill the cycle.

 Use a negative `n` to drop from the end instead.""",
                returnDoc = """A pattern with the first `n` steps removed, stretched to fill one cycle.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c d e f").drop(1)  // drops "c", plays "d e f" stretched""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("bd sd hh cp").drop(2)  // drops "bd sd", plays "hh cp" stretched""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "drop",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "n", type = kt7),
                ),
                returnType = kt2,
                description = """Skips the first `n` steps of this string pattern, stretched to fill the cycle.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "drop",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "n", type = kt7),
                ),
                returnType = kt5,
                description = """Chains a drop onto this [PatternMapperFn]; skips the first `n` steps.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "drop",
                params = listOf(
                    KlangParam(name = "n", type = kt7, description = """Number of steps to skip from the start."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that skips the first `n` steps of the source.""",
                returnDoc = """A [PatternMapperFn] that drops the first `n` steps of the source.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c d e f").apply(drop(1))  // via mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "duck" to KlangSymbol(
        name = "duck",
        category = "dynamics",
        tags = listOf("duck", "orbit", "depth", "attack"),
        aliases = listOf(),
        scope = KlangScope.ORBIT,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "duck",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "orbit", type = kt6, isOptional = true, defaultDoc = """null""", description = """Orbit index whose voices trigger the duck."""),
                    KlangParam(name = "depth", type = kt6, isOptional = true, defaultDoc = """null""", description = """Depth, 0 for none, 1 for full silence."""),
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null""", description = """Recovery time in seconds after the trigger stops."""),
                ),
                returnType = kt2,
                description = """Sidechain ducking: the orbit that triggers it, the depth and the recovery time.

 The pattern carrying `duck(...)` is ducked whenever the named orbit plays. The duck-down is
 instant, `attack` is the recovery.

 Ducking belongs to the orbit bus and runs after every orbit has been
 processed, so it ducks the whole orbit, set by its owning voice, not one note at a time.

 Every slot is independent and patternable; an omitted slot keeps its value, a named slot takes
 a mapper (`duck(depth = mul(2))`), and the numeric slots read back as `duck.orbit`, `duck.depth`, `duck.attack`.
 With no argument at all, the pattern's own values are reinterpreted as `orbit`.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """stack(s("bd*4").orbit(1), note("c2*8").s("saw").duck(1, 0.8, 0.2))          // the bass ducks under the kick""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """stack(s("bd*4").orbit(1), note("c2*8").s("saw").duck(1, 0.8).duck(depth = mul("<1 0.5>")))   // half as deep every other bar""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """stack(s("bd*4").orbit(1), note("c2*8").s("saw").duck(1, "0.3 0.9").gain(duck.depth))   // deeper duck, louder bass""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "duck",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "orbit", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "depth", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern, then applies [duck].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "duck",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "orbit", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "depth", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt5,
                description = """Chains a [duck] step onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "duty" to KlangSymbol(
        name = "duty",
        category = "tonal",
        tags = listOf("duty", "pulse", "square", "pwm", "oscillator"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "duty",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "width", type = kt6, isOptional = true, defaultDoc = """null""", description = """The share of each cycle the wave is high, 0 to 1. Default 0.5, a square."""),
                ),
                returnType = kt2,
                description = """Sets the pulse width / duty cycle of the pulse oscillator (`square` / `pulse` / `pulze`).

 `duty` is the fraction of each cycle the wave is high: `0.5` is a symmetric square, lower values give
 a narrower positive pulse, higher values a wider one. It can be modulated (PWM). Has no effect on
 non-pulse oscillators.""",
                returnDoc = """A new pattern with the duty cycle applied.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3 e3 g3").s("pulse").duty("<0.5 0.25 0.1>")   // PWM-style duty sweep""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "duty",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "width", type = kt6, isOptional = true, defaultDoc = """null""", description = """The share of each cycle the wave is high, 0 to 1 (default 0.5, a square)."""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern and sets the pulse duty cycle.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "duty",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "width", type = kt6, isOptional = true, defaultDoc = """null""", description = """The share of each cycle the wave is high, 0 to 1 (default 0.5, a square)."""),
                ),
                returnType = kt5,
                description = """Chains a duty-set onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "early" to KlangSymbol(
        name = "early",
        category = "tempo",
        tags = listOf("early", "shift", "time", "offset", "nudge", "ahead"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "early",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "amount", type = kt7, description = """Time shift in cycles. 0.5 = shift half a cycle earlier. Default: 0 (no shift). Typical range: 0–1."""),
                ),
                returnType = kt2,
                description = """Nudges the pattern to start earlier by the given number of cycles.

 Shifts all events backward in time by the specified amount. For example, `early(0.5)` moves
 every event half a cycle earlier so that what was at position 0.5 now appears at position 0.
 Useful for creating syncopation or aligning patterns that are slightly off-beat.""",
                returnDoc = """A pattern shifted earlier by the given number of cycles.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c d e f").early(0.25)         // shifts the pattern a quarter cycle earlier""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("bd sd").stack(s("hh*4").early(0.125))   // hi-hat slightly ahead of the beat""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "early",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "amount", type = kt7),
                ),
                returnType = kt2,
                description = """Nudges the pattern to start earlier by the given number of cycles.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "early",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "amount", type = kt7),
                ),
                returnType = kt5,
                description = """Chains an early operation onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "early",
                params = listOf(
                    KlangParam(name = "amount", type = kt7, description = """Time shift in cycles. Default: 0. Typical range: 0–1."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that nudges a pattern earlier by the given number of cycles.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """s("hh*4").apply(early(0.125))       // mapper form""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "earlyInCycle" to KlangSymbol(
        name = "earlyInCycle",
        category = "tempo",
        tags = listOf("earlyInCycle", "timing", "nudge", "offset"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "earlyInCycle",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "amount", type = kt7, description = """Fraction of a cycle to nudge events earlier. Positive values push events left."""),
                ),
                returnType = kt2,
                description = """Nudges events earlier within their cycle by the given fraction of a cycle.

 Only shifts events already within the queried time window — does not pull events
 from adjacent cycles. Complementary to [lateInCycle].""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd hh cp").earlyInCycle(0.02)                     // subtle early nudge""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("bd hh sd oh").earlyInCycle("<0 0.1 0.3 0.5>")        // cycle through nudge amounts""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "earlyInCycle",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "amount", type = kt7, description = """Fraction of a cycle to nudge events earlier."""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern and nudges events earlier within their cycle.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """"bd hh sd oh".earlyInCycle("<0 0.1 0.3 0.5>").s()       // cycle through nudge amounts""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "earlyInCycle",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "amount", type = kt7, description = """Fraction of a cycle to nudge events earlier."""),
                ),
                returnType = kt5,
                description = """Chains an early-nudge onto this [PatternMapperFn], shifting events earlier within their cycle.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd").apply(stretchBy(2).earlyInCycle(0.1))         // stretch then nudge early""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "earlyInCycle",
                params = listOf(
                    KlangParam(name = "amount", type = kt7, description = """Fraction of a cycle to nudge events earlier."""),
                ),
                returnType = kt5,
                description = """Creates a [PatternMapperFn] that nudges events earlier within their cycle.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd hh cp").apply(earlyInCycle(0.1))                // nudge via mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "echo" to KlangSymbol(
        name = "echo",
        category = "structural",
        tags = listOf("echo", "stut", "delay", "decay", "reverb", "effect"),
        aliases = listOf("stut"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "echo",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "times", type = kt10, description = """Number of layers including the original (must be ≥ 1)."""),
                    KlangParam(name = "delay", type = kt10, description = """Time offset per echo in cycles."""),
                    KlangParam(name = "decay", type = kt10, description = """Gain multiplier applied to each successive echo (0.0–1.0)."""),
                ),
                returnType = kt2,
                description = """Superimposes delayed and decayed copies of the pattern, creating an echo effect.

 Each copy is delayed by `delay × copy_number` cycles and its gain multiplied by `decay ^ copy_number`.
 The multiply is into each event's own gain, so `note("c3 e3").gain(0.9).echo(3, 0.125, 0.6)` gives
 the layers 0.9, 0.54 and 0.324; an event with no gain set counts as 1.0, so its layers are 1.0, 0.6 and 0.36.""",
                returnDoc = """A stacked pattern of the original plus decayed, delayed echoes.""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd").echo(3, 0.125, 0.7)  // original + 2 echoes, 0.125 cycles apart""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c e g").echo(4, 0.25, 0.5)  // 4 layers, quarter-cycle spacing, halving gain""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "echo",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "times", type = kt10, description = """Number of layers including the original (must be ≥ 1)."""),
                    KlangParam(name = "delay", type = kt10, description = """Time offset per echo in cycles."""),
                    KlangParam(name = "decay", type = kt10, description = """Gain multiplier applied to each successive echo (0.0–1.0)."""),
                ),
                returnType = kt2,
                description = """Like [echo] applied to a mini-notation string.""",
                returnDoc = """A stacked pattern of the original plus decayed, delayed echoes.""",
                samples = listOf(
                    KlangCodeSample(code = """"bd sd".echo(3, 0.125, 0.7).s()  // original + 2 echoes, 0.125 cycles apart""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "echo",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "times", type = kt10),
                    KlangParam(name = "delay", type = kt10),
                    KlangParam(name = "decay", type = kt10),
                ),
                returnType = kt5,
                description = """Chains an echo onto this [PatternMapperFn]; superimposes delayed and decayed copies of the result.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "echo",
                params = listOf(
                    KlangParam(name = "times", type = kt10, description = """Number of layers including the original (must be ≥ 1)."""),
                    KlangParam(name = "delay", type = kt10, description = """Time offset per echo in cycles."""),
                    KlangParam(name = "decay", type = kt10, description = """Gain multiplier applied to each successive echo (0.0–1.0)."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that superimposes delayed and decayed copies of the source pattern.""",
                returnDoc = """A [PatternMapperFn] that applies the echo effect to the source.""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd").apply(echo(3, 0.125, 0.7))  // via mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "echoWith" to KlangSymbol(
        name = "echoWith",
        category = "structural",
        tags = listOf("echoWith", "stutWith", "delay", "transform", "layers", "effect"),
        aliases = listOf("stutWith", "stutwith", "echowith"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "echoWith",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "times", type = kt10, description = """Number of layers including the original (must be ≥ 1)."""),
                    KlangParam(name = "delay", type = kt10, description = """Time offset per layer in cycles."""),
                    KlangParam(name = "transform", type = kt5, description = """Function applied cumulatively to each successive layer."""),
                ),
                returnType = kt2,
                description = """Superimposes versions of the pattern with a transform applied cumulatively to each layer.

 Unlike [echo], which simply decays gain, each layer receives the transform applied once more than
 the previous layer, creating a compounding effect.""",
                returnDoc = """A stacked pattern where each layer has the transform applied one more time.""",
                samples = listOf(
                    KlangCodeSample(code = """n("0").echoWith(4, 0.125, x => x.add(2))  // layers at n=0,2,4,6, each 0.125 apart""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("bd").echoWith(3, 0.25, x => x.fast(2))  // original + 2× and 4× faster copies""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "echoWith",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "times", type = kt10),
                    KlangParam(name = "delay", type = kt10),
                    KlangParam(name = "transform", type = kt5),
                ),
                returnType = kt2,
                description = """Like [echoWith] applied to a mini-notation string.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "echowith" to KlangSymbol(
        name = "echowith",
        category = "structural",
        tags = listOf("echowith", "echoWith", "stutWith", "delay", "transform", "layers"),
        aliases = listOf("echoWith", "stutWith", "stutwith"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "echowith",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "times", type = kt10, description = """Number of layers including the original."""),
                    KlangParam(name = "delay", type = kt10, description = """Time offset per layer in cycles."""),
                    KlangParam(name = "transform", type = kt5, description = """Function applied cumulatively to each successive layer."""),
                ),
                returnType = kt2,
                description = """Alias for [echoWith] — superimposes cumulatively-transformed layers.""",
                returnDoc = """A stacked pattern where each layer has the transform applied one more time.""",
                samples = listOf(
                    KlangCodeSample(code = """n("0").echowith(4, 0.125, x => x.add(2))  // lowercase alias""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("bd").echowith(3, 0.5, x => x.rev())  // each copy reversed""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "echowith",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "times", type = kt10),
                    KlangParam(name = "delay", type = kt10),
                    KlangParam(name = "transform", type = kt5),
                ),
                returnType = kt2,
                description = """Alias for [echoWith].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    )
)

private fun generatedSprudelDocsChunk10() = mapOf(

    "eish" to KlangSymbol(
        name = "eish",
        category = "structural",
        tags = listOf("eish", "euclidish", "euclid", "groove", "morph", "rhythm"),
        aliases = listOf("euclidish"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "eish",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "pulses", type = kt10, description = """Number of onsets (beats) to place."""),
                    KlangParam(name = "steps", type = kt10, description = """Total number of steps in the rhythm."""),
                    KlangParam(name = "groove", type = kt7, isOptional = true, defaultDoc = """0.0""", description = """Morph factor from 0 (strict) to 1 (even)."""),
                ),
                returnType = kt2,
                description = """Alias for [euclidish] — `euclid` variant with groove morphing.""",
                returnDoc = """A pattern with the morphed Euclidean rhythm applied.""",
                samples = listOf(
                    KlangCodeSample(code = """s("hh").eish(3, 8, 0.5)  // halfway between strict and even""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("bd").eish(5, 16, 1.0)  // completely even spacing""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "eish",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "pulses", type = kt10),
                    KlangParam(name = "steps", type = kt10),
                    KlangParam(name = "groove", type = kt7, isOptional = true, defaultDoc = """0.0"""),
                ),
                returnType = kt2,
                description = """Alias for [euclidish].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "eish",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "pulses", type = kt10),
                    KlangParam(name = "steps", type = kt10),
                    KlangParam(name = "groove", type = kt7, isOptional = true, defaultDoc = """0.0"""),
                ),
                returnType = kt5,
                description = """Chains an eish onto this [PatternMapperFn]; alias for [PatternMapperFn.euclidish].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "eish",
                params = listOf(
                    KlangParam(name = "pulses", type = kt10, description = """Number of onsets (beats) to place."""),
                    KlangParam(name = "steps", type = kt10, description = """Total number of steps in the rhythm."""),
                    KlangParam(name = "groove", type = kt7, isOptional = true, defaultDoc = """0.0""", description = """Morph factor from 0 (strict) to 1 (even)."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that is an alias for [euclidish] — applies morphed Euclidean rhythm.""",
                returnDoc = """A [PatternMapperFn] that restructures the source as a morphed Euclidean rhythm.""",
                samples = listOf(
                    KlangCodeSample(code = """s("hh").apply(eish(3, 8, 0.5))  // via mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "end" to KlangSymbol(
        name = "end",
        category = "sampling",
        tags = listOf("end", "stop", "sample", "position", "offset"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "end",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "pos", type = kt6, isOptional = true, defaultDoc = """null""", description = """End position in [0, 1]; 1 = end of sample."""),
                ),
                returnType = kt2,
                description = """Sets the sample end position as a fraction of the total sample length (0–1).

 `1` plays to the very end of the sample; `0` would end immediately (silence). Use with
 [begin] to play only a segment of a sample.""",
                returnDoc = """A pattern with the sample end position set.""",
                samples = listOf(
                    KlangCodeSample(code = """s("breaks").end(0.5)            // play only the first half of the sample""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("breaks").begin(0.25).end(0.75)  // play the middle 50% of the sample""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "end",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "pos", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt2,
                description = """Sets the sample end position (0–1) on a string pattern.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "end",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "pos", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt5,
                description = """Chains an end onto this [PatternMapperFn]; sets the sample end position (0–1).""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "eq" to KlangSymbol(
        name = "eq",
        category = "arithmetic",
        tags = listOf("eq", "equal", "equality", "comparison", "arithmetic"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "eq",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "other", type = kt7, description = """The value to compare against. May be a number, string mini-notation, or a [SprudelPattern]."""),
                ),
                returnType = kt2,
                description = """Compares every value in the pattern to [other] for strict equality, replacing each with
 `1` (true) if equal or `0` (false) otherwise.""",
                returnDoc = """A new pattern of `0`/`1` values.""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "eq",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "other", type = kt7),
                ),
                returnType = kt2,
                description = """""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "eq",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "other", type = kt7),
                ),
                returnType = kt5,
                description = """""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "eq",
                params = listOf(
                    KlangParam(name = "other", type = kt7),
                ),
                returnType = kt5,
                description = """""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "eqt" to KlangSymbol(
        name = "eqt",
        category = "arithmetic",
        tags = listOf("eqt", "truthiness", "equal", "comparison", "arithmetic"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "eqt",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "other", type = kt7, description = """The value to compare against. May be a number, string mini-notation, or a [SprudelPattern]."""),
                ),
                returnType = kt2,
                description = """Compares the truthiness of every value in the pattern to the truthiness of [other], replacing
 each with `1` (true) if both share the same truthiness, or `0` (false) otherwise.""",
                returnDoc = """A new pattern of `0`/`1` values.""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "eqt",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "other", type = kt7),
                ),
                returnType = kt2,
                description = """""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "eqt",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "other", type = kt7),
                ),
                returnType = kt5,
                description = """""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "eqt",
                params = listOf(
                    KlangParam(name = "other", type = kt7),
                ),
                returnType = kt5,
                description = """""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "euclid" to KlangSymbol(
        name = "euclid",
        category = "structural",
        tags = listOf("euclid", "rhythm", "euclidean", "structure", "pattern"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "euclid",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "pulses", type = kt10, description = """Number of onsets (beats) to place."""),
                    KlangParam(name = "steps", type = kt10, description = """Total number of steps in the rhythm."""),
                ),
                returnType = kt2,
                description = """Applies a Euclidean rhythm structure to the pattern.""",
                returnDoc = """A pattern with the Euclidean rhythm applied as structure.""",
                samples = listOf(
                    KlangCodeSample(code = """s("hh").euclid(3, 8)  // classic 3-over-8 Euclidean rhythm""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "euclid",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "pulses", type = kt10, description = """Number of onsets (beats) to place."""),
                    KlangParam(name = "steps", type = kt10, description = """Total number of steps in the rhythm."""),
                ),
                returnType = kt2,
                description = """Applies a Euclidean rhythm structure to the mini-notation string.""",
                returnDoc = """A pattern with the Euclidean rhythm applied as structure.""",
                samples = listOf(
                    KlangCodeSample(code = """"hh".euclid(3, 8).s()  // classic 3-over-8 Euclidean rhythm""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "euclid",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "pulses", type = kt10),
                    KlangParam(name = "steps", type = kt10),
                ),
                returnType = kt5,
                description = """Chains a euclid onto this [PatternMapperFn]; applies Euclidean rhythm structure to the result.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "euclid",
                params = listOf(
                    KlangParam(name = "pulses", type = kt10, description = """Number of onsets (beats) to place."""),
                    KlangParam(name = "steps", type = kt10, description = """Total number of steps in the rhythm."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that applies a Euclidean rhythm structure to the source pattern.""",
                returnDoc = """A [PatternMapperFn] that restructures the source as a Euclidean rhythm.""",
                samples = listOf(
                    KlangCodeSample(code = """s("hh").apply(euclid(3, 8))  // via mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "euclidLegato" to KlangSymbol(
        name = "euclidLegato",
        category = "structural",
        tags = listOf("euclidLegato", "euclid", "legato", "rhythm", "structure"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "euclidLegato",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "pulses", type = kt10, description = """Number of onsets (beats) to place."""),
                    KlangParam(name = "steps", type = kt10, description = """Total number of steps in the rhythm."""),
                ),
                returnType = kt2,
                description = """Like [euclid], but each pulse is held until the next pulse, so there are no gaps between notes.""",
                returnDoc = """A legato Euclidean rhythm pattern (no rests between onsets).""",
                samples = listOf(
                    KlangCodeSample(code = """s("hh").euclidLegato(3, 8)  // 3-over-8 legato (held notes)""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c").euclidLegato(5, 8)  // 5 legato notes across 8 steps""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "euclidLegato",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "pulses", type = kt10),
                    KlangParam(name = "steps", type = kt10),
                ),
                returnType = kt2,
                description = """Applies legato Euclidean structure to the mini-notation string.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "euclidLegato",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "pulses", type = kt10),
                    KlangParam(name = "steps", type = kt10),
                ),
                returnType = kt5,
                description = """Chains a euclidLegato onto this [PatternMapperFn]; applies legato Euclidean rhythm to the result.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "euclidLegato",
                params = listOf(
                    KlangParam(name = "pulses", type = kt10, description = """Number of onsets (beats) to place."""),
                    KlangParam(name = "steps", type = kt10, description = """Total number of steps in the rhythm."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that applies legato Euclidean rhythm structure to the source pattern.""",
                returnDoc = """A [PatternMapperFn] that restructures the source as a legato Euclidean rhythm.""",
                samples = listOf(
                    KlangCodeSample(code = """s("hh").apply(euclidLegato(3, 8))  // via mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "euclidLegatoRot" to KlangSymbol(
        name = "euclidLegatoRot",
        category = "structural",
        tags = listOf("euclidLegatoRot", "euclid", "legato", "rotation", "rhythm"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "euclidLegatoRot",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "pulses", type = kt10, description = """Number of onsets (beats) to place."""),
                    KlangParam(name = "steps", type = kt10, description = """Total number of steps in the rhythm."""),
                    KlangParam(name = "rotation", type = kt10, description = """Number of steps to rotate the pattern by."""),
                ),
                returnType = kt2,
                description = """Like [euclidLegato], but with rotation — each pulse is held until the next, with a step offset.""",
                returnDoc = """A legato Euclidean rhythm with rotation applied.""",
                samples = listOf(
                    KlangCodeSample(code = """s("hh").euclidLegatoRot(3, 8, 2)  // legato 3-over-8, rotated by 2""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c").euclidLegatoRot(5, 8, 1)  // legato 5-over-8, rotated by 1""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "euclidLegatoRot",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "pulses", type = kt10),
                    KlangParam(name = "steps", type = kt10),
                    KlangParam(name = "rotation", type = kt10),
                ),
                returnType = kt2,
                description = """Applies legato Euclidean structure with rotation to the mini-notation string.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "euclidLegatoRot",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "pulses", type = kt10),
                    KlangParam(name = "steps", type = kt10),
                    KlangParam(name = "rotation", type = kt10),
                ),
                returnType = kt5,
                description = """Chains a euclidLegatoRot onto this [PatternMapperFn]; applies rotated legato Euclidean rhythm to the result.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "euclidLegatoRot",
                params = listOf(
                    KlangParam(name = "pulses", type = kt10, description = """Number of onsets (beats) to place."""),
                    KlangParam(name = "steps", type = kt10, description = """Total number of steps in the rhythm."""),
                    KlangParam(name = "rotation", type = kt10, description = """Number of steps to rotate the pattern by."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that applies legato Euclidean rhythm with rotation to the source pattern.""",
                returnDoc = """A [PatternMapperFn] that restructures the source as a rotated legato Euclidean rhythm.""",
                samples = listOf(
                    KlangCodeSample(code = """s("hh").apply(euclidLegatoRot(3, 8, 2))  // via mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "euclidRot" to KlangSymbol(
        name = "euclidRot",
        category = "structural",
        tags = listOf("euclidRot", "euclid", "rhythm", "rotation", "structure"),
        aliases = listOf("euclidrot"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "euclidRot",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "pulses", type = kt10, description = """Number of onsets (beats) to place."""),
                    KlangParam(name = "steps", type = kt10, description = """Total number of steps in the rhythm."""),
                    KlangParam(name = "rotation", type = kt10, description = """Number of steps to rotate the pattern by."""),
                ),
                returnType = kt2,
                description = """Applies a rotated Euclidean rhythm structure to the pattern.""",
                returnDoc = """A rotated Euclidean rhythm pattern.""",
                samples = listOf(
                    KlangCodeSample(code = """s("hh").euclidRot(3, 8, 2)  // 3-over-8 rhythm, shifted by 2 steps""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "euclidRot",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "pulses", type = kt10, description = """Number of onsets (beats) to place."""),
                    KlangParam(name = "steps", type = kt10, description = """Total number of steps in the rhythm."""),
                    KlangParam(name = "rotation", type = kt10, description = """Number of steps to rotate the pattern by."""),
                ),
                returnType = kt2,
                description = """Applies a rotated Euclidean rhythm structure to the mini-notation string.""",
                returnDoc = """A rotated Euclidean rhythm pattern.""",
                samples = listOf(
                    KlangCodeSample(code = """"hh".euclidRot(3, 8, 2).s()  // 3-over-8 rhythm, shifted by 2 steps""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "euclidRot",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "pulses", type = kt10),
                    KlangParam(name = "steps", type = kt10),
                    KlangParam(name = "rotation", type = kt10),
                ),
                returnType = kt5,
                description = """Chains a euclidRot onto this [PatternMapperFn]; applies rotated Euclidean rhythm to the result.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "euclidRot",
                params = listOf(
                    KlangParam(name = "pulses", type = kt10, description = """Number of onsets (beats) to place."""),
                    KlangParam(name = "steps", type = kt10, description = """Total number of steps in the rhythm."""),
                    KlangParam(name = "rotation", type = kt10, description = """Number of steps to rotate the pattern by."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that applies a rotated Euclidean rhythm to the source pattern.""",
                returnDoc = """A [PatternMapperFn] that restructures the source as a rotated Euclidean rhythm.""",
                samples = listOf(
                    KlangCodeSample(code = """s("hh").apply(euclidRot(3, 8, 2))  // via mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    )
)

private fun generatedSprudelDocsChunk11() = mapOf(

    "euclidish" to KlangSymbol(
        name = "euclidish",
        category = "structural",
        tags = listOf("euclidish", "euclid", "groove", "morph", "rhythm"),
        aliases = listOf("eish"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "euclidish",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "pulses", type = kt10, description = """Number of onsets (beats) to place."""),
                    KlangParam(name = "steps", type = kt10, description = """Total number of steps in the rhythm."""),
                    KlangParam(name = "groove", type = kt7, isOptional = true, defaultDoc = """0.0""", description = """Morph factor from 0 (strict Euclidean) to 1 (completely even spacing)."""),
                ),
                returnType = kt2,
                description = """A `euclid` variant with a `groove` parameter that morphs the rhythm from strict (0) to even (1).""",
                returnDoc = """A pattern with the morphed Euclidean rhythm applied as structure.""",
                samples = listOf(
                    KlangCodeSample(code = """s("hh").euclidish(3, 8, 0.5)  // halfway between strict and even""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("bd").euclidish(5, 16, 0.0)  // same as euclid(5, 16)""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "euclidish",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "pulses", type = kt10),
                    KlangParam(name = "steps", type = kt10),
                    KlangParam(name = "groove", type = kt7, isOptional = true, defaultDoc = """0.0"""),
                ),
                returnType = kt2,
                description = """Applies morphed Euclidean structure to the mini-notation string.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "euclidish",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "pulses", type = kt10),
                    KlangParam(name = "steps", type = kt10),
                    KlangParam(name = "groove", type = kt7, isOptional = true, defaultDoc = """0.0"""),
                ),
                returnType = kt5,
                description = """Chains a euclidish onto this [PatternMapperFn]; applies morphed Euclidean rhythm to the result.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "euclidish",
                params = listOf(
                    KlangParam(name = "pulses", type = kt10, description = """Number of onsets (beats) to place."""),
                    KlangParam(name = "steps", type = kt10, description = """Total number of steps in the rhythm."""),
                    KlangParam(name = "groove", type = kt7, isOptional = true, defaultDoc = """0.0""", description = """Morph factor from 0 (strict Euclidean) to 1 (completely even spacing)."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that applies morphed Euclidean rhythm structure to the source pattern.""",
                returnDoc = """A [PatternMapperFn] that restructures the source as a morphed Euclidean rhythm.""",
                samples = listOf(
                    KlangCodeSample(code = """s("hh").apply(euclidish(3, 8, 0.5))  // via mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "euclidrot" to KlangSymbol(
        name = "euclidrot",
        category = "structural",
        tags = listOf("euclidrot", "euclidRot", "euclid", "rhythm", "rotation"),
        aliases = listOf("euclidRot"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "euclidrot",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "pulses", type = kt10, description = """Number of onsets (beats) to place."""),
                    KlangParam(name = "steps", type = kt10, description = """Total number of steps in the rhythm."""),
                    KlangParam(name = "rotation", type = kt10, description = """Number of steps to rotate the pattern by."""),
                ),
                returnType = kt2,
                description = """Alias for [euclidRot] applied to the pattern.""",
                returnDoc = """A rotated Euclidean rhythm pattern.""",
                samples = listOf(
                    KlangCodeSample(code = """s("hh").euclidrot(3, 8, 2).s()  // lowercase alias""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "euclidrot",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "pulses", type = kt10, description = """Number of onsets (beats) to place."""),
                    KlangParam(name = "steps", type = kt10, description = """Total number of steps in the rhythm."""),
                    KlangParam(name = "rotation", type = kt10, description = """Number of steps to rotate the pattern by."""),
                ),
                returnType = kt2,
                description = """Alias for [euclidRot] applied to the mini-notation string.""",
                returnDoc = """A rotated Euclidean rhythm pattern.""",
                samples = listOf(
                    KlangCodeSample(code = """"hh".euclidrot(3, 8, 2).s()  // lowercase alias""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "euclidrot",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "pulses", type = kt10),
                    KlangParam(name = "steps", type = kt10),
                    KlangParam(name = "rotation", type = kt10),
                ),
                returnType = kt5,
                description = """Chains a euclidrot onto this [PatternMapperFn]; alias for [PatternMapperFn.euclidRot].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "euclidrot",
                params = listOf(
                    KlangParam(name = "pulses", type = kt10, description = """Number of onsets (beats) to place."""),
                    KlangParam(name = "steps", type = kt10, description = """Total number of steps in the rhythm."""),
                    KlangParam(name = "rotation", type = kt10, description = """Number of steps to rotate the pattern by."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that is an alias for [euclidRot] — applies a rotated Euclidean rhythm.""",
                returnDoc = """A [PatternMapperFn] that restructures the source as a rotated Euclidean rhythm.""",
                samples = listOf(
                    KlangCodeSample(code = """s("hh").apply(euclidrot(3, 8, 2))  // via mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "every" to KlangSymbol(
        name = "every",
        category = "conditional",
        tags = listOf("every", "firstOf", "conditional", "cycle", "periodic", "transform"),
        aliases = listOf("firstOf"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "every",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "n", type = kt7, description = """How many cycles make one period. The transform fires on the first of these."""),
                    KlangParam(name = "transform", type = kt5, description = """The function to apply on the first cycle of each period."""),
                ),
                returnType = kt2,
                description = """Alias for [firstOf]. Applies [transform] on the **first** cycle of every [n] cycles.""",
                returnDoc = """A new pattern that applies [transform] periodically.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3 d3 e3 g3").every(4, x => x.rev())  // reverse every 4th cycle""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c3 d3 e3 g3").every("<2 4>", x => x.fast(2))  // alternating period""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "every",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "n", type = kt7, description = """How many cycles make one period. The transform fires on the first of these."""),
                    KlangParam(name = "transform", type = kt5, description = """The function to apply on the first cycle of each period."""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern, then applies [transform] on the first of every [n] cycles.""",
                returnDoc = """A new pattern that applies [transform] periodically.""",
                samples = listOf(
                    KlangCodeSample(code = """"c3 d3 e3 g3".every(4, x => x.rev()).note()  // reverse every 4th cycle""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "every",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "n", type = kt7, description = """How many cycles make one period. The transform fires on the first of these."""),
                    KlangParam(name = "transform", type = kt5, description = """The function to apply on the first cycle of each period."""),
                ),
                returnType = kt5,
                description = """Chains a periodic transform onto this [PatternMapperFn], applying [transform] on the first of every [n] cycles.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3 d3").apply(lastOf(4, x => x.rev()).every(2, x => x.fast(2)))  // alternate two transforms""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "every",
                params = listOf(
                    KlangParam(name = "n", type = kt7, description = """How many cycles make one period. The transform fires on the first of these."""),
                    KlangParam(name = "transform", type = kt5, description = """The function to apply on the first cycle of each period."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that applies [transform] on the **first** cycle of every [n] cycles.

 Use the returned mapper as a transform argument or apply it to a pattern via `.apply(...)`.""",
                returnDoc = """A [PatternMapperFn] that applies [transform] periodically.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3 d3 e3 g3").apply(every(4, x => x.rev()))  // reverse every 4th cycle""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c3 e3 g3").firstOf(3, every(2, x => x.fast(2)))  // nested periodic transforms""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "extend" to KlangSymbol(
        name = "extend",
        category = "structural",
        tags = listOf("extend", "fast", "speed", "tempo", "accelerate"),
        aliases = listOf("fast"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "extend",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "factor", type = kt7, description = """Speed-up factor. Values > 1 play faster; values < 1 play slower."""),
                ),
                returnType = kt2,
                description = """Speeds up this pattern by the given factor — alias for [fast].

 `extend(2)` is identical to `fast(2)`: events play twice as fast.""",
                returnDoc = """A pattern sped up by `factor`.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c d e f").extend(2)      // 8 events per cycle instead of 4""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("bd sd hh").extend("<1 2 4>") // varying speed each cycle""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "extend",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "factor", type = kt7),
                ),
                returnType = kt2,
                description = """Speeds up this string pattern by `factor` — alias for [fast].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "extend",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "factor", type = kt7),
                ),
                returnType = kt5,
                description = """Chains an extend (alias for [fast]) onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "extend",
                params = listOf(
                    KlangParam(name = "factor", type = kt7, description = """Speed-up factor."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that speeds up the source by `factor` — alias for [fast].""",
                returnDoc = """A [PatternMapperFn] that speeds up the source.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c d e f").apply(extend(2))  // via mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "fast" to KlangSymbol(
        name = "fast",
        category = "tempo",
        tags = listOf("fast", "speed", "tempo", "accelerate"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "fast",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "factor", type = kt7, description = """Speed-up factor. Values > 1 play faster; values < 1 play slower."""),
                ),
                returnType = kt2,
                description = """Speeds up the pattern by the given factor.

 `fast(2)` plays the pattern twice per cycle. Accepts mini-notation strings and control patterns.""",
                returnDoc = """A pattern sped up by `factor`.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c d e f").fast(2)           // 8 events per cycle instead of 4""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("bd sd hh").fast("<1 2 4>")     // varying speed each cycle""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "fast",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "factor", type = kt7),
                ),
                returnType = kt2,
                description = """Speeds up the mini-notation string pattern by `factor`.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "fast",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "factor", type = kt7),
                ),
                returnType = kt5,
                description = """Chains a fast operation onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "fast",
                params = listOf(
                    KlangParam(name = "factor", type = kt7, description = """Speed-up multiplier. 2 = double speed (twice as many events per cycle). Default: 1 (no change). Typical range: 0.25–16."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that speeds up a pattern by the given factor.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd hh").apply(fast(2))      // mapper form""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "fastChunk" to KlangSymbol(
        name = "fastChunk",
        category = "structural",
        tags = listOf("chunk", "cycle", "transform", "fast", "rotate"),
        aliases = listOf("fastchunk"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "fastChunk",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "n", type = kt10, description = """Number of chunks."""),
                    KlangParam(name = "transform", type = kt5, description = """Function applied to the active chunk each cycle."""),
                ),
                returnType = kt2,
                description = """Like [chunk], but the source pattern plays at natural speed (not repeated `n` times).

 While [chunk] repeats the source `n` times before cycling through transformations, `fastChunk` lets
 the pattern progress naturally while the transformed chunk cycles independently.""",
                returnDoc = """Pattern at natural speed with chunks cycling through the transformation.""",
                samples = listOf(
                    KlangCodeSample(code = """seq("0 1 2 3").fastChunk(4, x => x.add(10)).scale("c:minor").n()  // no repeat: chunks at normal speed""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("bd sd ht lt").fastChunk(4, x => x.gain(0.8))  // one hit boosted per cycle, no repeat""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "fastChunk",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "n", type = kt10),
                    KlangParam(name = "transform", type = kt5),
                ),
                returnType = kt2,
                description = """Like [chunk] on a string-parsed pattern but at natural speed.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """"bd sd ht lt".fastChunk(4, x => x.gain(0.8)).s()  // one hit boosted, no repeat""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "fastGap" to KlangSymbol(
        name = "fastGap",
        category = "tempo",
        tags = listOf("fastGap", "fast", "gap", "silence", "compress", "density"),
        aliases = listOf("densityGap"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "fastGap",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "factor", type = kt7, description = """Compression factor. 2 = play in first half, silence in second. Default: 1 (full cycle). Typical range: 1–8."""),
                ),
                returnType = kt2,
                description = """Speeds up the pattern by `factor` but plays it only once per cycle, leaving a gap.

 Unlike `fast(n)` which tiles the pattern `n` times to fill the cycle, `fastGap(n)` compresses
 the pattern into the first `1/n` of the cycle and leaves silence in the remaining space. As a
 top-level function the second argument is the source pattern.""",
                returnDoc = """A pattern compressed into the first `1/factor` of each cycle with silence after.""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd hh cp").fastGap(2)         // 4 events in first half, silence in second half""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c d e f g").fastGap(4)        // all events squeezed into first quarter""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "fastGap",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "factor", type = kt7),
                ),
                returnType = kt2,
                description = """Speeds up the pattern but plays it only once per cycle, leaving a gap.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "fastGap",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "factor", type = kt7),
                ),
                returnType = kt5,
                description = """Chains a fastGap operation onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "fastGap",
                params = listOf(
                    KlangParam(name = "factor", type = kt7),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that speeds up a pattern but plays it only once per cycle.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "fastcat" to KlangSymbol(
        name = "fastcat",
        category = "structural",
        tags = listOf("sequence", "timing", "order"),
        aliases = listOf("seq"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "fastcat",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "patterns", type = kt7, isVararg = true),
                ),
                returnType = kt2,
                description = """Alias for [seq]. Appends patterns to this pattern, squeezing all into one cycle.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd").fastcat(s("sd"))  // "bd sd" squeezed into one cycle""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "fastcat",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "patterns", type = kt7, isVararg = true),
                ),
                returnType = kt2,
                description = """Alias for [seq]. Parses this string and squeezes it together with the given patterns into one cycle.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """"bd".fastcat("sd").s()  // "bd sd" squeezed into one cycle""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "fastcat",
                params = listOf(
                    KlangParam(name = "patterns", type = kt7, isVararg = true, description = """Patterns to squeeze into one cycle."""),
                ),
                returnType = kt2,
                description = """Alias for [seq]. Concatenates patterns, squeezing them all into one cycle.""",
                returnDoc = """A pattern with all inputs squeezed into one cycle""",
                samples = listOf(
                    KlangCodeSample(code = """fastcat("bd", "sd").s()  // same as seq("bd", "sd") or "bd sd"""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    )
)

private fun generatedSprudelDocsChunk12() = mapOf(

    "fastchunk" to KlangSymbol(
        name = "fastchunk",
        category = "structural",
        tags = listOf("chunk", "cycle", "transform", "fast", "rotate"),
        aliases = listOf("fastChunk"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "fastchunk",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "n", type = kt10, description = """Number of chunks."""),
                    KlangParam(name = "transform", type = kt5, description = """Function applied to the active chunk each cycle."""),
                ),
                returnType = kt2,
                description = """Alias for [fastChunk] — like [chunk] but pattern plays at natural speed.""",
                returnDoc = """Pattern at natural speed with chunks cycling through the transformation.""",
                samples = listOf(
                    KlangCodeSample(code = """seq("0 1 2 3").fastchunk(4, x => x.add(10)).scale("c:minor").n()  // no repeat: chunks at normal speed""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("bd sd ht lt").fastchunk(4, x => x.gain(0.8))  // one hit boosted per cycle, no repeat""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "fastchunk",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "n", type = kt10),
                    KlangParam(name = "transform", type = kt5),
                ),
                returnType = kt2,
                description = """Alias for [fastChunk] on a string-parsed pattern.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """"bd sd ht lt".fastchunk(4, x => x.gain(0.8)).s()  // one hit boosted, no repeat""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "filterWhen" to KlangSymbol(
        name = "filterWhen",
        category = "structural",
        tags = listOf("filterWhen", "filter", "time", "conditional", "predicate"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "filterWhen",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "predicate", type = kt12, description = """Function that receives the begin time as a `Double`; returns `true` to keep the event."""),
                ),
                returnType = kt2,
                description = """Filters events from this pattern based on their begin time.

 Only events whose `part.begin` (as `Double`) satisfies [predicate] are kept.""",
                returnDoc = """A pattern with only the events whose begin time satisfies the predicate.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c d e f").filterWhen(t => t < 0.5)       // keep only first-half events""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("bd sd hh cp").filterWhen(t => t % 0.25 == 0) // keep only events on beat boundaries""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "filterWhen",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "predicate", type = kt12),
                ),
                returnType = kt2,
                description = """Filters events from this string pattern based on their begin time.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "filterWhen",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "predicate", type = kt12),
                ),
                returnType = kt5,
                description = """Chains a filterWhen onto this [PatternMapperFn]; filters events by their begin time.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "filterWhen",
                params = listOf(
                    KlangParam(name = "predicate", type = kt12, description = """Function that receives the begin time as a `Double`; returns `true` to keep the event."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that filters events from the source based on their begin time.""",
                returnDoc = """A [PatternMapperFn] that filters events by their begin time.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c d e f").apply(filterWhen(t => t < 0.5))   // via mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "firstOf" to KlangSymbol(
        name = "firstOf",
        category = "conditional",
        tags = listOf("firstOf", "every", "conditional", "cycle", "periodic", "transform"),
        aliases = listOf("every"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "firstOf",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "n", type = kt7, description = """How many cycles make one period. The transform fires on the first of these."""),
                    KlangParam(name = "transform", type = kt5, description = """The function to apply on the first cycle of each period."""),
                ),
                returnType = kt2,
                description = """Applies [transform] on the **first** cycle of every [n] cycles; all other cycles play unchanged.

 The pattern rotates through [n] cycles: the transformed version plays on cycle 1, then the
 original plays on cycles 2 through [n], then the sequence repeats.""",
                returnDoc = """A new pattern that applies [transform] periodically.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3 d3 e3 g3").firstOf(4, x => x.rev())  // reverse every 4th cycle""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c3 d3 e3 g3").firstOf("<2 4>", x => x.fast(2))  // alternating period""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "firstOf",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "n", type = kt7, description = """How many cycles make one period. The transform fires on the first of these."""),
                    KlangParam(name = "transform", type = kt5, description = """The function to apply on the first cycle of each period."""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern, then applies [transform] on the first of every [n] cycles.""",
                returnDoc = """A new pattern that applies [transform] periodically.""",
                samples = listOf(
                    KlangCodeSample(code = """"c3 d3 e3 g3".firstOf(4, x => x.rev()).note()  // reverse every 4th cycle""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "firstOf",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "n", type = kt7, description = """How many cycles make one period. The transform fires on the first of these."""),
                    KlangParam(name = "transform", type = kt5, description = """The function to apply on the first cycle of each period."""),
                ),
                returnType = kt5,
                description = """Chains a periodic transform onto this [PatternMapperFn], applying [transform] on the first of every [n] cycles.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("a").apply(lastOf(3, x => x.note("b")).firstOf(2, x => x.note("c")))""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "firstOf",
                params = listOf(
                    KlangParam(name = "n", type = kt7, description = """How many cycles make one period. The transform fires on the first of these."""),
                    KlangParam(name = "transform", type = kt5, description = """The function to apply on the first cycle of each period."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that applies [transform] on the **first** cycle of every [n] cycles.

 Use the returned mapper as a transform argument or apply it to a pattern via `.apply(...)`.""",
                returnDoc = """A [PatternMapperFn] that applies [transform] periodically.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3 d3 e3 g3").apply(firstOf(4, x => x.rev()))  // reverse every 4th cycle""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c3 e3 g3").every(3, firstOf(2, x => x.fast(2)))  // nested periodic transforms""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "flipSign" to KlangSymbol(
        name = "flipSign",
        category = "arithmetic",
        tags = listOf("flipSign", "negate", "invert", "arithmetic", "value"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "flipSign",
                receiver = kt0,
                params = emptyList(),
                returnType = kt2,
                description = """Flips the sign of numerical values in each event's voice data.

 Multiplies the current value by `-1`, turning positive values negative and vice versa.
 Useful for inverting modulation signals or creating mirror effects.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """seq("<[1 2 3 4] [-1 -2 -3 -4]>").flipSign().scale("c4:major").n()""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """sine.range(0, 1).flipSign()   // invert a unipolar sine to [-1, 0]""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "flipSign",
                receiver = kt3,
                params = emptyList(),
                returnType = kt2,
                description = """Flips the sign of numerical values in a string pattern.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """"<[1 2 3 4] [-1 -2 -3 -4]>".flipSign().scale("C4:major").n()""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "flipSign",
                receiver = kt4,
                params = emptyList(),
                returnType = kt5,
                description = """Chains a sign-flip onto this [PatternMapperFn], negating every numeric value in the result.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """seq("1 -2").apply(add(1).flipSign())  // flipSign(1+1)=-2, flipSign(-2+1)=1""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "floor" to KlangSymbol(
        name = "floor",
        category = "arithmetic",
        tags = listOf("floor", "rounding", "arithmetic", "math"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "floor",
                receiver = kt0,
                params = emptyList(),
                returnType = kt2,
                description = """Floors every numeric value in the pattern to the largest integer less than or equal to the value.""",
                returnDoc = """A new pattern with each value floored to an integer.""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "floor",
                receiver = kt3,
                params = emptyList(),
                returnType = kt2,
                description = """""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "floor",
                receiver = kt4,
                params = emptyList(),
                returnType = kt5,
                description = """""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "floor",
                params = emptyList(),
                returnType = kt5,
                description = """""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "fm" to KlangSymbol(
        name = "fm",
        category = "synthesis",
        tags = listOf("fm", "depth", "ratio", "attack", "decay", "sustain", "release"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "fm",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "depth", type = kt6, isOptional = true, defaultDoc = """null""", description = """Modulation depth in Hz."""),
                    KlangParam(name = "ratio", type = kt6, isOptional = true, defaultDoc = """null""", description = """The modulator's frequency as a multiple of the note."""),
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null""", description = """Modulation envelope attack in seconds."""),
                    KlangParam(name = "decay", type = kt6, isOptional = true, defaultDoc = """null""", description = """Modulation envelope decay in seconds."""),
                    KlangParam(name = "sustain", type = kt6, isOptional = true, defaultDoc = """null""", description = """Modulation envelope sustain, 0 to 1."""),
                    KlangParam(name = "release", type = kt6, isOptional = true, defaultDoc = """null""", description = """Modulation envelope release in seconds, after the note ends."""),
                ),
                returnType = kt2,
                description = """FM synthesis: modulation depth, ratio and the modulation envelope.

 `depth` is the peak modulation in Hz, `ratio` the modulator's frequency as a multiple of the note, and the envelope
 shapes the depth over the note per voice. FM is active once `depth` is set and not 0;
 `ratio` defaults to 1, a modulator at the carrier's own pitch.

 A depth of 10 to 100 Hz is subtle, 200 to 500 brassy, above 500 metallic. Integer ratios are
 harmonic, fractions inharmonic; a modulation sustain of 0 gives a percussive bell. With every envelope stage at its
 default (attack 0, decay 0, sustain 1 or more, release 0) no envelope runs and the depth holds for the whole note,
 its release tail included; otherwise (attack above 0, decay above 0, sustain below 1 or release above 0) the
 envelope runs and the depth falls back to 0 over `release` after the note ends (0 is at once).

 Every slot is independent and patternable; an omitted slot keeps its value, a named slot takes
 a mapper (`fm(ratio = mul(2))`), and the slots read back as `fm.depth`, `fm.ratio`, `fm.attack`, `fm.decay`,
 `fm.sustain`, `fm.release`. With no argument at all, the pattern's own values are reinterpreted as `depth`.

 The door fills the FM stage of `classic()` (the `fm.*` slots), the Ignitor `fm` node with a sine modulator; an
 instrument without `classic()` ignores it, like the other `classic()` doors. The other pitch doors (`vib`, `penv`,
 `accelerate`) move carrier and modulator together, so the ratio holds.

 The words are the Ignitor door's (`x.fm(modulator, ratio, depth, ...)`), the positional order is not: this door
 leads with the depth and kept its order, so no positional call changed (`fm(300, 1.4)` is depth 300, ratio 1.4); the
 Ignitor door leads with the modulator, its structure. A recorded asymmetry (`/dsl-design` section 4).""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3 e3").s("sine").fm(200, 2)                                     // a bright, harmonic FM tone""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c3 e3").s("sine").fm(300, 1.4, 0.01, 0.3, 0)                     // a bell: the modulation dies away""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c3 e3").s("sine").fm(200, 2).fm(depth = mul("1 3"))              // the second note far more metallic""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c3 ~ e3 ~").s("sine").fm(400, 1, 0, 0, 1, 0.4).adsr(0.01, 0.1, 0.8, 0.6)   // the brightness fades with the tail""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "fm",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "depth", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "ratio", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "decay", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "sustain", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "release", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern, then applies [fm].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "fm",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "depth", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "ratio", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "decay", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "sustain", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "release", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt5,
                description = """Chains a [fm] step onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "focus" to KlangSymbol(
        name = "focus",
        category = "tempo",
        tags = listOf("focus", "zoom", "timespan", "range", "stretch"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "focus",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "start", type = kt7, description = """Beginning of the section to zoom into, as a cycle fraction. Default: 0. Range: 0–1."""),
                    KlangParam(name = "end", type = kt7, description = """End of the section to zoom into, as a cycle fraction. Default: 1. Range: 0–1. Must be greater than start."""),
                ),
                returnType = kt2,
                description = """Zooms in on a sub-range of a cycle, stretching that portion to fill the whole cycle.

 `focus(start, end)` is like the inverse of `compress`: it takes the slice `[start, end]`
 of the original pattern and stretches it to fill a full cycle.""",
                returnDoc = """A pattern that zooms into `[start, end]`, stretching it to fill each cycle.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c d e f").focus(0, 0.5)       // only the first half is shown, stretched to a full cycle""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("bd sd hh cp").focus(0.25, 0.75)  // middle 50% of the pattern, stretched to fill the cycle""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "focus",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "start", type = kt7),
                    KlangParam(name = "end", type = kt7),
                ),
                returnType = kt2,
                description = """Zooms in on `[start, end]` of a cycle and stretches that portion to fill each cycle.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "focus",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "start", type = kt7),
                    KlangParam(name = "end", type = kt7),
                ),
                returnType = kt5,
                description = """Chains a focus operation onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "focus",
                params = listOf(
                    KlangParam(name = "start", type = kt7, description = """Beginning of the section as a cycle fraction. Range: 0–1."""),
                    KlangParam(name = "end", type = kt7, description = """End of the section as a cycle fraction. Range: 0–1."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that zooms in on `[start, end]` and stretches it to fill each cycle.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c d e f").apply(focus(0, 0.5))  // mapper form""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "freq" to KlangSymbol(
        name = "freq",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "freq",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "hz", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt2,
                description = """Sets the playback frequency in Hz on this pattern.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "freq",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "hz", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt2,
                description = """Sets the playback frequency in Hz on a string pattern.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "freq",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "hz", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt5,
                description = """Chains a freq step onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    )
)

private fun generatedSprudelDocsChunk13() = mapOf(

    "gain" to KlangSymbol(
        name = "gain",
        category = "dynamics",
        tags = listOf("gain", "volume", "amplitude", "dynamics"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "gain",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "amount", type = kt6, isOptional = true, defaultDoc = """null""", description = """Level multiplier, 1 leaves the event as it is.""", uitools = listOf("SprudelGainEditor", "SprudelGainSequenceEditor")),
                ),
                returnType = kt2,
                description = """Sets the level each event leaves at, per voice.

 The one level word. It is tone-neutral and it comes last: the voice's filters, its distortion and
 its envelope have all run by the time `gain` is applied, so turning it down makes the sound
 smaller and changes nothing else about it. Set it once the sound is designed and only its size is
 still wrong. Below 1 is quieter, above 1 is louder.

 A later `gain` REPLACES an earlier one, so the last call in the chain wins. To scale a level
 that is already set instead of replacing it, pass a mapper: `gain(mul(0.5))` halves whatever is
 there. On an event with no gain set at all a mapper does nothing, so set a level first.

 `velocity` is multiplied into it, and mute, solo and fade scale it as well. Takes a control
 pattern, so the level can move from event to event.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd hh cp").gain(0.5)              // all hits at half volume""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("bd*4").gain("<0.2 0.5 0.8 1.0>")    // different gain each cycle""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("bd*4").distort(0.7).gain(0.2)       // dirty it first, then set the level it leaves at""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "gain",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "amount", type = kt6, isOptional = true, defaultDoc = """null""", description = """Level multiplier, 1 leaves the event as it is.""", uitools = listOf("SprudelGainEditor", "SprudelGainSequenceEditor")),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern and sets the gain for each event.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """"bd*4".gain("0.2 0.5 0.8 1.0").s()    // different gain each beat""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "gain",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "amount", type = kt6, isOptional = true, defaultDoc = """null""", description = """Level multiplier, 1 leaves the event as it is.""", uitools = listOf("SprudelGainEditor", "SprudelGainSequenceEditor")),
                ),
                returnType = kt5,
                description = """Creates a chained [PatternMapperFn] that sets the gain after the previous mapper.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """s("hh*4").apply(gain("1.0 0.5").gain(0.8))  // chain gain modifiers""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "gap" to KlangSymbol(
        name = "gap",
        category = "structural",
        tags = listOf("silence", "rest", "gap", "rhythm"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "gap",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "steps", type = kt7, isVararg = true),
                ),
                returnType = kt2,
                description = """Replaces this pattern with a silent slot occupying the given number of steps.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c").gap()  // Replaces with 1-step silence""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c").gap(2)  // Replaces with 2-step silence""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "gap",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "steps", type = kt7, isVararg = true),
                ),
                returnType = kt2,
                description = """Replaces this string pattern with a silent slot occupying the given number of steps.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """seq("bd", "hh".gap(), "sd").s()  // Middle step replaced by silence""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "gap",
                params = listOf(
                    KlangParam(name = "steps", type = kt7, isVararg = true, description = """Step count for the silence (default 1). Accepts static numbers and control patterns."""),
                ),
                returnType = kt2,
                description = """Creates a silent slot that produces no events.

 When called with a static step count and used inside [seq] or [cat], the gap occupies
 proportionally more space than adjacent 1-step elements. Equivalent to the `~` rest character
 in mini-notation.

 Control patterns (e.g. `gap("<1 2>")`) are supported — the step count is evaluated per event —
 but proportional space allocation in sequences is not affected (weight defaults to 1 for
 control patterns, since [seq] reads weights once at construction time).""",
                returnDoc = """A silent pattern with the given step weight""",
                samples = listOf(
                    KlangCodeSample(code = """seq("bd", gap(), "hh").s()  // bd, 1-step rest, hh — each gets 1/3 of the cycle""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """seq("bd", gap(2), "hh").s()  // bd=1/4, rest=2/4, hh=1/4""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "gt" to KlangSymbol(
        name = "gt",
        category = "arithmetic",
        tags = listOf("gt", "greater than", "comparison", "arithmetic"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "gt",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "threshold", type = kt7, description = """The value to compare against. May be a number, string mini-notation, or a [SprudelPattern]."""),
                ),
                returnType = kt2,
                description = """Compares every value in the pattern to [threshold], replacing each with `1` (true) if greater
 than [threshold] or `0` (false) otherwise.""",
                returnDoc = """A new pattern of `0`/`1` values.""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "gt",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "threshold", type = kt7),
                ),
                returnType = kt2,
                description = """""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "gt",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "threshold", type = kt7),
                ),
                returnType = kt5,
                description = """""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "gt",
                params = listOf(
                    KlangParam(name = "threshold", type = kt7),
                ),
                returnType = kt5,
                description = """""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "gte" to KlangSymbol(
        name = "gte",
        category = "arithmetic",
        tags = listOf("gte", "greater than or equal", "comparison", "arithmetic"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "gte",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "threshold", type = kt7, description = """The value to compare against. May be a number, string mini-notation, or a [SprudelPattern]."""),
                ),
                returnType = kt2,
                description = """Compares every value in the pattern to [threshold], replacing each with `1` (true) if greater
 than or equal to [threshold] or `0` (false) otherwise.""",
                returnDoc = """A new pattern of `0`/`1` values.""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "gte",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "threshold", type = kt7),
                ),
                returnType = kt2,
                description = """""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "gte",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "threshold", type = kt7),
                ),
                returnType = kt5,
                description = """""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "gte",
                params = listOf(
                    KlangParam(name = "threshold", type = kt7),
                ),
                returnType = kt5,
                description = """""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "highpass" to KlangSymbol(
        name = "highpass",
        category = "effects",
        tags = listOf("highpass", "hpf.freq", "filter"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "highpass",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "freq", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "q", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "passes", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "env", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "decay", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "sustain", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "release", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt2,
                description = """Applies a highpass filter, the long name of [hpf]; both are the same door, use whichever
 reads better in the line you are writing.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3").s("saw").highpass(800)""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "highpass",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "freq", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "q", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "passes", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "env", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "decay", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "sustain", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "release", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern, then applies [highpass].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "highpass",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "freq", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "q", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "passes", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "env", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "decay", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "sustain", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "release", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt5,
                description = """Chains a highpass step onto this [PatternMapperFn] (see [SprudelPattern.highpass]).""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "hpf" to KlangSymbol(
        name = "hpf",
        category = "effects",
        tags = listOf("hpf", "freq", "q", "passes", "env", "attack", "decay", "sustain", "release", "hcutoff", "high pass filter", "filter", "envelope"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "hpf",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "freq", type = kt6, isOptional = true, defaultDoc = """null""", description = """Cutoff in Hz.""", uitools = listOf("SprudelHpFilterEditor", "SprudelHpFilterSequenceEditor")),
                    KlangParam(name = "q", type = kt6, isOptional = true, defaultDoc = """null""", description = """Resonance, higher emphasises the cutoff.""", uitools = listOf("SprudelHpResonanceEditor", "SprudelHpResonanceSequenceEditor")),
                    KlangParam(name = "passes", type = kt6, isOptional = true, defaultDoc = """null""", description = """Cascade count, 1 to 16."""),
                    KlangParam(name = "env", type = kt6, isOptional = true, defaultDoc = """null""", description = """Envelope depth in semitones.""", uitools = listOf("SprudelHpEnvEditor", "SprudelHpEnvSequenceEditor")),
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null""", description = """Envelope attack in seconds."""),
                    KlangParam(name = "decay", type = kt6, isOptional = true, defaultDoc = """null""", description = """Envelope decay in seconds."""),
                    KlangParam(name = "sustain", type = kt6, isOptional = true, defaultDoc = """null""", description = """Envelope sustain, 0 to 1."""),
                    KlangParam(name = "release", type = kt6, isOptional = true, defaultDoc = """null""", description = """Envelope release in seconds."""),
                ),
                returnType = kt2,
                description = """The highpass filter: cutoff, resonance, cascade and the cutoff envelope.

 Only frequencies above the cutoff pass, so higher values sound thinner. Every note carries its
 own cutoff, resonance and envelope, per voice.

 The envelope sweeps `freq` up by `env` semitones: attack is the time to reach full depth, decay
 the fall to the sustain share, release the fall back to `freq` after the note ends. `env = 12`
 doubles the cutoff, a negative `env` sweeps down, and without `env` the filter rests at `freq`.

 `passes` cascades the filter: `2` is 24 dB/oct, `3` is 36, omit it for one 12 dB/oct stage. It is
 rounded and coerced to 1..16, a resource count, never an error. Resonance compounds across the
 stages, so `hpf(200, 10, 4)` peaks far louder than `hpf(200, 10)`.

 Every slot is independent and patternable; an omitted slot keeps its value, a named slot takes
 a mapper (`hpf(q = mul(2))`), and every slot reads back as a child: `hpf.freq`, `hpf.q`, `hpf.passes`, `hpf.env`, `hpf.attack`, `hpf.decay`, `hpf.sustain`, `hpf.release`.
 With no argument at all, the pattern's own values are reinterpreted as `freq`.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3 e3").s("saw").hpf(400, 6)                                          // cutoff and resonance""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c2*4").s("saw").hpf(freq = 200, env = -24, attack = 0.01, decay = 0.4, sustain = 0)   // the low end swells back after each hit""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c3 e3").s("saw").hpf("200 800").lpf(hpf.freq.mul(4))                  // a two-octave band above the highpass""", type = KlangCodeSampleType.PLAYABLE)
                ),
                uitools = listOf("SprudelHpFilterEditor"),
                library = "sprudel"
            ),
            KlangCallable(
                name = "hpf",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "freq", type = kt6, isOptional = true, defaultDoc = """null""", uitools = listOf("SprudelHpFilterEditor", "SprudelHpFilterSequenceEditor")),
                    KlangParam(name = "q", type = kt6, isOptional = true, defaultDoc = """null""", uitools = listOf("SprudelHpResonanceEditor", "SprudelHpResonanceSequenceEditor")),
                    KlangParam(name = "passes", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "env", type = kt6, isOptional = true, defaultDoc = """null""", uitools = listOf("SprudelHpEnvEditor", "SprudelHpEnvSequenceEditor")),
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "decay", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "sustain", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "release", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern, then applies [hpf].""",
                returnDoc = """""",
                samples = emptyList(),
                uitools = listOf("SprudelHpFilterEditor"),
                library = "sprudel"
            ),
            KlangCallable(
                name = "hpf",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "freq", type = kt6, isOptional = true, defaultDoc = """null""", uitools = listOf("SprudelHpFilterEditor", "SprudelHpFilterSequenceEditor")),
                    KlangParam(name = "q", type = kt6, isOptional = true, defaultDoc = """null""", uitools = listOf("SprudelHpResonanceEditor", "SprudelHpResonanceSequenceEditor")),
                    KlangParam(name = "passes", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "env", type = kt6, isOptional = true, defaultDoc = """null""", uitools = listOf("SprudelHpEnvEditor", "SprudelHpEnvSequenceEditor")),
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "decay", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "sustain", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "release", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt5,
                description = """Chains a [hpf] step onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                uitools = listOf("SprudelHpFilterEditor"),
                library = "sprudel"
            )
        )
    ),

    "hpfCurves" to KlangSymbol(
        name = "hpfCurves",
        category = "effects",
        tags = listOf("hpf", "curve", "envelope", "shape", "filter envelope"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "hpfCurves",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the attack stage."""),
                    KlangParam(name = "decay", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the decay stage."""),
                    KlangParam(name = "release", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the release stage."""),
                ),
                returnType = kt2,
                description = """Sets the shape of each stage of the highpass filter's cutoff envelope ([hpf]'s `env`, `attack`,
 `decay`, `sustain`, `release`), the way [adsrCurves] shapes the amplitude envelope. Each stage is
 independent; an omitted stage, or an unknown curve name, keeps its current curve, so
 `hpfCurves(decay = "linear")` changes only the decay.

 The curves are the same six as `adsrCurves`: `linear`, `square`, `cube`, `scurve`, `invsquare`,
 `exponential`, with the same aliases. Unset, every stage is `exponential`, the default of every
 modulation envelope on every surface (decision D3). A curve alone switches nothing on: without an
 envelope on the `hpf` there is no sweep to shape. The Ignitor filters name the same curves inside
 their envelope: `x => x.adsr(a, d, s, r, e => e.curves(...))`.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3*4").s("saw").hpf(freq = 200, env = 24, decay = 0.2, sustain = 0).hpfCurves(decay = "scurve")   // the sweep eases in and out""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "hpfCurves",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the attack stage."""),
                    KlangParam(name = "decay", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the decay stage."""),
                    KlangParam(name = "release", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the release stage."""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern and sets the highpass filter envelope's stage curves (see [hpfCurves]).""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "hpfCurves",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the attack stage. Omit to keep the current curve."""),
                    KlangParam(name = "decay", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the decay stage. Omit to keep the current curve."""),
                    KlangParam(name = "release", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the release stage. Omit to keep the current curve."""),
                ),
                returnType = kt5,
                description = """Creates a chained [PatternMapperFn] that sets the highpass filter envelope's stage curves after the previous mapper.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "hurry" to KlangSymbol(
        name = "hurry",
        category = "tempo",
        tags = listOf("hurry", "fast", "speed", "pitch", "accelerate"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "hurry",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "factor", type = kt7, description = """Speed and pitch multiplier. 2 = double speed with pitch up one octave. Default: 1 (no change). Typical range: 0.25–16."""),
                ),
                returnType = kt2,
                description = """Speeds up the pattern like `fast()` and multiplies the `speed` audio parameter by the same factor.

 Unlike `fast()` which only changes the temporal density of events, `hurry()` also scales the
 `speed` field (sample playback rate) so samples sound proportionally higher-pitched. This
 mimics tape-speed acceleration. As a top-level function the second argument is the source pattern.""",
                returnDoc = """A pattern sped up in both timing and sample playback rate.""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd hh").hurry(2)              // twice as fast and samples pitch up by an octave""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("bass:1").speed(0.5).hurry(2)     // existing speed 0.5 × hurry 2 = speed 1.0""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "hurry",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "factor", type = kt7),
                ),
                returnType = kt2,
                description = """Speeds up pattern and multiplies the `speed` audio parameter by the same factor.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "hurry",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "factor", type = kt7),
                ),
                returnType = kt5,
                description = """Chains a hurry operation onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "hurry",
                params = listOf(
                    KlangParam(name = "factor", type = kt7),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that speeds up a pattern and multiplies the `speed` parameter.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    )
)

private fun generatedSprudelDocsChunk14() = mapOf(

    "hush" to KlangSymbol(
        name = "hush",
        category = "structural",
        tags = listOf("silence", "mute", "control"),
        aliases = listOf("bypass", "mute"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "hush",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true, description = """Optional condition pattern. When truthy the pattern is silenced."""),
                ),
                returnType = kt2,
                description = """Silences this pattern. Without arguments, unconditionally returns silence.
 With a condition, silences when the condition is truthy — supports control patterns.""",
                returnDoc = """Silence, or the original pattern gated by the condition.""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd").hush()          // Unconditional silence""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("bd sd").hush("<1 0>")   // Silent on odd cycles, audible on even""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "hush",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true),
                ),
                returnType = kt2,
                description = """Silences this string pattern. Without arguments, unconditionally returns silence.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "hush",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true),
                ),
                returnType = kt5,
                description = """Chains a hush onto this [PatternMapperFn]; silences or conditionally gates the result.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "hush",
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true, description = """Optional condition pattern. When truthy the source pattern is silenced."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that silences the source pattern.

 Without arguments, unconditionally silences. With a condition, silences when truthy.""",
                returnDoc = """A [PatternMapperFn] that silences or conditionally gates the source pattern.""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd").apply(hush())          // Unconditional silence via mapper""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("bd sd").apply(hush("<1 0>"))   // Silent on odd cycles via mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "ignitorParam" to KlangSymbol(
        name = "ignitorParam",
        category = "tonal",
        tags = listOf("ignitor", "parameter", "slot"),
        aliases = listOf("ignp"),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "ignitorParam",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "slot", type = kt13, description = """The Ignitor slot (required): its name, or the Ignitor param itself."""),
                    KlangParam(name = "value", type = kt7, description = """The slot value."""),
                ),
                returnType = kt2,
                description = """Writes one Ignitor slot, per voice: by its name, or by the param object itself.

 Direct access to the `ignitorParams` map, for slots that have no dedicated door of their own.
 Slots used elsewhere in this library are `analog`, `onepole` and `density`.



 The slot can be the param OBJECT instead of its name: a classic slot (`Ignitor.slot.lpf.freq`), or a param of
 your own instrument held in a variable. Only the NAME is written; the default stays the instrument's.


 A Katalyst param (`Katalyst.param(...)`, `Katalyst.slot.*`) is the orbit chain's slot, which `katalystParam`
 writes; handing one to this door is a script error at the call, and so is a number, a sound or an expression
 over a param (`Ignitor.param("x", 1).mul(2)` is not a slot).""",
                returnDoc = """A new pattern with the slot written.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3 e3").s("supersaw").ignitorParam("analog", 4)""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c3 e3").ignitorParam("onepole", "<12000 3700>") // pattern-cycle the value""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """let cutoff = Ignitor.param("cutoff", 800)
let pad = Ignitor.saw().lowpass(cutoff).classic()
note("c3 e3").sound(pad).ignitorParam(cutoff, "<400 2000>")""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "ignitorParam",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "slot", type = kt13),
                    KlangParam(name = "value", type = kt7),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern and writes one Ignitor slot, by name or by the param object.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "ignitorParam",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "slot", type = kt13),
                    KlangParam(name = "value", type = kt7),
                ),
                returnType = kt5,
                description = """Chains an Ignitor slot write onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "ignitorParam",
                params = listOf(
                    KlangParam(name = "slot", type = kt13),
                    KlangParam(name = "value", type = kt7),
                ),
                returnType = kt5,
                description = """Creates a [PatternMapperFn] that writes one Ignitor slot, by name or by the param object.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "ignp" to KlangSymbol(
        name = "ignp",
        category = "tonal",
        tags = listOf("ignp", "ignitor", "parameter", "slot"),
        aliases = listOf("ignitorParam"),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "ignp",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "slot", type = kt13, description = """The Ignitor slot (required): its name, or the Ignitor param itself."""),
                    KlangParam(name = "value", type = kt7, description = """The slot value."""),
                ),
                returnType = kt2,
                description = """Alias for [ignitorParam]: writes one Ignitor slot, by name or by the param object.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "ignp",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "slot", type = kt13),
                    KlangParam(name = "value", type = kt7),
                ),
                returnType = kt2,
                description = """Alias for [ignitorParam]. Parses this string as a pattern and writes one Ignitor slot.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "ignp",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "slot", type = kt13),
                    KlangParam(name = "value", type = kt7),
                ),
                returnType = kt5,
                description = """Alias for [ignitorParam]. Chains an Ignitor slot write onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "ignp",
                params = listOf(
                    KlangParam(name = "slot", type = kt13),
                    KlangParam(name = "value", type = kt7),
                ),
                returnType = kt5,
                description = """Alias for [ignitorParam]. Creates a [PatternMapperFn] that writes one Ignitor slot.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "inhabit" to KlangSymbol(
        name = "inhabit",
        category = "structural",
        tags = listOf("inhabit", "pickSqueeze", "squeeze", "select", "index", "lookup"),
        aliases = listOf("pickSqueeze"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "inhabit",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true),
                ),
                returnType = kt2,
                description = """Selects patterns from a list or map by index and squeezes each into the trigger's timespan.

 The last argument (or the second when the first is a list/map) is the index pattern.
 Selected patterns are squeezed so their full cycle fits within the selecting event's duration.
 Indices are clamped to valid bounds.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """"<0 1>".apply(inhabit("bd sd hh", "rim cp", n("0 1 2 0"))).s()   // picked pattern fills event duration""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """"<0 1>".apply(inhabit(["c3 e3", "g3 b3"], n("0 1 0")))          // each chosen pattern is squeezed in""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "inhabit",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true),
                ),
                returnType = kt2,
                description = """Selects patterns from a list by index and squeezes each into the timespan of the trigger.

 Each event of this string pattern picks a pattern from the lookup by index (clamped) and
 squeezes it so that the full cycle of the chosen pattern fits within the duration of the event.
 This is equivalent to [squeeze] with arguments reversed.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """"0 1 2".inhabit("bd sd hh", "rim cp", "hh*4").s()         // chosen pattern fills event""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """"0 1".inhabit(note("c3 e3 g3"), note("b3 d4"))             // pattern squeezed per index""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "inhabit",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true),
                ),
                returnType = kt5,
                description = """Chains an inhabit onto this [PatternMapperFn]; clamped index, squeeze semantics.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "inhabit",
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that selects patterns from a lookup by index and squeezes them into event timespans.

 Like [inhabit] but as a top-level mapper: the last argument is the selector pattern and the
 preceding arguments form the lookup. Indices are clamped to valid bounds.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """"<0 1>".apply(inhabit("bd sd hh", "rim cp", n("0 1 2 0"))).s()""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "inhabitmod" to KlangSymbol(
        name = "inhabitmod",
        category = "structural",
        tags = listOf("inhabitmod", "pickmodSqueeze", "modulo", "squeeze", "select", "index", "lookup"),
        aliases = listOf("pickmodSqueeze"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "inhabitmod",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true),
                ),
                returnType = kt2,
                description = """Like [inhabit] but wraps out-of-bounds indices with modulo arithmetic.

 Selects patterns from the lookup using modulo-wrapped indices and squeezes each selected
 pattern into the timespan of the event that triggered it. Negative indices are handled.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """"0 1 2 3".inhabitmod("bd sd", "hh rim", "cp").s()       // 3→0 mod 3; squeezed""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """n("0 5").inhabitmod(note("c3"), note("e3"), note("g3"))  // 5→2 mod 3; squeezed""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "inhabitmod",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true),
                ),
                returnType = kt2,
                description = """Like [inhabit] but wraps out-of-bounds indices with modulo arithmetic — string receiver.

 This string is parsed as mini-notation to produce indices that select patterns from the
 lookup with modulo wrapping. Selected patterns are squeezed into each event's timespan.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """"0 1 2 3".inhabitmod("bd sd", "hh rim", "cp").s()       // 3→0 mod 3; squeezed""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """"0 5".inhabitmod(note("c3"), note("e3"), note("g3"))     // 5→2 mod 3; squeezed""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "inhabitmod",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true),
                ),
                returnType = kt5,
                description = """Chains an inhabitmod onto this [PatternMapperFn]; modulo-wrapped index, squeeze semantics.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "inhabitmod",
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that is like [inhabit] but wraps indices with modulo.

 The last argument is the selector pattern and the preceding arguments form the lookup.
 Indices wrap cyclically; negative indices are handled correctly.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """"<0 1 2 3>".apply(inhabitmod("bd", "sd", "hh")).s()   // 3→0 mod 3; squeezed into event""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "inside" to KlangSymbol(
        name = "inside",
        category = "tempo",
        tags = listOf("inside", "transform", "zoom", "slow", "fast"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "inside",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "factor", type = kt7, description = """The zoom-in amount. The pattern is slowed by this factor before the transform, then sped back up."""),
                    KlangParam(name = "transform", type = kt5, description = """Transformation to apply while the pattern is spread over `factor` cycles."""),
                ),
                returnType = kt2,
                description = """Applies a transformation inside a zoomed-in view of the cycle.

 Slows the pattern by `factor`, applies `transform`, then speeds it back up to the original
 tempo. The net effect is that `transform` sees a pattern spread over `factor` cycles,
 allowing operations like `rev()` to work across a larger musical phrase while the result
 still fits in one cycle.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("0 1 2 3").inside(4, x => x.rev())       // reverse across 4-cycle span, then compress back""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("bd sd hh cp").inside(2, x => x.slow(2))    // double-slow inside = no net change in tempo""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "inside",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "factor", type = kt7),
                    KlangParam(name = "transform", type = kt5),
                ),
                returnType = kt2,
                description = """Applies a transformation inside a zoomed-in view of the cycle.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "inside",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "factor", type = kt7),
                    KlangParam(name = "transform", type = kt5),
                ),
                returnType = kt5,
                description = """Chains an inside operation onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "inside",
                params = listOf(
                    KlangParam(name = "factor", type = kt7),
                    KlangParam(name = "transform", type = kt5),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that applies a transformation inside a zoomed-in view of the cycle.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "inv" to KlangSymbol(
        name = "inv",
        category = "structural",
        tags = listOf("invert", "inv", "boolean", "mask", "flip", "negate"),
        aliases = listOf("invert"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "inv",
                receiver = kt0,
                params = emptyList(),
                returnType = kt2,
                description = """Alias for [invert]. Inverts boolean values in this pattern: `true` ↔ `false`, `1` ↔ `0`.""",
                returnDoc = """A pattern with all boolean values toggled.""",
                samples = listOf(
                    KlangCodeSample(code = """"1 0 1 1".inv()                         // produces 0 1 0 0""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c d e f").struct("1 0 1 0").inv() // swaps active and silent beats""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "inv",
                receiver = kt3,
                params = emptyList(),
                returnType = kt2,
                description = """Alias for [invert] on a string pattern.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "inv",
                receiver = kt4,
                params = emptyList(),
                returnType = kt5,
                description = """Chains an inv (alias for [invert]) onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "inv",
                params = emptyList(),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] — alias for [invert] — that toggles all boolean values.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "invert" to KlangSymbol(
        name = "invert",
        category = "structural",
        tags = listOf("invert", "inv", "boolean", "mask", "flip", "negate"),
        aliases = listOf("inv"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "invert",
                receiver = kt0,
                params = emptyList(),
                returnType = kt2,
                description = """Inverts boolean values in this pattern: `true` ↔ `false`, `1` ↔ `0`.

 Useful for flipping structural masks so that silent beats become active and vice-versa.""",
                returnDoc = """A pattern with all boolean values toggled.""",
                samples = listOf(
                    KlangCodeSample(code = """"1 0 1 1".invert()                         // produces 0 1 0 0""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c d e f").struct("1 0 1 0").invert() // swaps active and silent beats""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "invert",
                receiver = kt3,
                params = emptyList(),
                returnType = kt2,
                description = """Inverts boolean values in this string pattern.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "invert",
                receiver = kt4,
                params = emptyList(),
                returnType = kt5,
                description = """Chains an invert onto this [PatternMapperFn]; toggles all boolean values.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "invert",
                params = emptyList(),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that inverts boolean values in the source pattern.""",
                returnDoc = """A [PatternMapperFn] that toggles all boolean values.""",
                samples = listOf(
                    KlangCodeSample(code = """seq("1 0 1 1").apply(invert())  // via mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    )
)

private fun generatedSprudelDocsChunk15() = mapOf(

    "irand" to KlangSymbol(
        name = "irand",
        category = "random",
        tags = listOf("irand", "random", "integer", "continuous"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "irand",
                params = listOf(
                    KlangParam(name = "n", type = kt7, description = """Upper bound (exclusive) — random integers are produced in the range 0 to n-1. Any positive integer."""),
                ),
                returnType = kt2,
                description = """Continuous pattern of random integers in the range `0` to `n - 1`.

 Generates a new random integer at each distinct point in time. Useful for randomly
 selecting scale degrees, sample numbers, or any indexed choice.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """n(irand(8)).scale("C:minor").note()         // random scale degree 0–7 each event""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("bd*8").n(irand(6))                       // random sample variant 0–5 per hit""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "iter" to KlangSymbol(
        name = "iter",
        category = "structural",
        tags = listOf("iter", "iterate", "rotate", "cycle", "shift", "forward"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "iter",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "n", type = kt10, description = """Number of slices to divide the pattern into."""),
                ),
                returnType = kt2,
                description = """Divides this pattern into `n` slices and shifts the view forward by one slice each cycle.

 Each cycle `c` starts at offset `(c % n) / n`, creating a rotating effect.
 Only static integer values are supported for `n`.""",
                returnDoc = """A pattern that rotates forward by one slice each cycle.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c d e f").iter(4)  // cycle 0: c d e f, cycle 1: d e f c, …""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("bd sd hh cp").iter(4)  // rotating drum pattern every cycle""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "iter",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "n", type = kt10),
                ),
                returnType = kt2,
                description = """Rotates this string pattern forward by one slice each cycle, dividing into `n` slices.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "iter",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "n", type = kt10),
                ),
                returnType = kt5,
                description = """Chains an iter onto this [PatternMapperFn]; rotates forward by one slice per cycle.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "iter",
                params = listOf(
                    KlangParam(name = "n", type = kt10, description = """Number of slices to divide the source into."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that rotates the source forward by one slice per cycle.""",
                returnDoc = """A [PatternMapperFn] that rotates the source forward each cycle.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c d e f").apply(iter(4))  // via mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "iterBack" to KlangSymbol(
        name = "iterBack",
        category = "structural",
        tags = listOf("iterBack", "iterate", "rotate", "cycle", "shift", "backward"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "iterBack",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "n", type = kt10, description = """Number of slices to divide the pattern into."""),
                ),
                returnType = kt2,
                description = """Divides this pattern into `n` slices and shifts the view backward by one slice each cycle.

 Like [iter] but in the opposite direction: each cycle starts later within the pattern.
 Only static integer values are supported for `n`.""",
                returnDoc = """A pattern that rotates backward by one slice each cycle.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c d e f").iterBack(4)  // cycle 0: c d e f, cycle 1: f c d e, …""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("bd sd hh cp").iterBack(4)  // backward-rotating drum pattern""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "iterBack",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "n", type = kt10),
                ),
                returnType = kt2,
                description = """Rotates this string pattern backward by one slice each cycle, dividing into `n` slices.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "iterBack",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "n", type = kt10),
                ),
                returnType = kt5,
                description = """Chains an iterBack onto this [PatternMapperFn]; rotates backward by one slice per cycle.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "iterBack",
                params = listOf(
                    KlangParam(name = "n", type = kt10, description = """Number of slices to divide the source into."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that rotates the source backward by one slice per cycle.""",
                returnDoc = """A [PatternMapperFn] that rotates the source backward each cycle.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c d e f").apply(iterBack(4))  // via mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "jux" to KlangSymbol(
        name = "jux",
        category = "structural",
        tags = listOf("jux", "pan", "stereo", "spatial", "transform"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "jux",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "transform", type = kt5, description = """Function applied to the right-channel copy of the pattern."""),
                ),
                returnType = kt2,
                description = """Pans this pattern hard left and a transformed version hard right.

 Creates a stereo image by stacking the original panned to 0.0 (left) with `transform(this)` panned
 to 1.0 (right). Useful for stereo width or call-and-response effects.""",
                returnDoc = """A stereo pattern with the original on the left and the transformed copy on the right.""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd").jux(x => x.rev())       // reversed pattern panned right""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c e g").jux(x => x.fast(2))  // double-speed version panned right""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "jux",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "transform", type = kt5),
                ),
                returnType = kt2,
                description = """Pans this string pattern hard left and a transformed version hard right.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "jux",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "transform", type = kt5),
                ),
                returnType = kt5,
                description = """Chains a jux onto this [PatternMapperFn]; pans left and transformed-right.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "jux",
                params = listOf(
                    KlangParam(name = "transform", type = kt5, description = """Function applied to the right-channel copy of the source pattern."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that pans the source hard left and a transformed version hard right.""",
                returnDoc = """A [PatternMapperFn] producing a stereo pattern.""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd").apply(jux(x => x.rev()))   // via mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "juxBy" to KlangSymbol(
        name = "juxBy",
        category = "structural",
        tags = listOf("juxBy", "jux", "pan", "stereo", "spatial", "width"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "juxBy",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "amount", type = kt10, description = """Stereo width from 0.0 (mono) to 1.0 (full hard pan)."""),
                    KlangParam(name = "transform", type = kt5, description = """Function applied to the right-channel copy."""),
                ),
                returnType = kt2,
                description = """Like [jux], but with adjustable stereo width.

 Pans the original left by `0.5 * (1 - amount)` and the transformed copy right by `0.5 * (1 + amount)`.
 At `amount = 1.0` (full stereo) this is equivalent to [jux]. At `amount = 0.0` both copies are centred.""",
                returnDoc = """A stereo pattern with width controlled by `amount`.""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd").juxBy(0.5, x => x.rev())        // half stereo width, reversed on right""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c e g").juxBy(0.75, x => x.fast(2))  // 75% stereo, faster on right""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "juxBy",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "amount", type = kt10),
                    KlangParam(name = "transform", type = kt5),
                ),
                returnType = kt2,
                description = """Like [jux] with adjustable stereo width on a string pattern.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "juxBy",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "amount", type = kt10),
                    KlangParam(name = "transform", type = kt5),
                ),
                returnType = kt5,
                description = """Chains a juxBy onto this [PatternMapperFn]; pans with adjustable stereo width.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "juxBy",
                params = listOf(
                    KlangParam(name = "amount", type = kt10, description = """Stereo width from 0.0 (mono) to 1.0 (full hard pan)."""),
                    KlangParam(name = "transform", type = kt5, description = """Function applied to the right-channel copy."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that pans the source with adjustable stereo width.""",
                returnDoc = """A [PatternMapperFn] producing a stereo pattern with the given width.""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd").apply(juxBy(0.5, x => x.rev()))  // via mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "katalyst" to KlangSymbol(
        name = "katalyst",
        category = "effects",
        tags = listOf("katalyst", "orbit", "chain", "bus", "effects", "motor"),
        aliases = listOf(),
        scope = KlangScope.ORBIT,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "katalyst",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "katalyst", type = kt14, description = """The orbit chain to declare."""),
                ),
                returnType = kt2,
                description = """Declares the orbit chain from this pattern's events onward.

 Unlike the top-level [katalyst] carrier, these events still sound: the chain declaration simply
 rides them.

 **The door REPLACES**, like `sound()` and `master()`: the last `.katalyst(...)` on a pattern is
 the chain its orbit runs, and writing two of them is not two halves of one chain. Build the whole
 chain in one `Katalyst(k => ...)`, where the list order is the signal order and you can see it:


 That is the familiar orbit with a 300 Hz lift at the end of it: `k.classic()` brings the whole
 familiar block (once, whatever else the builder says), so the `reverb(...)` on the pattern
 still reaches the room, and the `eq` shapes the summed orbit after it.""",
                returnDoc = """A new pattern whose events carry the chain.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3 e3 g3").s("supersaw").reverb(wet = 0.3, size = 3)
  .katalyst(Katalyst(k => k
    .classic()
    .eq(e => e.band(freq = 300, q = 0.8, db = 2.0))
  ))""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "katalyst",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "katalyst", type = kt14, description = """The orbit chain to declare."""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern and declares its orbit chain from its events onward.""",
                returnDoc = """A new pattern whose events carry the chain.""",
                samples = listOf(
                    KlangCodeSample(code = """"c3 e3 g3".katalyst(Katalyst(k => k.classic().gain(1.6))).s("supersaw")""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "katalyst",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "katalyst", type = kt14, description = """The orbit chain to declare."""),
                ),
                returnType = kt5,
                description = """Creates a chained [PatternMapperFn] that declares the orbit chain after the previous mapper.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "katalyst",
                params = listOf(
                    KlangParam(name = "katalyst", type = kt14, description = """The orbit chain to declare."""),
                ),
                returnType = kt2,
                description = """Creates a pattern that declares the **orbit chain**: one silent control event per cycle that
 carries nothing but the chain reference.

 A Katalyst is the instrument an orbit plays through: the effects its summed voices run, in the
 order written, before the playback's master bus. Put it on an orbit and everything stacked onto
 that orbit shares it:


 The declaration above adds an EQ the familiar chain does not have, which is what a declaration is
 FOR. `Katalyst(k => k.classic())` on its own declares exactly the chain an orbit already runs and
 therefore changes nothing: it is the one spelling that is a no-op.

 The event is a **control event**: it never sounds. `.orbit(n)` on the carrier is what routes the
 declaration to an orbit, which is why the carrier is an ordinary pattern and not a special
 value.

 `k.classic()` is the chain an orbit has always run, declared as named slots, so the `reverb(...)`
 on the stack drives the declared room, for the kick and the bass alike: that is how a bus door
 and a declaration meet. A chain
 that declares no `reverb` stage would have nowhere for that call to land, which is what "the
 chain is the instrument" means.""",
                returnDoc = """A pattern emitting one control event per cycle.""",
                samples = listOf(
                    KlangCodeSample(code = """stack(
  s("bd*4"),
  note("c2 g2").s("supersaw"),
  katalyst(Katalyst(k => k.classic().eq(e => e.band(freq = 300, q = 1.0, db = 3.0)))),
).orbit(1).reverb(wet = 0.25, size = 4)""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "katalystParam" to KlangSymbol(
        name = "katalystParam",
        category = "effects",
        tags = listOf("katalyst", "orbit", "chain", "bus", "param", "slot"),
        aliases = listOf("katp"),
        scope = KlangScope.ORBIT,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "katalystParam",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "slot", type = kt15, description = """The chain slot (required): its name, or the Katalyst param itself."""),
                    KlangParam(name = "value", type = kt7, description = """The slot value."""),
                ),
                returnType = kt2,
                description = """Writes one **orbit chain slot**, per orbit, by its `<stage>.<knob>`
 name or by the Katalyst param object itself.

 Direct access to a declared chain's named knobs, the orbit twin of [ignitorParam]: `ignp` fills the
 voice's own instrument, `katp` the chain its orbit runs. The vocabulary is what the chain
 declares, which for a chain built from `k.classic()` is every classic knob: `body.material`,
 `body.wet`, `body.floor`, `vowel.vowel`, `vowel.wet`, `vowel.floor`, `delay.wet`, `delay.time`,
 `delay.feedback`, `delay.cap`, `reverb.wet`, `reverb.size`, `reverb.lowpass`, `phaser.rate`,
 `phaser.wet`, `phaser.center`, `phaser.sweep`, `phaser.floor`, `compressor.threshold`,
 `compressor.ratio`, `compressor.knee`, `compressor.attack`, `compressor.release`, `gain.gain`,
 `duck.orbit`, `duck.depth`, `duck.attack`. An authored chain names its own with
 `Katalyst.param("room", 5)`.

 The slot can be the param OBJECT instead of its name: `Katalyst.slot.reverb.wet` is the classic knob
 `reverb.wet`, and a `Katalyst.param(...)` held in a variable is its own name. Only the NAME is written; the
 default stays the chain's. An Ignitor param (`Ignitor.param(...)`, `Ignitor.slot.*`) is the voice's slot, which
 [ignitorParam] writes; handing one to this door is a script error at the call, and so is a number or a sound.

 `gain.gain` is the orbit's **group fader**, the last stage before the duck: one multiply of the
 whole orbit mix, after the compressor, covering the dry signal and the delay and reverb returns
 alike. 1 is unity and is what every orbit runs at; below 1 is quieter, above 1 louder, and a
 move glides over 50 ms so it never steps.


 **It is a mix knob, not an articulation**, and for the ordinary reason every `katp` value is:
 the fader follows the orbit's owner: the orbit's bus settings are owned by the newest sounding
 voice, a voice gives the orbit up when its gate closes or it is cut, so a new value lands with
 the next note's onset. Set it and leave it. For something that moves
 per note, reach for `gain` (the level a voice leaves at) or `pregain` (how hard it is played in).

 **Patterning it through exactly 0 keeps the orbit running**: an orbit never deactivates while a
 voice plays on it, so the fader waits at zero and glides back up from there. It is still not a
 per-note mute: the way back up starts when the next owner hands the fader its new value, which
 can fall mid-note of an older voice still ringing. Mute a note with `gain` on the
 pattern instead.

 **Which chain hears this map.** THIS IS THE ONE HOME of that rule; every other mention of it is
 a pointer here.

 **Every chain does, for every stage it declares.** An orbit that declares nothing runs the
 familiar chain and reads this map exactly as a declared one does, so `katp("gain.gain", 0.8)`
 moves the fader of any orbit and needs no `.katalyst(...)` first. A bus DOOR and its slot are
 the same knob written two ways: `reverb(wet = 0.4, size = 8)` writes `reverb.wet` and
 `reverb.size`, and the stage reads them; `katp("reverb.size", 8)` moves that same size slot, and
 whether a room is HEARD then depends on the wet as it always does (see the last paragraph).
 Declaring a chain therefore changes what STAGES an orbit has, never where their knobs come from,
 and `.katalyst(Katalyst(k => k.classic()))` on an orbit that declared nothing changes nothing at
 all.

 The one thing to know: a slot only exists when a stage declares it. `k.classic()` declares every
 knob listed above; a chain that declares an `eq` names the eq's own slots; and a name nothing
 declares is simply not read, which is what a `.katalyst(Katalyst(k => k.eq(...)))` (an EQ and
 nothing else) does to a `reverb(...)` on its voices.

 **`body.material` and `vowel.vowel` are numbers, and the number is an INDEX** into the material
 and vowel catalogues, 0 = none (Katalyst step 5a-2, 2026-09-18). The `body(...)` and `vowel(...)`
 doors convert a name for you, so `body(material = "wood", wet = 0.3)` reaches a declared chain
 like every other knob. Writing an index by hand here is possible and rarely what you want: the
 names are the readable door, and a raw index moves if the catalogue grows.

 Three more things it is NOT, and they all follow from the orbit being a bus and not a note:

  - **No per-note snapshot.** The value is orbit state: the chain re-reads it when the owner's map
    changes, so a chord writes it once, not once per note.
  - **Only the OWNER is heard.** The newest sounding voice owns the orbit; an older pattern's note on
    the same orbit writes into nothing while a newer one sounds. Give it its own orbit.
  - **Only a SLOT moves.** A knob the chain wrote as a number (`k.reverb(size = 4)`) is
    fixed; write `Katalyst.param` where the chain should listen.

 A raw slot write is exactly one slot, unlike a compound door (`reverb(...)`, `body(...)`,
 `compressor(...)` and the rest), which fills the companions of the stage it names: on the
 familiar chain a `katp("reverb.wet", 0.3)` alone stays silent until `reverb.size` is written
 too, because the engine gates the room on its size.""",
                returnDoc = """A new pattern with the orbit chain slot set.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3 e3 g3").s("supersaw").orbit(1).katalystParam("gain.gain", 0.8)   // this orbit, a little down""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c3 e3 g3").s("supersaw").reverb(wet = 0.4).katalystParam("reverb.size", "<2 8>")   // small room, then a hall""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c3 e3").s("saw").katalyst(Katalyst(k => k.reverb(0.5, Katalyst.param("room", 2))))
  .katalystParam("room", "<2 9>")""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """let room = Katalyst.param("room", 2)
note("c3 e3").s("saw").katalyst(Katalyst(k => k.reverb(0.5, room))).katalystParam(room, "<2 9>")""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "katalystParam",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "slot", type = kt15, description = """The chain slot (required): its name, or the Katalyst param itself."""),
                    KlangParam(name = "value", type = kt7, description = """The slot value."""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern and writes an orbit chain slot, by name or by the Katalyst param object.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """"c3 e3 g3".katalystParam("reverb.size", 6).reverb(wet = 0.4).s("supersaw").note()""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "katalystParam",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "slot", type = kt15, description = """The chain slot (required): its name, or the Katalyst param itself."""),
                    KlangParam(name = "value", type = kt7, description = """The slot value."""),
                ),
                returnType = kt5,
                description = """Chains an orbit-chain-slot write onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "katalystParam",
                params = listOf(
                    KlangParam(name = "slot", type = kt15, description = """The chain slot (required): its name, or the Katalyst param itself."""),
                    KlangParam(name = "value", type = kt7, description = """The slot value."""),
                ),
                returnType = kt5,
                description = """Creates a [PatternMapperFn] that writes an orbit chain slot, by name or by the Katalyst param object.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3 e3").s("saw").reverb(wet = 0.4).apply(katalystParam("reverb.size", 8))""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "katp" to KlangSymbol(
        name = "katp",
        category = "effects",
        tags = listOf("katp", "katalyst", "orbit", "chain", "bus", "param", "slot"),
        aliases = listOf("katalystParam"),
        scope = KlangScope.ORBIT,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "katp",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "slot", type = kt15, description = """The chain slot (required): its name, or the Katalyst param itself."""),
                    KlangParam(name = "value", type = kt7, description = """The slot value."""),
                ),
                returnType = kt2,
                description = """Alias for [katalystParam].""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3 e3 g3").s("supersaw").reverb(wet = 0.4).katp(Katalyst.slot.reverb.size, "<2 8>")""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "katp",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "slot", type = kt15, description = """The chain slot (required): its name, or the Katalyst param itself."""),
                    KlangParam(name = "value", type = kt7, description = """The slot value."""),
                ),
                returnType = kt2,
                description = """Alias for [katalystParam]. Parses this string as a pattern and writes an orbit chain slot.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """"c3 e3 g3".katp("reverb.size", 6).reverb(wet = 0.4).s("supersaw").note()""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "katp",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "slot", type = kt15, description = """The chain slot (required): its name, or the Katalyst param itself."""),
                    KlangParam(name = "value", type = kt7, description = """The slot value."""),
                ),
                returnType = kt5,
                description = """Alias for [katalystParam]. Chains an orbit-chain-slot write onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "katp",
                params = listOf(
                    KlangParam(name = "slot", type = kt15, description = """The chain slot (required): its name, or the Katalyst param itself."""),
                    KlangParam(name = "value", type = kt7, description = """The slot value."""),
                ),
                returnType = kt5,
                description = """Alias for [katalystParam]. Creates a [PatternMapperFn] that writes an orbit chain slot.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3 e3").s("saw").reverb(wet = 0.4).apply(katp("reverb.size", 8))""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    )
)

private fun generatedSprudelDocsChunk16() = mapOf(

    "lastOf" to KlangSymbol(
        name = "lastOf",
        category = "conditional",
        tags = listOf("lastOf", "conditional", "cycle", "periodic", "transform"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "lastOf",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "n", type = kt7, description = """How many cycles make one period. The transform fires on the last of these."""),
                    KlangParam(name = "transform", type = kt5, description = """The function to apply on the last cycle of each period."""),
                ),
                returnType = kt2,
                description = """Applies [transform] on the **last** cycle of every [n] cycles; all other cycles play unchanged.

 The pattern rotates through [n] cycles: the original plays on cycles 1 through n−1, then the
 transformed version plays on cycle [n], then the sequence repeats.""",
                returnDoc = """A new pattern that applies [transform] at the end of each period.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3 d3 e3 g3").lastOf(4, x => x.rev())  // reverse on 4th of every 4""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c3 d3 e3 g3").lastOf("<2 4>", x => x.fast(2))  // alternating period""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "lastOf",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "n", type = kt7, description = """How many cycles make one period. The transform fires on the last of these."""),
                    KlangParam(name = "transform", type = kt5, description = """The function to apply on the last cycle of each period."""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern, then applies [transform] on the last of every [n] cycles.""",
                returnDoc = """A new pattern that applies [transform] at the end of each period.""",
                samples = listOf(
                    KlangCodeSample(code = """"c3 d3 e3 g3".lastOf(4, x => x.rev()).note()  // reverse on the 4th of every 4 cycles""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "lastOf",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "n", type = kt7, description = """How many cycles make one period. The transform fires on the last of these."""),
                    KlangParam(name = "transform", type = kt5, description = """The function to apply on the last cycle of each period."""),
                ),
                returnType = kt5,
                description = """Chains a periodic transform onto this [PatternMapperFn], applying [transform] on the last of every [n] cycles.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3 d3").apply(firstOf(4, x => x.rev()).lastOf(2, x => x.fast(2)))  // alternate two transforms""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "lastOf",
                params = listOf(
                    KlangParam(name = "n", type = kt7, description = """How many cycles make one period. The transform fires on the last of these."""),
                    KlangParam(name = "transform", type = kt5, description = """The function to apply on the last cycle of each period."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that applies [transform] on the **last** cycle of every [n] cycles.

 Use the returned mapper as a transform argument or apply it to a pattern via `.apply(...)`.""",
                returnDoc = """A [PatternMapperFn] that applies [transform] at the end of each period.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3 d3 e3 g3").apply(lastOf(4, x => x.rev()))  // reverse on the 4th of every 4 cycles""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c3 e3 g3").firstOf(3, lastOf(2, x => x.fast(2)))  // nested periodic transforms""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "late" to KlangSymbol(
        name = "late",
        category = "tempo",
        tags = listOf("late", "shift", "time", "offset", "nudge", "delay", "behind"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "late",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "amount", type = kt7, description = """Time shift in cycles. 0.5 = shift half a cycle later. Default: 0 (no shift). Typical range: 0–1."""),
                ),
                returnType = kt2,
                description = """Nudges the pattern to start later by the given number of cycles.

 Shifts all events forward in time by the specified amount. For example, `late(0.5)` moves
 every event half a cycle later so that what was at position 0 now appears at position 0.5.
 Useful for creating delay effects or adjusting phase relationships between patterns.""",
                returnDoc = """A pattern shifted later by the given number of cycles.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c d e f").late(0.25)          // shifts the pattern a quarter cycle later""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("bd sd").stack(s("hh*4").late(0.125))    // hi-hat slightly behind the beat""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "late",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "amount", type = kt7),
                ),
                returnType = kt2,
                description = """Nudges the pattern to start later by the given number of cycles.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "late",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "amount", type = kt7),
                ),
                returnType = kt5,
                description = """Chains a late operation onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "late",
                params = listOf(
                    KlangParam(name = "amount", type = kt7, description = """Time shift in cycles. Default: 0. Typical range: 0–1."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that nudges a pattern later by the given number of cycles.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """s("hh*4").apply(late(0.125))        // mapper form""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "lateInCycle" to KlangSymbol(
        name = "lateInCycle",
        category = "tempo",
        tags = listOf("lateInCycle", "timing", "swing", "nudge", "offset"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "lateInCycle",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "amount", type = kt7, description = """Fraction of a cycle to nudge events later. Positive values push events right."""),
                ),
                returnType = kt2,
                description = """Nudges events later within their cycle by the given fraction of a cycle.

 Only shifts events already within the queried time window — does not pull events
 from adjacent cycles. Useful for swing and intra-cycle timing adjustments.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd hh cp").lateInCycle(0.02)                     // subtle late nudge""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("bd hh sd oh").lateInCycle("<0 0.1 0.3 0.5>")        // cycle through nudge amounts""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "lateInCycle",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "amount", type = kt7, description = """Fraction of a cycle to nudge events later."""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern and nudges events later within their cycle.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """"bd hh sd oh".lateInCycle("<0 0.1 0.3 0.5>").s()       // cycle through nudge amounts""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "lateInCycle",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "amount", type = kt7, description = """Fraction of a cycle to nudge events later."""),
                ),
                returnType = kt5,
                description = """Chains a late-nudge onto this [PatternMapperFn], shifting events later within their cycle.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd").apply(stretchBy(2).lateInCycle(0.1))         // stretch then nudge late""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "lateInCycle",
                params = listOf(
                    KlangParam(name = "amount", type = kt7, description = """Fraction of a cycle to nudge events later."""),
                ),
                returnType = kt5,
                description = """Creates a [PatternMapperFn] that nudges events later within their cycle.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd hh cp").apply(lateInCycle(0.1))                // nudge via mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "layer" to KlangSymbol(
        name = "layer",
        category = "structural",
        tags = listOf("layer", "stack", "transform", "superimpose"),
        aliases = listOf("apply"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "layer",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "transforms", type = kt5, isVararg = true, description = """One or more functions to apply; each result is stacked with the others."""),
                ),
                returnType = kt2,
                description = """Applies one or more transformation functions to this pattern and stacks the results.

 Each function in [transforms] is applied to the original pattern independently, and all
 results are stacked together. Useful for building complex textures from a single source.""",
                returnDoc = """All transformed copies stacked as a single pattern.""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd hh sd oh").layer(x => x.fast(2), x => x.rev())              // two transformed layers stacked""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c e g").layer(x => x.transpose(7), x => x.transpose(12))    // fifth and octave stacked""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "layer",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "transforms", type = kt5, isVararg = true),
                ),
                returnType = kt2,
                description = """Applies transformations to this string pattern and stacks the results.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "layer",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "transforms", type = kt5, isVararg = true),
                ),
                returnType = kt5,
                description = """Chains a layer onto this [PatternMapperFn]; stacks the transformed copies.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "layer",
                params = listOf(
                    KlangParam(name = "transforms", type = kt5, isVararg = true, description = """One or more functions; each is applied to the source and results are stacked."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that applies the given transforms to the source and stacks results.""",
                returnDoc = """A [PatternMapperFn] that stacks the transformed copies.""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd").apply(layer(x => x.fast(2), x => x.rev()))   // via mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "legato" to KlangSymbol(
        name = "legato",
        category = "tonal",
        tags = listOf("legato", "clip", "duration", "sustain", "staccato"),
        aliases = listOf("clip"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "legato",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "amount", type = kt6, isOptional = true, defaultDoc = """null""", description = """Duration scaling factor. 1.0 = fill event slot exactly, 0.5 = staccato (half length), 1.5 = overlapping (legato), 2.0 = double length. Default: 1.0. Typical range: 0.1 to 2.0."""),
                ),
                returnType = kt2,
                description = """Sets the legato (duration scaling) factor for events in this pattern.

 A legato of `1.0` fills the full event duration; values above `1.0` create overlapping
 notes (true legato), while values below `1.0` create staccato-like gaps between notes.
 When called with no argument, reinterprets the current event value as a legato amount.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3 e3 g3").legato(1.5)   // notes overlap slightly (legato)""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c3 e3 g3").legato(0.5)   // notes are shorter (staccato)""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "legato",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "amount", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt2,
                description = """Sets the legato (duration scaling) factor on a string pattern.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "legato",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "amount", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt5,
                description = """Chains a legato operation onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "linger" to KlangSymbol(
        name = "linger",
        category = "structural",
        tags = listOf("linger", "loop", "fraction", "repeat", "slice"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "linger",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "t", type = kt7, description = """Fraction to select (positive = from start, negative = from end, 0 = silence). Can be a pattern string."""),
                ),
                returnType = kt2,
                description = """Selects the given fraction of the pattern and repeats that part to fill the remainder of the cycle.

 - `linger(0.5)`: Takes first 50% of pattern, repeats it to fill the cycle
 - `linger(-0.5)`: Takes last 50% of pattern, repeats it to fill the cycle
 - `linger(0)`: Returns silence

 The selected portion is slowed down by the fraction amount to fill the full cycle time.""",
                returnDoc = """A pattern of the selected fraction, looped to fill the cycle.""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd ht lt").linger(0.5)  // repeats "bd sd" throughout the cycle""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("lt ht mt cp").linger("<1 .5 .25 .125 .0625 .03125>")  // different fraction each cycle""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "linger",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "t", type = kt7, description = """Fraction to select (positive = from start, negative = from end, 0 = silence). Can be a pattern string."""),
                ),
                returnType = kt2,
                description = """Selects the given fraction of this string-parsed pattern and repeats that part to fill the cycle.""",
                returnDoc = """A pattern of the selected fraction, looped to fill the cycle.""",
                samples = listOf(
                    KlangCodeSample(code = """"bd sd ht lt".linger(0.5).s()  // repeats "bd sd" throughout the cycle""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "linger",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "t", type = kt7),
                ),
                returnType = kt5,
                description = """Chains a linger onto this [PatternMapperFn]; repeats the selected fraction of the result to fill the cycle.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "linger",
                params = listOf(
                    KlangParam(name = "t", type = kt7, description = """Fraction to select (positive = from start, negative = from end, 0 = silence). Can be a pattern string."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that selects the given fraction of the source pattern and repeats it to fill the cycle.""",
                returnDoc = """A [PatternMapperFn] that lingers on the selected fraction of the source.""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd ht lt").apply(linger(0.5))  // via mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "log2" to KlangSymbol(
        name = "log2",
        category = "arithmetic",
        tags = listOf("log2", "logarithm", "arithmetic", "math"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "log2",
                receiver = kt0,
                params = emptyList(),
                returnType = kt2,
                description = """Applies log base 2 to every numeric value in the pattern.

 Only the raw event `value` is affected — `note`, `soundIndex`, and all other voice properties
 remain unchanged. Useful for converting exponential frequency ratios to linear semitone or
 octave values.""",
                returnDoc = """A new pattern where each value is replaced by `log2(value)`.""",
                samples = listOf(
                    KlangCodeSample(code = """"8 16".log2().scale("c3:major").n()  // log2(8)=3, log2(16)=4""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """"1 2 4 8".log2().scale("c3:major").n()  // 0, 1, 2, 3""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "log2",
                receiver = kt3,
                params = emptyList(),
                returnType = kt2,
                description = """Parses this string as a pattern, then applies log base 2 to every numeric value.

 Only the raw event `value` is affected — `note`, `soundIndex`, and other voice properties
 remain unchanged.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """"1 2 4 8".log2().scale("c3:major").n()  // 0, 1, 2, 3""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "log2",
                receiver = kt4,
                params = emptyList(),
                returnType = kt5,
                description = """Chains a log2 operation onto this [PatternMapperFn], applying log base 2 to every numeric value.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """seq("2 4").apply(mul(4).log2()).scale("c3:major").n()  // log2(2*4)=log2(8)=3, log2(4*4)=log2(16)=4""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "log2",
                params = emptyList(),
                returnType = kt5,
                description = """Creates a [PatternMapperFn] that applies log base 2 to every numeric value in a pattern.

 Only the raw event `value` is affected — `note`, `soundIndex`, and other voice properties
 remain unchanged. Use with [SprudelPattern.apply] to apply the transform to an existing pattern.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """seq("1 2 4 8").apply(log2()).scale("c3:major").n()  // 0, 1, 2, 3""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "loop" to KlangSymbol(
        name = "loop",
        category = "sampling",
        tags = listOf("loop", "looping", "repeat", "sample"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "loop",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "flag", type = kt7, isOptional = true, defaultDoc = """true""", description = """Loop flag; truthy = enable looping. Defaults to `true`."""),
                ),
                returnType = kt2,
                description = """Enables continuous looping of the sample.

 When `loop` is set to a truthy value, the sample repeats continuously after reaching
 the end (or the [end] position). Use [begin] and [end] to set the loop region.""",
                returnDoc = """A pattern with sample looping enabled.""",
                samples = listOf(
                    KlangCodeSample(code = """s("pad").loop(1)                    // loop the sample continuously""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("pad").loop(1).begin(0.25).end(0.75)  // loop only the middle section""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "loop",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "flag", type = kt7, isOptional = true, defaultDoc = """true"""),
                ),
                returnType = kt2,
                description = """Enables sample looping on a string pattern.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "loop",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "flag", type = kt7, isOptional = true, defaultDoc = """true"""),
                ),
                returnType = kt5,
                description = """Chains a loop onto this [PatternMapperFn]; enables sample looping.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "loop",
                params = listOf(
                    KlangParam(name = "flag", type = kt7, isOptional = true, defaultDoc = """true""", description = """Loop flag; truthy = enable looping. Defaults to `true`."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that enables sample looping.""",
                returnDoc = """A [PatternMapperFn] that sets the loop flag on the source pattern.""",
                samples = listOf(
                    KlangCodeSample(code = """s("pad").apply(loop(1))             // enable looping via mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    )
)

private fun generatedSprudelDocsChunk17() = mapOf(

    "loopAt" to KlangSymbol(
        name = "loopAt",
        category = "sampling",
        tags = listOf("loopAt", "loop", "fit", "cycles", "tempo", "stretch"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "loopAt",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "cycles", type = kt7, description = """Number of cycles to fit the sample into."""),
                ),
                returnType = kt2,
                description = """Fits the sample playback duration to the given number of cycles.

 Adjusts the [speed] and [unit] automatically so that the sample stretches or compresses
 to exactly fill the specified number of cycles. Useful for syncing loops to the pattern
 tempo. `loopAt(1)` fills one cycle; `loopAt(2)` fills two cycles.""",
                returnDoc = """A pattern with speed and unit adjusted to fill the given cycles.""",
                samples = listOf(
                    KlangCodeSample(code = """s("breaks").loopAt(1)          // stretch/compress to exactly one cycle""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("breaks").loopAt(2).slow(2)  // fill two cycles, then play at half speed""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "loopAt",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "cycles", type = kt7),
                ),
                returnType = kt2,
                description = """Fits the sample to the specified number of cycles on a string pattern.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "loopAt",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "cycles", type = kt7),
                ),
                returnType = kt5,
                description = """Chains a loopAt onto this [PatternMapperFn]; fits the sample to the given number of cycles.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "loopAt",
                params = listOf(
                    KlangParam(name = "cycles", type = kt7, description = """Number of cycles to fit the sample into."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that fits the sample to the given number of cycles.""",
                returnDoc = """A [PatternMapperFn] that adjusts speed and unit for the given cycle count.""",
                samples = listOf(
                    KlangCodeSample(code = """s("breaks").apply(loopAt(1))   // fit to one cycle via mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "loopAtCps" to KlangSymbol(
        name = "loopAtCps",
        category = "sampling",
        tags = listOf("loopAtCps", "loopatcps", "loop", "fit", "cycles", "cps", "tempo", "stretch"),
        aliases = listOf("loopatcps"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "loopAtCps",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "factor", type = kt7, description = """Number of cycles to fit the sample into. Default: 1."""),
                    KlangParam(name = "cps", type = kt7, description = """Cycles per second used for speed calculation. Default: 0.5."""),
                ),
                returnType = kt2,
                description = """Fits the sample to the given number of cycles, taking the current cycles-per-second into account.

 Like [loopAt] but also accepts a `cps` (cycles per second) argument to compute the exact
 playback [speed]. This makes the sample lock to the live-coding clock at a specific
 tempo. Default `cps` is `0.5`.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """s("breaks").loopAtCps(1, 0.5)    // fit to 1 cycle at 0.5 cps (default tempo)""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("breaks").loopAtCps(2, 0.75)   // fit to 2 cycles at 0.75 cps""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "loopAtCps",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "factor", type = kt7),
                    KlangParam(name = "cps", type = kt7),
                ),
                returnType = kt2,
                description = """Fits the sample to the given number of cycles and cps value on a string pattern.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "loopAtCps",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "factor", type = kt7),
                    KlangParam(name = "cps", type = kt7),
                ),
                returnType = kt5,
                description = """Chains a loopAtCps onto this [PatternMapperFn]; fits the sample to the given cycles and cps.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "loopAtCps",
                params = listOf(
                    KlangParam(name = "factor", type = kt7, description = """Number of cycles to fit the sample into."""),
                    KlangParam(name = "cps", type = kt7, description = """Cycles per second for speed calculation."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that fits the sample to the given number of cycles and cps.""",
                returnDoc = """A [PatternMapperFn] that adjusts speed and unit for the given cycle count and cps.""",
                samples = listOf(
                    KlangCodeSample(code = """s("breaks").apply(loopAtCps(1, 0.5))   // fit to one cycle at default cps""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "loopatcps" to KlangSymbol(
        name = "loopatcps",
        category = "sampling",
        tags = listOf("loopatcps", "loopAtCps", "loop", "fit", "cycles", "cps", "tempo", "stretch"),
        aliases = listOf("loopAtCps"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "loopatcps",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "factor", type = kt7, description = """Number of cycles to fit the sample into. Default: 1."""),
                    KlangParam(name = "cps", type = kt7, description = """Cycles per second used for speed calculation. Default: 0.5."""),
                ),
                returnType = kt2,
                description = """Alias for [loopAtCps]. Fits the sample to the given number of cycles and cps.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "loopatcps",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "factor", type = kt7),
                    KlangParam(name = "cps", type = kt7),
                ),
                returnType = kt2,
                description = """Alias for [loopAtCps] on a string pattern.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "loopatcps",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "factor", type = kt7),
                    KlangParam(name = "cps", type = kt7),
                ),
                returnType = kt5,
                description = """Chains a loopatcps (alias for [loopAtCps]) onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "loopatcps",
                params = listOf(
                    KlangParam(name = "factor", type = kt7),
                    KlangParam(name = "cps", type = kt7),
                ),
                returnType = kt5,
                description = """Alias for [loopAtCps] — returns a [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "lowpass" to KlangSymbol(
        name = "lowpass",
        category = "effects",
        tags = listOf("lowpass", "lpf.freq", "filter"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "lowpass",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "freq", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "q", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "passes", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "env", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "decay", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "sustain", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "release", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt2,
                description = """Applies a lowpass filter, the long name of [lpf]; both are the same door, use whichever
 reads better in the line you are writing.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3").s("saw").lowpass(800)""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "lowpass",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "freq", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "q", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "passes", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "env", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "decay", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "sustain", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "release", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern, then applies [lowpass].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "lowpass",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "freq", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "q", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "passes", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "env", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "decay", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "sustain", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "release", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt5,
                description = """Chains a lowpass step onto this [PatternMapperFn] (see [SprudelPattern.lowpass]).""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "lpf" to KlangSymbol(
        name = "lpf",
        category = "effects",
        tags = listOf("lpf", "freq", "q", "passes", "env", "attack", "decay", "sustain", "release", "cutoff", "low pass filter", "filter", "envelope"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "lpf",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "freq", type = kt6, isOptional = true, defaultDoc = """null""", description = """Cutoff in Hz.""", uitools = listOf("SprudelLpFilterEditor", "SprudelLpFilterSequenceEditor")),
                    KlangParam(name = "q", type = kt6, isOptional = true, defaultDoc = """null""", description = """Resonance, higher emphasises the cutoff.""", uitools = listOf("SprudelLpResonanceEditor", "SprudelLpResonanceSequenceEditor")),
                    KlangParam(name = "passes", type = kt6, isOptional = true, defaultDoc = """null""", description = """Cascade count, 1 to 16."""),
                    KlangParam(name = "env", type = kt6, isOptional = true, defaultDoc = """null""", description = """Envelope depth in semitones.""", uitools = listOf("SprudelLpEnvEditor", "SprudelLpEnvSequenceEditor")),
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null""", description = """Envelope attack in seconds."""),
                    KlangParam(name = "decay", type = kt6, isOptional = true, defaultDoc = """null""", description = """Envelope decay in seconds."""),
                    KlangParam(name = "sustain", type = kt6, isOptional = true, defaultDoc = """null""", description = """Envelope sustain, 0 to 1."""),
                    KlangParam(name = "release", type = kt6, isOptional = true, defaultDoc = """null""", description = """Envelope release in seconds."""),
                ),
                returnType = kt2,
                description = """The lowpass filter: cutoff, resonance, cascade and the cutoff envelope.

 Only frequencies below the cutoff pass, so lower values sound darker. Every note carries its own
 cutoff, resonance and envelope, per voice.

 The envelope sweeps `freq` up by `env` semitones: attack is the time to reach full depth, decay
 the fall to the sustain share, release the fall back to `freq` after the note ends. `env = 12`
 doubles the cutoff, a negative `env` sweeps down, and without `env` the filter rests at `freq`.

 `passes` cascades the filter: `2` is 24 dB/oct, `3` is 36, omit it for one 12 dB/oct stage. It is
 rounded and coerced to 1..16, a resource count, never an error. Resonance compounds across the
 stages, so `lpf(800, 10, 4)` peaks far louder than `lpf(800, 10)`.

 Every slot is independent and patternable; an omitted slot keeps its value, a named slot takes
 a mapper (`lpf(q = mul(2))`), and every slot reads back as a child: `lpf.freq`, `lpf.q`, `lpf.passes`, `lpf.env`, `lpf.attack`, `lpf.decay`, `lpf.sustain`, `lpf.release`.
 With no argument at all, the pattern's own values are reinterpreted as `freq`.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3 e3").s("saw").lpf(800, 8)                                          // cutoff and resonance""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c3*4").s("saw").lpf(freq = 300, env = 24, attack = 0.01, decay = 0.3, sustain = 0.2)   // a two-octave filter pluck""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c3 e3").s("saw").lpf(800).lpf(freq = mul(perlin.seg(4).range(0.5, 2)))       // the cutoff wanders""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c3 e3").s("saw").lpf("400 1600").hpf(lpf.freq.div(2))                 // highpass an octave below the cutoff""", type = KlangCodeSampleType.PLAYABLE)
                ),
                uitools = listOf("SprudelLpFilterEditor"),
                library = "sprudel"
            ),
            KlangCallable(
                name = "lpf",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "freq", type = kt6, isOptional = true, defaultDoc = """null""", uitools = listOf("SprudelLpFilterEditor", "SprudelLpFilterSequenceEditor")),
                    KlangParam(name = "q", type = kt6, isOptional = true, defaultDoc = """null""", uitools = listOf("SprudelLpResonanceEditor", "SprudelLpResonanceSequenceEditor")),
                    KlangParam(name = "passes", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "env", type = kt6, isOptional = true, defaultDoc = """null""", uitools = listOf("SprudelLpEnvEditor", "SprudelLpEnvSequenceEditor")),
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "decay", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "sustain", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "release", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern, then applies [lpf].""",
                returnDoc = """""",
                samples = emptyList(),
                uitools = listOf("SprudelLpFilterEditor"),
                library = "sprudel"
            ),
            KlangCallable(
                name = "lpf",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "freq", type = kt6, isOptional = true, defaultDoc = """null""", uitools = listOf("SprudelLpFilterEditor", "SprudelLpFilterSequenceEditor")),
                    KlangParam(name = "q", type = kt6, isOptional = true, defaultDoc = """null""", uitools = listOf("SprudelLpResonanceEditor", "SprudelLpResonanceSequenceEditor")),
                    KlangParam(name = "passes", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "env", type = kt6, isOptional = true, defaultDoc = """null""", uitools = listOf("SprudelLpEnvEditor", "SprudelLpEnvSequenceEditor")),
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "decay", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "sustain", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "release", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt5,
                description = """Chains a [lpf] step onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                uitools = listOf("SprudelLpFilterEditor"),
                library = "sprudel"
            )
        )
    ),

    "lpfCurves" to KlangSymbol(
        name = "lpfCurves",
        category = "effects",
        tags = listOf("lpf", "curve", "envelope", "shape", "filter envelope"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "lpfCurves",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the attack stage."""),
                    KlangParam(name = "decay", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the decay stage."""),
                    KlangParam(name = "release", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the release stage."""),
                ),
                returnType = kt2,
                description = """Sets the shape of each stage of the lowpass filter's cutoff envelope ([lpf]'s `env`, `attack`,
 `decay`, `sustain`, `release`), the way [adsrCurves] shapes the amplitude envelope. Each stage is
 independent; an omitted stage, or an unknown curve name, keeps its current curve, so
 `lpfCurves(decay = "linear")` changes only the decay.

 The curves are the same six as `adsrCurves`: `linear`, `square`, `cube`, `scurve`, `invsquare`,
 `exponential`, with the same aliases. Unset, every stage is `exponential`, the default of every
 modulation envelope on every surface (decision D3). A curve alone switches nothing on: without an
 envelope on the `lpf` there is no sweep to shape. The Ignitor filters name the same curves inside
 their envelope: `x => x.adsr(a, d, s, r, e => e.curves(...))`.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3*4").s("saw").lpf(freq = 300, env = 24, decay = 0.3, sustain = 0.2).lpfCurves("linear", "linear", "linear")   // a straight glide in semitones""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "lpfCurves",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the attack stage."""),
                    KlangParam(name = "decay", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the decay stage."""),
                    KlangParam(name = "release", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the release stage."""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern and sets the lowpass filter envelope's stage curves (see [lpfCurves]).""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "lpfCurves",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the attack stage. Omit to keep the current curve."""),
                    KlangParam(name = "decay", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the decay stage. Omit to keep the current curve."""),
                    KlangParam(name = "release", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the release stage. Omit to keep the current curve."""),
                ),
                returnType = kt5,
                description = """Creates a chained [PatternMapperFn] that sets the lowpass filter envelope's stage curves after the previous mapper.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "lt" to KlangSymbol(
        name = "lt",
        category = "arithmetic",
        tags = listOf("lt", "less than", "comparison", "arithmetic"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "lt",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "threshold", type = kt7, description = """The value to compare against. May be a number, string mini-notation, or a [SprudelPattern]."""),
                ),
                returnType = kt2,
                description = """Compares every value in the pattern to [threshold], replacing each with `1` (true) if less
 than [threshold] or `0` (false) otherwise.

 Only the raw event `value` is affected — `note`, `soundIndex`, and all other voice properties
 remain unchanged. Supports control patterns: pass a mini-notation string or another
 [SprudelPattern] as [threshold] to modulate the threshold per cycle or event.""",
                returnDoc = """A new pattern of `0`/`1` values.""",
                samples = listOf(
                    KlangCodeSample(code = """seq("5 10").lt(8).scale("c3:major").n()  // 5<8 -> 1, 10<8 -> 0""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """seq("5 10").lt("<8 6>").scale("c3:major").n()  // threshold changes each cycle""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "lt",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "threshold", type = kt7),
                ),
                returnType = kt2,
                description = """""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "lt",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "threshold", type = kt7),
                ),
                returnType = kt5,
                description = """""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "lt",
                params = listOf(
                    KlangParam(name = "threshold", type = kt7),
                ),
                returnType = kt5,
                description = """""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "lte" to KlangSymbol(
        name = "lte",
        category = "arithmetic",
        tags = listOf("lte", "less than or equal", "comparison", "arithmetic"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "lte",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "threshold", type = kt7, description = """The value to compare against. May be a number, string mini-notation, or a [SprudelPattern]."""),
                ),
                returnType = kt2,
                description = """Compares every value in the pattern to [threshold], replacing each with `1` (true) if less
 than or equal to [threshold] or `0` (false) otherwise.""",
                returnDoc = """A new pattern of `0`/`1` values.""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "lte",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "threshold", type = kt7),
                ),
                returnType = kt2,
                description = """""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "lte",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "threshold", type = kt7),
                ),
                returnType = kt5,
                description = """""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "lte",
                params = listOf(
                    KlangParam(name = "threshold", type = kt7),
                ),
                returnType = kt5,
                description = """""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    )
)

private fun generatedSprudelDocsChunk18() = mapOf(

    "mask" to KlangSymbol(
        name = "mask",
        category = "structural",
        tags = listOf("mask", "gate", "filter", "rhythm", "boolean"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "mask",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true, description = """Boolean pattern — truthy events let the source through, falsy events silence it."""),
                ),
                returnType = kt2,
                description = """Filters this pattern using a boolean mask, keeping events that overlap truthy mask events.

 Unlike [struct], which uses the mask's timing for structure, `mask` keeps the source pattern's
 original timing and gates out events where the mask is falsy.""",
                returnDoc = """The source pattern gated by the mask.""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd hh cp").mask("1 0 1 1")  // second beat silenced by the mask""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c d e f").mask("<1 0>")      // entire pattern alternates on/off each cycle""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "mask",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true),
                ),
                returnType = kt2,
                description = """Filters this string pattern using a boolean mask; truthy events pass, falsy events are silenced.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "mask",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true),
                ),
                returnType = kt5,
                description = """Chains a mask onto this [PatternMapperFn]; gates the result by the boolean mask.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "mask",
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true, description = """Boolean pattern — truthy events let the source through, falsy events silence it."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that filters the source using a boolean mask.""",
                returnDoc = """A [PatternMapperFn] that gates the source pattern by the mask.""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd hh cp").apply(mask("1 0 1 1"))  // via mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "maskAll" to KlangSymbol(
        name = "maskAll",
        category = "structural",
        tags = listOf("maskAll", "mask", "gate", "filter", "rhythm"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "maskAll",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true, description = """Pattern that defines the gating structure (all values allowed, not just truthy)."""),
                ),
                returnType = kt2,
                description = """Like [mask], but keeps all source events overlapping the mask structure regardless of truthiness.""",
                returnDoc = """The source pattern gated by the mask's structure, with all overlapping events kept.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c d e f").maskAll("x ~ x ~")  // every other beat silenced by structure""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "maskAll",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true),
                ),
                returnType = kt2,
                description = """Like [maskAll] on a string pattern; gates by mask structure, all values pass.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "maskAll",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true),
                ),
                returnType = kt5,
                description = """Chains a maskAll onto this [PatternMapperFn]; gates the result keeping all overlapping events.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "maskAll",
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true, description = """Pattern that defines the gating structure."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that gates the source using the mask's structure (all values pass).""",
                returnDoc = """A [PatternMapperFn] that gates the source, keeping all overlapping events.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c d e f").apply(maskAll("x ~ x ~"))  // via mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "master" to KlangSymbol(
        name = "master",
        category = "effects",
        tags = listOf("master", "loudness", "gain", "limiter", "bus", "motor"),
        aliases = listOf(),
        scope = KlangScope.MASTER,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "master",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "master", type = kt14, description = """The master chain to apply."""),
                ),
                returnType = kt2,
                description = """Sets the master chain from this pattern's events onward.

 Unlike the top-level [master] carrier, these events still sound — the master swap simply rides
 them. That makes the master patternable: put it on a slow rest-like pattern to stage a change,
 or on real notes to align it with the music.""",
                returnDoc = """A new pattern whose events carry the master reference.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3 e3 g3").s("supersaw").master(Katalyst(k => k.gain(1.8)))""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "master",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "master", type = kt14, description = """The master chain to apply."""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern and sets the master chain from its events onward.""",
                returnDoc = """A new pattern whose events carry the master reference.""",
                samples = listOf(
                    KlangCodeSample(code = """"c3 e3 g3".master(Katalyst(k => k.gain(1.8))).s("supersaw")""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "master",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "master", type = kt14, description = """The master chain to apply."""),
                ),
                returnType = kt5,
                description = """Creates a chained [PatternMapperFn] that sets the master chain after the previous mapper.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "master",
                params = listOf(
                    KlangParam(name = "master", type = kt14, description = """The master chain to apply."""),
                ),
                returnType = kt2,
                description = """Creates a pattern that sets the **master chain** for the whole playback — one silent control event
 per cycle that carries nothing but the master reference.

 The master is the last stage of the signal path: everything this playback plays (all orbits, after
 their Katalyst effects) runs through it before being mixed with other playbacks. Use it to bring a
 deliberately quiet mix back up and to hold the ceiling:


 The chain is a `Katalyst`, the same chain an orbit runs, so every stage the builder offers works
 here. Two differences follow from the position: nothing fills a `Katalyst.param(...)` slot at the
 output (it stays at its default, `katp` reaches orbits only), and a `duck` stage is inert (there is
 no other orbit to listen to). `master(Katalyst())` switches the master back off.

 The event is a **control event**: it never sounds. Because a master reference can ride any event,
 `note("c3").master(…)` swaps the master at that note's onset *and* still plays the note — which is
 how you automate a master over musical time (see [SprudelPattern.master]).""",
                returnDoc = """A pattern emitting one control event per cycle.""",
                samples = listOf(
                    KlangCodeSample(code = """stack(
  note("c2 g2").s("supersaw"),
  s("bd*4"),
  master(Katalyst(k => k.gain(2.5).limiter())),
)""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "max" to KlangSymbol(
        name = "max",
        category = "arithmetic",
        tags = listOf("max", "maximum", "cap", "ceiling", "clamp", "arithmetic", "value"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "max",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "other", type = kt7, description = """The maximum allowed value (cap). May be a number, string mini-notation, or a [SprudelPattern]."""),
                ),
                returnType = kt2,
                description = """Enforces a maximum allowed value of [other] on each event.

 Anything above [other] is lowered to [other]; values at or below [other] pass through
 unchanged. Supports control patterns: pass a mini-notation string or another
 [SprudelPattern] as [other] to vary the cap per cycle or event.""",
                returnDoc = """A new pattern with each numeric value capped at [other].""",
                samples = listOf(
                    KlangCodeSample(code = """seq("0 1 2 3 4").max(2).scale("c4:major").n()   // becomes: 0 1 2 2 2""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """sine.range(0, 2).max("<1 0.5>")   // alternate the cap each cycle""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "max",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "other", type = kt7),
                ),
                returnType = kt2,
                description = """Enforces a maximum allowed value of [other] on each numeric value of a string pattern.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """"0 1 2 3 4".max(2).scale("c4:major").n()   // becomes: 0 1 2 2 2""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "max",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "other", type = kt7),
                ),
                returnType = kt5,
                description = """Chains a `max` cap onto this [PatternMapperFn], enforcing [other] as the maximum value.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """seq("1 2 3").apply(mul(2).max(4))  // max(1*2,4)=2, max(2*2,4)=4, max(3*2,4)=4""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "max",
                params = listOf(
                    KlangParam(name = "other", type = kt7),
                ),
                returnType = kt5,
                description = """Creates a [PatternMapperFn] that enforces a maximum allowed value of [other].""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """seq("0 1 2 3 4").apply(max(2)).scale("c4:major").n()   // becomes: 0 1 2 2 2""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "merge" to KlangSymbol(
        name = "merge",
        category = "structural",
        tags = listOf("merge", "overlay", "combine", "voice", "data"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "merge",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "ctrl", type = kt7, description = """The pattern (or mini-notation string) whose voice data is merged in."""),
                ),
                returnType = kt2,
                description = """Overlays voice properties from a control pattern onto this pattern's events.

 For each source event the control is sampled at the event's onset time. Non-null fields
 from the control's [SprudelVoiceData] override the corresponding fields in the source event.
 Source fields that the control leaves `null` are kept unchanged.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """s("hh hh hh hh").merge(note("c3 d3 e3 f3"))   // high-hat gains note values from the note pattern""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("hh!8").merge(freq("100 200 300 400"))   // high-hat gains frequencies""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("hh!8").merge("x!8".freq(sine.range(100, 1000)))   // high-hat gains frequencies""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("<[c3 d3] [e3 f3]>").merge(seq("<12000 8000 4000 2000>").onepole())   // notes darken per event (one-pole Hz)""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "merge",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "ctrl", type = kt7, description = """The pattern (or mini-notation string) whose voice data is merged in."""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern and overlays voice properties from the control pattern.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """"1 2 3 4".merge("<12000 8000 4000 2000>".onepole()).scale("c3:major").n()   // value sequence gains warmth from control""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "merge",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "ctrl", type = kt7, description = """The pattern (or mini-notation string) whose voice data is merged in."""),
                ),
                returnType = kt5,
                description = """Chains a voice-data overlay onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "merge",
                params = listOf(
                    KlangParam(name = "ctrl", type = kt7, description = """The pattern (or mini-notation string) whose voice data is merged in."""),
                ),
                returnType = kt5,
                description = """Creates a [PatternMapperFn] that overlays voice properties from the control pattern.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """seq("1 2").apply(merge(seq("8000 3000").onepole())).scale("c3:major").n()   // apply warmth overlay as a mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "min" to KlangSymbol(
        name = "min",
        category = "arithmetic",
        tags = listOf("min", "minimum", "floor", "clamp", "arithmetic", "value"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "min",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "other", type = kt7, description = """The minimum allowed value (floor). May be a number, string mini-notation, or a [SprudelPattern]."""),
                ),
                returnType = kt2,
                description = """Enforces a minimum allowed value of [other] on each event.

 Anything below [other] is raised to [other]; values at or above [other] pass through
 unchanged. Supports control patterns: pass a mini-notation string or another
 [SprudelPattern] as [other] to vary the floor per cycle or event.""",
                returnDoc = """A new pattern with each numeric value floored at [other].""",
                samples = listOf(
                    KlangCodeSample(code = """seq("0 1 2 3 4").min(2).scale("c4:major").n()   // becomes: 2 2 2 3 4""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """sine.range(-1, 1).min(0)   // half-wave rectify a sine""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "min",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "other", type = kt7),
                ),
                returnType = kt2,
                description = """Enforces a minimum allowed value of [other] on each numeric value of a string pattern.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """"0 1 2 3 4".min(2).scale("c4:major").n()   // becomes: 2 2 2 3 4""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "min",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "other", type = kt7),
                ),
                returnType = kt5,
                description = """Chains a `min` floor onto this [PatternMapperFn], enforcing [other] as the minimum value.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """seq("1 2 3").apply(sub(2).min(0))  // min(1-2,0)=0, min(2-2,0)=0, min(3-2,0)=1""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "min",
                params = listOf(
                    KlangParam(name = "other", type = kt7),
                ),
                returnType = kt5,
                description = """Creates a [PatternMapperFn] that enforces a minimum allowed value of [other].""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """seq("0 1 2 3 4").apply(min(2)).scale("c4:major").n()   // becomes: 2 2 2 3 4""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "mini" to KlangSymbol(
        name = "mini",
        category = "structural",
        tags = listOf("mini", "notation", "parse", "sequence"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "mini",
                receiver = kt3,
                params = emptyList(),
                returnType = kt2,
                description = """Parses this string as mini-notation and returns the resulting pattern.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """"c d e f".mini().note()  // Four notes from mini-notation string""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "mini",
                params = listOf(
                    KlangParam(name = "patterns", type = kt7, isVararg = true, description = """Strings or other pattern-like values to parse as mini-notation."""),
                ),
                returnType = kt2,
                description = """Parses mini-notation and returns the resulting pattern. Effectively an alias for [seq].

 Mini-notation is the compact pattern language for expressing sequences, sub-sequences,
 alternations, and other rhythmic structures inline as strings.""",
                returnDoc = """A pattern built from the mini-notation input""",
                samples = listOf(
                    KlangCodeSample(code = """mini("c d e f").note()  // Four notes, one per quarter cycle""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """mini("bd [sd cp] hh").s()  // Nested sub-sequence in square brackets""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "mod" to KlangSymbol(
        name = "mod",
        category = "arithmetic",
        tags = listOf("mod", "modulo", "arithmetic", "math", "wrap"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "mod",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "divisor", type = kt7, description = """The modulus. May be a number, string mini-notation, or a [SprudelPattern]."""),
                ),
                returnType = kt2,
                description = """Applies modulo [divisor] to every numeric value in the pattern.

 Only the raw event `value` is affected — `note`, `soundIndex`, and all other voice properties
 remain unchanged. Useful for wrapping note indices, step counters, or any cyclic numeric range.
 Division by zero is safe — events with a zero divisor are silenced. Supports control patterns:
 pass a mini-notation string or another [SprudelPattern] as [divisor].""",
                returnDoc = """A new pattern where each value is replaced by `value % divisor`.""",
                samples = listOf(
                    KlangCodeSample(code = """seq("10 11").mod(3).scale("c3:major").n()  // values become 1 and 2""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """seq("0 1 2 3 4 5 6 7").mod(4).scale("c3:major").n()  // wraps at 4: 0 1 2 3 0 1 2 3""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "mod",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "divisor", type = kt7, description = """The modulus. May be a number, string mini-notation, or a [SprudelPattern]."""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern, then applies modulo [divisor] to every numeric value.

 Only the raw event `value` is affected — `note`, `soundIndex`, and other voice properties
 remain unchanged. Division by zero is safe — events with a zero divisor are silenced.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """"10 11".mod(3).scale("c3:major").n()  // values become 1 and 2""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "mod",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "divisor", type = kt7, description = """The modulus. May be a number, string mini-notation, or a [SprudelPattern]."""),
                ),
                returnType = kt5,
                description = """Chains a modulo operation onto this [PatternMapperFn], applying modulo [divisor] to every numeric value.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """seq("10 11").apply(add(1).mod(4)).scale("c3:major").n()  // (10+1)%4=3, (11+1)%4=0""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "mod",
                params = listOf(
                    KlangParam(name = "divisor", type = kt7, description = """The modulus. May be a number, string mini-notation, or a [SprudelPattern]."""),
                ),
                returnType = kt5,
                description = """Creates a [PatternMapperFn] that applies modulo [divisor] to every numeric value in a pattern.

 Only the raw event `value` is affected — `note`, `soundIndex`, and other voice properties
 remain unchanged. Division by zero is safe — events with a zero divisor are silenced.
 Use with [SprudelPattern.apply] to apply the modulo to an existing pattern.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """seq("0 1 2 3 4 5 6 7").apply(mod(4)).scale("c3:major").n()  // wraps at 4: 0 1 2 3 0 1 2 3""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    )
)

private fun generatedSprudelDocsChunk19() = mapOf(

    "morse" to KlangSymbol(
        name = "morse",
        category = "structural",
        tags = listOf("morse", "code", "rhythm", "structure", "pattern"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "morse",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "text", type = kt7, description = """The text to encode as Morse code. Case-insensitive; unknown characters are skipped."""),
                ),
                returnType = kt2,
                description = """Structures this pattern using a Morse code rhythm derived from the given text.

 Dots are 1 unit; dashes are 3 units. Gaps are inserted automatically:
 1 unit between symbols within a character, 3 units between characters, 7 units between words.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3 d3 e3").morse("sos")         // structure notes with SOS rhythm""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("hh").morse("hello world!")                   // structure a kick with "hi" Morse code""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "morse",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "text", type = kt7, description = """The text to encode as Morse code. Case-insensitive; unknown characters are skipped."""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern and structures it using a Morse code rhythm.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """"hh".morse("hi").s()            // structure a sawtooth sound with "hi" Morse code""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "morse",
                params = listOf(
                    KlangParam(name = "text", type = kt7, description = """The text to encode as Morse code. Case-insensitive; unknown characters are skipped."""),
                ),
                returnType = kt2,
                description = """Creates a rhythmic pattern from a string using Morse code timing.

 The resulting pattern contains events with value `1.0` for dots and dashes, separated by silences.
 Use this to drive a `struct` or as a standalone rhythm, then layer notes or sounds on top.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """morse("sos").note("c4")               // SOS rhythm as notes on c4""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """morse("hello world").s("hh")          // encode a message as a kick drum pattern""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "mul" to KlangSymbol(
        name = "mul",
        category = "arithmetic",
        tags = listOf("mul", "multiply", "arithmetic", "math", "scale"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "mul",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "factor", type = kt7, description = """The multiplier. May be a number, string mini-notation, or a [SprudelPattern]."""),
                ),
                returnType = kt2,
                description = """Multiplies every numeric value in the pattern by [factor].

 Only the raw event `value` is affected — `note`, `soundIndex`, and all other voice properties
 remain unchanged. Supports control patterns: pass a mini-notation string or another
 [SprudelPattern] as [factor] to modulate the scale per cycle or event.""",
                returnDoc = """A new pattern with each numeric value multiplied by [factor].""",
                samples = listOf(
                    KlangCodeSample(code = """seq("2 3").mul(4).scale("c3:major").n()  // values become 8 and 12""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """seq("1 2").mul("<1 2>").scale("c3:major").n()  // double every other cycle""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "mul",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "factor", type = kt7, description = """The multiplier. May be a number, string mini-notation, or a [SprudelPattern]."""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern, then multiplies every numeric value by [factor].

 Only the raw event `value` is affected — `note`, `soundIndex`, and other voice properties
 remain unchanged.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """"2 3".mul(4).scale("c3:major").n()  // values become 8 and 12""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "mul",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "factor", type = kt7, description = """The multiplier. May be a number, string mini-notation, or a [SprudelPattern]."""),
                ),
                returnType = kt5,
                description = """Chains a multiplication onto this [PatternMapperFn], multiplying every numeric value by [factor].""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """seq("1 2").apply(add(1).mul(3)).scale("c2:major").n()  // (1+1)*3=6, (2+1)*3=9""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "mul",
                receiver = kt8,
                params = listOf(
                    KlangParam(name = "factor", type = kt7, description = """The operand. May be a number, string mini-notation, or a [SprudelPattern]."""),
                ),
                returnType = kt5,
                description = """First step of a mapper chain on a field accessor: `freq.mul(...)` reads the field, then multiplies by [factor].""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c e g a").bpf(freq.mul(2))""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "mul",
                params = listOf(
                    KlangParam(name = "factor", type = kt7, description = """The multiplier. May be a number, string mini-notation, or a [SprudelPattern]."""),
                ),
                returnType = kt5,
                description = """Creates a [PatternMapperFn] that multiplies every numeric value in a pattern by [factor].

 Only the raw event `value` is affected — `note`, `soundIndex`, and other voice properties
 remain unchanged. Use with [SprudelPattern.apply] to apply the multiplication to an existing pattern.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """seq("2 3").apply(mul(4)).scale("c3:major").n()  // values become 8 and 12""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "mute" to KlangSymbol(
        name = "mute",
        category = "structural",
        tags = listOf("silence", "mute", "control"),
        aliases = listOf("hush", "bypass"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "mute",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true, description = """Optional condition pattern. When truthy the pattern is silenced."""),
                ),
                returnType = kt2,
                description = """Alias for [hush]. Silences this pattern. Without arguments, unconditionally returns silence.""",
                returnDoc = """Silence, or the original pattern gated by the condition.""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd").mute()          // Unconditional silence""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("bd sd").mute("<1 0>")   // Silent on odd cycles, audible on even""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "mute",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true),
                ),
                returnType = kt2,
                description = """Alias for [hush] on a string pattern. Without arguments, unconditionally returns silence.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "mute",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true),
                ),
                returnType = kt5,
                description = """Chains a mute (alias for [hush]) onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "mute",
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true, description = """Optional condition pattern. When truthy the source pattern is silenced."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] — alias for [hush] — that silences the source pattern.""",
                returnDoc = """A [PatternMapperFn] that silences or conditionally gates the source pattern.""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd").apply(mute())   // Unconditional silence via mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "n" to KlangSymbol(
        name = "n",
        category = "tonal",
        tags = listOf("n", "note number", "sample index", "pitch index", "pattern-creator"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "n",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "index", type = kt6, isOptional = true, defaultDoc = """null""", description = """The sound index to set, or null to reparse sequence values as sound index.""", uitools = listOf("SprudelScaleDegreeEditor")),
                ),
                returnType = kt2,
                description = """Sets the sound index on this pattern.

 When param [index] is null, the sequence values will be reinterpreted as sound index.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """n("0 2 4").scale("c4:major").note()   // indices 0, 2, 4 → C4, E4, G4""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("hh").n("0 1 2")                    // selects different hh samples by index""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "n",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "index", type = kt6, isOptional = true, defaultDoc = """null""", uitools = listOf("SprudelScaleDegreeEditor")),
                ),
                returnType = kt2,
                description = """Sets the sound index on this string pattern.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "n",
                params = listOf(
                    KlangParam(name = "index", type = kt7, description = """The scale degree index pattern in mini-notation, e.g. `"0 1 2 3"`.""", uitools = listOf("SprudelScaleDegreeEditor")),
                ),
                returnType = kt2,
                description = """Creates a pattern of sound indices.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "ne" to KlangSymbol(
        name = "ne",
        category = "arithmetic",
        tags = listOf("ne", "not equal", "inequality", "comparison", "arithmetic"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "ne",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "other", type = kt7, description = """The value to compare against. May be a number, string mini-notation, or a [SprudelPattern]."""),
                ),
                returnType = kt2,
                description = """Compares every value in the pattern to [other] for strict inequality, replacing each with
 `1` (true) if not equal or `0` (false) otherwise.""",
                returnDoc = """A new pattern of `0`/`1` values.""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "ne",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "other", type = kt7),
                ),
                returnType = kt2,
                description = """""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "ne",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "other", type = kt7),
                ),
                returnType = kt5,
                description = """""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "ne",
                params = listOf(
                    KlangParam(name = "other", type = kt7),
                ),
                returnType = kt5,
                description = """""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "net" to KlangSymbol(
        name = "net",
        category = "arithmetic",
        tags = listOf("net", "truthiness", "not equal", "inequality", "comparison", "arithmetic"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "net",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "other", type = kt7, description = """The value to compare against. May be a number, string mini-notation, or a [SprudelPattern]."""),
                ),
                returnType = kt2,
                description = """Compares the truthiness of every value in the pattern to the truthiness of [other], replacing
 each with `1` (true) if their truthiness differs, or `0` (false) otherwise.""",
                returnDoc = """A new pattern of `0`/`1` values.""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "net",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "other", type = kt7),
                ),
                returnType = kt2,
                description = """""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "net",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "other", type = kt7),
                ),
                returnType = kt5,
                description = """""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "net",
                params = listOf(
                    KlangParam(name = "other", type = kt7),
                ),
                returnType = kt5,
                description = """""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "never" to KlangSymbol(
        name = "never",
        category = "random",
        tags = listOf("never", "noop", "placeholder", "conditional"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "never",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "mapper", type = kt5, description = """The transformation — ignored; pattern passes through unchanged."""),
                ),
                returnType = kt2,
                description = """Never applies `transform` — the pattern passes through unchanged. Shorthand for
 `sometimesBy(0, fn)`. Useful as a placeholder during development.""",
                returnDoc = """The unmodified source pattern.""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd").never(x => x.rev())       // rev is never applied; pattern plays normally""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "never",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "mapper", type = kt5),
                ),
                returnType = kt2,
                description = """Never applies `transform` — the pattern passes through unchanged.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "never",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "mapper", type = kt5),
                ),
                returnType = kt5,
                description = """Chains a never (no-op) onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "never",
                params = listOf(
                    KlangParam(name = "mapper", type = kt5),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that never applies `mapper` — source passes through unchanged.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "noCull" to KlangSymbol(
        name = "noCull",
        category = "dynamics",
        tags = listOf("cull", "voice", "release"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "noCull",
                receiver = kt0,
                params = emptyList(),
                returnType = kt2,
                description = """Turns silence culling OFF for each voice: the voice renders its whole scheduled release tail,
 silent or not, the way every voice did before culling existed.

 The one reason to reach for it is a sound whose release goes silent and then comes back (a
 sparse `Ignitor.dust` still ringing, a gate inside the ignitor), which the 50 ms window would cut.
 `cull(seconds)` widens the window instead of removing it. A voice with a `tremolo` gets this
 automatically.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c2").sound("supersaw").adsr(0.01, 0.1, 1, 3).noCull()   // the full three-second tail, always""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "noCull",
                receiver = kt3,
                params = emptyList(),
                returnType = kt2,
                description = """Parses this string as a pattern and turns silence culling off for it (see [noCull]).""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "noCull",
                receiver = kt4,
                params = emptyList(),
                returnType = kt5,
                description = """Chains `noCull` onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    )
)

private fun generatedSprudelDocsChunk20() = mapOf(

    "not" to KlangSymbol(
        name = "not",
        category = "arithmetic",
        tags = listOf("not", "logical", "boolean", "gate", "invert"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "not",
                receiver = kt0,
                params = emptyList(),
                returnType = kt2,
                description = """Applies logical NOT to each event's boolean value.

 Truthy values become `false`; falsy values become `true`. Useful for inverting
 gate or trigger patterns.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """"1 0 0 1".not().scale("c4:minor").n()   // becomes: false true true false""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "not",
                receiver = kt3,
                params = emptyList(),
                returnType = kt2,
                description = """Applies logical NOT to a string pattern's boolean values.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """"1 0 0 1".not().scale("c4:minor").n()   // becomes: false true true false""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "not",
                receiver = kt4,
                params = emptyList(),
                returnType = kt5,
                description = """Chains a logical NOT onto this [PatternMapperFn], inverting every boolean value in the result.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """seq("1 0").apply(mul(1).not())  // not(1*1)=false, not(0*1)=true""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "notch" to KlangSymbol(
        name = "notch",
        category = "effects",
        tags = listOf("notch", "freq", "q", "env", "attack", "decay", "sustain", "release", "notch.freq", "notch filter", "filter", "envelope"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "notch",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "freq", type = kt6, isOptional = true, defaultDoc = """null""", description = """Centre frequency in Hz.""", uitools = listOf("SprudelNotchFilterEditor", "SprudelNotchFilterSequenceEditor")),
                    KlangParam(name = "q", type = kt6, isOptional = true, defaultDoc = """null""", description = """Resonance, higher narrows the notch.""", uitools = listOf("SprudelNResonanceEditor", "SprudelNResonanceSequenceEditor")),
                    KlangParam(name = "env", type = kt6, isOptional = true, defaultDoc = """null""", description = """Envelope depth in semitones.""", uitools = listOf("SprudelNfEnvEditor", "SprudelNfEnvSequenceEditor")),
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null""", description = """Envelope attack in seconds.""", uitools = listOf("SprudelNfAttackEditor", "SprudelNfAttackSequenceEditor")),
                    KlangParam(name = "decay", type = kt6, isOptional = true, defaultDoc = """null""", description = """Envelope decay in seconds.""", uitools = listOf("SprudelNfDecayEditor", "SprudelNfDecaySequenceEditor")),
                    KlangParam(name = "sustain", type = kt6, isOptional = true, defaultDoc = """null""", description = """Envelope sustain, 0 to 1.""", uitools = listOf("SprudelNfSustainEditor", "SprudelNfSustainSequenceEditor")),
                    KlangParam(name = "release", type = kt6, isOptional = true, defaultDoc = """null""", description = """Envelope release in seconds.""", uitools = listOf("SprudelNfReleaseEditor", "SprudelNfReleaseSequenceEditor")),
                ),
                returnType = kt2,
                description = """The notch filter: centre, resonance and the centre envelope.

 A narrow band around the centre is cut and everything else passes, the opposite of a bandpass.
 Higher `q` narrows the cut. Every note carries its own centre, width and envelope,
 per voice.

 The envelope sweeps `freq` up by `env` semitones: attack is the time to reach full depth, decay
 the fall to the sustain share, release the fall back to `freq` after the note ends. `env = 12`
 doubles the centre, a negative `env` sweeps down, and without `env` the filter rests at `freq`.

 Every slot is independent and patternable; an omitted slot keeps its value, a named slot takes
 a mapper (`notch(q = mul(2))`), and every slot reads back as a child: `notch.freq`, `notch.q`, `notch.env`, `notch.attack`, `notch.decay`, `notch.sustain`, `notch.release`.
 With no argument at all, the pattern's own values are reinterpreted as `freq`.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3 e3").s("saw").notch(1000, 8)                                       // a narrow cut at 1 kHz""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c3*4").s("saw").notch(freq = 500, q = 8, env = 24, attack = 0.01, decay = 0.4, sustain = 0.2)   // the notch sweeps two octaves on every hit""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c3 e3").s("saw").notch("800 1600").bpf(notch.freq.mul(2), 3)           // a band an octave above the notch""", type = KlangCodeSampleType.PLAYABLE)
                ),
                uitools = listOf("SprudelNotchFilterEditor"),
                library = "sprudel"
            ),
            KlangCallable(
                name = "notch",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "freq", type = kt6, isOptional = true, defaultDoc = """null""", uitools = listOf("SprudelNotchFilterEditor", "SprudelNotchFilterSequenceEditor")),
                    KlangParam(name = "q", type = kt6, isOptional = true, defaultDoc = """null""", uitools = listOf("SprudelNResonanceEditor", "SprudelNResonanceSequenceEditor")),
                    KlangParam(name = "env", type = kt6, isOptional = true, defaultDoc = """null""", uitools = listOf("SprudelNfEnvEditor", "SprudelNfEnvSequenceEditor")),
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null""", uitools = listOf("SprudelNfAttackEditor", "SprudelNfAttackSequenceEditor")),
                    KlangParam(name = "decay", type = kt6, isOptional = true, defaultDoc = """null""", uitools = listOf("SprudelNfDecayEditor", "SprudelNfDecaySequenceEditor")),
                    KlangParam(name = "sustain", type = kt6, isOptional = true, defaultDoc = """null""", uitools = listOf("SprudelNfSustainEditor", "SprudelNfSustainSequenceEditor")),
                    KlangParam(name = "release", type = kt6, isOptional = true, defaultDoc = """null""", uitools = listOf("SprudelNfReleaseEditor", "SprudelNfReleaseSequenceEditor")),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern, then applies [notch].""",
                returnDoc = """""",
                samples = emptyList(),
                uitools = listOf("SprudelNotchFilterEditor"),
                library = "sprudel"
            ),
            KlangCallable(
                name = "notch",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "freq", type = kt6, isOptional = true, defaultDoc = """null""", uitools = listOf("SprudelNotchFilterEditor", "SprudelNotchFilterSequenceEditor")),
                    KlangParam(name = "q", type = kt6, isOptional = true, defaultDoc = """null""", uitools = listOf("SprudelNResonanceEditor", "SprudelNResonanceSequenceEditor")),
                    KlangParam(name = "env", type = kt6, isOptional = true, defaultDoc = """null""", uitools = listOf("SprudelNfEnvEditor", "SprudelNfEnvSequenceEditor")),
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null""", uitools = listOf("SprudelNfAttackEditor", "SprudelNfAttackSequenceEditor")),
                    KlangParam(name = "decay", type = kt6, isOptional = true, defaultDoc = """null""", uitools = listOf("SprudelNfDecayEditor", "SprudelNfDecaySequenceEditor")),
                    KlangParam(name = "sustain", type = kt6, isOptional = true, defaultDoc = """null""", uitools = listOf("SprudelNfSustainEditor", "SprudelNfSustainSequenceEditor")),
                    KlangParam(name = "release", type = kt6, isOptional = true, defaultDoc = """null""", uitools = listOf("SprudelNfReleaseEditor", "SprudelNfReleaseSequenceEditor")),
                ),
                returnType = kt5,
                description = """Chains a [notch] step onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                uitools = listOf("SprudelNotchFilterEditor"),
                library = "sprudel"
            )
        )
    ),

    "notchCurves" to KlangSymbol(
        name = "notchCurves",
        category = "effects",
        tags = listOf("notch", "curve", "envelope", "shape", "filter envelope"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "notchCurves",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the attack stage."""),
                    KlangParam(name = "decay", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the decay stage."""),
                    KlangParam(name = "release", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the release stage."""),
                ),
                returnType = kt2,
                description = """Sets the shape of each stage of the notch filter's cutoff envelope ([notch]'s `env`, `attack`,
 `decay`, `sustain`, `release`), the way [adsrCurves] shapes the amplitude envelope. Each stage is
 independent; an omitted stage, or an unknown curve name, keeps its current curve, so
 `notchCurves(decay = "linear")` changes only the decay.

 The curves are the same six as `adsrCurves`: `linear`, `square`, `cube`, `scurve`, `invsquare`,
 `exponential`, with the same aliases. Unset, every stage is `exponential`, the default of every
 modulation envelope on every surface (decision D3). A curve alone switches nothing on: without an
 envelope on the `notch` there is no sweep to shape. The Ignitor filters name the same curves inside
 their envelope: `x => x.adsr(a, d, s, r, e => e.curves(...))`.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3*4").s("saw").notch(freq = 800, q = 2, env = 24, decay = 0.3, sustain = 0).notchCurves(decay = "cube")   // a fast first drop, a long tail""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "notchCurves",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the attack stage."""),
                    KlangParam(name = "decay", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the decay stage."""),
                    KlangParam(name = "release", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the release stage."""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern and sets the notch filter envelope's stage curves (see [notchCurves]).""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "notchCurves",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the attack stage. Omit to keep the current curve."""),
                    KlangParam(name = "decay", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the decay stage. Omit to keep the current curve."""),
                    KlangParam(name = "release", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the release stage. Omit to keep the current curve."""),
                ),
                returnType = kt5,
                description = """Creates a chained [PatternMapperFn] that sets the notch filter envelope's stage curves after the previous mapper.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "note" to KlangSymbol(
        name = "note",
        category = "tonal",
        tags = listOf("note", "pitch", "frequency", "MIDI", "note name", "pattern-creator"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "note",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "noteName", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt2,
                description = """Applies note values from arguments (or reinterprets current value as a note name).""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "note",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "noteName", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt2,
                description = """Applies note values to a string pattern.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "note",
                params = listOf(
                    KlangParam(name = "note", type = kt7, isVararg = true, description = """The note pattern in mini-notation, e.g. `"c4 e4 g4"`.""", uitools = listOf("SprudelNoteEditor")),
                ),
                returnType = kt2,
                description = """Creates a pattern of musical notes from a mini-notation string or sequence of note names.

 Note values can be scientific notation (`"c4"`, `"d#3"`, `"bb2"`), MIDI note numbers, or
 numeric indices resolved via the active [scale] context.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c4 e4 g4")          // arpeggiate a C major chord""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("<c3 e3 g3> b2")     // alternating chord tones with a bass note""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "o" to KlangSymbol(
        name = "o",
        category = "dynamics",
        tags = listOf("o", "orbit", "routing", "effects", "bus", "channel"),
        aliases = listOf("orbit"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "o",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "index", type = kt6, isOptional = true, defaultDoc = """null""", description = """The orbit index to route events to."""),
                ),
                returnType = kt2,
                description = """Alias for [orbit]. Routes the pattern to an audio output orbit for independent effect processing.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd").o(1)                       // send drums to orbit 1""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c3 e3").o(2).reverb(0.8, 4)     // melodic line on orbit 2 with reverb""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "o",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "index", type = kt6, isOptional = true, defaultDoc = """null""", description = """The orbit index to route events to."""),
                ),
                returnType = kt2,
                description = """Alias for [orbit]. Parses this string as a pattern and routes it to the given orbit.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """"bd sd".o(1).s()   // send drums to orbit 1""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "off" to KlangSymbol(
        name = "off",
        category = "structural",
        tags = listOf("off", "delay", "echo", "layer", "stack", "time"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "off",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "time", type = kt10, description = """Time offset in cycles for the delayed copy. Default is 0.25 (quarter cycle)."""),
                    KlangParam(name = "transform", type = kt5, description = """Function applied to the delayed copy."""),
                ),
                returnType = kt2,
                description = """Layers a time-shifted, transformed copy of this pattern on top of itself.

 Stacks the original with a delayed copy produced by applying [transform]. Useful for creating rhythmic
 echoes, counterpoint, or call-and-response effects.""",
                returnDoc = """The original pattern stacked with a time-shifted, transformed copy.""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd").off(0.125, x => x.gain(0.2))       // quiet echo 1/8 cycle behind""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c e g").off(0.25, x => x.transpose(12)) // octave-up copy a quarter cycle behind""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "off",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "time", type = kt10),
                    KlangParam(name = "transform", type = kt5),
                ),
                returnType = kt2,
                description = """Layers a time-shifted, transformed copy of this string pattern on top of itself.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "off",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "time", type = kt10),
                    KlangParam(name = "transform", type = kt5),
                ),
                returnType = kt5,
                description = """Chains an off onto this [PatternMapperFn]; layers a time-shifted, transformed copy.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "off",
                params = listOf(
                    KlangParam(name = "time", type = kt10, description = """Time offset in cycles for the delayed copy."""),
                    KlangParam(name = "transform", type = kt5, description = """Function applied to the delayed copy."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that layers a time-shifted, transformed copy on top of the source.""",
                returnDoc = """A [PatternMapperFn] that stacks the source with a late, transformed copy.""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd").apply(off(0.125, x => x.gain(0.2)))   // via mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "often" to KlangSymbol(
        name = "often",
        category = "random",
        tags = listOf("often", "random", "probability", "conditional", "transform"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "often",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "mapper", type = kt5, description = """The transformation to apply 75% of the time."""),
                ),
                returnType = kt2,
                description = """Applies `transform` with 75% probability per event. Shorthand for `sometimesBy(0.75, fn)`.""",
                returnDoc = """A pattern with `mapper` applied to ~75% of events.""",
                samples = listOf(
                    KlangCodeSample(code = """s("hh*8").often(x => x.gain(0.5))    // 75% of hi-hats at half gain""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "often",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "mapper", type = kt5),
                ),
                returnType = kt2,
                description = """Applies `transform` with 75% probability per event. Shorthand for `sometimesBy(0.75, fn)`.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "often",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "mapper", type = kt5),
                ),
                returnType = kt5,
                description = """Chains an often (75% per event) onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "often",
                params = listOf(
                    KlangParam(name = "mapper", type = kt5),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that applies `mapper` with 75% probability per event.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "oneMinusValue" to KlangSymbol(
        name = "oneMinusValue",
        category = "arithmetic",
        tags = listOf("oneMinusValue", "invert", "complement", "arithmetic", "value"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "oneMinusValue",
                receiver = kt0,
                params = emptyList(),
                returnType = kt2,
                description = """Calculates `1.0 - value` for each event's voice data.

 Inverts a value within the `[0, 1]` range. Useful for reversing the direction of
 modulation or envelope signals without leaving the unipolar range.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """rand.oneMinusValue()               // invert random values: high becomes low""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """sine.range(0, 1).oneMinusValue()   // flip a rising sine to a falling sine""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "oneMinusValue",
                receiver = kt3,
                params = emptyList(),
                returnType = kt2,
                description = """Calculates `1.0 - value` for a string pattern.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "oneMinusValue",
                receiver = kt4,
                params = emptyList(),
                returnType = kt5,
                description = """Chains a `1 - value` operation onto this [PatternMapperFn], inverting every value within `[0, 1]`.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """seq("0.2 0.8").apply(mul(2).oneMinusValue())  // 1-(0.2*2)=0.6, 1-(0.8*2)=-0.6""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    )
)

private fun generatedSprudelDocsChunk21() = mapOf(

    "onepole" to KlangSymbol(
        name = "onepole",
        category = "tonal",
        tags = listOf("onepole", "warmth", "oscillator", "filter", "low-pass", "tone"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "onepole",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "freq", type = kt6, isOptional = true, defaultDoc = """null""", description = """Cutoff in Hz. 0 is no filter, lower is darker."""),
                ),
                returnType = kt2,
                description = """Puts a one-pole lowpass on the oscillator at [freq] Hz, the gentlest filter there is
 (6 dB/oct, no resonance). Musically it is a "warmth" knob: lower frequencies are darker.
 `0` (or omitting the call) means no filter.

 This is deliberately a DIFFERENT thing from [lpf]: `lpf` is the resonant 12 dB/oct SVF
 and never secretly swaps character, `onepole` is the soft tone control. It was renamed from
 `warmth(0..1)` in the pitch and unit unification, 2026-08-24, when the value changed from a raw,
 sample-rate dependent filter coefficient to a frequency in Hz.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c d e f").onepole(3700)          // warm, muffled sawtooth""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c d e f").onepole("<12000 3700 1700>")  // stepwise darker""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "onepole",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "freq", type = kt6, isOptional = true, defaultDoc = """null""", description = """The one-pole cutoff in Hz. 0 = no filter; lower = warmer/darker."""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern and sets the oscillator one-pole lowpass (see
 [SprudelPattern.onepole]).""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c d e f").s("square").onepole("<12000 3700 1700>")  // stepwise darker""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "onepole",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "freq", type = kt6, isOptional = true, defaultDoc = """null""", description = """The one-pole cutoff in Hz. 0 = no filter; lower = warmer/darker."""),
                ),
                returnType = kt5,
                description = """Chains a onepole-set onto this [PatternMapperFn], applying the one-pole lowpass after the
 previous step.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """seq("1700 3700").apply(mul(2).onepole())  // mul doubles values, onepole() reads them as Hz""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "or" to KlangSymbol(
        name = "or",
        category = "arithmetic",
        tags = listOf("or", "logical", "boolean", "arithmetic"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "or",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "other", type = kt7, description = """The right-hand operand. May be a number, string mini-notation, or a [SprudelPattern]."""),
                ),
                returnType = kt2,
                description = """Applies logical OR between every value in the pattern and [other].""",
                returnDoc = """A new pattern where each value is `value || other`.""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "or",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "other", type = kt7),
                ),
                returnType = kt2,
                description = """""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "or",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "other", type = kt7),
                ),
                returnType = kt5,
                description = """""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "or",
                params = listOf(
                    KlangParam(name = "other", type = kt7),
                ),
                returnType = kt5,
                description = """""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "orbit" to KlangSymbol(
        name = "orbit",
        category = "dynamics",
        tags = listOf("orbit", "o", "routing", "effects", "bus", "channel"),
        aliases = listOf("o"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "orbit",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "index", type = kt6, isOptional = true, defaultDoc = """null""", description = """The orbit index to route events to."""),
                ),
                returnType = kt2,
                description = """Routes the pattern to an orbit bus, its own channel of shared effects.

 This is the answer whenever two patterns fight over a bus effect. Reverb, delay, phaser,
 compressor, body, vowel and ducking exist once per orbit and take their settings from the first
 voice that sounds there, so a second pattern asking for a different reverb size is ignored. Move it
 to another orbit and it gets its own.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd").orbit(1)                           // send drums to orbit 1""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c3 e3").orbit(2).reverb(wet = 0.8, size = 4)  // melodic line on orbit 2 with reverb""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "orbit",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "index", type = kt6, isOptional = true, defaultDoc = """null""", description = """The orbit index to route events to."""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern and routes it to the given audio output orbit.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """"bd sd".orbit(1).s()   // send drums to orbit 1""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "orbit",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "index", type = kt6, isOptional = true, defaultDoc = """null""", description = """The orbit index to route events to."""),
                ),
                returnType = kt5,
                description = """Creates a chained [PatternMapperFn] that routes events to the given orbit after the previous mapper.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd").apply(gain(0.8).orbit(1))  // gain + orbit chained""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "outside" to KlangSymbol(
        name = "outside",
        category = "tempo",
        tags = listOf("outside", "transform", "zoom", "fast", "slow"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "outside",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "factor", type = kt7, description = """The zoom-out amount. The pattern is sped up by this factor before the transform, then slowed back down."""),
                    KlangParam(name = "transform", type = kt5, description = """Transformation to apply while the pattern covers only `1/factor` of the original cycle."""),
                ),
                returnType = kt2,
                description = """Applies a transformation outside the current cycle, across a wider temporal context.

 Speeds the pattern by `factor`, applies `transform`, then slows it back down. The net effect
 is that `transform` sees only `1/factor` of the original pattern per cycle, allowing
 operations like `rev()` to work on a globally coarser time scale.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("0 1 2 3").outside(4, x => x.rev())      // reverse on 1/4 speed, then speed back up""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("bd sd hh cp").outside(2, x => x.fast(2))   // double-fast outside = no net change in tempo""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "outside",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "factor", type = kt7),
                    KlangParam(name = "transform", type = kt5),
                ),
                returnType = kt2,
                description = """Applies a transformation outside the current cycle on this string pattern.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "outside",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "factor", type = kt7),
                    KlangParam(name = "transform", type = kt5),
                ),
                returnType = kt5,
                description = """Chains an outside operation onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "outside",
                params = listOf(
                    KlangParam(name = "factor", type = kt7),
                    KlangParam(name = "transform", type = kt5),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that applies a transformation outside the current cycle.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "pace" to KlangSymbol(
        name = "pace",
        category = "structural",
        tags = listOf("pace", "steps", "tempo", "speed", "cycle"),
        aliases = listOf("steps"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "pace",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "n", type = kt7, description = """Target number of steps per cycle."""),
                ),
                returnType = kt2,
                description = """Adjusts this pattern's speed so it plays exactly `n` steps per cycle.

 Computes the speed factor relative to the pattern's natural step count and applies [fast].""",
                returnDoc = """The pattern sped up or slowed down to fit `n` steps per cycle.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c d e f").pace(8)   // 4-step pattern runs at 8 steps/cycle (double speed)""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c d e f g").pace(4) // 5-step pattern runs at 4 steps/cycle""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "pace",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "n", type = kt7),
                ),
                returnType = kt2,
                description = """Adjusts this string pattern to play `n` steps per cycle.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "pace",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "n", type = kt7),
                ),
                returnType = kt5,
                description = """Chains a pace onto this [PatternMapperFn]; adjusts to play `n` steps per cycle.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "pace",
                params = listOf(
                    KlangParam(name = "n", type = kt7, description = """Target number of steps per cycle."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that adjusts the source to play `n` steps per cycle.""",
                returnDoc = """A [PatternMapperFn] that speeds up or slows down the source to fit `n` steps.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c d e f").apply(pace(8))   // via mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "palindrome" to KlangSymbol(
        name = "palindrome",
        category = "tempo",
        tags = listOf("palindrome", "reverse", "mirror", "order", "retrograde"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "palindrome",
                receiver = kt0,
                params = emptyList(),
                returnType = kt2,
                description = """Plays the pattern forward then backward, creating a two-cycle palindrome.

 Cycle 0 plays the original pattern; cycle 1 plays the reversed pattern. The reversal
 uses absolute time so the second half mirrors the first half correctly over the full
 phrase, not just a single cycle.""",
                returnDoc = """A two-cycle palindrome pattern.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c d e f").palindrome()        // c d e f ... f e d c ... c d e f ...""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("bd sd hh cp").palindrome()       // forward drum loop then reversed drum loop""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "palindrome",
                receiver = kt3,
                params = emptyList(),
                returnType = kt2,
                description = """Plays the pattern forward then backward, creating a two-cycle palindrome.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "palindrome",
                receiver = kt4,
                params = emptyList(),
                returnType = kt5,
                description = """Chains a palindrome operation onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "palindrome",
                params = emptyList(),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that plays the pattern forward then backward.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c d e f").apply(palindrome())  // mapper form""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "pan" to KlangSymbol(
        name = "pan",
        category = "dynamics",
        tags = listOf("pan", "stereo", "panning", "position"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "pan",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "amount", type = kt6, isOptional = true, defaultDoc = """null""", description = """Pan position, 0 left to 1 right.""", uitools = listOf("SprudelPanEditor", "SprudelPanSequenceEditor")),
                ),
                returnType = kt2,
                description = """Sets the stereo position of each event, per voice.

 0 is full left, 0.5 is centre, 1 is full right. A continuous pattern such as `sine.range(0, 1)`
 sweeps the position instead of stepping it.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd").pan(0.25)                   // slightly left""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("bd hh sd cp").pan("0 0.33 0.66 1")  // left to right""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("hh*8").pan(sine.range(0, 1))        // smooth left-right sweep""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "pan",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "amount", type = kt6, isOptional = true, defaultDoc = """null""", description = """Pan position, 0 left to 1 right.""", uitools = listOf("SprudelPanEditor", "SprudelPanSequenceEditor")),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern and sets the stereo panning position.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """"bd hh sd cp".pan("0 0.33 0.66 1").s()  // left to right""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "pan",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "amount", type = kt6, isOptional = true, defaultDoc = """null""", description = """Pan position, 0 left to 1 right.""", uitools = listOf("SprudelPanEditor", "SprudelPanSequenceEditor")),
                ),
                returnType = kt5,
                description = """Creates a chained [PatternMapperFn] that sets the pan after the previous mapper.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd hh sd cp").apply(pan("0 0.33 0.66 1").gain(0.8))  // pan + gain chained""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "penv" to KlangSymbol(
        name = "penv",
        category = "tonal",
        tags = listOf("penv", "semitones", "attack", "decay", "sustain", "release", "pitch envelope"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "penv",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "semitones", type = kt6, isOptional = true, defaultDoc = """null""", description = """The pitch at the envelope's peak, in semitones."""),
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null""", description = """Attack in seconds."""),
                    KlangParam(name = "decay", type = kt6, isOptional = true, defaultDoc = """null""", description = """Decay in seconds."""),
                    KlangParam(name = "sustain", type = kt6, isOptional = true, defaultDoc = """null""", description = """Held share of `semitones` while the note is on; 0 is the note itself."""),
                    KlangParam(name = "release", type = kt6, isOptional = true, defaultDoc = """null""", description = """Release in seconds, back to the note after the note ends."""),
                ),
                returnType = kt2,
                description = """The pitch envelope: its depth in semitones, and its attack, decay, sustain and release.

 The pitch rises `semitones` away from the note over `attack`, falls back to the `sustain`
 share of `semitones` over `decay`, holds there while the note is on, and after the note ends returns
 to the note over `release`. 12 is an octave up, -12 an octave down, 0 no pitch envelope at all.
 An unwritten stage is the Ignitor `pitchEnvelope`'s default: attack 0.01, decay 0.1, sustain 0
 (back on the note), release 0 (on the note at the note's end). Each stage bends exponentially
 unless [penvCurves] shapes it. The release does not make the note ring longer.

 Every slot is independent and patternable; an omitted slot keeps its value, a named slot takes
 a mapper (`penv(attack = mul(2))`), and the slots read back as `penv.semitones`, `penv.attack`,
 `penv.decay`, `penv.sustain`, `penv.release`. With no argument at all, the pattern's own values
 are reinterpreted as `semitones`.

 The door fills the pitch envelope stage of `classic()` (the `penv.*` slots), the Ignitor `pitchEnvelope` node; an
 instrument without `classic()` ignores it, like the other `classic()` doors.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c2*4").s("sine").penv(24, 0.001, 0.08)                               // a kick: two octaves down onto the note""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c3 ~ e3 ~").s("saw").penv(12, 0.02, 0.1, 0.5, 0.3).adsr(0.01, 0.1, 0.8, 0.5)   // holds half an octave up, glides home after""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c2*4").s("sine").penv(24, 0.001, 0.08).penv(semitones = mul("1 0.5"))   // half the drop on every second hit""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c4*4").s("saw").penv("12 -12", 0.01, 0.2).lpf(penv.semitones.mul(100).add(2000))   // brighter with the rise""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "penv",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "semitones", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "decay", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "sustain", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "release", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern, then applies [penv].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "penv",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "semitones", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "decay", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "sustain", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "release", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt5,
                description = """Chains a [penv] step onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    )
)

private fun generatedSprudelDocsChunk22() = mapOf(

    "penvCurves" to KlangSymbol(
        name = "penvCurves",
        category = "tonal",
        tags = listOf("penv", "curve", "envelope", "shape", "pitch envelope"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "penvCurves",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the attack stage."""),
                    KlangParam(name = "decay", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the decay stage."""),
                    KlangParam(name = "release", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the release stage."""),
                ),
                returnType = kt2,
                description = """Sets the shape of each stage of the pitch envelope ([penv]), the way [adsrCurves] shapes the
 amplitude envelope. Each stage is independent; an omitted stage, or an unknown curve name, keeps
 its current curve, so `penvCurves(decay = "linear")` changes only the decay.

 The curves are the same six as `adsrCurves`: `linear`, `square`, `cube`, `scurve`, `invsquare`,
 `exponential`, with the same aliases. Unset, every stage is `exponential`, the default of every
 modulation envelope on every surface (decision D3). A curve alone switches nothing on: without a
 `penv` semitones written there is no pitch envelope to shape.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c2*4").s("sine").penv(24, 0.001, 0.08).penvCurves(decay = "linear")   // a straight drop, the old sweep""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "penvCurves",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the attack stage."""),
                    KlangParam(name = "decay", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the decay stage."""),
                    KlangParam(name = "release", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the release stage."""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern and sets the pitch envelope's stage curves (see [penvCurves]).""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "penvCurves",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the attack stage. Omit to keep the current curve."""),
                    KlangParam(name = "decay", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the decay stage. Omit to keep the current curve."""),
                    KlangParam(name = "release", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the release stage. Omit to keep the current curve."""),
                ),
                returnType = kt5,
                description = """Creates a chained [PatternMapperFn] that sets the pitch envelope's stage curves after the previous mapper.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "phaser" to KlangSymbol(
        name = "phaser",
        category = "effects",
        tags = listOf("phaser", "wet", "rate", "center", "sweep", "floor"),
        aliases = listOf(),
        scope = KlangScope.ORBIT,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "phaser",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "wet", type = kt6, isOptional = true, defaultDoc = """null""", description = """Depth, 0 to 1. Engages above 0.01."""),
                    KlangParam(name = "rate", type = kt6, isOptional = true, defaultDoc = """null""", description = """LFO rate in Hz.""", uitools = listOf("SprudelPhaserEditor", "SprudelPhaserSequenceEditor")),
                    KlangParam(name = "center", type = kt6, isOptional = true, defaultDoc = """null""", description = """Centre frequency of the sweep, Hz."""),
                    KlangParam(name = "sweep", type = kt6, isOptional = true, defaultDoc = """null""", description = """Sweep range around the centre, Hz."""),
                    KlangParam(name = "floor", type = kt6, isOptional = true, defaultDoc = """null""", description = """Minimum dry share kept in the mix, 0 to 1."""),
                ),
                returnType = kt2,
                description = """The orbit phaser: depth, rate, centre, sweep and dry floor.

 One sweep over the summed orbit bus, the DAW-insert model, so every
 knob belongs to the orbit's owning voice: a voice that sets phaser knobs without owning its orbit
 is not phased at all. Route it to its own orbit to give it its own phaser.

 The dry signal stays untouched by default (`floor` is 1), so `wet` ADDS the swept notch on top
 rather than crossfading into it. Lower `floor` to turn `wet` back into a crossfade.

 `wet` comes first, as on every door that has one, and the LFO rate second: `phaser(0.5, 2)` is
 half depth at 2 Hz.

 The call sets every slot: the ones you leave out take their shared defaults, rate 0, wet 0,
 centre 1000 Hz, sweep 1000 Hz and floor 1, unless an earlier call already set them. Wet 0 is the
 engine's own gate, so reaching for the phaser without a depth is still silent, exactly as before.
 Slots apply in order, wet first, so a mapper on a later slot sees a default an earlier slot of
 the same call filled in. A wet MAPPER runs before any other knob can fill the wet, so it maps
 nothing on a fresh note: `phaser(rate = 2, wet = add(0.3))` is wet 0, the rate's fill. Map the
 wet in a later call, once it is set: `phaser(rate = 2).phaser(wet = add(0.3))` is wet 0.3.

 Every slot is independent and patternable; an omitted slot keeps its value, a named slot takes
 a mapper (`phaser(wet = mul(2))`), and the numeric slots read back as `phaser.wet`, `phaser.rate`, `phaser.center`, `phaser.sweep`, `phaser.floor`.
 With no argument at all, the pattern's own values are reinterpreted as `wet`; a value that is not
 a number writes nothing.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3 e3").s("saw").phaser(0.5, 0.5)                                 // depth and rate""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c3 e3").s("saw").phaser(0.5, 0.5).phaser(rate = mul("1 4"))        // the second note swirls faster""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c3 e3").s("saw").phaser("0.2 0.8", 0.5).delay(wet = phaser.wet, time = 0.25)   // as much delay as phaser""", type = KlangCodeSampleType.PLAYABLE)
                ),
                uitools = listOf("SprudelPhaserEditor"),
                library = "sprudel"
            ),
            KlangCallable(
                name = "phaser",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "wet", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "rate", type = kt6, isOptional = true, defaultDoc = """null""", uitools = listOf("SprudelPhaserEditor", "SprudelPhaserSequenceEditor")),
                    KlangParam(name = "center", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "sweep", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "floor", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern, then applies [phaser].""",
                returnDoc = """""",
                samples = emptyList(),
                uitools = listOf("SprudelPhaserEditor"),
                library = "sprudel"
            ),
            KlangCallable(
                name = "phaser",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "wet", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "rate", type = kt6, isOptional = true, defaultDoc = """null""", uitools = listOf("SprudelPhaserEditor", "SprudelPhaserSequenceEditor")),
                    KlangParam(name = "center", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "sweep", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "floor", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt5,
                description = """Chains a [phaser] step onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                uitools = listOf("SprudelPhaserEditor"),
                library = "sprudel"
            )
        )
    ),

    "pick" to KlangSymbol(
        name = "pick",
        category = "structural",
        tags = listOf("pick", "select", "index", "lookup"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "pick",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true, description = """Lookup items to pick from — strings, patterns, or a single map for key-based lookup."""),
                ),
                returnType = kt2,
                description = """Selects patterns from a lookup using this pattern's values as indices, clamping out-of-bounds indices.

 Each event value is used as a zero-based integer index (or string key for map lookups) to
 select a pattern from the vararg lookup. Out-of-bounds integer indices are clamped to the
 nearest valid position. The selected pattern's timing structure is used (inner-join).""",
                returnDoc = """A pattern playing the selected items in the order given by this pattern's values.""",
                samples = listOf(
                    KlangCodeSample(code = """seq("<0 1 2!2 3>").pick("g a", "e f", "f g f g" , "g c d").note()""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """seq("<0 1 [2,0]>").pick("bd sd", "cp cp", "hh hh").s()""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "pick",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true, description = """Lookup items to pick from — strings, patterns, or a single map."""),
                ),
                returnType = kt2,
                description = """Selects patterns from a lookup using this string parsed as a mini-notation index pattern.

 The string is parsed as mini-notation to produce a sequence of index/key values. Those
 values select from the vararg lookup items with clamped out-of-bounds handling.
 Equivalent to `seq(this).pick(*args)`.""",
                returnDoc = """A pattern playing the selected items driven by this string's parsed values.""",
                samples = listOf(
                    KlangCodeSample(code = """"<0 1 2 1>".pick("bd", "sd", "hh").s().fast(2)""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "pick",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true),
                ),
                returnType = kt5,
                description = """Chains a pick onto this [PatternMapperFn]; the chained result picks from the given lookup.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "pick",
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true, description = """Lookup items to pick from — strings, patterns, or a single map."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that selects patterns from a lookup, clamping out-of-bounds indices.

 The source pattern's event values are used as zero-based indices (or string keys for maps)
 to pick from the lookup. Apply the returned mapper to a pattern using `.apply()`. Indices
 outside valid bounds are clamped to the nearest valid position.""",
                returnDoc = """A [PatternMapperFn] that maps a source pattern to a pick result.""",
                samples = listOf(
                    KlangCodeSample(code = """"<0 1 2 1>".apply(pick("bd", "sd", "hh")).s().fast(2)""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "pickF" to KlangSymbol(
        name = "pickF",
        category = "structural",
        tags = listOf("pickF", "pick", "apply", "transform", "function", "index"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "pickF",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true, description = """Index pattern followed by the function list — `pickF(indexPat, [fn1, fn2, ...])`."""),
                ),
                returnType = kt2,
                description = """Applies a function from a list to this pattern, selected by an index pattern (clamped).

 The first argument is the index pattern; the second is a list of pattern-transforming functions.
 The index (clamped to bounds) selects which function is applied to this pattern.""",
                returnDoc = """A pattern with the selected function applied.""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd rim hh").pickF("<0 1 2>", [rev, fast(2), jux(rev())])  // fn selected by index""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c3 e3 g3").pickF(n("0 1"), [slow(2), fast(3)])       // 0→slow(2), 1→fast(3)""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "pickF",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true, description = """Index pattern followed by the function list."""),
                ),
                returnType = kt2,
                description = """Applies a function from a list to this string pattern, selected by an index pattern (clamped).""",
                returnDoc = """A pattern with the selected function applied.""",
                samples = listOf(
                    KlangCodeSample(code = """"bd rim hh".pickF("<0 1 2>", [rev, fast(2), jux(rev())]).s()  // string source, fn by index""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "pickF",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true, description = """Index pattern followed by the function list."""),
                ),
                returnType = kt5,
                description = """Chains a pickF onto this [PatternMapperFn]; applies a function selected by clamped index.""",
                returnDoc = """A new [PatternMapperFn] composing this mapper with the function-select operation.""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "pickF",
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true, description = """Index pattern followed by the function list."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that applies a function from a list to the source, selected by index (clamped).

 The first argument is the index pattern; the second is the function list. Apply using `.apply()`.""",
                returnDoc = """A [PatternMapperFn] that applies the selected function to the source pattern.""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd rim hh").apply(pickF("<0 1 2>", [rev, fast(2), jux(rev())]))  // via mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "pickOut" to KlangSymbol(
        name = "pickOut",
        category = "structural",
        tags = listOf("pickOut", "pick", "select", "index", "outer", "outerJoin"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "pickOut",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true, description = """Lookup items to pick from — strings, patterns, or a single map for key-based lookup."""),
                ),
                returnType = kt2,
                description = """Like [pick] but uses outer-join semantics: all selected events fire at the selector's onset.

 Whereas [pick] preserves the selected pattern's internal timing (inner-join), `pickOut`
 forces every resulting event to share the onset of the selecting event. Indices are clamped.""",
                returnDoc = """A pattern playing the selected items with onset timing driven by this pattern's values.""",
                samples = listOf(
                    KlangCodeSample(code = """seq("<0 1 2!2 3>").pickOut("g a", "e f", "f g f g" , "g c d").note()""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """seq("<0 1 [2,0]>").pickOut("bd sd", "cp cp", "hh hh").s()""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "pickOut",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true, description = """Lookup items to pick from — strings, patterns, or a single map."""),
                ),
                returnType = kt2,
                description = """Like [pick] but uses outer-join semantics — this string is parsed as a mini-notation index pattern.""",
                returnDoc = """A pattern with onset timing from this string's parsed values; selected items are outer-joined.""",
                samples = listOf(
                    KlangCodeSample(code = """"<0 1 2 1>".pickOut("bd", "sd", "hh").s().fast(2)""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "pickOut",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true),
                ),
                returnType = kt5,
                description = """Chains a pickOut onto this [PatternMapperFn]; outer-join semantics, clamped indices.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "pickOut",
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true, description = """Lookup items to pick from — strings, patterns, or a single map."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that selects from a lookup with outer-join semantics, clamped indices.

 Like [pick] but forces all selected events to fire at the selector's onset. Apply using `.apply()`.""",
                returnDoc = """A [PatternMapperFn] that maps a source pattern to an outer-join pick result.""",
                samples = listOf(
                    KlangCodeSample(code = """"<0 1 2 1>".apply(pickOut("bd", "sd", "hh")).s().fast(2)""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "pickReset" to KlangSymbol(
        name = "pickReset",
        category = "structural",
        tags = listOf("pickReset", "pick", "reset", "trigger", "select", "index"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "pickReset",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true, description = """Lookup items to pick from — strings, patterns, or a single map for key-based lookup."""),
                ),
                returnType = kt2,
                description = """Like [pick] but resets the chosen pattern to its initial phase each time it is triggered.

 Similar to [pickRestart] but "reset" aligns the chosen pattern to the global cycle boundary
 of the trigger rather than always starting from beat zero. Indices are clamped.""",
                returnDoc = """A pattern that resets the selected item's phase on each trigger.""",
                samples = listOf(
                    KlangCodeSample(code = """seq("<0 1 2!2 3>").pickReset("g a", "e f", "f g f g" , "g c d").note()""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """seq("<0 1 [2,0]>").pickReset("bd sd", "cp cp", "hh hh").s()""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "pickReset",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true, description = """Lookup items to pick from — strings, patterns, or a single map."""),
                ),
                returnType = kt2,
                description = """Like [pick] but resets the chosen pattern — this string parsed as a mini-notation index pattern.""",
                returnDoc = """A pattern that resets the selected item's phase on each trigger.""",
                samples = listOf(
                    KlangCodeSample(code = """"<0 1 2 1>".pickReset("bd", "sd", "hh").s().fast(2)""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "pickReset",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true),
                ),
                returnType = kt5,
                description = """Chains a pickReset onto this [PatternMapperFn]; clamped indices, resets phase on trigger.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "pickReset",
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true, description = """Lookup items to pick from — strings, patterns, or a single map."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that selects from a lookup and resets the chosen pattern's phase on trigger.

 Like [pick] but the selected pattern's phase is reset on each trigger. Apply using `.apply()`.""",
                returnDoc = """A [PatternMapperFn] that maps a source pattern to a reset-pick result.""",
                samples = listOf(
                    KlangCodeSample(code = """"<0 1 2 1>".apply(pickReset("bd", "sd", "hh")).s().fast(2)""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "pickRestart" to KlangSymbol(
        name = "pickRestart",
        category = "structural",
        tags = listOf("pickRestart", "pick", "restart", "trigger", "select", "index"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "pickRestart",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true, description = """Lookup items to pick from — strings, patterns, or a single map for key-based lookup."""),
                ),
                returnType = kt2,
                description = """Like [pick] but restarts the chosen pattern from its beginning each time it is triggered.

 Each event's index selects a pattern from the lookup, which is then restarted from its
 cycle beginning. Indices are clamped. Useful for building phrase-based structures where
 each trigger always plays the selected pattern from the top.""",
                returnDoc = """A pattern that restarts the selected item on each trigger.""",
                samples = listOf(
                    KlangCodeSample(code = """seq("<0 1 2!2 3>").pickRestart("g a", "e f", "f g f g" , "g c d").note()""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """seq("<0 1 [2,0]>").pickRestart("bd sd", "cp cp", "hh hh").s()""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "pickRestart",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true, description = """Lookup items to pick from — strings, patterns, or a single map."""),
                ),
                returnType = kt2,
                description = """Like [pick] but restarts the chosen pattern — this string parsed as a mini-notation index pattern.""",
                returnDoc = """A pattern that restarts the selected item on each trigger.""",
                samples = listOf(
                    KlangCodeSample(code = """"<0 1 2 1>".pickRestart("bd", "sd", "hh").s().fast(2)""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "pickRestart",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true),
                ),
                returnType = kt5,
                description = """Chains a pickRestart onto this [PatternMapperFn]; clamped indices, restarts on trigger.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "pickRestart",
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true, description = """Lookup items to pick from — strings, patterns, or a single map."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that selects from a lookup and restarts the chosen pattern on each trigger.

 Like [pick] but the selected pattern always restarts from its beginning. Apply using `.apply()`.""",
                returnDoc = """A [PatternMapperFn] that maps a source pattern to a restart-pick result.""",
                samples = listOf(
                    KlangCodeSample(code = """"<0 1 2 1>".apply(pickRestart("bd", "sd", "hh")).s().fast(2)""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "pickSqueeze" to KlangSymbol(
        name = "pickSqueeze",
        category = "structural",
        tags = listOf("pickSqueeze", "inhabit", "squeeze", "select", "index", "lookup"),
        aliases = listOf("inhabit"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "pickSqueeze",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true),
                ),
                returnType = kt2,
                description = """Alias for [inhabit]. Selects patterns from a list by index and squeezes into event duration.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "pickSqueeze",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true),
                ),
                returnType = kt2,
                description = """Alias for [inhabit] on a string pattern. Selects patterns from a lookup by index and squeezes into event duration.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "pickSqueeze",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true),
                ),
                returnType = kt5,
                description = """Chains a pickSqueeze (alias for [inhabit]) onto this [PatternMapperFn]; clamped index, squeeze semantics.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "pickSqueeze",
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that is an alias for [inhabit]; selects by clamped index and squeezes into event duration.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    )
)

private fun generatedSprudelDocsChunk23() = mapOf(

    "pickmod" to KlangSymbol(
        name = "pickmod",
        category = "structural",
        tags = listOf("pickmod", "pick", "modulo", "wrap", "index", "lookup"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "pickmod",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true, description = """Lookup items to pick from — strings, patterns, or a single map for key-based lookup."""),
                ),
                returnType = kt2,
                description = """Like [pick] but wraps out-of-bounds indices with modulo arithmetic.

 Each event value is used as a zero-based integer index (or string key for map lookups).
 Integer indices wrap cyclically — index 3 with a 3-item lookup maps to 0; negative
 indices are handled correctly (e.g. -1 maps to the last item).""",
                returnDoc = """A pattern playing the selected items with modulo-wrapped index resolution.""",
                samples = listOf(
                    KlangCodeSample(code = """seq("<0 1 2!2 3>").pickmod("g a", "e f", "f g f g" , "g c d").note()""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """seq("<0 1 [2,0]>").pickmod("bd sd", "cp cp", "hh hh").s()""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "pickmod",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true, description = """Lookup items to pick from — strings, patterns, or a single map."""),
                ),
                returnType = kt2,
                description = """Like [pick] but wraps indices with modulo — this string is parsed as a mini-notation index pattern.""",
                returnDoc = """A pattern playing the selected items driven by this string's parsed values (modulo-wrapped).""",
                samples = listOf(
                    KlangCodeSample(code = """"<0 1 2 1>".pickmod("bd", "sd", "hh").s().fast(2)""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "pickmod",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true),
                ),
                returnType = kt5,
                description = """Chains a modulo-pick onto this [PatternMapperFn]; indices wrap cyclically.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "pickmod",
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true, description = """Lookup items to pick from — strings, patterns, or a single map."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that selects from a lookup with modulo-wrapped index values.

 Like [pick] but indices wrap cyclically. Apply the returned mapper to a pattern using `.apply()`.""",
                returnDoc = """A [PatternMapperFn] that maps a source pattern to a modulo-pick result.""",
                samples = listOf(
                    KlangCodeSample(code = """"<0 1 2 1>".apply(pickmod("bd", "sd", "hh")).s().fast(2)""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "pickmodF" to KlangSymbol(
        name = "pickmodF",
        category = "structural",
        tags = listOf("pickmodF", "pickF", "modulo", "apply", "transform", "function", "index"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "pickmodF",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true, description = """Index pattern followed by the function list."""),
                ),
                returnType = kt2,
                description = """Like [pickF] but wraps out-of-bounds indices with modulo arithmetic.

 The first argument is the index pattern; the second is the function list. Indices wrap cyclically.""",
                returnDoc = """A pattern with the modulo-selected function applied.""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd rim hh").pickmodF("<0 1 2 3>", [rev, fast(2)])          // 2→0, 3→1 mod 2""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c3 e3 g3").pickmodF(n("0 5"), [slow(2), fast(3)])       // 5→1 mod 2""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "pickmodF",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true, description = """Index pattern followed by the function list."""),
                ),
                returnType = kt2,
                description = """Like [pickF] but wraps indices with modulo — this string pattern is the source.""",
                returnDoc = """A pattern with the modulo-selected function applied.""",
                samples = listOf(
                    KlangCodeSample(code = """"bd rim hh".pickmodF("<0 1 2 3>", [rev, fast(2)]).s()  // string source, modulo index""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "pickmodF",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true, description = """Index pattern followed by the function list."""),
                ),
                returnType = kt5,
                description = """Chains a pickmodF onto this [PatternMapperFn]; applies a function selected by modulo-wrapped index.""",
                returnDoc = """A new [PatternMapperFn] composing this mapper with the modulo function-select operation.""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "pickmodF",
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true, description = """Index pattern followed by the function list."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that applies a function from a list with modulo-wrapped index.

 Like [pickF] but indices wrap cyclically. Apply using `.apply()`.""",
                returnDoc = """A [PatternMapperFn] that applies the modulo-selected function to the source pattern.""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd rim hh").apply(pickmodF("<0 1 2 3>", [rev, fast(2)]))  // via mapper, modulo""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "pickmodOut" to KlangSymbol(
        name = "pickmodOut",
        category = "structural",
        tags = listOf("pickmodOut", "pickOut", "pickmod", "modulo", "select", "index", "outer"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "pickmodOut",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true, description = """Lookup items to pick from — strings, patterns, or a single map for key-based lookup."""),
                ),
                returnType = kt2,
                description = """Like [pickOut] but wraps out-of-bounds indices with modulo arithmetic.

 Outer-join semantics (onset from selector) combined with modulo index wrapping.
 Indices wrap cyclically; negative indices are handled correctly.""",
                returnDoc = """A pattern with onset timing from this pattern; indices wrap cyclically.""",
                samples = listOf(
                    KlangCodeSample(code = """seq("<0 1 2!2 3>").pickmodOut("g a", "e f", "f g f g" , "g c d").note()""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """seq("<0 1 [2,0]>").pickmodOut("bd sd", "cp cp", "hh hh").s()""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "pickmodOut",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true, description = """Lookup items to pick from — strings, patterns, or a single map."""),
                ),
                returnType = kt2,
                description = """Like [pickOut] but wraps indices with modulo — this string is parsed as a mini-notation index pattern.""",
                returnDoc = """A pattern with onset timing from this string's parsed values; indices wrap cyclically.""",
                samples = listOf(
                    KlangCodeSample(code = """"<0 1 2 1>".pickmodOut("bd", "sd", "hh").s().fast(2)""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "pickmodOut",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true),
                ),
                returnType = kt5,
                description = """Chains a pickmodOut onto this [PatternMapperFn]; outer-join semantics, modulo indices.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "pickmodOut",
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true, description = """Lookup items to pick from — strings, patterns, or a single map."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that selects from a lookup with outer-join semantics and modulo indices.

 Like [pickOut] but wraps indices cyclically. Apply the returned mapper using `.apply()`.""",
                returnDoc = """A [PatternMapperFn] that maps a source pattern to an outer-join modulo-pick result.""",
                samples = listOf(
                    KlangCodeSample(code = """"<0 1 2 1>".apply(pickmodOut("bd", "sd", "hh")).s().fast(2)""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "pickmodReset" to KlangSymbol(
        name = "pickmodReset",
        category = "structural",
        tags = listOf("pickmodReset", "pickReset", "modulo", "reset", "trigger", "index"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "pickmodReset",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true, description = """Lookup items to pick from — strings, patterns, or a single map for key-based lookup."""),
                ),
                returnType = kt2,
                description = """Like [pickReset] but wraps out-of-bounds indices with modulo arithmetic.

 Selects patterns with modulo-wrapped indices and resets the chosen pattern's phase on
 each trigger. Negative indices are handled correctly.""",
                returnDoc = """A pattern that resets the selected item's phase on each trigger; indices wrap cyclically.""",
                samples = listOf(
                    KlangCodeSample(code = """seq("<0 1 2!2 3>").pickmodReset("g a", "e f", "f g f g" , "g c d").note()""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """seq("<0 1 [2,0]>").pickmodReset("bd sd", "cp cp", "hh hh").s()""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "pickmodReset",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true, description = """Lookup items to pick from — strings, patterns, or a single map."""),
                ),
                returnType = kt2,
                description = """Like [pickReset] but wraps indices with modulo — this string parsed as a mini-notation index pattern.""",
                returnDoc = """A pattern that resets the selected item's phase on each trigger; indices wrap cyclically.""",
                samples = listOf(
                    KlangCodeSample(code = """"<0 1 2 1>".pickmodReset("bd", "sd", "hh").s().fast(2)""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "pickmodReset",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true),
                ),
                returnType = kt5,
                description = """Chains a pickmodReset onto this [PatternMapperFn]; modulo indices, resets phase on trigger.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "pickmodReset",
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true, description = """Lookup items to pick from — strings, patterns, or a single map."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that selects from a lookup with modulo indices and resets the chosen pattern.

 Like [pickReset] but wraps indices cyclically. Apply the returned mapper using `.apply()`.""",
                returnDoc = """A [PatternMapperFn] that maps a source pattern to a modulo reset-pick result.""",
                samples = listOf(
                    KlangCodeSample(code = """"<0 1 2 1>".apply(pickmodReset("bd", "sd", "hh")).s().fast(2)""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "pickmodRestart" to KlangSymbol(
        name = "pickmodRestart",
        category = "structural",
        tags = listOf("pickmodRestart", "pickRestart", "modulo", "restart", "trigger", "index"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "pickmodRestart",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true, description = """Lookup items to pick from — strings, patterns, or a single map for key-based lookup."""),
                ),
                returnType = kt2,
                description = """Like [pickRestart] but wraps out-of-bounds indices with modulo arithmetic.

 Selects patterns with modulo-wrapped indices and restarts the chosen pattern from its
 beginning on each trigger. Negative indices are handled correctly.""",
                returnDoc = """A pattern that restarts the selected item on each trigger; indices wrap cyclically.""",
                samples = listOf(
                    KlangCodeSample(code = """seq("<0 1 2!2 3>").pickmodRestart("g a", "e f", "f g f g" , "g c d").note()""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """seq("<0 1 [2,0]>").pickmodRestart("bd sd", "cp cp", "hh hh").s()""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "pickmodRestart",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true, description = """Lookup items to pick from — strings, patterns, or a single map."""),
                ),
                returnType = kt2,
                description = """Like [pickRestart] but wraps indices with modulo — this string parsed as a mini-notation index pattern.""",
                returnDoc = """A pattern that restarts the selected item on each trigger; indices wrap cyclically.""",
                samples = listOf(
                    KlangCodeSample(code = """"<0 1 2 1>".pickmodRestart("bd", "sd", "hh").s().fast(2)""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "pickmodRestart",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true),
                ),
                returnType = kt5,
                description = """Chains a pickmodRestart onto this [PatternMapperFn]; modulo indices, restarts on trigger.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "pickmodRestart",
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true, description = """Lookup items to pick from — strings, patterns, or a single map."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that selects from a lookup with modulo indices and restarts the chosen pattern.

 Like [pickRestart] but wraps indices cyclically. Apply the returned mapper using `.apply()`.""",
                returnDoc = """A [PatternMapperFn] that maps a source pattern to a modulo restart-pick result.""",
                samples = listOf(
                    KlangCodeSample(code = """"<0 1 2 1>".apply(pickmodRestart("bd", "sd", "hh")).s().fast(2)""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "pickmodSqueeze" to KlangSymbol(
        name = "pickmodSqueeze",
        category = "structural",
        tags = listOf("pickmodSqueeze", "inhabitmod", "modulo", "squeeze", "select", "index", "lookup"),
        aliases = listOf("inhabitmod"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "pickmodSqueeze",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true),
                ),
                returnType = kt2,
                description = """Alias for [inhabitmod]. Selects patterns by modulo-wrapped index and squeezes into events.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "pickmodSqueeze",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true),
                ),
                returnType = kt2,
                description = """Alias for [inhabitmod] on a string pattern. Selects patterns by modulo-wrapped index and squeezes into events.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "pickmodSqueeze",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true),
                ),
                returnType = kt5,
                description = """Chains a pickmodSqueeze (alias for [inhabitmod]) onto this [PatternMapperFn]; modulo-wrapped index, squeeze.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "pickmodSqueeze",
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that is an alias for [inhabitmod]; selects by modulo-wrapped index and squeezes.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "ply" to KlangSymbol(
        name = "ply",
        category = "tempo",
        tags = listOf("ply", "repeat", "subdivide", "multiply", "density"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "ply",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "n", type = kt7, description = """Number of repetitions per event. Default: 1 (no repetition). Typical range: 1–16. Accepts control patterns."""),
                ),
                returnType = kt2,
                description = """Repeats each event `n` times within its original timespan.

 Each event in the pattern is subdivided into `n` equal copies squeezed into the same
 duration. For example, `ply(3)` on a 2-event pattern produces 6 events: 3 copies of the
 first event followed by 3 copies of the second. Accepts control patterns for `n`.""",
                returnDoc = """A pattern with each event repeated `n` times within its timespan.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c d").ply(3)                  // c c c d d d — 6 events squeezed into 1 cycle""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c d e f").ply("<1 2 4>")      // varying subdivision each cycle""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "ply",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "n", type = kt7),
                ),
                returnType = kt2,
                description = """Repeats each event `n` times within its original timespan.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "ply",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "n", type = kt7),
                ),
                returnType = kt5,
                description = """Chains a ply operation onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "ply",
                params = listOf(
                    KlangParam(name = "n", type = kt7, description = """Number of repetitions per event. Default: 1. Typical range: 1–16."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that repeats each event `n` times within its timespan.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c d").apply(ply(3))           // mapper form""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "plyForEach" to KlangSymbol(
        name = "plyForEach",
        category = "tempo",
        tags = listOf("plyForEach", "repeat", "transform", "index", "subdivide"),
        aliases = listOf("plyforeach"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "plyForEach",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "factor", type = kt10, description = """Number of repetitions per event slot. Typical range: 1–16."""),
                    KlangParam(name = "transform", type = kt16, description = """Function receiving (pattern, index) where index is 0-based; copy 0 is always unmodified."""),
                ),
                returnType = kt2,
                description = """Repeats each event `n` times within its timespan, passing the iteration index to `transform`.

 Similar to `plyWith` but the transform function receives both the pattern and the index
 (0-based). Copy 0 is always unmodified; copies 1 through `n-1` receive their index so the
 transform can produce index-specific variations. As a top-level function the third argument
 is the source pattern.""",
                returnDoc = """A pattern with `n` index-specific copies of each event per slot.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c").plyForEach(4, (pat, i) => pat.add(i * 2))   // c, d, e, f# — index * 2 semitones""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("bd").plyForEach(3, (pat, i) => pat.gain(1.0 - i * 0.3))  // fading copies""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "plyForEach",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "factor", type = kt10),
                    KlangParam(name = "transform", type = kt16),
                ),
                returnType = kt2,
                description = """Repeats each event `n` times, passing the iteration index to `transform`.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "plyForEach",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "factor", type = kt10),
                    KlangParam(name = "transform", type = kt16),
                ),
                returnType = kt5,
                description = """Chains a plyForEach operation onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "plyForEach",
                params = listOf(
                    KlangParam(name = "factor", type = kt10),
                    KlangParam(name = "transform", type = kt16),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that repeats each event `n` times, passing the index to `transform`.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    )
)

private fun generatedSprudelDocsChunk24() = mapOf(

    "plyWith" to KlangSymbol(
        name = "plyWith",
        category = "tempo",
        tags = listOf("plyWith", "repeat", "transform", "cumulative", "subdivide"),
        aliases = listOf("plywith"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "plyWith",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "factor", type = kt10, description = """Number of repetitions per event slot. Typical range: 1–16."""),
                    KlangParam(name = "transform", type = kt5, description = """Pattern transformation applied cumulatively — copy 0 is unmodified, copy 1 has it applied once, etc."""),
                ),
                returnType = kt2,
                description = """Repeats each event `n` times within its timespan, applying `transform` cumulatively.

 Like `ply(n)` but instead of plain copies, each repetition applies `transform` one more
 time: copy 0 is unmodified, copy 1 has `transform` applied once, copy 2 twice, and so on.
 This creates escalating variations within each event's slot.""",
                returnDoc = """A pattern with `n` progressively transformed copies of each event per slot.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c").plyWith(4, x => x.add(7))   // c, g, d5, a5 — each copy adds 7 semitones more""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("bd").plyWith(3, x => x.fast(2))    // original, then 2x speed, then 4x speed in same slot""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "plyWith",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "factor", type = kt10),
                    KlangParam(name = "transform", type = kt5),
                ),
                returnType = kt2,
                description = """Repeats each event `n` times, applying `transform` cumulatively (0, 1, 2 … times).""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "plyWith",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "factor", type = kt10),
                    KlangParam(name = "transform", type = kt5),
                ),
                returnType = kt5,
                description = """Chains a plyWith operation onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "plyWith",
                params = listOf(
                    KlangParam(name = "factor", type = kt10, description = """Number of repetitions per event slot."""),
                    KlangParam(name = "transform", type = kt5, description = """Pattern transformation applied cumulatively per copy."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that repeats each event `n` times, applying `transform` cumulatively.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c").apply(plyWith(4, x => x.add(7)))   // mapper form""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "plyforeach" to KlangSymbol(
        name = "plyforeach",
        category = "tempo",
        tags = listOf("plyforeach", "plyForEach", "repeat", "transform", "index"),
        aliases = listOf("plyForEach"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "plyforeach",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "factor", type = kt10, description = """Number of repetitions per event slot."""),
                    KlangParam(name = "transform", type = kt16, description = """Function receiving (pattern, index) where index is 0-based."""),
                ),
                returnType = kt2,
                description = """Alias for `plyForEach`.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "plyforeach",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "factor", type = kt10),
                    KlangParam(name = "transform", type = kt16),
                ),
                returnType = kt2,
                description = """Alias for [plyForEach] on a string pattern.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "plyforeach",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "factor", type = kt10),
                    KlangParam(name = "transform", type = kt16),
                ),
                returnType = kt5,
                description = """Alias for [PatternMapperFn.plyForEach].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "plyforeach",
                params = listOf(
                    KlangParam(name = "factor", type = kt10),
                    KlangParam(name = "transform", type = kt16),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that is an alias for [plyForEach].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "plywith" to KlangSymbol(
        name = "plywith",
        category = "tempo",
        tags = listOf("plywith", "plyWith", "repeat", "transform", "cumulative"),
        aliases = listOf("plyWith"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "plywith",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "factor", type = kt10, description = """Number of repetitions per event slot."""),
                    KlangParam(name = "transform", type = kt5, description = """Pattern transformation applied cumulatively per copy."""),
                ),
                returnType = kt2,
                description = """Alias for `plyWith`.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "plywith",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "factor", type = kt10),
                    KlangParam(name = "transform", type = kt5),
                ),
                returnType = kt2,
                description = """Alias for [plyWith] on a string pattern.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "plywith",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "factor", type = kt10),
                    KlangParam(name = "transform", type = kt5),
                ),
                returnType = kt5,
                description = """Alias for [PatternMapperFn.plyWith].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "plywith",
                params = listOf(
                    KlangParam(name = "factor", type = kt10),
                    KlangParam(name = "transform", type = kt5),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that is an alias for [plyWith].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "polymeter" to KlangSymbol(
        name = "polymeter",
        category = "structural",
        tags = listOf("polymeter", "rhythm", "timing", "alignment"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "polymeter",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "patterns", type = kt7, isVararg = true),
                ),
                returnType = kt2,
                description = """Prepends this pattern and aligns all patterns to a shared polymeter cycle.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c d").polymeter(note("c d e"))  // 2 and 3 steps aligned to LCM""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "polymeter",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "patterns", type = kt7, isVararg = true),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern and aligns all patterns to a shared polymeter cycle.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """"c d".polymeter("c d e").note()  // 2 and 3 steps aligned to LCM""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "polymeter",
                params = listOf(
                    KlangParam(name = "patterns", type = kt7, isVararg = true, description = """Patterns to align. Each must have a defined step count."""),
                ),
                returnType = kt2,
                description = """Aligns patterns with different step counts so they share a common cycle, creating polymeters.

 Patterns are sped up so that their LCM number of steps fits into one cycle. For example,
 a 2-step and a 3-step pattern are both sped up to a 6-step cycle — the 2-step plays 3 times
 and the 3-step plays 2 times per cycle, all in lockstep.""",
                returnDoc = """A pattern with all inputs aligned to their LCM step count per cycle""",
                samples = listOf(
                    KlangCodeSample(code = """polymeter(note("c d"), note("c d e")).s("piano")  // 2- and 3-step in a 6-step cycle""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """polymeter(s("bd sd"), s("hh hh hh"))  // 2-beat and 3-beat polyrhythm""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "polymeterSteps" to KlangSymbol(
        name = "polymeterSteps",
        category = "structural",
        tags = listOf("polymeter", "rhythm", "timing", "steps"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "polymeterSteps",
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true, description = """First argument is the target step count; remaining arguments are the patterns."""),
                ),
                returnType = kt2,
                description = """Like [polymeter], but with an explicit step count instead of using the LCM.

 All patterns are sped up or slowed down to fit exactly `steps` steps per cycle.""",
                returnDoc = """A pattern with all inputs adjusted to the given step count per cycle""",
                samples = listOf(
                    KlangCodeSample(code = """polymeterSteps(4, note("c d"), note("c d e"))  // both fit into 4 steps per cycle""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "polyrhythm" to KlangSymbol(
        name = "polyrhythm",
        category = "structural",
        tags = listOf("polyrhythm", "stack", "layer", "simultaneous", "rhythm"),
        aliases = listOf("stack"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "polyrhythm",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "patterns", type = kt7, isVararg = true),
                ),
                returnType = kt2,
                description = """Alias for [stack]. Layers this pattern together with additional patterns simultaneously.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd").polyrhythm(s("hh hh hh"))  // Layer two patterns""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "polyrhythm",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "patterns", type = kt7, isVararg = true),
                ),
                returnType = kt2,
                description = """Alias for [stack]. Parses this string as a pattern and layers it with additional patterns.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """"bd sd".polyrhythm(s("hh hh hh"))  // Layer two patterns""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "polyrhythm",
                params = listOf(
                    KlangParam(name = "patterns", type = kt7, isVararg = true, description = """Patterns to layer simultaneously."""),
                ),
                returnType = kt2,
                description = """Alias for [stack]. Plays multiple patterns simultaneously to create polyrhythms.""",
                returnDoc = """A pattern that plays all inputs at the same time""",
                samples = listOf(
                    KlangCodeSample(code = """polyrhythm(s("bd sd"), s("hh hh hh"))  // 2-beat and 3-beat patterns together""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "pow" to KlangSymbol(
        name = "pow",
        category = "arithmetic",
        tags = listOf("pow", "power", "exponent", "arithmetic", "math"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "pow",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "exponent", type = kt7, description = """The exponent. May be a number, string mini-notation, or a [SprudelPattern]."""),
                ),
                returnType = kt2,
                description = """Raises every numeric value in the pattern to the power of [exponent].

 Only the raw event `value` is affected — `note`, `soundIndex`, and all other voice properties
 remain unchanged. Supports control patterns: pass a mini-notation string or another
 [SprudelPattern] as [exponent] to modulate the exponent per cycle or event.""",
                returnDoc = """A new pattern where each value is replaced by `value ^ exponent`.""",
                samples = listOf(
                    KlangCodeSample(code = """seq("2 3").pow(3).scale("c3:major").n()  // values become 8 (2³) and 27 (3³)""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """seq("2").pow("<1 2 3>").scale("c3:major").n()  // 2, 4, 8 over three cycles""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "pow",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "exponent", type = kt7, description = """The exponent. May be a number, string mini-notation, or a [SprudelPattern]."""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern, then raises every numeric value to the power of [exponent].

 Only the raw event `value` is affected — `note`, `soundIndex`, and other voice properties
 remain unchanged.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """"2 3".pow(3).scale("c3:major").n()  // values become 8 (2³) and 27 (3³)""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "pow",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "exponent", type = kt7, description = """The exponent. May be a number, string mini-notation, or a [SprudelPattern]."""),
                ),
                returnType = kt5,
                description = """Chains an exponentiation onto this [PatternMapperFn], raising every numeric value to [exponent].""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """seq("2 3").apply(add(1).pow(2)).scale("c2:major").n()  // (2+1)^2=9, (3+1)^2=16""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "pow",
                params = listOf(
                    KlangParam(name = "exponent", type = kt7, description = """The exponent. May be a number, string mini-notation, or a [SprudelPattern]."""),
                ),
                returnType = kt5,
                description = """Creates a [PatternMapperFn] that raises every numeric value in a pattern to the power of [exponent].

 Only the raw event `value` is affected — `note`, `soundIndex`, and other voice properties
 remain unchanged. Use with [SprudelPattern.apply] to apply the exponentiation to an existing pattern.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """seq("2 3").apply(pow(3)).scale("c3:major").n()  // values become 8 (2³) and 27 (3³)""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "pregain" to KlangSymbol(
        name = "pregain",
        category = "dynamics",
        tags = listOf("pregain", "drive", "touch", "level", "oscillator"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "pregain",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "amount", type = kt6, isOptional = true, defaultDoc = """null""", description = """How hard the note is played in, 1 leaves the instrument at its own level."""),
                ),
                returnType = kt2,
                description = """Sets how hard each event is played INTO its instrument, per voice.

 The other level word, and the only one that is not a fader. `gain` is the level the event LEAVES
 at, after everything; `pregain` is the level the signal ARRIVES at inside the instrument, where
 it meets whatever the instrument does to it. Exactly `ignitorParam("pregain", amount)`: it writes the
 `pregain` slot and nothing else.

 **It does what the instrument wires it to, and nothing otherwise.** An instrument that places the
 slot in front of a nonlinearity turns this into touch: play harder, get dirtier, the way an amp
 does. An instrument that never places it ignores the call, note for note, and that is not a bug
 to work around: a bare sine has no drive. Reach for `gain` when you want the size of the sound.

 **`pregain` is not the drive amount, and the two scales are not the same.** An instrument's
 `distort(amount)` is EXPONENTIAL (about 4x at `0.5`, 16x at `1`, 250x at `2`) and it is fixed
 inside the instrument, one setting for every note; `pregain` is LINEAR, 1 is unity, and the
 pattern sets it per note. Design the drive once by ear, and leave `pregain` the touch.

 **Where it stops working, which is the opposite of what you might expect.** On a CLIPPING shape
 driven into hard saturation, turning `pregain` down changes almost nothing: not the tone and
 not the level either, because a clipper holds both. Measured on `saw.pregain().distort(2)
 .lowpass(2500)` at `pregain` 1 against 0.4: the level comes out at 0.999 of the loud one and
 the shape distance is 0.006, a rounding-scale no-op. So on a heavily driven lead, `pregain` is
 the wrong knob twice over: the LEVEL has to come from `gain`, and there is no touch left to
 find. The room to hear touch is at the gentle end of the drive (`distort(0.5)` gives a shape
 distance of 0.223 on the same measurement), which is what the example below uses.

 **That is true of the shapes that SATURATE, which is `soft` and the other clippers.** The three
 WAVEFOLDERS never saturate: `fold`, `linearfold` and `sineshaper` keep folding the harder you
 drive them, so there `pregain` IS the fold depth and stays the strongest tone knob at any drive
 (the same measurement at `distort(2)` gives a shape distance of 1.36 to 1.76 against `soft`'s
 0.006). It is not a level knob there either, and it is not even monotonic: on `fold` at
 `distort(2)`, turning `pregain` DOWN to 0.4 makes the note about four times LOUDER. `rectify`
 sits between the two families (0.054). A folder is a fine home for touch; just do not expect
 "down" to mean "softer".



 **Per VOICE, which is what makes it touch at all**: every note carries its own value, so
 `"1 0.6 1 0.4"` is four different notes. The orbit's own knobs (`katp`, the bus doors) are per
 ORBIT: the newest note that is still held (not its release tail) sets the orbit's effects, so they cannot articulate a line.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """let amp = Ignitor.saw().pregain().distort(0.5).lowpass(2500).classic()
note("c3 e3 g3 e3").sound(amp).pregain("1 0.6 1 0.4").gain(0.3)   // touch: harder notes dirtier""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c3 e3 g3 e3").sound("saw").distort(0.4).pregain("1 2.5").gain(0.3)   // every built-in SYNTH sound places the slot (samples do not): the distort bites harder on the loud notes""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "pregain",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "amount", type = kt6, isOptional = true, defaultDoc = """null""", description = """How hard the note is played in, 1 leaves the instrument at its own level."""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern and sets how hard each event is played into its instrument.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "pregain",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "amount", type = kt6, isOptional = true, defaultDoc = """null""", description = """How hard the note is played in, 1 leaves the instrument at its own level."""),
                ),
                returnType = kt5,
                description = """Creates a chained [PatternMapperFn] that sets the pregain after the previous mapper.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    )
)

private fun generatedSprudelDocsChunk25() = mapOf(

    "press" to KlangSymbol(
        name = "press",
        category = "structural",
        tags = listOf("press", "pressBy", "syncopate", "compress", "rhythm", "timing", "off-beat"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "press",
                receiver = kt0,
                params = emptyList(),
                returnType = kt2,
                description = """Syncopates this pattern by shifting each event halfway into its timespan.

 Equivalent to `pressBy(0.5)`. Creates a classic off-beat feel.""",
                returnDoc = """A syncopated pattern where events start halfway through their slots.""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd mt sd ht").press()                   // classic off-beat feel""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c d e f").every(4, x => x.press())   // press every 4th cycle""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "press",
                receiver = kt3,
                params = emptyList(),
                returnType = kt2,
                description = """Syncopates this string pattern by shifting events halfway into their timespan.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "press",
                receiver = kt4,
                params = emptyList(),
                returnType = kt5,
                description = """Chains a press onto this [PatternMapperFn]; shifts each event halfway into its timespan.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "press",
                params = emptyList(),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that syncopates the source by shifting events halfway.

 Equivalent to `pressBy(0.5)` as a mapper. Apply using `.apply()`.""",
                returnDoc = """A [PatternMapperFn] that shifts each event halfway into its slot.""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd mt sd ht").apply(press())   // classic off-beat feel via mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "pressBy" to KlangSymbol(
        name = "pressBy",
        category = "structural",
        tags = listOf("pressBy", "press", "syncopate", "compress", "rhythm", "timing"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "pressBy",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "r", type = kt7, description = """Compression ratio in the range [0, 1]; supports control patterns."""),
                ),
                returnType = kt2,
                description = """Syncopates this pattern by compressing each event to start at position `r` within its timespan.

 - `r = 0`: No compression (normal timing).
 - `r = 0.5`: Events start halfway through their slot (classic syncopation).
 - `r = 1`: Events compressed to the very end of their slot.""",
                returnDoc = """A syncopated pattern.""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd mt sd ht").pressBy(0.5)          // classic syncopation""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("bd mt sd ht").pressBy("<0 0.5 0.25>") // varying syncopation each cycle""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "pressBy",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "r", type = kt7),
                ),
                returnType = kt2,
                description = """Syncopates this string pattern by compressing events to start at position `r`.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "pressBy",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "r", type = kt7),
                ),
                returnType = kt5,
                description = """Chains a pressBy onto this [PatternMapperFn]; compresses events to position `r`.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "pressBy",
                params = listOf(
                    KlangParam(name = "r", type = kt7, description = """Compression ratio in the range [0, 1]."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that syncopates the source by compressing events to position `r`.""",
                returnDoc = """A [PatternMapperFn] that syncopates the source.""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd mt sd ht").apply(pressBy(0.5))   // classic syncopation via mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "pure" to KlangSymbol(
        name = "pure",
        category = "structural",
        tags = listOf("pure", "value", "atomic", "repeat"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "pure",
                params = listOf(
                    KlangParam(name = "value", type = kt7, description = """The value to wrap in a pattern."""),
                ),
                returnType = kt2,
                description = """Creates an atomic pattern that repeats a single value every cycle.""",
                returnDoc = """A pattern that emits `value` once per cycle""",
                samples = listOf(
                    KlangCodeSample(code = """pure("c").note()  // repeats note "c" every cycle""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """pure(1)  // repeats the number 1 every cycle""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "randcat" to KlangSymbol(
        name = "randcat",
        category = "random",
        tags = listOf("randcat", "chooseCycles", "random", "cycle"),
        aliases = listOf("chooseCycles"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "randcat",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true),
                ),
                returnType = kt2,
                description = """Alias for [chooseCycles].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "randcat",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true),
                ),
                returnType = kt2,
                description = """Alias for [chooseCycles].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "randcat",
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true, description = """Values or patterns to randomly pick from; one is chosen per cycle."""),
                ),
                returnType = kt2,
                description = """Alias for [chooseCycles].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "randrun" to KlangSymbol(
        name = "randrun",
        category = "random",
        tags = listOf("randrun", "random", "permutation", "shuffle", "sequence"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "randrun",
                params = listOf(
                    KlangParam(name = "n", type = kt7, description = """Number of integers in the random permutation (produces values 0 to n-1). Any positive integer."""),
                ),
                returnType = kt2,
                description = """Creates a pattern of `n` integers (0 to n-1) in a new random order each cycle.

 Every cycle, the range `0..(n-1)` is shuffled and played in that random order. Each value
 appears exactly once per cycle. Useful for randomised but non-repeating sequences.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """n(randrun(8)).scale("C:pentatonic").note()   // random permutation of 8 scale degrees""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("bd sd hh cp").bite(4, randrun(4))         // random order of 4 slices each cycle""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "range" to KlangSymbol(
        name = "range",
        category = "continuous",
        tags = listOf("range", "scale", "from", "to", "oscillator", "lfo", "continuous", "unipolar", "bipolar"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "range",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "from", type = kt9, isOptional = true, defaultDoc = """0.0""", description = """The value where the signal is at its low end (default `0.0`)."""),
                    KlangParam(name = "to", type = kt9, isOptional = true, defaultDoc = """1.0""", description = """The value where the signal is at its high end (default `1.0`)."""),
                ),
                returnType = kt2,
                description = """Lets a continuous signal swing between [from] and [to].

 The signals (`sine`, `saw`, `perlin`, `rand`, ...) swing between `0` and `1` on their own. `range` maps that
 swing linearly onto `[from, to]`: where the signal is `0` you get [from], where it is `1` you get [to]. Every
 signal has a shorthand for it: `perlin(200, 400)` is exactly `perlin.range(200, 400)`.

 `range` shapes continuous signals only. Discrete values (a mini-notation string, `seq(...)`) scale with `mul` and
 `add`: `"0 0.5 1".mul(900).add(100)` gives 100, 550 and 1000.

 Where the swing sits is up to the two values:

 | Call              | The signal moves                                      |
 |-------------------|-------------------------------------------------------|
 | `range(0, 1)`     | only upward, between 0 and 1 (the signal as it is)    |
 | `range(-1, 0)`    | only downward, between -1 and 0                       |
 | `range(-1, 1)`    | both ways, centred on 0                               |
 | `range(-0.5, 1)`  | mostly upward, dipping a little below 0               |
 | `range(1, 0)`     | the same swing turned upside down                     |

 The Ignitor oscillators swing between `-1` and `1` instead, and their `range(from, to)` gives the same result:
 `x.range(200, 400)` swings between 200 and 400 in both DSLs, so no one needs to know where a source started.

 The innermost range wins: `perlin(200, 400).range(0, 1)` still swings between 200 and 400, so a signal is
 ranged once. An outer [rangex] does not reshape a ranged signal either (`perlin(200, 400).rangex(100, 1000)` gives
 wrong values): use [rangex] on the bare signal, `perlin.rangex(200, 400)`. A centred swing is `sine.range(-1, 1)`.

 For an exponential (perceptually even) scaling, useful with frequencies, use [rangex] instead.""",
                returnDoc = """A new pattern with values linearly scaled to `[from, to]`.""",
                samples = listOf(
                    KlangCodeSample(code = """sine.range(200, 2000).freq().segment(128)  // sine frequency sweep 200 to 2000 Hz""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("hh*8").pan(0.5).pan(add(perlin.seg(8).range(-0.2, 0.2)))  // drifts both ways around the centre""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c4*8").s("saw").lpf(perlin(400, 2000).slow(8))  // the shorthand: perlin.range(400, 2000)""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "range",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "from", type = kt9, isOptional = true, defaultDoc = """0.0""", description = """The value where the signal is at its low end (default `0.0`)."""),
                    KlangParam(name = "to", type = kt9, isOptional = true, defaultDoc = """1.0""", description = """The value where the signal is at its high end (default `1.0`)."""),
                ),
                returnType = kt5,
                description = """Chains a linear range-scaling onto this [PatternMapperFn], mapping values to `[from, to]`.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """sine.apply(slow(4).range(200, 2000)).freq().segment(64)  // chain slow then scale""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "range",
                params = listOf(
                    KlangParam(name = "from", type = kt9, isOptional = true, defaultDoc = """0.0""", description = """The value where the signal is at its low end (default `0.0`)."""),
                    KlangParam(name = "to", type = kt9, isOptional = true, defaultDoc = """1.0""", description = """The value where the signal is at its high end (default `1.0`)."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that linearly scales pattern values to `[from, to]`.

 Use the returned mapper as a transform argument or apply it to a pattern via `.apply(...)`.""",
                returnDoc = """A [PatternMapperFn] that linearly scales values to `[from, to]`.""",
                samples = listOf(
                    KlangCodeSample(code = """sine.apply(range(200, 2000)).freq().segment(128)  // sine frequency sweep 200–2000 Hz""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """sine.firstOf(4, range(0.2, 0.9)).gain().segment(128)  // alternate gain range every 4 cycles""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "rangex" to KlangSymbol(
        name = "rangex",
        category = "continuous",
        tags = listOf("rangex", "range", "exponential", "logarithmic", "scale", "frequency", "oscillator", "lfo", "continuous"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "rangex",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "from", type = kt9, isOptional = true, defaultDoc = """0.0""", description = """The value where the signal is at its low end (default `0.0`; use a small positive number for frequencies)."""),
                    KlangParam(name = "to", type = kt9, isOptional = true, defaultDoc = """1.0""", description = """The value where the signal is at its high end (default `1.0`)."""),
                ),
                returnType = kt2,
                description = """Scales the values of a continuous pattern to `[from, to]` using an **exponential** curve.

 `rangex` shapes continuous signals only, like [range]. Discrete values scale with `mul` and `add`.

 Unlike [range] (linear), `rangex` applies a logarithmic input mapping so that equal
 perceived steps correspond to equal value steps. This is particularly useful for audio
 frequencies and filter cutoffs, where musical intervals (octaves, fifths) are ratios
 rather than fixed differences.

 Both values must be greater than `0` for meaningful results; values ≤ `0` are coerced to
 `0.0001` internally to avoid `ln(0)`. The Ignitor's `rangex(from, to)` is the same mapping on its `-1..1` swing.""",
                returnDoc = """A new pattern with values exponentially scaled to `[from, to]`.""",
                samples = listOf(
                    KlangCodeSample(code = """sine.rangex(100, 1000).freq().segment(128)  // frequency sweep with musical spacing""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """perlin.rangex(50, 1000).freq().segment(128)  // exponential filter cutoff sweep""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "rangex",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "from", type = kt9, isOptional = true, defaultDoc = """0.0""", description = """The value where the signal is at its low end (default `0.0`; use a small positive number for frequencies)."""),
                    KlangParam(name = "to", type = kt9, isOptional = true, defaultDoc = """1.0""", description = """The value where the signal is at its high end (default `1.0`)."""),
                ),
                returnType = kt5,
                description = """Chains an exponential range-scaling onto this [PatternMapperFn], mapping values to `[from, to]`.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """sine.apply(slow(4).rangex(100, 2000)).freq().segment(64)  // chain slow then exponential frequency range""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "rangex",
                params = listOf(
                    KlangParam(name = "from", type = kt9, isOptional = true, defaultDoc = """0.0""", description = """The value where the signal is at its low end (default `0.0`; use a small positive number for frequencies)."""),
                    KlangParam(name = "to", type = kt9, isOptional = true, defaultDoc = """1.0""", description = """The value where the signal is at its high end (default `1.0`)."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that exponentially scales pattern values to `[from, to]`.

 Use the returned mapper as a transform argument or apply it to a pattern via `.apply(...)`.""",
                returnDoc = """A [PatternMapperFn] that exponentially scales values to `[from, to]`.""",
                samples = listOf(
                    KlangCodeSample(code = """sine.apply(rangex(100, 1000)).freq().segment(128)  // exponential frequency sweep""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """sine.firstOf(4, rangex(50, 500)).freq().segment(128)  // alternate exponential range every 4 cycles""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "rarely" to KlangSymbol(
        name = "rarely",
        category = "random",
        tags = listOf("rarely", "random", "probability", "conditional", "transform"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "rarely",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "mapper", type = kt5, description = """The transformation to apply 25% of the time."""),
                ),
                returnType = kt2,
                description = """Applies `transform` with 25% probability per event. Shorthand for `sometimesBy(0.25, fn)`.""",
                returnDoc = """A pattern with `mapper` applied to ~25% of events.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c d e f").rarely(x => x.transpose(12))   // only 1 in 4 notes shifted an octave""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "rarely",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "mapper", type = kt5),
                ),
                returnType = kt2,
                description = """Applies `transform` with 25% probability per event. Shorthand for `sometimesBy(0.25, fn)`.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "rarely",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "mapper", type = kt5),
                ),
                returnType = kt5,
                description = """Chains a rarely (25% per event) onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "rarely",
                params = listOf(
                    KlangParam(name = "mapper", type = kt5),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that applies `mapper` with 25% probability per event.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    )
)

private fun generatedSprudelDocsChunk26() = mapOf(

    "ratio" to KlangSymbol(
        name = "ratio",
        category = "structural",
        tags = listOf("ratio", "tuning", "fraction", "colon", "notation"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "ratio",
                receiver = kt0,
                params = emptyList(),
                returnType = kt2,
                description = """Converts colon-ratio notation in the pattern's values to numbers.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "ratio",
                receiver = kt3,
                params = emptyList(),
                returnType = kt2,
                description = """Converts colon-ratio notation in the mini-notation string to numbers.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "ratio",
                params = listOf(
                    KlangParam(name = "values", type = kt7, isVararg = true, description = """One or more ratio strings or numbers to convert."""),
                ),
                returnType = kt2,
                description = """Parses colon-separated ratios into numbers: `"5:4"` → 1.25, `"3:2"` → 1.5, `"12:3:2"` → 2.0.

 Useful for specifying tuning ratios or rhythmic proportions using familiar ratio notation.""",
                returnDoc = """A pattern of the computed ratio values.""",
                samples = listOf(
                    KlangCodeSample(code = """ratio("5:4", "3:2", "2:1").note()  // major third, fifth, octave as ratios""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """ratio("3:2").note()  // perfect fifth ratio""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "repeat" to KlangSymbol(
        name = "repeat",
        category = "structural",
        tags = listOf("repeat", "loop", "duplicate", "sequence"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "repeat",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "times", type = kt7, description = """The number of times to repeat. `0` returns silence; `1` returns the pattern unchanged."""),
                ),
                returnType = kt2,
                description = """Repeats this pattern `times` times sequentially.

 The total duration becomes `times × original_duration`. Unlike [fast], which compresses events
 into fewer cycles, each repetition occupies its own full cycle. Useful for extending a short
 pattern to fill multiple bars before it loops.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("a b").repeat(2)              // plays "a b a b" spread over 2 cycles""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("bd sd hh cp").repeat(4)         // loop a 4-beat bar four times before cycling""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "repeat",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "times", type = kt7, description = """The number of times to repeat. `0` returns silence; `1` returns the pattern unchanged."""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern and repeats it `times` times sequentially.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """"a b".repeat(3).note()             // plays "a b a b a b" spread over 3 cycles""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """"bd sd".repeat(2).s()              // double-length drum bar""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "repeat",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "times", type = kt7, description = """The number of times to repeat. `0` returns silence; `1` returns the pattern unchanged."""),
                ),
                returnType = kt5,
                description = """Chains a repeat operation onto this [PatternMapperFn], repeating the result `times` times.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("a b").apply(fast(2).repeat(2))   // fast doubles density, repeat duplicates over 2 cycles""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "repeat",
                params = listOf(
                    KlangParam(name = "times", type = kt7, description = """The number of times to repeat. `0` returns silence; `1` returns the pattern unchanged."""),
                ),
                returnType = kt5,
                description = """Creates a [PatternMapperFn] that repeats the input pattern `times` times sequentially.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("a b").apply(repeat(2))       // plays "a b a b" spread over 2 cycles""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("bd sd").apply(repeat(3))        // triple-length drum bar via mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "repeatCycles" to KlangSymbol(
        name = "repeatCycles",
        category = "structural",
        tags = listOf("repeatCycles", "repeat", "cycle", "loop", "stutter"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "repeatCycles",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "n", type = kt7, description = """Number of times to repeat each cycle."""),
                ),
                returnType = kt2,
                description = """Repeats each cycle of this pattern `n` times before advancing.

 Cycle 0 plays `n` times, then cycle 1 plays `n` times, and so on. Supports control patterns.""",
                returnDoc = """A pattern where each cycle is repeated `n` times.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c d e f").repeatCycles(3)    // each cycle repeats 3 times""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("bd sd").repeatCycles("<1 2 4>") // varying repetitions each cycle""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "repeatCycles",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "n", type = kt7),
                ),
                returnType = kt2,
                description = """Repeats each cycle of this string pattern `n` times.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "repeatCycles",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "n", type = kt7),
                ),
                returnType = kt5,
                description = """Chains a repeatCycles onto this [PatternMapperFn]; repeats each cycle `n` times.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "repeatCycles",
                params = listOf(
                    KlangParam(name = "n", type = kt7, description = """Number of times to repeat each cycle."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that repeats each cycle of the source `n` times.""",
                returnDoc = """A [PatternMapperFn] that repeats cycles.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c d e f").apply(repeatCycles(3))  // via mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "rev" to KlangSymbol(
        name = "rev",
        category = "tempo",
        tags = listOf("rev", "reverse", "order", "retrograde"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "rev",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "n", type = kt7, isOptional = true, defaultDoc = """1""", description = """Number of cycles to reverse across. Default: 1 (reverse within each cycle). Typical range: 1–8."""),
                ),
                returnType = kt2,
                description = """Reverses the order of events within each cycle (or across `n` cycles when given an argument).

 With no argument, each individual cycle plays its events in reverse order. With an integer `n`,
 the reversal is applied across every `n`-cycle span — useful for longer retrograde effects.
 Accepts control patterns for the cycle count.""",
                returnDoc = """A pattern with events reversed per cycle (or per `n`-cycle group).""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd hh sd hh hh cp").rev()              // reversed each cycle""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("<[c d] [e f]>").rev(2)              // reverses across every 2-cycle span""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "rev",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "n", type = kt7, isOptional = true, defaultDoc = """1"""),
                ),
                returnType = kt2,
                description = """Reverses the order of events, applying the reversal across every `n`-cycle span.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "rev",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "n", type = kt7, isOptional = true, defaultDoc = """1"""),
                ),
                returnType = kt5,
                description = """Chains a rev operation onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "rev",
                params = listOf(
                    KlangParam(name = "n", type = kt7, isOptional = true, defaultDoc = """1""", description = """Number of cycles to reverse across. Default: 1. Typical range: 1–8."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that reverses the order of events across every `n`-cycle span.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd hh sd cp").apply(rev())             // mapper form""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "reverb" to KlangSymbol(
        name = "reverb",
        category = "effects",
        tags = listOf("reverb", "wet", "size", "lowpass"),
        aliases = listOf(),
        scope = KlangScope.ORBIT,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "reverb",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "wet", type = kt6, isOptional = true, defaultDoc = """null""", description = """How much of the orbit goes into the room, 0 to 1, default 0.25. Orbit-wide.""", uitools = listOf("SprudelReverbEditor", "SprudelReverbSequenceEditor")),
                    KlangParam(name = "size", type = kt6, isOptional = true, defaultDoc = """null""", description = """Tail length, about 0 to 10, default 5; above 10 is bounded at 10. Orbit-wide.""", uitools = listOf("SprudelReverbSizeEditor", "SprudelReverbSizeSequenceEditor")),
                    KlangParam(name = "lowpass", type = kt6, isOptional = true, defaultDoc = """null""", description = """Lowpass on the tail, Hz. Lower is darker. Unset by default. Orbit-wide."""),
                ),
                returnType = kt2,
                description = """The orbit reverb: how much of the orbit goes into the room, its size and its lowpass.

 One reverb per orbit bus, and all three are set once for everyone
 by the orbit's owning voice. `wet` is how much of the orbit goes into the room: the room is added
 on top of the dry sound, and every voice on the orbit is in it alike. So a pattern that should
 stay dry, or sit in the room by a different amount, goes on an orbit of its own. The room hears
 everything before it on the orbit: a `body`, a `vowel` and the `delay`'s echoes. When another
 pattern with a reverb takes the orbit over, `wet` and `size` move smoothly to its values; a
 pattern without one switches the room off: its feed fades out over 50 ms and the tail rings out.

 The call sets every slot: the ones you leave out take the same default as on the master reverb,
 wet 0.25 and size 5 (lowpass has none), unless an earlier call already set them. So a bare
 `reverb(0.4)` already plays in a medium room, and `reverb.size` reads 5 after it. Slots apply in
 order, wet first, so a mapper on a later slot sees a default an earlier slot of the same call
 filled in (`reverb(0.3, size = mul(2))` is size 10). A call whose only slot rests in its control
 pattern writes nothing on that event, and fills nothing. `size` sets the tail: 3 is
 roughly 1 s, 5 roughly 1.4 s, 10 roughly 12.5 s, the longest there is. `lowpass` darkens the
 tail: the lower the cutoff, the duller the room.

 Every slot is independent and patternable; an omitted slot keeps its value, a named slot takes
 a mapper (`reverb(size = mul(2))`), and the numeric slots read back as `reverb.wet`, `reverb.size`, `reverb.lowpass`.
 With no argument at all, the pattern's own values are reinterpreted as `wet`.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd").reverb(0.3, 4)                                                  // wet and size""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("bd sd").reverb(0.3, 4).reverb(size = mul("<1 2>"))                      // twice the room every other bar""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c3 e3 g3").s("saw").reverb(wet = 0.5, size = 6, lowpass = "<16000 1500>")    // a bright room, then a dark one""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("bd sd").reverb("<0.1 0.5>", 4).delay(wet = reverb.wet, time = 0.25)     // as much delay as reverb""", type = KlangCodeSampleType.PLAYABLE)
                ),
                uitools = listOf("SprudelReverbEditor"),
                library = "sprudel"
            ),
            KlangCallable(
                name = "reverb",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "wet", type = kt6, isOptional = true, defaultDoc = """null""", uitools = listOf("SprudelReverbEditor", "SprudelReverbSequenceEditor")),
                    KlangParam(name = "size", type = kt6, isOptional = true, defaultDoc = """null""", uitools = listOf("SprudelReverbSizeEditor", "SprudelReverbSizeSequenceEditor")),
                    KlangParam(name = "lowpass", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern, then applies [reverb].""",
                returnDoc = """""",
                samples = emptyList(),
                uitools = listOf("SprudelReverbEditor"),
                library = "sprudel"
            ),
            KlangCallable(
                name = "reverb",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "wet", type = kt6, isOptional = true, defaultDoc = """null""", uitools = listOf("SprudelReverbEditor", "SprudelReverbSequenceEditor")),
                    KlangParam(name = "size", type = kt6, isOptional = true, defaultDoc = """null""", uitools = listOf("SprudelReverbSizeEditor", "SprudelReverbSizeSequenceEditor")),
                    KlangParam(name = "lowpass", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt5,
                description = """Chains a [reverb] step onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                uitools = listOf("SprudelReverbEditor"),
                library = "sprudel"
            )
        )
    ),

    "revv" to KlangSymbol(
        name = "revv",
        category = "tempo",
        tags = listOf("revv", "reverse", "retrograde", "time", "global"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "revv",
                receiver = kt0,
                params = emptyList(),
                returnType = kt2,
                description = """Reverses the pattern in absolute time across all cycles.

 Unlike `rev()` which reverses each cycle independently, `revv()` negates the time axis
 globally: cycle N becomes cycle -N, so a long phrase is played completely backwards in
 absolute time. Useful for true retrograde playback of multi-cycle phrases.""",
                returnDoc = """A globally time-reversed version of the pattern.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c d e f").revv()              // plays f e d c in absolute negative time direction""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "revv",
                receiver = kt3,
                params = emptyList(),
                returnType = kt2,
                description = """Reverses the pattern in absolute time across all cycles.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "revv",
                receiver = kt4,
                params = emptyList(),
                returnType = kt5,
                description = """Chains a revv operation onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "revv",
                params = emptyList(),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that reverses the pattern in absolute time.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c d e f").apply(revv())       // mapper form""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "rib" to KlangSymbol(
        name = "rib",
        category = "structural",
        tags = listOf("rib", "ribbon", "loop", "slice", "offset", "cycle"),
        aliases = listOf("ribbon"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "rib",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "offset", type = kt7, description = """Start point of the loop in cycles."""),
                    KlangParam(name = "cycles", type = kt7, isOptional = true, defaultDoc = """1.0""", description = """Length of the looped segment in cycles (default 1.0)."""),
                ),
                returnType = kt2,
                description = """Alias for [ribbon]. Loops a segment of the pattern starting at `offset` for `cycles` cycles.""",
                returnDoc = """A pattern that loops the specified segment.""",
                samples = listOf(
                    KlangCodeSample(code = """note("<c d e f>").rib(1, 2)  // loops the 2-cycle segment starting at cycle 1""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("bd sd hh cp").rib(0.5, 1)  // starts half a cycle in, loops 1 cycle""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "rib",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "offset", type = kt7, description = """Start point of the loop in cycles."""),
                    KlangParam(name = "cycles", type = kt7, isOptional = true, defaultDoc = """1.0""", description = """Length of the looped segment in cycles (default 1.0)."""),
                ),
                returnType = kt2,
                description = """Alias for [ribbon] applied to a mini-notation string.""",
                returnDoc = """A pattern that loops the specified segment.""",
                samples = listOf(
                    KlangCodeSample(code = """"bd sd hh cp".rib(0.5, 1).s()  // starts half a cycle in, loops 1 cycle""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "rib",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "offset", type = kt7),
                    KlangParam(name = "cycles", type = kt7, isOptional = true, defaultDoc = """1.0"""),
                ),
                returnType = kt5,
                description = """Chains a rib onto this [PatternMapperFn]; alias for [PatternMapperFn.ribbon].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "rib",
                params = listOf(
                    KlangParam(name = "offset", type = kt7, description = """Start point of the loop in cycles."""),
                    KlangParam(name = "cycles", type = kt7, isOptional = true, defaultDoc = """1.0""", description = """Length of the looped segment in cycles (default 1.0)."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that is an alias for [ribbon] — loops a segment of the source pattern.""",
                returnDoc = """A [PatternMapperFn] that loops the specified segment of the source.""",
                samples = listOf(
                    KlangCodeSample(code = """note("<c d e f>").apply(rib(1, 2))  // via mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "ribbon" to KlangSymbol(
        name = "ribbon",
        category = "structural",
        tags = listOf("ribbon", "rib", "loop", "slice", "offset", "cycle"),
        aliases = listOf("rib"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "ribbon",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "offset", type = kt7, description = """Start point of the loop in cycles."""),
                    KlangParam(name = "cycles", type = kt7, isOptional = true, defaultDoc = """1.0""", description = """Length of the looped segment in cycles (default 1.0)."""),
                ),
                returnType = kt2,
                description = """Loops a segment of the pattern starting at `offset` for `cycles` cycles.

 Imagine the entire timeline as a ribbon: `ribbon` cuts a piece starting at `offset` with length
 `cycles`, then loops that piece indefinitely.""",
                returnDoc = """A pattern that loops the specified segment.""",
                samples = listOf(
                    KlangCodeSample(code = """note("<c d e f>").ribbon(1, 2)  // loops the 2-cycle segment starting at cycle 1""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("bd sd hh cp").ribbon(0.5, 1)  // starts half a cycle in, loops 1 cycle""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "ribbon",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "offset", type = kt7, description = """Start point of the loop in cycles."""),
                    KlangParam(name = "cycles", type = kt7, isOptional = true, defaultDoc = """1.0""", description = """Length of the looped segment in cycles (default 1.0)."""),
                ),
                returnType = kt2,
                description = """Loops a segment of the mini-notation string pattern starting at `offset` for `cycles` cycles.""",
                returnDoc = """A pattern that loops the specified segment.""",
                samples = listOf(
                    KlangCodeSample(code = """"bd sd hh cp".ribbon(0.5, 1).s()  // starts half a cycle in, loops 1 cycle""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "ribbon",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "offset", type = kt7),
                    KlangParam(name = "cycles", type = kt7, isOptional = true, defaultDoc = """1.0"""),
                ),
                returnType = kt5,
                description = """Chains a ribbon onto this [PatternMapperFn]; loops a segment of the result starting at `offset`.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "ribbon",
                params = listOf(
                    KlangParam(name = "offset", type = kt7, description = """Start point of the loop in cycles."""),
                    KlangParam(name = "cycles", type = kt7, isOptional = true, defaultDoc = """1.0""", description = """Length of the looped segment in cycles (default 1.0)."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that loops a segment of the source pattern starting at `offset` for `cycles` cycles.""",
                returnDoc = """A [PatternMapperFn] that loops the specified segment of the source.""",
                samples = listOf(
                    KlangCodeSample(code = """note("<c d e f>").apply(ribbon(1, 2))  // via mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    )
)

private fun generatedSprudelDocsChunk27() = mapOf(

    "rootNotes" to KlangSymbol(
        name = "rootNotes",
        category = "tonal",
        tags = listOf("rootNotes", "chord root", "bass", "harmony"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "rootNotes",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "octave", type = kt6, isOptional = true, defaultDoc = """null""", description = """Root note extraction mode or offset. Default: extracts the root note from the current chord."""),
                ),
                returnType = kt2,
                description = """Extracts the root (bass) note from a chord pattern.

 Given a pattern with chord names set via [chord], `rootNotes` produces events carrying
 only the chord root note. An optional integer argument forces the root to a specific octave.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """chord("C:major Am:minor F:major").rootNotes()   // root notes: C, A, F""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """chord("Cmaj7 Am7 Fmaj7").rootNotes(3)           // roots forced to octave 3""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "rootNotes",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "octave", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt2,
                description = """Extracts root notes from chord events in a string pattern, forcing to the given octave.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "rootNotes",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "octave", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt5,
                description = """Chains a rootNotes step (with forced octave) onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "rootNotes",
                params = listOf(
                    KlangParam(name = "octave", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that extracts root notes from chord events, forcing to the given octave.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "round" to KlangSymbol(
        name = "round",
        category = "arithmetic",
        tags = listOf("round", "rounding", "arithmetic", "math"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "round",
                receiver = kt0,
                params = emptyList(),
                returnType = kt2,
                description = """Rounds every numeric value in the pattern to the nearest integer.""",
                returnDoc = """A new pattern with each value rounded to the nearest integer.""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "round",
                receiver = kt3,
                params = emptyList(),
                returnType = kt2,
                description = """""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "round",
                receiver = kt4,
                params = emptyList(),
                returnType = kt5,
                description = """""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "round",
                params = emptyList(),
                returnType = kt5,
                description = """""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "run" to KlangSymbol(
        name = "run",
        category = "structural",
        tags = listOf("run", "sequence", "range", "index", "discrete"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "run",
                params = listOf(
                    KlangParam(name = "n", type = kt10, description = """Number of steps; the pattern produces values 0, 1, …, n-1."""),
                ),
                returnType = kt2,
                description = """Creates a discrete pattern of integers from 0 to `n - 1`.

 Equivalent to `n("0 1 2 … n-1")`. Useful for driving scale or sample index patterns.""",
                returnDoc = """A sequential pattern of integers from 0 to n-1.""",
                samples = listOf(
                    KlangCodeSample(code = """n(run(4)).scale("C4:pentatonic")  // 4 scale degrees per cycle""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """n(run(8)).s("piano")  // 8 sequential notes""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "s" to KlangSymbol(
        name = "s",
        category = "tonal",
        tags = listOf("sound", "sample", "instrument", "s", "pattern-creator"),
        aliases = listOf("sound"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "s",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "name", type = kt6, isOptional = true, defaultDoc = """null""", description = """The sound/sample name pattern in mini-notation, e.g. `"bd sd hh"`.""", uitools = listOf("SprudelSampleEditor", "SprudelSampleSequenceEditor")),
                ),
                returnType = kt2,
                description = """Alias for [sound]. Creates a pattern selecting a sound (instrument or sample bank) by name.

 Each event's value selects the instrument or sample bank used during playback.
 The format `"name:index"` also sets the sample index, e.g. `"bd:2"` selects sample 2
 from the `bd` bank.

 When [name] is omitted, reinterprets the current event values as sound names.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd hh")  // basic drum pattern""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """seq("bd hh sd hh").s()  // interprets the sequence values as sounds""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "s",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "name", type = kt6, isOptional = true, defaultDoc = """null""", uitools = listOf("SprudelSampleEditor", "SprudelSampleSequenceEditor")),
                ),
                returnType = kt2,
                description = """Alias for [sound] on a string pattern.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "s",
                params = listOf(
                    KlangParam(name = "name", type = kt7, description = """The sound/sample name pattern in mini-notation, e.g. `"bd sd hh"`.""", uitools = listOf("SprudelSampleEditor", "SprudelSampleSequenceEditor")),
                ),
                returnType = kt2,
                description = """Alias for [sound]. Creates a sound pattern.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "s_cat" to KlangSymbol(
        name = "s_cat",
        category = "structural",
        tags = listOf("stepcat", "sequence", "timing", "proportional", "duration"),
        aliases = listOf("stepcat", "timeCat", "timecat"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "s_cat",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "segments", type = kt7, isVararg = true),
                ),
                returnType = kt2,
                description = """Alias for [stepcat]. Prepends this pattern (weight 1) and arranges all segments in one cycle.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c").s_cat([3, note("e g")])  // "c" takes 1/4, "e g" takes 3/4""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "s_cat",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "segments", type = kt7, isVararg = true),
                ),
                returnType = kt2,
                description = """Alias for [stepcat]. Parses this string and arranges all segments proportionally in one cycle.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """"c".s_cat([3, "e g"]).note()  // "c" takes 1/4, "e g" takes 3/4""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "s_cat",
                params = listOf(
                    KlangParam(name = "segments", type = kt7, isVararg = true, description = """Pairs of `[duration, pattern]`, or bare patterns (weight defaults to 1)."""),
                ),
                returnType = kt2,
                description = """Alias for [stepcat]. Concatenates weighted patterns into exactly one cycle.""",
                returnDoc = """A pattern with all segments proportionally distributed within one cycle""",
                samples = listOf(
                    KlangCodeSample(code = """s_cat([1, "a"], [3, "b"]).note()  // "a" takes 1/4, "b" takes 3/4""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "scale" to KlangSymbol(
        name = "scale",
        category = "tonal",
        tags = listOf("scale", "pitch", "musical scale", "mode", "tuning"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "scale",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "name", type = kt6, isOptional = true, defaultDoc = """null""", description = """The scale name in `"root:mode"` or `"root mode"` format, e.g. `"c4:major"`.""", uitools = listOf("SprudelScaleEditor")),
                ),
                returnType = kt2,
                description = """Sets the musical scale context for resolving note indices to note names.

 When a scale is set, numeric values passed to [n] are resolved against the scale's note
 list using `Scale.steps()`. Scale names use the format `"root:mode"` or `"root mode"`,
 e.g. `"c4:major"` or `"c4 minor"`. If no scale is set, numeric indices map to semitones.
 When called with no argument, reinterprets the current event value as a scale name.""",
                returnDoc = """A pattern with the scale context applied to each event.""",
                samples = listOf(
                    KlangCodeSample(code = """n("0 1 2 3").scale("c4:major")          // C4, D4, E4, F4""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """n("0 2 4").scale("<c4:major a3:minor>")  // alternates scale per cycle""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "scale",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "name", type = kt6, isOptional = true, defaultDoc = """null""", uitools = listOf("SprudelScaleEditor")),
                ),
                returnType = kt2,
                description = """Applies scale context to a string pattern; numeric values are resolved to scale notes.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "scale",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "name", type = kt6, isOptional = true, defaultDoc = """null""", uitools = listOf("SprudelScaleEditor")),
                ),
                returnType = kt5,
                description = """Chains a scale operation onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "scale",
                params = listOf(
                    KlangParam(name = "name", type = kt6, isOptional = true, defaultDoc = """null""", uitools = listOf("SprudelScaleEditor")),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that sets the scale context for resolving note indices.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """n("0 1 2").apply(scale("c4:major"))     // mapper form: C4, D4, E4""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "scaleTranspose" to KlangSymbol(
        name = "scaleTranspose",
        category = "tonal",
        tags = listOf("scaleTranspose", "scale degrees", "pitch", "transpose"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "scaleTranspose",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "steps", type = kt7, description = """Number of scale steps to transpose. 1 = next scale note up, -1 = previous. Integer values. Default: 0. Range: any integer."""),
                ),
                returnType = kt2,
                description = """Transposes notes by a number of scale degrees within the active [scale].

 Unlike [transpose] which shifts by semitones, `scaleTranspose` steps through the notes of
 the current scale context. Falls back to chromatic (semitone) transposition when no scale
 is active.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """n("0 2 4").scale("c4:major").note().scaleTranspose(1)  // shift up 1 scale degree""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c4 e4 g4").scale("c4:major").scaleTranspose(-2)  // shift down 2 scale degrees""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "scaleTranspose",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "steps", type = kt7),
                ),
                returnType = kt2,
                description = """Transposes a string pattern by a number of scale degrees within the active scale.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "scaleTranspose",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "steps", type = kt7),
                ),
                returnType = kt5,
                description = """Chains a scaleTranspose step onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "scaleTranspose",
                params = listOf(
                    KlangParam(name = "steps", type = kt7),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that transposes each event by the given number of scale degrees.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "scramble" to KlangSymbol(
        name = "scramble",
        category = "random",
        tags = listOf("scramble", "random", "slice", "replacement", "selection"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "scramble",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "n", type = kt7, description = """Number of equal slices to divide the pattern into and pick from."""),
                ),
                returnType = kt2,
                description = """Slices the pattern into `n` equal parts and picks slices at random each cycle.

 Unlike [shuffle], which plays each slice exactly once, `scramble` picks randomly with
 replacement: some slices may play multiple times, others not at all.""",
                returnDoc = """A pattern with randomly selected (with replacement) slices each cycle.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c d e f").scramble(4)         // random selection with repetition of 4 slices""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("bd sd hh cp").scramble(4)        // random drum hit order, repeats allowed""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "scramble",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "n", type = kt7),
                ),
                returnType = kt2,
                description = """Slices the pattern into `n` equal parts and picks slices at random each cycle.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "scramble",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "n", type = kt7),
                ),
                returnType = kt5,
                description = """Chains a scramble onto this [PatternMapperFn]; randomly picks `n` slices with replacement.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "scramble",
                params = listOf(
                    KlangParam(name = "n", type = kt7, description = """Number of equal slices to divide the pattern into and pick from."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that slices the source into `n` parts and picks randomly with replacement.""",
                returnDoc = """A [PatternMapperFn] that randomly picks `n` slices (with repetition) each cycle.""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd hh cp").apply(scramble(4)) // random drum hit order via mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    )
)

private fun generatedSprudelDocsChunk28() = mapOf(

    "seed" to KlangSymbol(
        name = "seed",
        category = "random",
        tags = listOf("seed", "random", "reproducible", "deterministic"),
        aliases = listOf("withSeed"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "seed",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "n", type = kt7, description = """Seed value — any integer-compatible pattern or literal."""),
                ),
                returnType = kt2,
                description = """Sets the random seed for the pattern, making all random operations reproducible.

 All random-based functions (`rand`, `degradeBy`, `sometimes`, etc.) use the seed to generate
 deterministic pseudo-random values. Calling `seed(n)` with the same `n` always produces the
 same random sequence, which is useful for reproducible live performances.""",
                returnDoc = """A pattern whose random operations are pinned to the given seed.""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd hh").degradeBy(0.3).seed(42)     // reproducible random removal""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c d e f").sometimes(x => x.rev()).seed(7)   // fixed random decisions""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "seed",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "n", type = kt7),
                ),
                returnType = kt2,
                description = """Sets the random seed for reproducible random operations on a string pattern.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "seed",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "n", type = kt7),
                ),
                returnType = kt5,
                description = """Chains a seed onto this [PatternMapperFn]; pins all random operations to the given seed value.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "seed",
                params = listOf(
                    KlangParam(name = "n", type = kt7, description = """Seed value — any integer-compatible pattern or literal."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that pins all random operations to the given seed.

 Apply using `.apply()` to make any random-based transformation reproducible.""",
                returnDoc = """A [PatternMapperFn] that sets the random seed on the source pattern.""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd hh").apply(degradeBy(0.3).seed(42))   // chain seed onto a mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "seg" to KlangSymbol(
        name = "seg",
        category = "structural",
        tags = listOf("seg", "segment", "sample", "discrete", "quantize"),
        aliases = listOf("segment"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "seg",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "n", type = kt7, description = """Number of segments per cycle."""),
                ),
                returnType = kt2,
                description = """Alias for [segment] — samples the pattern at a rate of `n` events per cycle.""",
                returnDoc = """A discrete pattern with `n` evenly-spaced samples per cycle.""",
                samples = listOf(
                    KlangCodeSample(code = """note(saw.range(40, 52).seg(24))  // smooth saw wave sampled at 24 steps""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note(sine.range(48, 60).seg(8))  // sine wave at 8 steps per cycle""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "seg",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "n", type = kt7, description = """Number of segments per cycle."""),
                ),
                returnType = kt2,
                description = """Alias for [segment] applied to a mini-notation string.""",
                returnDoc = """A discrete pattern with `n` evenly-spaced samples per cycle.""",
                samples = listOf(
                    KlangCodeSample(code = """"0".seg(4).note()  // four evenly-spaced notes per cycle""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "seg",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "n", type = kt7),
                ),
                returnType = kt5,
                description = """Chains a seg onto this [PatternMapperFn]; alias for [PatternMapperFn.segment].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "seg",
                params = listOf(
                    KlangParam(name = "n", type = kt7, description = """Number of segments per cycle."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that is an alias for [segment] — samples the source at `n` events per cycle.""",
                returnDoc = """A [PatternMapperFn] that discretises the source into `n` evenly-spaced samples.""",
                samples = listOf(
                    KlangCodeSample(code = """sine.range(40, 60).apply(seg(8)).note()  // via mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "segment" to KlangSymbol(
        name = "segment",
        category = "structural",
        tags = listOf("segment", "seg", "sample", "discrete", "quantize"),
        aliases = listOf("seg"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "segment",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "n", type = kt7, description = """Number of segments per cycle. Can be an integer or a mini-notation string."""),
                ),
                returnType = kt2,
                description = """Samples the pattern at a rate of `n` events per cycle.

 Useful for turning a continuous pattern (e.g. from a signal) into a discrete stepped one.""",
                returnDoc = """A discrete pattern with `n` evenly-spaced samples per cycle.""",
                samples = listOf(
                    KlangCodeSample(code = """note(saw.range(40, 52).segment(24))  // smooth saw wave sampled at 24 steps""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note(sine.range(48, 60).segment(8))  // sine wave at 8 steps per cycle""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "segment",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "n", type = kt7, description = """Number of segments per cycle. Can be an integer or a mini-notation string."""),
                ),
                returnType = kt2,
                description = """Like [segment] applied to a mini-notation string.""",
                returnDoc = """A discrete pattern with `n` evenly-spaced samples per cycle.""",
                samples = listOf(
                    KlangCodeSample(code = """"0".segment(4).note()  // four evenly-spaced notes per cycle""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "segment",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "n", type = kt7),
                ),
                returnType = kt5,
                description = """Chains a segment onto this [PatternMapperFn]; samples the result at `n` events per cycle.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "segment",
                params = listOf(
                    KlangParam(name = "n", type = kt7, description = """Number of segments per cycle. Can be an integer or a mini-notation string."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that samples the source pattern at `n` events per cycle.""",
                returnDoc = """A [PatternMapperFn] that discretises the source into `n` evenly-spaced samples.""",
                samples = listOf(
                    KlangCodeSample(code = """sine.range(40, 60).apply(segment(8)).note()  // via mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "seq" to KlangSymbol(
        name = "seq",
        category = "structural",
        tags = listOf("sequence", "timing", "control", "order", "pattern-creator"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "seq",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "patterns", type = kt7, isVararg = true, description = """Additional patterns to append to the sequence"""),
                ),
                returnType = kt2,
                description = """Appends patterns to this pattern and squeezes all of them into one cycle.

 This pattern and all appended patterns are evenly distributed within a single cycle.""",
                returnDoc = """A pattern with all inputs squeezed into one cycle""",
                samples = listOf(
                    KlangCodeSample(code = """note("c e").seq("g a".note())""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """"bd sd".seq("hh hh", "cp").s()""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "seq",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "patterns", type = kt7, isVararg = true, description = """Additional patterns to append to the sequence"""),
                ),
                returnType = kt2,
                description = """Converts this string to a pattern and squeezes it together with additional patterns into one cycle.""",
                returnDoc = """A pattern with all inputs squeezed into one cycle""",
                samples = listOf(
                    KlangCodeSample(code = """"c e".seq("g a").note()  // Two patterns squeezed into one cycle""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "seq",
                params = listOf(
                    KlangParam(name = "patterns", type = kt7, isVararg = true, description = """Patterns to squeeze into one cycle. Accepts patterns, strings, numbers, lists (as nested sub-sequences), and other values that can be converted to patterns."""),
                ),
                returnType = kt2,
                description = """Creates a sequence pattern that squeezes all patterns into one cycle.

 All patterns are evenly distributed within a single cycle. With two patterns
 each gets half the cycle; with three patterns each gets a third, and so on.
 A list passed as an argument is treated as a nested sub-sequence that occupies
 the same time slot as any other single argument.""",
                returnDoc = """A pattern with all inputs squeezed into one cycle""",
                samples = listOf(
                    KlangCodeSample(code = """seq("c d e", "f g a").note()  // Two patterns squeezed into one cycle""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """seq(note("c"), note("e"), note("g"))  // Three notes, each gets 1/3 of the cycle""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """seq("bd", ["sd", "oh"], "hh").s()  // Nested list as sub-sequence within its slot""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "sequenceP" to KlangSymbol(
        name = "sequenceP",
        category = "structural",
        tags = listOf("sequence", "timing", "order"),
        aliases = listOf("seq"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "sequenceP",
                params = listOf(
                    KlangParam(name = "patterns", type = kt7, isVararg = true, description = """Patterns to squeeze into one cycle."""),
                ),
                returnType = kt2,
                description = """Alias for [seq]. Creates a sequence pattern that squeezes all patterns into one cycle.""",
                returnDoc = """A pattern with all inputs squeezed into one cycle""",
                samples = listOf(
                    KlangCodeSample(code = """sequenceP("c d", "e f").note()  // Two patterns squeezed into one cycle""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "shuffle" to KlangSymbol(
        name = "shuffle",
        category = "random",
        tags = listOf("shuffle", "random", "reorder", "slice", "permutation"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "shuffle",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "n", type = kt7, description = """Number of equal slices to divide the pattern into and reorder."""),
                ),
                returnType = kt2,
                description = """Slices the pattern into `n` equal parts and plays them in a new random order each cycle.

 Each slice is played exactly once per cycle — the order changes but nothing is omitted.
 Compare with [scramble], which may repeat or skip slices.""",
                returnDoc = """A pattern with its slices randomly permuted each cycle.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c d e f").shuffle(4)                 // random permutation of 4 quarter-cycle slices""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("bd sd hh cp").shuffle(4)                // randomly reorder the 4 drum hits each cycle""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "shuffle",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "n", type = kt7),
                ),
                returnType = kt2,
                description = """Slices the pattern into `n` equal parts and plays them in a new random order each cycle.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "shuffle",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "n", type = kt7),
                ),
                returnType = kt5,
                description = """Chains a shuffle onto this [PatternMapperFn]; randomly reorders `n` equal slices each cycle.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "shuffle",
                params = listOf(
                    KlangParam(name = "n", type = kt7, description = """Number of equal slices to divide the pattern into and reorder."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that slices the source into `n` parts and plays them in random order.""",
                returnDoc = """A [PatternMapperFn] that randomly reorders `n` slices each cycle.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c d e f").apply(shuffle(4))          // random permutation via mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "signal" to KlangSymbol(
        name = "signal",
        category = "continuous",
        tags = listOf("signal", "continuous", "lfo", "function", "custom", "oscillator"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "signal",
                params = listOf(
                    KlangParam(name = "f", type = kt17, description = """A function `(t: Double) -> Double` where `t` is the current cycle time."""),
                ),
                returnType = kt2,
                description = """Creates a continuous pattern driven by a user-supplied function of time.

 The function [f] receives the current cycle position as a [Double] (increases by `1` per
 cycle) and must return a [Double]. The resulting pattern is continuous — it has no discrete
 events and can be queried for any time position. Use [range] or [rangex] afterwards to map
 the output to a useful parameter range.""",
                returnDoc = """A continuous pattern driven by [f].""",
                samples = listOf(
                    KlangCodeSample(code = """signal(t => Math.sin(t * 6.28318)).range(200, 2000).freq().segment(128)""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """signal(t => t % 1.0).range(0.0, 127.0).freq().segment(128)""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "slice" to KlangSymbol(
        name = "slice",
        category = "sampling",
        tags = listOf("slice", "segment", "chop", "sample", "begin", "end"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "slice",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "n", type = kt7, description = """Number of equal slices to divide the sample into. Integer."""),
                    KlangParam(name = "index", type = kt7, description = """Zero-based index of the slice to play. Integer."""),
                ),
                returnType = kt2,
                description = """Plays a specific slice of the sample by dividing it into equal parts.

 Splits the sample into `n` equal segments and plays only the one at `index` (0-based).
 Implemented by setting [begin] and [end] appropriately. Combine with a pattern for
 the index to sequence through different slices.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """s("breaks").slice(8, 0)                // play the first of 8 slices""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("breaks").slice(8, "0 1 2 3 4 5 6 7")    // sequence through all 8 slices""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "slice",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "n", type = kt7),
                    KlangParam(name = "index", type = kt7),
                ),
                returnType = kt2,
                description = """Plays a specific slice of the sample on a string pattern.
 See [SprudelPattern.slice] for full documentation.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "slice",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "n", type = kt7),
                    KlangParam(name = "index", type = kt7),
                ),
                returnType = kt5,
                description = """Chains a slice onto this [PatternMapperFn]; plays the given slice of the sample.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "slice",
                params = listOf(
                    KlangParam(name = "n", type = kt7, description = """Number of equal slices to divide the sample into."""),
                    KlangParam(name = "index", type = kt7, description = """Zero-based index of the slice to play."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that plays a specific slice of the sample.""",
                returnDoc = """A [PatternMapperFn] that sets begin and end to the given slice.""",
                samples = listOf(
                    KlangCodeSample(code = """s("breaks").apply(slice(8, 0))   // first of 8 slices via mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    )
)

private fun generatedSprudelDocsChunk29() = mapOf(

    "slow" to KlangSymbol(
        name = "slow",
        category = "tempo",
        tags = listOf("slow", "tempo", "stretch", "speed"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "slow",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "factor", type = kt7, description = """Slowdown multiplier. 2 = half speed. Default: 1 (no change). Typical range: 0.25–16. Inverse of fast()."""),
                ),
                returnType = kt2,
                description = """Slows down a pattern by the given factor.

 `slow(2)` stretches the pattern so it takes 2 cycles to complete. Accepts control patterns for the factor.""",
                returnDoc = """A pattern slowed by `factor`.""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd hh cp").slow(2)              // half tempo — pattern spans 2 cycles""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("bd sd").slow("<1 2 4>")            // varying slow factor each cycle""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "slow",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "factor", type = kt7),
                ),
                returnType = kt2,
                description = """Slows down this string pattern by the given factor.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "slow",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "factor", type = kt7),
                ),
                returnType = kt5,
                description = """Chains a slow operation onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "slow",
                params = listOf(
                    KlangParam(name = "factor", type = kt7, description = """Slowdown multiplier. 2 = half speed. Default: 1 (no change). Typical range: 0.25–16."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that slows down a pattern by the given factor.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd hh cp").apply(slow(2))       // mapper form""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "slowChunk" to KlangSymbol(
        name = "slowChunk",
        category = "structural",
        tags = listOf("slowChunk", "chunk", "cycle", "transform", "rotate", "slice"),
        aliases = listOf("chunk", "slowchunk"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "slowChunk",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "n", type = kt10, description = """Number of chunks to divide the pattern into."""),
                    KlangParam(name = "transform", type = kt5, description = """Function applied to the currently active chunk each cycle."""),
                    KlangParam(name = "back", type = kt11, isOptional = true, defaultDoc = """false""", description = """If `true`, cycles backward through chunks (default `false`)."""),
                    KlangParam(name = "fast", type = kt11, isOptional = true, defaultDoc = """false""", description = """If `true`, the source pattern is not repeated (default `false`)."""),
                ),
                returnType = kt2,
                description = """Alias for [chunk] — divides the pattern into `n` chunks and cycles through them.""",
                returnDoc = """A new pattern with the transform cycling through chunks.""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd ht lt").slowChunk(4, x => x.gain(1.5))  // alias for chunk""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c d e f").slowChunk(4, x => x.transpose(5))""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "slowChunk",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "n", type = kt10),
                    KlangParam(name = "transform", type = kt5),
                    KlangParam(name = "back", type = kt11, isOptional = true, defaultDoc = """false"""),
                    KlangParam(name = "fast", type = kt11, isOptional = true, defaultDoc = """false"""),
                ),
                returnType = kt2,
                description = """Alias for [chunk].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "slowcat" to KlangSymbol(
        name = "slowcat",
        category = "structural",
        tags = listOf("sequence", "concatenate", "timing"),
        aliases = listOf("cat"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "slowcat",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "patterns", type = kt7, isVararg = true),
                ),
                returnType = kt2,
                description = """Alias for [cat]. Appends patterns to this pattern, each taking one full cycle.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd").slowcat(s("hh hh hh hh"))  // alternates each cycle""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "slowcat",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "patterns", type = kt7, isVararg = true),
                ),
                returnType = kt2,
                description = """Alias for [cat]. Parses this string and concatenates with the given patterns, each taking one cycle.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """"bd sd".slowcat("hh hh hh hh").s()  // alternates each cycle""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "slowcat",
                params = listOf(
                    KlangParam(name = "patterns", type = kt7, isVararg = true, description = """Patterns to concatenate. Each plays for one cycle."""),
                ),
                returnType = kt2,
                description = """Alias for [cat]. Concatenates patterns, each taking one full cycle.

 Note: this behaves like `cat` / `slowcatPrime`, maintaining
 absolute time (cycles of inner patterns may be "skipped" while they are not playing).""",
                returnDoc = """A pattern that plays each input for one cycle in turn""",
                samples = listOf(
                    KlangCodeSample(code = """slowcat("bd sd", "hh hh hh hh").s()  // cycle 0: "bd sd", cycle 1: "hh hh hh hh"""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "slowcatPrime" to KlangSymbol(
        name = "slowcatPrime",
        category = "structural",
        tags = listOf("sequence", "concatenate", "timing", "absolute"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "slowcatPrime",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "patterns", type = kt7, isVararg = true),
                ),
                returnType = kt2,
                description = """Appends patterns to this pattern, cycling through them one per cycle at absolute time.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c d").slowcatPrime(note("e f g"))  // cycles through at absolute time""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "slowcatPrime",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "patterns", type = kt7, isVararg = true),
                ),
                returnType = kt2,
                description = """Parses this string and cycles through it with given patterns, one per cycle at absolute time.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """"c d".slowcatPrime("e f g").note()  // cycles through at absolute time""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "slowcatPrime",
                params = listOf(
                    KlangParam(name = "patterns", type = kt7, isVararg = true, description = """Patterns to cycle through, one per cycle."""),
                ),
                returnType = kt2,
                description = """Cycles through patterns one per cycle, preserving absolute time across pattern switches.

 Like [cat], but when a pattern resumes it continues from where it would be at absolute time,
 rather than restarting from zero. This means inner cycles of each pattern are not reset.""",
                returnDoc = """A pattern that cycles through each input at absolute time""",
                samples = listOf(
                    KlangCodeSample(code = """slowcatPrime(note("c d e f"), note("g a b c")).s("piano")  // each pattern plays at abs time""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "slowchunk" to KlangSymbol(
        name = "slowchunk",
        category = "structural",
        tags = listOf("slowchunk", "chunk", "cycle", "transform", "rotate", "slice"),
        aliases = listOf("chunk", "slowChunk"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "slowchunk",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "n", type = kt10, description = """Number of chunks to divide the pattern into."""),
                    KlangParam(name = "transform", type = kt5, description = """Function applied to the currently active chunk each cycle."""),
                    KlangParam(name = "back", type = kt11, isOptional = true, defaultDoc = """false""", description = """If `true`, cycles backward through chunks (default `false`)."""),
                    KlangParam(name = "fast", type = kt11, isOptional = true, defaultDoc = """false""", description = """If `true`, the source pattern is not repeated (default `false`)."""),
                ),
                returnType = kt2,
                description = """Alias for [chunk] — divides the pattern into `n` chunks and cycles through them.""",
                returnDoc = """A new pattern with the transform cycling through chunks.""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd ht lt").slowchunk(4, x => x.gain(1.5))  // alias for chunk""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c d e f").slowchunk(4, x => x.transpose(5))""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "slowchunk",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "n", type = kt10),
                    KlangParam(name = "transform", type = kt5),
                    KlangParam(name = "back", type = kt11, isOptional = true, defaultDoc = """false"""),
                    KlangParam(name = "fast", type = kt11, isOptional = true, defaultDoc = """false"""),
                ),
                returnType = kt2,
                description = """Alias for [chunk].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "sndBrown" to KlangSymbol(
        name = "sndBrown",
        category = "tonal",
        tags = listOf("noise", "brownnoise", "brown", "snd"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "sndBrown",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "leak", type = kt6, isOptional = true, defaultDoc = """null""", description = """Per-sample white leak (default 0.02): lower is deeper and slower, higher is brighter."""),
                ),
                returnType = kt2,
                description = """Sets the sound to brown noise (Brownian/red noise).""",
                returnDoc = """A new pattern with sound set to "brownnoise".""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sndBrown",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "leak", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern and sets sound to brown noise.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sndBrown",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "leak", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt5,
                description = """Chains a brown noise sound onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sndBrown",
                params = listOf(
                    KlangParam(name = "leak", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that sets the sound to brown noise.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "sndCrackle" to KlangSymbol(
        name = "sndCrackle",
        category = "tonal",
        tags = listOf("crackle", "noise", "snd"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "sndCrackle",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "chaos", type = kt6, isOptional = true, defaultDoc = """null""", description = """Chaos amount (~1 sparse … ~2 dense)."""),
                ),
                returnType = kt2,
                description = """Sets the sound to a crackle generator (chaotic recurrence → bipolar pops) with configurable chaos.""",
                returnDoc = """A new pattern with sound set to "crackle" and parameters applied.""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sndCrackle",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "chaos", type = kt6, isOptional = true, defaultDoc = """null""", description = """Chaos amount (~1 sparse … ~2 dense)."""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern and sets sound to crackle generator.""",
                returnDoc = """A new pattern with sound set to "crackle".""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sndCrackle",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "chaos", type = kt6, isOptional = true, defaultDoc = """null""", description = """Chaos amount (~1 sparse … ~2 dense)."""),
                ),
                returnType = kt5,
                description = """Chains a crackle generator sound onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sndCrackle",
                params = listOf(
                    KlangParam(name = "chaos", type = kt6, isOptional = true, defaultDoc = """null""", description = """Chaos amount (~1 sparse … ~2 dense)."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that sets the sound to crackle generator.""",
                returnDoc = """A [PatternMapperFn] that sets sound to "crackle".""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "sndDust" to KlangSymbol(
        name = "sndDust",
        category = "tonal",
        tags = listOf("dust", "impulse", "noise", "snd"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "sndDust",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "density", type = kt6, isOptional = true, defaultDoc = """null""", description = """Impulse rate, 0 to 1, scaling a 200 per second ceiling.""", uitools = listOf("SprudelDustEditor", "SprudelDustSequenceEditor")),
                    KlangParam(name = "tail", type = kt6, isOptional = true, defaultDoc = """null""", description = """Impulse tail length."""),
                ),
                returnType = kt2,
                description = """Sets the sound to dust (random impulse) generator with configurable density.""",
                returnDoc = """A new pattern with sound set to "dust" and parameters applied.""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sndDust",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "density", type = kt6, isOptional = true, defaultDoc = """null""", description = """Impulse rate, 0 to 1, scaling a 200 per second ceiling.""", uitools = listOf("SprudelDustEditor", "SprudelDustSequenceEditor")),
                    KlangParam(name = "tail", type = kt6, isOptional = true, defaultDoc = """null""", description = """Impulse tail length."""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern and sets sound to dust generator.""",
                returnDoc = """A new pattern with sound set to "dust".""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sndDust",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "density", type = kt6, isOptional = true, defaultDoc = """null""", description = """Impulse rate, 0 to 1, scaling a 200 per second ceiling.""", uitools = listOf("SprudelDustEditor", "SprudelDustSequenceEditor")),
                    KlangParam(name = "tail", type = kt6, isOptional = true, defaultDoc = """null""", description = """Impulse tail length."""),
                ),
                returnType = kt5,
                description = """Chains a dust generator sound onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sndDust",
                params = listOf(
                    KlangParam(name = "density", type = kt6, isOptional = true, defaultDoc = """null""", description = """Impulse rate, 0 to 1, scaling a 200 per second ceiling.""", uitools = listOf("SprudelDustEditor", "SprudelDustSequenceEditor")),
                    KlangParam(name = "tail", type = kt6, isOptional = true, defaultDoc = """null""", description = """Impulse tail length."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that sets the sound to dust generator.""",
                returnDoc = """A [PatternMapperFn] that sets sound to "dust".""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    )
)

private fun generatedSprudelDocsChunk30() = mapOf(

    "sndNoise" to KlangSymbol(
        name = "sndNoise",
        category = "tonal",
        tags = listOf("noise", "whitenoise", "snd"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "sndNoise",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "color", type = kt6, isOptional = true, defaultDoc = """null""", description = """Noise color."""),
                ),
                returnType = kt2,
                description = """Sets the sound to white noise.""",
                returnDoc = """A new pattern with sound set to "whitenoise".""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sndNoise",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "color", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern and sets sound to white noise.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sndNoise",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "color", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt5,
                description = """Chains a white noise sound onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sndNoise",
                params = listOf(
                    KlangParam(name = "color", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that sets the sound to white noise.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "sndPink" to KlangSymbol(
        name = "sndPink",
        category = "tonal",
        tags = listOf("noise", "pinknoise", "pink", "snd"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "sndPink",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "params", type = kt6, isOptional = true, defaultDoc = """null""", description = """Optional pattern-like parameter."""),
                ),
                returnType = kt2,
                description = """Sets the sound to pink noise (1/f noise).""",
                returnDoc = """A new pattern with sound set to "pinknoise".""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sndPink",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "params", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern and sets sound to pink noise.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sndPink",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "params", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt5,
                description = """Chains a pink noise sound onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sndPink",
                params = listOf(
                    KlangParam(name = "params", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that sets the sound to pink noise.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "sndPluck" to KlangSymbol(
        name = "sndPluck",
        category = "tonal",
        tags = listOf("pluck", "string", "karplus-strong", "physical-model", "snd"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "sndPluck",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "feedback", type = kt6, isOptional = true, defaultDoc = """null""", description = """How long the string rings: the share of its level kept on each pass round the loop, 0.9 (a short thud) to 0.999 (rings for seconds); a coefficient, not a time""", uitools = listOf("SprudelPluckEditor", "SprudelPluckSequenceEditor")),
                    KlangParam(name = "brightness", type = kt6, isOptional = true, defaultDoc = """null""", description = """Lowpass cutoff (0 = dark, 1 = bright)."""),
                    KlangParam(name = "pickPosition", type = kt6, isOptional = true, defaultDoc = """null""", description = """Pluck position (0 = bridge, 1 = neck)."""),
                    KlangParam(name = "stiffness", type = kt6, isOptional = true, defaultDoc = """null""", description = """String stiffness (0 = nylon, 1 = piano wire)."""),
                ),
                returnType = kt2,
                description = """Sets the sound to a Karplus-Strong plucked string and optionally configures its
 parameters. Each parameter is independent and patternable.

 Each field is optional; trailing fields can be omitted.
 - **feedback**: how long the string rings, 0.9 (a short thud) to 0.999 (rings for seconds)
 - **brightness**: lowpass cutoff, 0.0 (dark) to 1.0 (bright)
 - **pickPosition**: pluck position, 0.0 (bridge) to 1.0 (neck)
 - **stiffness**: harmonic stiffness, 0.0 (nylon) to 1.0 (piano wire)""",
                returnDoc = """A new pattern with sound set to "pluck" and parameters applied.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3 e3 g3").sndPluck()                     // default plucked string
note("c3 e3 g3").sndPluck(0.999, 0.8)          // bright, long sustain
note("c3 e3 g3").sndPluck(0.93, 0.2)           // dark pizzicato
note("c3 e3 g3").sndPluck(0.996, 0.5, 0.2, 0.5)  // steel string, bridge pick""", type = KlangCodeSampleType.PLAYABLE)
                ),
                uitools = listOf("SprudelPluckEditor"),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sndPluck",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "feedback", type = kt6, isOptional = true, defaultDoc = """null""", description = """How long the string rings: the share of its level kept on each pass round the loop, 0.9 (a short thud) to 0.999 (rings for seconds); a coefficient, not a time.""", uitools = listOf("SprudelPluckEditor", "SprudelPluckSequenceEditor")),
                    KlangParam(name = "brightness", type = kt6, isOptional = true, defaultDoc = """null""", description = """Lowpass cutoff (0 = dark, 1 = bright)."""),
                    KlangParam(name = "pickPosition", type = kt6, isOptional = true, defaultDoc = """null""", description = """Pluck position (0 = bridge, 1 = neck)."""),
                    KlangParam(name = "stiffness", type = kt6, isOptional = true, defaultDoc = """null""", description = """String stiffness (0 = nylon, 1 = piano wire)."""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern and sets sound to plucked string.""",
                returnDoc = """A new pattern with sound set to "pluck" and parameters applied.""",
                samples = emptyList(),
                uitools = listOf("SprudelPluckEditor"),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sndPluck",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "feedback", type = kt6, isOptional = true, defaultDoc = """null""", description = """How long the string rings: the share of its level kept on each pass round the loop, 0.9 (a short thud) to 0.999 (rings for seconds); a coefficient, not a time.""", uitools = listOf("SprudelPluckEditor", "SprudelPluckSequenceEditor")),
                    KlangParam(name = "brightness", type = kt6, isOptional = true, defaultDoc = """null""", description = """Lowpass cutoff (0 = dark, 1 = bright)."""),
                    KlangParam(name = "pickPosition", type = kt6, isOptional = true, defaultDoc = """null""", description = """Pluck position (0 = bridge, 1 = neck)."""),
                    KlangParam(name = "stiffness", type = kt6, isOptional = true, defaultDoc = """null""", description = """String stiffness (0 = nylon, 1 = piano wire)."""),
                ),
                returnType = kt5,
                description = """Chains a plucked string sound onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                uitools = listOf("SprudelPluckEditor"),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sndPluck",
                params = listOf(
                    KlangParam(name = "feedback", type = kt6, isOptional = true, defaultDoc = """null""", description = """How long the string rings: the share of its level kept on each pass round the loop, 0.9 (a short thud) to 0.999 (rings for seconds); a coefficient, not a time.""", uitools = listOf("SprudelPluckEditor", "SprudelPluckSequenceEditor")),
                    KlangParam(name = "brightness", type = kt6, isOptional = true, defaultDoc = """null""", description = """Lowpass cutoff (0 = dark, 1 = bright)."""),
                    KlangParam(name = "pickPosition", type = kt6, isOptional = true, defaultDoc = """null""", description = """Pluck position (0 = bridge, 1 = neck)."""),
                    KlangParam(name = "stiffness", type = kt6, isOptional = true, defaultDoc = """null""", description = """String stiffness (0 = nylon, 1 = piano wire)."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that sets the sound to plucked string.""",
                returnDoc = """A [PatternMapperFn] that sets sound to "pluck".""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3 e3 g3").apply(sndPluck(0.999, 0.8))""", type = KlangCodeSampleType.PLAYABLE)
                ),
                uitools = listOf("SprudelPluckEditor"),
                library = "sprudel"
            )
        )
    ),

    "sndPulze" to KlangSymbol(
        name = "sndPulze",
        category = "tonal",
        tags = listOf("pulze", "pulse", "oscillator", "snd"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "sndPulze",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "duty", type = kt6, isOptional = true, defaultDoc = """null""", description = """The share of each cycle the wave is high, 0 to 1 (default 0.5, a square).""", uitools = listOf("SprudelPulzeEditor", "SprudelPulzeSequenceEditor")),
                ),
                returnType = kt2,
                description = """Sets the sound to a pulse wave oscillator with configurable duty cycle.""",
                returnDoc = """A new pattern with sound set to "pulze" and parameters applied.""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sndPulze",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "duty", type = kt6, isOptional = true, defaultDoc = """null""", description = """The share of each cycle the wave is high, 0 to 1 (default 0.5, a square).""", uitools = listOf("SprudelPulzeEditor", "SprudelPulzeSequenceEditor")),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern and sets sound to pulse wave.""",
                returnDoc = """A new pattern with sound set to "pulze".""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sndPulze",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "duty", type = kt6, isOptional = true, defaultDoc = """null""", description = """The share of each cycle the wave is high, 0 to 1 (default 0.5, a square).""", uitools = listOf("SprudelPulzeEditor", "SprudelPulzeSequenceEditor")),
                ),
                returnType = kt5,
                description = """Chains a pulse wave sound onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sndPulze",
                params = listOf(
                    KlangParam(name = "duty", type = kt6, isOptional = true, defaultDoc = """null""", description = """The share of each cycle the wave is high, 0 to 1 (default 0.5, a square).""", uitools = listOf("SprudelPulzeEditor", "SprudelPulzeSequenceEditor")),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that sets the sound to pulse wave.""",
                returnDoc = """A [PatternMapperFn] that sets sound to "pulze".""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "sndRamp" to KlangSymbol(
        name = "sndRamp",
        category = "tonal",
        tags = listOf("ramp", "oscillator", "snd"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "sndRamp",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "params", type = kt6, isOptional = true, defaultDoc = """null""", description = """Optional pattern-like parameter."""),
                ),
                returnType = kt2,
                description = """Sets the sound to a ramp wave oscillator.""",
                returnDoc = """A new pattern with sound set to "ramp".""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sndRamp",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "params", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern and sets sound to ramp wave.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sndRamp",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "params", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt5,
                description = """Chains a ramp wave sound onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sndRamp",
                params = listOf(
                    KlangParam(name = "params", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that sets the sound to ramp wave.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "sndSaw" to KlangSymbol(
        name = "sndSaw",
        category = "tonal",
        tags = listOf("saw", "sawtooth", "oscillator", "snd"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "sndSaw",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "params", type = kt6, isOptional = true, defaultDoc = """null""", description = """Optional pattern-like parameter."""),
                ),
                returnType = kt2,
                description = """Sets the sound to a sawtooth wave oscillator.""",
                returnDoc = """A new pattern with sound set to "sawtooth".""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sndSaw",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "params", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern and sets sound to sawtooth wave.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sndSaw",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "params", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt5,
                description = """Chains a sawtooth wave sound onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sndSaw",
                params = listOf(
                    KlangParam(name = "params", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that sets the sound to sawtooth wave.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "sndSine" to KlangSymbol(
        name = "sndSine",
        category = "tonal",
        tags = listOf("sine", "oscillator", "snd"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "sndSine",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "params", type = kt6, isOptional = true, defaultDoc = """null""", description = """Optional pattern-like parameter."""),
                ),
                returnType = kt2,
                description = """Sets the sound to a sine wave oscillator.""",
                returnDoc = """A new pattern with sound set to "sine".""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sndSine",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "params", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern and sets sound to sine wave.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sndSine",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "params", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt5,
                description = """Chains a sine wave sound onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sndSine",
                params = listOf(
                    KlangParam(name = "params", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that sets the sound to sine wave.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "sndSquare" to KlangSymbol(
        name = "sndSquare",
        category = "tonal",
        tags = listOf("square", "oscillator", "snd"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "sndSquare",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "params", type = kt6, isOptional = true, defaultDoc = """null""", description = """Optional pattern-like parameter."""),
                ),
                returnType = kt2,
                description = """Sets the sound to a square wave oscillator.""",
                returnDoc = """A new pattern with sound set to "square".""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sndSquare",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "params", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern and sets sound to square wave.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sndSquare",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "params", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt5,
                description = """Chains a square wave sound onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sndSquare",
                params = listOf(
                    KlangParam(name = "params", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that sets the sound to square wave.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    )
)

private fun generatedSprudelDocsChunk31() = mapOf(

    "sndSuperPluck" to KlangSymbol(
        name = "sndSuperPluck",
        category = "tonal",
        tags = listOf("superpluck", "pluck", "string", "karplus-strong", "unison", "physical-model", "snd"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "sndSuperPluck",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "voices", type = kt6, isOptional = true, defaultDoc = """null""", description = """Number of unison voices.""", uitools = listOf("SprudelSuperPluckEditor", "SprudelSuperPluckSequenceEditor")),
                    KlangParam(name = "spread", type = kt6, isOptional = true, defaultDoc = """null""", description = """Detune spread between voices."""),
                    KlangParam(name = "feedback", type = kt6, isOptional = true, defaultDoc = """null""", description = """How long the string rings: the share of its level kept on each pass round the loop, 0.9 (a short thud) to 0.999 (rings for seconds); a coefficient, not a time"""),
                    KlangParam(name = "brightness", type = kt6, isOptional = true, defaultDoc = """null""", description = """Lowpass cutoff (0 = dark, 1 = bright)."""),
                    KlangParam(name = "pickPosition", type = kt6, isOptional = true, defaultDoc = """null""", description = """Pluck position (0 = bridge, 1 = neck)."""),
                    KlangParam(name = "stiffness", type = kt6, isOptional = true, defaultDoc = """null""", description = """String stiffness (0 = nylon, 1 = piano wire)."""),
                ),
                returnType = kt2,
                description = """Sets the sound to a super plucked string (multiple detuned Karplus-Strong strings)
 and optionally configures parameters via `"voices:detune:feedback:brightness:pickPosition:stiffness"`.

 Like a 12-string guitar or chorus of harps — each string has independent noise excitation
 and drift, creating rich evolving shimmer.""",
                returnDoc = """A new pattern with sound set to "superpluck" and parameters applied.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3 e3 g3").sndSuperPluck()                         // default 5-string
note("c3 e3 g3").sndSuperPluck(7, 0.3, 0.998, 0.8)       // 7-string, wide, bright, long
note("c3 e3 g3").sndSuperPluck(3, 0.1, 0.93, 0.2)        // 3-string, tight, dark pizzicato""", type = KlangCodeSampleType.PLAYABLE)
                ),
                uitools = listOf("SprudelSuperPluckEditor"),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sndSuperPluck",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "voices", type = kt6, isOptional = true, defaultDoc = """null""", description = """Number of unison voices.""", uitools = listOf("SprudelSuperPluckEditor", "SprudelSuperPluckSequenceEditor")),
                    KlangParam(name = "spread", type = kt6, isOptional = true, defaultDoc = """null""", description = """Detune spread between voices."""),
                    KlangParam(name = "feedback", type = kt6, isOptional = true, defaultDoc = """null""", description = """How long the string rings: the share of its level kept on each pass round the loop, 0.9 (a short thud) to 0.999 (rings for seconds); a coefficient, not a time."""),
                    KlangParam(name = "brightness", type = kt6, isOptional = true, defaultDoc = """null""", description = """Lowpass cutoff (0 = dark, 1 = bright)."""),
                    KlangParam(name = "pickPosition", type = kt6, isOptional = true, defaultDoc = """null""", description = """Pluck position (0 = bridge, 1 = neck)."""),
                    KlangParam(name = "stiffness", type = kt6, isOptional = true, defaultDoc = """null""", description = """String stiffness (0 = nylon, 1 = piano wire)."""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern and sets sound to super plucked string.""",
                returnDoc = """A new pattern with sound set to "superpluck".""",
                samples = emptyList(),
                uitools = listOf("SprudelSuperPluckEditor"),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sndSuperPluck",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "voices", type = kt6, isOptional = true, defaultDoc = """null""", description = """Number of unison voices.""", uitools = listOf("SprudelSuperPluckEditor", "SprudelSuperPluckSequenceEditor")),
                    KlangParam(name = "spread", type = kt6, isOptional = true, defaultDoc = """null""", description = """Detune spread between voices."""),
                    KlangParam(name = "feedback", type = kt6, isOptional = true, defaultDoc = """null""", description = """How long the string rings: the share of its level kept on each pass round the loop, 0.9 (a short thud) to 0.999 (rings for seconds); a coefficient, not a time."""),
                    KlangParam(name = "brightness", type = kt6, isOptional = true, defaultDoc = """null""", description = """Lowpass cutoff (0 = dark, 1 = bright)."""),
                    KlangParam(name = "pickPosition", type = kt6, isOptional = true, defaultDoc = """null""", description = """Pluck position (0 = bridge, 1 = neck)."""),
                    KlangParam(name = "stiffness", type = kt6, isOptional = true, defaultDoc = """null""", description = """String stiffness (0 = nylon, 1 = piano wire)."""),
                ),
                returnType = kt5,
                description = """Chains a super plucked string sound onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                uitools = listOf("SprudelSuperPluckEditor"),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sndSuperPluck",
                params = listOf(
                    KlangParam(name = "voices", type = kt6, isOptional = true, defaultDoc = """null""", description = """Number of unison voices.""", uitools = listOf("SprudelSuperPluckEditor", "SprudelSuperPluckSequenceEditor")),
                    KlangParam(name = "spread", type = kt6, isOptional = true, defaultDoc = """null""", description = """Detune spread between voices."""),
                    KlangParam(name = "feedback", type = kt6, isOptional = true, defaultDoc = """null""", description = """How long the string rings: the share of its level kept on each pass round the loop, 0.9 (a short thud) to 0.999 (rings for seconds); a coefficient, not a time."""),
                    KlangParam(name = "brightness", type = kt6, isOptional = true, defaultDoc = """null""", description = """Lowpass cutoff (0 = dark, 1 = bright)."""),
                    KlangParam(name = "pickPosition", type = kt6, isOptional = true, defaultDoc = """null""", description = """Pluck position (0 = bridge, 1 = neck)."""),
                    KlangParam(name = "stiffness", type = kt6, isOptional = true, defaultDoc = """null""", description = """String stiffness (0 = nylon, 1 = piano wire)."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that sets the sound to super plucked string.""",
                returnDoc = """A [PatternMapperFn] that sets sound to "superpluck".""",
                samples = emptyList(),
                uitools = listOf("SprudelSuperPluckEditor"),
                library = "sprudel"
            )
        )
    ),

    "sndSuperRamp" to KlangSymbol(
        name = "sndSuperRamp",
        category = "tonal",
        tags = listOf("superramp", "ramp", "unison", "oscillator", "snd"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "sndSuperRamp",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "voices", type = kt6, isOptional = true, defaultDoc = """null""", description = """Number of oscillators (1–16)""", uitools = listOf("SprudelSuperSawEditor", "SprudelSuperSawSequenceEditor")),
                    KlangParam(name = "spread", type = kt6, isOptional = true, defaultDoc = """null""", description = """Detune spread between voices."""),
                ),
                returnType = kt2,
                description = """Sets the sound to a super ramp (multiple detuned ramp oscillators).""",
                returnDoc = """A new pattern with sound set to "superramp" and parameters applied.""",
                samples = emptyList(),
                uitools = listOf("SprudelSuperSawEditor"),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sndSuperRamp",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "voices", type = kt6, isOptional = true, defaultDoc = """null""", description = """Number of unison voices.""", uitools = listOf("SprudelSuperSawEditor", "SprudelSuperSawSequenceEditor")),
                    KlangParam(name = "spread", type = kt6, isOptional = true, defaultDoc = """null""", description = """Detune spread between voices."""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern and sets sound to super ramp.""",
                returnDoc = """A new pattern with sound set to "superramp".""",
                samples = emptyList(),
                uitools = listOf("SprudelSuperSawEditor"),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sndSuperRamp",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "voices", type = kt6, isOptional = true, defaultDoc = """null""", description = """Number of unison voices.""", uitools = listOf("SprudelSuperSawEditor", "SprudelSuperSawSequenceEditor")),
                    KlangParam(name = "spread", type = kt6, isOptional = true, defaultDoc = """null""", description = """Detune spread between voices."""),
                ),
                returnType = kt5,
                description = """Chains a super ramp sound onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                uitools = listOf("SprudelSuperSawEditor"),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sndSuperRamp",
                params = listOf(
                    KlangParam(name = "voices", type = kt6, isOptional = true, defaultDoc = """null""", description = """Number of unison voices.""", uitools = listOf("SprudelSuperSawEditor", "SprudelSuperSawSequenceEditor")),
                    KlangParam(name = "spread", type = kt6, isOptional = true, defaultDoc = """null""", description = """Detune spread between voices."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that sets the sound to super ramp.""",
                returnDoc = """A [PatternMapperFn] that sets sound to "superramp".""",
                samples = emptyList(),
                uitools = listOf("SprudelSuperSawEditor"),
                library = "sprudel"
            )
        )
    ),

    "sndSuperSaw" to KlangSymbol(
        name = "sndSuperSaw",
        category = "tonal",
        tags = listOf("supersaw", "saw", "unison", "oscillator", "snd"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "sndSuperSaw",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "voices", type = kt6, isOptional = true, defaultDoc = """null""", description = """Number of oscillators (1–16)""", uitools = listOf("SprudelSuperSawEditor", "SprudelSuperSawSequenceEditor")),
                    KlangParam(name = "spread", type = kt6, isOptional = true, defaultDoc = """null""", description = """Detune spread between voices."""),
                ),
                returnType = kt2,
                description = """Sets the sound to a super sawtooth (multiple detuned sawtooth oscillators).""",
                returnDoc = """A new pattern with sound set to "supersaw" and parameters applied.""",
                samples = emptyList(),
                uitools = listOf("SprudelSuperSawEditor"),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sndSuperSaw",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "voices", type = kt6, isOptional = true, defaultDoc = """null""", description = """Number of unison voices.""", uitools = listOf("SprudelSuperSawEditor", "SprudelSuperSawSequenceEditor")),
                    KlangParam(name = "spread", type = kt6, isOptional = true, defaultDoc = """null""", description = """Detune spread between voices."""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern and sets sound to super sawtooth.""",
                returnDoc = """A new pattern with sound set to "supersaw".""",
                samples = emptyList(),
                uitools = listOf("SprudelSuperSawEditor"),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sndSuperSaw",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "voices", type = kt6, isOptional = true, defaultDoc = """null""", description = """Number of unison voices.""", uitools = listOf("SprudelSuperSawEditor", "SprudelSuperSawSequenceEditor")),
                    KlangParam(name = "spread", type = kt6, isOptional = true, defaultDoc = """null""", description = """Detune spread between voices."""),
                ),
                returnType = kt5,
                description = """Chains a super sawtooth sound onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                uitools = listOf("SprudelSuperSawEditor"),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sndSuperSaw",
                params = listOf(
                    KlangParam(name = "voices", type = kt6, isOptional = true, defaultDoc = """null""", description = """Number of unison voices.""", uitools = listOf("SprudelSuperSawEditor", "SprudelSuperSawSequenceEditor")),
                    KlangParam(name = "spread", type = kt6, isOptional = true, defaultDoc = """null""", description = """Detune spread between voices."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that sets the sound to super sawtooth.""",
                returnDoc = """A [PatternMapperFn] that sets sound to "supersaw".""",
                samples = emptyList(),
                uitools = listOf("SprudelSuperSawEditor"),
                library = "sprudel"
            )
        )
    ),

    "sndSuperSine" to KlangSymbol(
        name = "sndSuperSine",
        category = "tonal",
        tags = listOf("supersine", "sine", "unison", "oscillator", "snd"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "sndSuperSine",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "voices", type = kt6, isOptional = true, defaultDoc = """null""", description = """Number of oscillators (1–16)""", uitools = listOf("SprudelSuperSawEditor", "SprudelSuperSawSequenceEditor")),
                    KlangParam(name = "spread", type = kt6, isOptional = true, defaultDoc = """null""", description = """Detune spread between voices."""),
                ),
                returnType = kt2,
                description = """Sets the sound to a super sine (multiple detuned sine oscillators).""",
                returnDoc = """A new pattern with sound set to "supersine" and parameters applied.""",
                samples = emptyList(),
                uitools = listOf("SprudelSuperSawEditor"),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sndSuperSine",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "voices", type = kt6, isOptional = true, defaultDoc = """null""", description = """Number of unison voices.""", uitools = listOf("SprudelSuperSawEditor", "SprudelSuperSawSequenceEditor")),
                    KlangParam(name = "spread", type = kt6, isOptional = true, defaultDoc = """null""", description = """Detune spread between voices."""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern and sets sound to super sine.""",
                returnDoc = """A new pattern with sound set to "supersine".""",
                samples = emptyList(),
                uitools = listOf("SprudelSuperSawEditor"),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sndSuperSine",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "voices", type = kt6, isOptional = true, defaultDoc = """null""", description = """Number of unison voices.""", uitools = listOf("SprudelSuperSawEditor", "SprudelSuperSawSequenceEditor")),
                    KlangParam(name = "spread", type = kt6, isOptional = true, defaultDoc = """null""", description = """Detune spread between voices."""),
                ),
                returnType = kt5,
                description = """Chains a super sine sound onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                uitools = listOf("SprudelSuperSawEditor"),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sndSuperSine",
                params = listOf(
                    KlangParam(name = "voices", type = kt6, isOptional = true, defaultDoc = """null""", description = """Number of unison voices.""", uitools = listOf("SprudelSuperSawEditor", "SprudelSuperSawSequenceEditor")),
                    KlangParam(name = "spread", type = kt6, isOptional = true, defaultDoc = """null""", description = """Detune spread between voices."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that sets the sound to super sine.""",
                returnDoc = """A [PatternMapperFn] that sets sound to "supersine".""",
                samples = emptyList(),
                uitools = listOf("SprudelSuperSawEditor"),
                library = "sprudel"
            )
        )
    ),

    "sndSuperSquare" to KlangSymbol(
        name = "sndSuperSquare",
        category = "tonal",
        tags = listOf("supersquare", "square", "unison", "oscillator", "snd"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "sndSuperSquare",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "voices", type = kt6, isOptional = true, defaultDoc = """null""", description = """Number of oscillators (1–16)""", uitools = listOf("SprudelSuperSawEditor", "SprudelSuperSawSequenceEditor")),
                    KlangParam(name = "spread", type = kt6, isOptional = true, defaultDoc = """null""", description = """Detune spread between voices."""),
                ),
                returnType = kt2,
                description = """Sets the sound to a super square (multiple detuned square oscillators).""",
                returnDoc = """A new pattern with sound set to "supersquare" and parameters applied.""",
                samples = emptyList(),
                uitools = listOf("SprudelSuperSawEditor"),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sndSuperSquare",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "voices", type = kt6, isOptional = true, defaultDoc = """null""", description = """Number of unison voices.""", uitools = listOf("SprudelSuperSawEditor", "SprudelSuperSawSequenceEditor")),
                    KlangParam(name = "spread", type = kt6, isOptional = true, defaultDoc = """null""", description = """Detune spread between voices."""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern and sets sound to super square.""",
                returnDoc = """A new pattern with sound set to "supersquare".""",
                samples = emptyList(),
                uitools = listOf("SprudelSuperSawEditor"),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sndSuperSquare",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "voices", type = kt6, isOptional = true, defaultDoc = """null""", description = """Number of unison voices.""", uitools = listOf("SprudelSuperSawEditor", "SprudelSuperSawSequenceEditor")),
                    KlangParam(name = "spread", type = kt6, isOptional = true, defaultDoc = """null""", description = """Detune spread between voices."""),
                ),
                returnType = kt5,
                description = """Chains a super square sound onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                uitools = listOf("SprudelSuperSawEditor"),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sndSuperSquare",
                params = listOf(
                    KlangParam(name = "voices", type = kt6, isOptional = true, defaultDoc = """null""", description = """Number of unison voices.""", uitools = listOf("SprudelSuperSawEditor", "SprudelSuperSawSequenceEditor")),
                    KlangParam(name = "spread", type = kt6, isOptional = true, defaultDoc = """null""", description = """Detune spread between voices."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that sets the sound to super square.""",
                returnDoc = """A [PatternMapperFn] that sets sound to "supersquare".""",
                samples = emptyList(),
                uitools = listOf("SprudelSuperSawEditor"),
                library = "sprudel"
            )
        )
    ),

    "sndSuperTri" to KlangSymbol(
        name = "sndSuperTri",
        category = "tonal",
        tags = listOf("supertri", "triangle", "unison", "oscillator", "snd"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "sndSuperTri",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "voices", type = kt6, isOptional = true, defaultDoc = """null""", description = """Number of oscillators (1–16)""", uitools = listOf("SprudelSuperSawEditor", "SprudelSuperSawSequenceEditor")),
                    KlangParam(name = "spread", type = kt6, isOptional = true, defaultDoc = """null""", description = """Detune spread between voices."""),
                ),
                returnType = kt2,
                description = """Sets the sound to a super triangle (multiple detuned triangle oscillators).""",
                returnDoc = """A new pattern with sound set to "supertri" and parameters applied.""",
                samples = emptyList(),
                uitools = listOf("SprudelSuperSawEditor"),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sndSuperTri",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "voices", type = kt6, isOptional = true, defaultDoc = """null""", description = """Number of unison voices.""", uitools = listOf("SprudelSuperSawEditor", "SprudelSuperSawSequenceEditor")),
                    KlangParam(name = "spread", type = kt6, isOptional = true, defaultDoc = """null""", description = """Detune spread between voices."""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern and sets sound to super triangle.""",
                returnDoc = """A new pattern with sound set to "supertri".""",
                samples = emptyList(),
                uitools = listOf("SprudelSuperSawEditor"),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sndSuperTri",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "voices", type = kt6, isOptional = true, defaultDoc = """null""", description = """Number of unison voices.""", uitools = listOf("SprudelSuperSawEditor", "SprudelSuperSawSequenceEditor")),
                    KlangParam(name = "spread", type = kt6, isOptional = true, defaultDoc = """null""", description = """Detune spread between voices."""),
                ),
                returnType = kt5,
                description = """Chains a super triangle sound onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                uitools = listOf("SprudelSuperSawEditor"),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sndSuperTri",
                params = listOf(
                    KlangParam(name = "voices", type = kt6, isOptional = true, defaultDoc = """null""", description = """Number of unison voices.""", uitools = listOf("SprudelSuperSawEditor", "SprudelSuperSawSequenceEditor")),
                    KlangParam(name = "spread", type = kt6, isOptional = true, defaultDoc = """null""", description = """Detune spread between voices."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that sets the sound to super triangle.""",
                returnDoc = """A [PatternMapperFn] that sets sound to "supertri".""",
                samples = emptyList(),
                uitools = listOf("SprudelSuperSawEditor"),
                library = "sprudel"
            )
        )
    ),

    "sndTri" to KlangSymbol(
        name = "sndTri",
        category = "tonal",
        tags = listOf("tri", "triangle", "oscillator", "snd"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "sndTri",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "params", type = kt6, isOptional = true, defaultDoc = """null""", description = """Optional pattern-like parameter."""),
                ),
                returnType = kt2,
                description = """Sets the sound to a triangle wave oscillator.""",
                returnDoc = """A new pattern with sound set to "triangle".""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sndTri",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "params", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern and sets sound to triangle wave.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sndTri",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "params", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt5,
                description = """Chains a triangle wave sound onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sndTri",
                params = listOf(
                    KlangParam(name = "params", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that sets the sound to triangle wave.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "sndZamp" to KlangSymbol(
        name = "sndZamp",
        category = "tonal",
        tags = listOf("zamp", "ramp", "raw", "oscillator", "snd"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "sndZamp",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "params", type = kt6, isOptional = true, defaultDoc = """null""", description = """Optional pattern-like parameter."""),
                ),
                returnType = kt2,
                description = """Sets the sound to a raw ramp ("zamp") oscillator — the naive/aliased counterpart of [sndRamp].""",
                returnDoc = """A new pattern with sound set to "zamp".""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sndZamp",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "params", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern and sets sound to raw ramp ("zamp").""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sndZamp",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "params", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt5,
                description = """Chains a raw ramp ("zamp") sound onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sndZamp",
                params = listOf(
                    KlangParam(name = "params", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that sets the sound to raw ramp ("zamp").""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    )
)

private fun generatedSprudelDocsChunk32() = mapOf(

    "solo" to KlangSymbol(
        name = "solo",
        category = "structural",
        tags = listOf("solo", "mute", "isolate", "playback"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "solo",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "amount", type = kt6, isOptional = true, defaultDoc = """null""", description = """`0.0`..`1.0` solo strength; `null` defaults to `0.95`. Accepts control patterns."""),
                ),
                returnType = kt2,
                description = """Solos this pattern: every pattern that is not soloed drops in level while it plays.

 Pass a value between `0.0` (no solo) and `1.0` (full solo). The other patterns play at `1 - amount`:
 `solo(0.7)` leaves them at 0.3, `solo(1)` silences them. Omit or pass `null` to use the default amount
 of `0.95`: the others drop to 5 %. The others fade down and back up over about 1.5 s, and the fade starts at
 once: the newest amount wins. A pattern changed to `solo(0)` is no longer soloed from its first event with the
 new amount; when `solo()` is removed, the solo ends when the pattern's last soloed event ends, at most 1/8 of
 the soloed pattern's own cycle after the edit takes effect (plus a few milliseconds; after `.solo().slow(4)`,
 half a cycle). A structural op after `.solo()` (`struct`, `mask`, `degradeBy`) drops the solo in its gaps:
 put `.solo()` last. Tracked in KLANG-00315 (solo survives ops). Accepts control patterns, so the
 amount can change per cycle. When several patterns are soloed, the strongest amount wins: a `solo(0.7)` beside
 a `solo()` changes nothing.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """stack(
  s("bd*4").solo(),             // the kick at full level
  note("c3 e3")                 // drops to 5 % (amount = 0.95)
)""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """stack(
  s("bd sd").solo(1),           // full solo
  note("c3 e3")                 // silent
)""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """stack(
  s("bd sd").solo(0.5),         // half solo
  note("c3 e3")                 // at half level
)""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """stack(
  s("hh*8").solo("<1 0>"),      // solo in every other cycle
  note("c3 e3")                 // fades out and back in (about 1.5 s each way)
)""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "solo",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "amount", type = kt6, isOptional = true, defaultDoc = """null""", description = """`0.0`..`1.0` solo strength; `null` defaults to `0.95`. Accepts control patterns."""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern and solos it: every pattern that is not soloed drops in level (see
 [SprudelPattern.solo]).""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """stack(
  "bd sd".solo().s(),           // solo this string pattern
  note("c3 e3")                 // drops to 5 %
)""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """stack(
  "bd sd".solo("<1 0>").s(),    // solo in every other cycle
  note("c3 e3")                 // fades out and back in (about 1.5 s each way)
)""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "solo",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "amount", type = kt6, isOptional = true, defaultDoc = """null""", description = """`0.0`..`1.0` solo strength; `null` defaults to `0.95`. Accepts control patterns."""),
                ),
                returnType = kt5,
                description = """Chains a solo operation onto this [PatternMapperFn] (see [SprudelPattern.solo]).""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """stack(
  s("bd*4").apply(timeLoop(2).solo()),          // loop the first 2 cycles, then solo
  note("c3 e3")                                 // drops to 5 %
)""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """stack(
  s("hh*8").apply(timeLoop(1).solo("<1 0>")),   // loop, then solo in every other cycle
  note("c3 e3")                                 // fades out and back in
)""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "solo",
                params = listOf(
                    KlangParam(name = "amount", type = kt6, isOptional = true, defaultDoc = """null""", description = """`0.0`..`1.0` solo strength; `null` defaults to `0.95`. Accepts control patterns."""),
                ),
                returnType = kt5,
                description = """Creates a [PatternMapperFn] that solos the input pattern: every pattern that is not soloed drops in level
 (see [SprudelPattern.solo]).""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """stack(
  s("bd*4").apply(solo()),      // solo the kick via a mapper (amount = 0.95)
  note("c3 e3")                 // drops to 5 %
)""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """stack(
  s("hh*8").apply(solo("<1 0>")),   // solo in every other cycle, via a mapper
  note("c3 e3")                     // fades out and back in (about 1.5 s each way)
)""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """stack(
  note("c3 e3 g3").apply(timeLoop(2).solo()),   // loop, then solo
  s("hh*4")                                     // drops to 5 %
)""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "someCycles" to KlangSymbol(
        name = "someCycles",
        category = "random",
        tags = listOf("someCycles", "someCyclesBy", "random", "cycle", "probability"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "someCycles",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "mapper", type = kt5, description = """The transformation to apply to the whole cycle ~50% of the time."""),
                ),
                returnType = kt2,
                description = """Applies `transform` with 50% probability per cycle. Shorthand for `someCyclesBy(0.5, fn)`.""",
                returnDoc = """A pattern with `mapper` applied to roughly half the cycles.""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd hh cp").someCycles(x => x.rev())   // reverse the entire cycle ~50% of the time""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "someCycles",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "mapper", type = kt5),
                ),
                returnType = kt2,
                description = """Applies `transform` with 50% probability per cycle. Shorthand for `someCyclesBy(0.5, fn)`.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "someCycles",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "mapper", type = kt5),
                ),
                returnType = kt5,
                description = """Chains a someCycles (50% per cycle) onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "someCycles",
                params = listOf(
                    KlangParam(name = "mapper", type = kt5),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that applies `mapper` with 50% probability per cycle.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "someCyclesBy" to KlangSymbol(
        name = "someCyclesBy",
        category = "random",
        tags = listOf("someCyclesBy", "random", "cycle", "probability", "conditional"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "someCyclesBy",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "prob", type = kt7, description = """Probability in [0, 1] that the entire cycle is transformed."""),
                    KlangParam(name = "mapper", type = kt5, description = """The transformation to apply to the whole cycle."""),
                ),
                returnType = kt2,
                description = """Applies `transform` with the given probability, decided once per cycle (not per event).

 Like [sometimesBy], but the random decision is made at cycle granularity: all events in
 the same cycle are either all transformed or all untouched.""",
                returnDoc = """A pattern with `mapper` applied to ~`prob` fraction of cycles.""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd hh cp").someCyclesBy(0.5, x => x.rev())  // entire cycle reversed ~50% of cycles""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c d e f").someCyclesBy(0.3, x => x.fast(2)) // ~30% of cycles play at double speed""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "someCyclesBy",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "prob", type = kt7),
                    KlangParam(name = "mapper", type = kt5),
                ),
                returnType = kt2,
                description = """Applies `transform` with the given probability, decided once per cycle (not per event).""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "someCyclesBy",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "prob", type = kt7),
                    KlangParam(name = "mapper", type = kt5),
                ),
                returnType = kt5,
                description = """Chains a someCyclesBy onto this [PatternMapperFn]; applies inner mapper at the given per-cycle probability.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "someCyclesBy",
                params = listOf(
                    KlangParam(name = "prob", type = kt7, description = """Probability in [0, 1] that the entire cycle is transformed."""),
                    KlangParam(name = "mapper", type = kt5, description = """The transformation to apply to the whole cycle."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that applies `mapper` with the given probability per cycle.""",
                returnDoc = """A [PatternMapperFn] that applies the mapper to ~`prob` fraction of cycles.""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd hh cp").apply(someCyclesBy(0.5, x => x.rev()))  // via mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "sometimes" to KlangSymbol(
        name = "sometimes",
        category = "random",
        tags = listOf("sometimes", "random", "probability", "conditional", "transform"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "sometimes",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "mapper", type = kt5, description = """The transformation to apply 50% of the time."""),
                ),
                returnType = kt2,
                description = """Applies `transform` with a 50% chance per event. Shorthand for `sometimesBy(0.5, fn)`.""",
                returnDoc = """A pattern with `mapper` applied to roughly half the events.""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd hh cp").sometimes(x => x.speed(2))  // half the hits at double speed""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c d e f").sometimes(x => x.transpose(7))     // 50% of notes shifted a fifth up""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sometimes",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "mapper", type = kt5),
                ),
                returnType = kt2,
                description = """Applies `transform` with a 50% chance per event. Shorthand for `sometimesBy(0.5, fn)`.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sometimes",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "mapper", type = kt5),
                ),
                returnType = kt5,
                description = """Chains a sometimes (50% per event) onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sometimes",
                params = listOf(
                    KlangParam(name = "mapper", type = kt5),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that applies `mapper` with 50% probability per event.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "sometimesBy" to KlangSymbol(
        name = "sometimesBy",
        category = "random",
        tags = listOf("sometimesBy", "random", "probability", "conditional", "transform"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "sometimesBy",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "prob", type = kt7, description = """Probability in [0, 1] that the transform is applied to each event."""),
                    KlangParam(name = "mapper", type = kt5, description = """The transformation to apply probabilistically."""),
                ),
                returnType = kt2,
                description = """Applies `transform` to each event independently with the given probability.

 `sometimesBy(p, fn)` randomly decides per-event: with probability `p` the event is
 transformed by `fn`; otherwise it plays unmodified. For cycle-level decisions use [someCyclesBy].""",
                returnDoc = """A pattern with `mapper` applied to each event at the given probability.""",
                samples = listOf(
                    KlangCodeSample(code = """s("hh*8").sometimesBy(0.4, x => x.speed(0.5))   // 40% of hits at half speed""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c d e f").sometimesBy(0.5, x => x.transpose(12)) // 50% of notes an octave higher""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sometimesBy",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "prob", type = kt7),
                    KlangParam(name = "mapper", type = kt5),
                ),
                returnType = kt2,
                description = """Applies `transform` to each event independently with the given probability.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sometimesBy",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "prob", type = kt7),
                    KlangParam(name = "mapper", type = kt5),
                ),
                returnType = kt5,
                description = """Chains a sometimesBy onto this [PatternMapperFn]; applies inner mapper at the given probability.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sometimesBy",
                params = listOf(
                    KlangParam(name = "prob", type = kt7, description = """Probability in [0, 1] that the transform is applied to each event."""),
                    KlangParam(name = "mapper", type = kt5, description = """The transformation to apply probabilistically."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that applies `mapper` to each event at the given probability.""",
                returnDoc = """A [PatternMapperFn] that applies the mapper at the given probability.""",
                samples = listOf(
                    KlangCodeSample(code = """s("hh*8").apply(sometimesBy(0.4, x => x.speed(0.5)))   // via mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "sound" to KlangSymbol(
        name = "sound",
        category = "tonal",
        tags = listOf("sound", "sample", "instrument", "s", "pattern-creator"),
        aliases = listOf("s"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "sound",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "name", type = kt6, isOptional = true, defaultDoc = """null""", description = """The sound/sample name pattern in mini-notation, e.g. `"bd sd hh"`.""", uitools = listOf("SprudelSampleEditor", "SprudelSampleSequenceEditor")),
                ),
                returnType = kt2,
                description = """Creates a pattern selecting a sound (instrument or sample bank) by name.

 Each event's value selects the instrument or sample bank used during playback.
 The format `"name:index"` also sets the sample index, e.g. `"bd:2"` selects sample 2
 from the `bd` bank.

 When [name] is omitted, reinterprets the current event values as sound names.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """sound("bd sd hh")  // basic drum pattern""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """sound("bd bd bd bd ").n("0 1 2 3")  // changes the sound variants""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """seq("bd hh sd hh").sound()  // interprets the sequence values as sounds""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sound",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "name", type = kt6, isOptional = true, defaultDoc = """null""", description = """The sound/sample name pattern in mini-notation, e.g. `"bd sd hh"`.""", uitools = listOf("SprudelSampleEditor", "SprudelSampleSequenceEditor")),
                ),
                returnType = kt2,
                description = """Modifies or reinterprets the sounds of a string pattern.""",
                returnDoc = """A new pattern with the specified sounds applied.""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sound",
                params = listOf(
                    KlangParam(name = "name", type = kt7, description = """The sound/sample name pattern in mini-notation, e.g. `"bd sd hh"`.""", uitools = listOf("SprudelSampleEditor", "SprudelSampleSequenceEditor")),
                ),
                returnType = kt2,
                description = """Creates a pattern of sounds.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "speed" to KlangSymbol(
        name = "speed",
        category = "sampling",
        tags = listOf("speed", "playback", "pitch", "rate"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "speed",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "rate", type = kt6, isOptional = true, defaultDoc = """null""", description = """Speed multiplier; 1 = normal, 2 = double, 0.5 = half; negative only sounds with `begin` set (backwards to the start)."""),
                ),
                returnType = kt2,
                description = """Sets the sample playback speed as a multiplier.

 `1` is normal speed; `2` doubles the speed (one octave up); `0.5` halves the speed
 (one octave down). A negative speed sounds only when `begin` is set (it then plays backwards
 to the sample start); with `begin` unset the playhead starts at 0 and the voice is silent.""",
                returnDoc = """A pattern with the playback speed set.""",
                samples = listOf(
                    KlangCodeSample(code = """s("breaks").speed(2)              // double speed, one octave up""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("bd").speed("<1 0.5>")          // alternate normal and half speed per cycle""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "speed",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "rate", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt2,
                description = """Sets the sample playback speed on a string pattern.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "speed",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "rate", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt5,
                description = """Chains a speed onto this [PatternMapperFn]; sets the sample playback speed.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "splice" to KlangSymbol(
        name = "splice",
        category = "sampling",
        tags = listOf("splice", "slice", "chop", "sample", "speed", "tempo"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "splice",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "n", type = kt7, description = """Number of equal slices to divide the sample into; also used as speed multiplier. Integer."""),
                    KlangParam(name = "index", type = kt7, description = """Zero-based index of the slice to play. Integer."""),
                ),
                returnType = kt2,
                description = """Plays a specific slice of the sample at the original sample tempo.

 Like [slice], but multiplies [speed] by `n` to compensate for the shorter segment
 duration, so each slice plays at the same pitch and rate as the original sample.
 Useful for beat-slicing without pitch artifacts.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """s("breaks").splice(8, 0)               // first of 8 slices at original pitch""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("breaks").splice(8, "0 2 4 6")      // every other slice, original tempo""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "splice",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "n", type = kt7),
                    KlangParam(name = "index", type = kt7),
                ),
                returnType = kt2,
                description = """Plays a specific slice of the sample at the original tempo on a string pattern.
 See [SprudelPattern.splice] for full documentation.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "splice",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "n", type = kt7),
                    KlangParam(name = "index", type = kt7),
                ),
                returnType = kt5,
                description = """Chains a splice onto this [PatternMapperFn]; plays the given slice at original sample tempo.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "splice",
                params = listOf(
                    KlangParam(name = "n", type = kt7, description = """Number of equal slices to divide the sample into."""),
                    KlangParam(name = "index", type = kt7, description = """Zero-based index of the slice to play."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that plays a specific slice at the original sample tempo.""",
                returnDoc = """A [PatternMapperFn] that sets begin, end, and compensates speed for the slice.""",
                samples = listOf(
                    KlangCodeSample(code = """s("breaks").apply(splice(8, 0))  // first of 8 slices at original pitch via mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    )
)

private fun generatedSprudelDocsChunk33() = mapOf(

    "squeeze" to KlangSymbol(
        name = "squeeze",
        category = "structural",
        tags = listOf("squeeze", "inhabit", "select", "index", "lookup", "pickSqueeze"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "squeeze",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true),
                ),
                returnType = kt2,
                description = """Squeezes patterns from a list into the timespans of events in this pattern (clamped index).

 The receiver pattern provides the indices; the arguments are the lookup patterns squeezed
 into each event's duration. Equivalent to calling `inhabit(lookup, this)`.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """n("0 1 2").squeeze("bd sd hh", "rim cp", "hh*4").s()  // receiver is index pattern""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """"0 1".squeeze(note("c3 e3"), note("g3 b3"))            // string receiver; squeezes in""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "squeeze",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true),
                ),
                returnType = kt2,
                description = """Squeezes patterns from a list into the timespans of events in this string pattern (clamped).

 This string is parsed as mini-notation to produce index values. Those values select from the
 lookup with clamped out-of-bounds handling. Selected patterns are squeezed into each event's timespan.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """"0 1".squeeze("bd sd hh", "rim cp").s()   // string receiver as index pattern""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "squeeze",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true),
                ),
                returnType = kt5,
                description = """Chains a squeeze onto this [PatternMapperFn]; clamped index, squeeze semantics.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "squeeze",
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true),
                ),
                returnType = kt5,
                description = """Selects patterns from a list by index and squeezes them into the triggering event's timespan.

 Like [inhabit] but with arguments in the opposite order: the first argument is the selector
 (index) pattern and the remaining arguments are the lookup patterns. Indices are clamped.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """"<0 1>".apply(squeeze("bd sd hh", "rim cp")).s()   // selector first, then lookup""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """"<0 1>".apply(squeeze(note("c3 e3"), note("g3 b3")))  // index → squeezed pattern""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "stack" to KlangSymbol(
        name = "stack",
        category = "structural",
        tags = listOf("stack", "layer", "chord", "polyrhythm", "simultaneous"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "stack",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "patterns", type = kt7, isVararg = true),
                ),
                returnType = kt2,
                description = """Layers this pattern together with additional patterns so they all play simultaneously.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c e g").stack(s("bd sd"))  // Melody on top of a beat""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c e").stack("g b".note())  // Two melodic lines layered""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "stack",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "patterns", type = kt7, isVararg = true),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern and layers it together with additional patterns.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """"c e g".stack("g b d").note()  // Two chord voicings layered""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "stack",
                params = listOf(
                    KlangParam(name = "patterns", type = kt7, isVararg = true, description = """Patterns to layer. Accepts patterns, strings, numbers, and other pattern-like values."""),
                ),
                returnType = kt2,
                description = """Plays multiple patterns simultaneously, layering them on top of each other.

 Unlike [seq], which plays patterns one after another, `stack` overlays all patterns so they all
 sound at the same time over the full cycle. This is useful for chords, polyrhythms, and combining
 independent pattern layers.""",
                returnDoc = """A pattern that plays all inputs simultaneously""",
                samples = listOf(
                    KlangCodeSample(code = """stack(note("c e g"), s("bd sd"))  // Chord with beat underneath""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """stack("c e", "g b").note()  // Two melodic lines at the same time""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "stackBy" to KlangSymbol(
        name = "stackBy",
        category = "structural",
        tags = listOf("stack", "layer", "alignment", "simultaneous"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "stackBy",
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true),
                ),
                returnType = kt2,
                description = """Layers patterns simultaneously, aligning shorter patterns within the span of the longest.

 Unlike [stack], which always aligns all patterns from the start, `stackBy` lets you control
 where shorter patterns sit within the span of the longest: 0 = left-aligned, 0.5 = centered,
 1 = right-aligned.""",
                returnDoc = """A pattern with all inputs layered at the given alignment""",
                samples = listOf(
                    KlangCodeSample(code = """stackBy(0.5, note("c"), note("c e g"))  // short pattern centered within the long one""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """stackBy(1.0, s("bd"), s("bd sd ht lt"))  // short pattern right-aligned""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "stackCentre" to KlangSymbol(
        name = "stackCentre",
        category = "structural",
        tags = listOf("stack", "layer", "alignment", "simultaneous"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "stackCentre",
                params = listOf(
                    KlangParam(name = "patterns", type = kt7, isVararg = true, description = """Patterns to layer."""),
                ),
                returnType = kt2,
                description = """Layers patterns simultaneously, aligning shorter patterns to the centre of the longest.""",
                returnDoc = """A pattern with all inputs layered, shorter ones centred""",
                samples = listOf(
                    KlangCodeSample(code = """stackCentre(note("c"), note("c e g"))  // short pattern centred within the long one""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "stackLeft" to KlangSymbol(
        name = "stackLeft",
        category = "structural",
        tags = listOf("stack", "layer", "alignment", "simultaneous"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "stackLeft",
                params = listOf(
                    KlangParam(name = "patterns", type = kt7, isVararg = true, description = """Patterns to layer."""),
                ),
                returnType = kt2,
                description = """Layers patterns simultaneously, aligning shorter patterns to the left (start) of the longest.""",
                returnDoc = """A pattern with all inputs layered, shorter ones left-aligned""",
                samples = listOf(
                    KlangCodeSample(code = """stackLeft(note("c"), note("c e g"))  // short pattern starts at the same time as the long one""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "stackRight" to KlangSymbol(
        name = "stackRight",
        category = "structural",
        tags = listOf("stack", "layer", "alignment", "simultaneous"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "stackRight",
                params = listOf(
                    KlangParam(name = "patterns", type = kt7, isVararg = true, description = """Patterns to layer."""),
                ),
                returnType = kt2,
                description = """Layers patterns simultaneously, aligning shorter patterns to the right (end) of the longest.""",
                returnDoc = """A pattern with all inputs layered, shorter ones right-aligned""",
                samples = listOf(
                    KlangCodeSample(code = """stackRight(note("c"), note("c e g"))  // short pattern ends at the same time as the long one""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "steady" to KlangSymbol(
        name = "steady",
        category = "continuous",
        tags = listOf("steady", "constant", "continuous", "signal", "dc"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "steady",
                params = listOf(
                    KlangParam(name = "value", type = kt9, description = """The constant value the pattern should produce at every point in time."""),
                ),
                returnType = kt2,
                description = """Creates a continuous pattern that always returns the same constant [value].

 `steady` is a convenience wrapper around [signal] that ignores the time argument.
 It is useful as a placeholder or when a continuous-pattern slot needs a fixed scalar value.""",
                returnDoc = """A continuous pattern that always evaluates to [value].""",
                samples = listOf(
                    KlangCodeSample(code = """steady(440.0).freq().segment(128)  // constant 440 Hz carrier frequency""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """steady(60).note().segment(128)  // constant note c4 (MIDI 60) on every event""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "stepcat" to KlangSymbol(
        name = "stepcat",
        category = "structural",
        tags = listOf("stepcat", "sequence", "timing", "proportional", "duration"),
        aliases = listOf("timeCat", "timecat", "s_cat"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "stepcat",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "segments", type = kt7, isVararg = true),
                ),
                returnType = kt2,
                description = """Prepends this pattern (weight 1) and arranges all segments proportionally in one cycle.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c").stepcat([3, note("e g")])  // "c" takes 1/4, "e g" takes 3/4""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "stepcat",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "segments", type = kt7, isVararg = true),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern (weight 1) and arranges all segments proportionally in one cycle.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """"c".stepcat([3, "e g"]).note()  // "c" takes 1/4, "e g" takes 3/4""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "stepcat",
                params = listOf(
                    KlangParam(name = "segments", type = kt7, isVararg = true, description = """Pairs of `[duration, pattern]`, or bare patterns (weight defaults to 1)."""),
                ),
                returnType = kt2,
                description = """Concatenates weighted patterns and compresses the result to fit exactly one cycle.

 Each segment is a `[duration, pattern]` pair. Duration determines the proportional share of the
 cycle each pattern gets. A bare pattern without a duration defaults to weight 1.
 Unlike [arrange], `stepcat` always fits everything into a single cycle regardless of durations.""",
                returnDoc = """A pattern with all segments proportionally distributed within one cycle""",
                samples = listOf(
                    KlangCodeSample(code = """stepcat([1, "a"], [3, "b"]).note()  // "a" takes 1/4, "b" takes 3/4 of the cycle""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """stepcat([2, note("c")], [1, note("e g")])  // "c" takes 2/3, "e g" takes 1/3""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    )
)

private fun generatedSprudelDocsChunk34() = mapOf(

    "steps" to KlangSymbol(
        name = "steps",
        category = "structural",
        tags = listOf("steps", "pace", "tempo", "speed", "cycle"),
        aliases = listOf("pace"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "steps",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "n", type = kt7, description = """Target number of steps per cycle."""),
                ),
                returnType = kt2,
                description = """Alias for [pace] — adjusts this pattern's speed so it plays `n` steps per cycle.""",
                returnDoc = """The pattern sped up or slowed down to fit `n` steps per cycle.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c d e f").steps(8)   // 4-step pattern runs at 8 steps/cycle""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "steps",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "n", type = kt7),
                ),
                returnType = kt2,
                description = """Alias for [pace] on a string pattern.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "steps",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "n", type = kt7),
                ),
                returnType = kt5,
                description = """Chains a steps (alias for [pace]) onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "steps",
                params = listOf(
                    KlangParam(name = "n", type = kt7),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] — alias for [pace] — that adjusts to play `n` steps per cycle.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "stretchBy" to KlangSymbol(
        name = "stretchBy",
        category = "tempo",
        tags = listOf("stretchBy", "duration", "stretch", "event length"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "stretchBy",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "factor", type = kt7, description = """The duration multiplier. Values > 1 extend events; values < 1 shorten them."""),
                ),
                returnType = kt2,
                description = """Multiplies the duration of each event in this pattern by the given factor, without affecting onset time.

 A factor of `2.0` doubles each event's duration; `0.5` halves it. Events can overlap
 (factor > 1) or leave gaps (factor < 1).""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3 e3 g3").stretchBy(2)       // each note lasts twice as long""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("bd sd").stretchBy("<1 2 0.5>")   // cycle through duration multipliers""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "stretchBy",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "factor", type = kt7, description = """The duration multiplier. Values > 1 extend events; values < 1 shorten them."""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern and multiplies the duration of each event by the given factor.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """"c3 e3 g3".stretchBy(0.5)           // each note lasts half its original duration""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "stretchBy",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "factor", type = kt7, description = """The duration multiplier. Values > 1 extend events; values < 1 shorten them."""),
                ),
                returnType = kt5,
                description = """Chains a duration-stretch onto this [PatternMapperFn], multiplying each event's duration.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3 d3").apply(lateInCycle(0.1).stretchBy(2))   // nudge late then double duration""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "stretchBy",
                params = listOf(
                    KlangParam(name = "factor", type = kt7, description = """The duration multiplier. Values > 1 extend events; values < 1 shorten them."""),
                ),
                returnType = kt5,
                description = """Creates a [PatternMapperFn] that multiplies the duration of each event by the given factor.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3 e3 g3").apply(stretchBy(2))     // each note lasts twice as long via mapper""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("bd sd").apply(stretchBy("<1 2 0.5>")) // cycle through duration multipliers via mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "struct" to KlangSymbol(
        name = "struct",
        category = "structural",
        tags = listOf("struct", "mask", "rhythm", "structure", "timing"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "struct",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true, description = """Patterns whose truthy events define the new rhythmic structure."""),
                ),
                returnType = kt2,
                description = """Restructures this pattern using the timing of a mask pattern, keeping only truthy mask events.

 The mask provides the rhythmic structure; the source pattern provides the values. Only source
 events that overlap with truthy events in the mask are kept, clipped to the mask's timing.""",
                returnDoc = """The source pattern reshaped to the mask's rhythm.""",
                samples = listOf(
                    KlangCodeSample(code = """s("hh").struct("x ~ x x ~ x x ~")  // hats shaped by a boolean rhythm pattern""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c e g").struct("x*4")         // chord hits restructured to 4 equal beats""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "struct",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true),
                ),
                returnType = kt2,
                description = """Restructures this string pattern using the mask's timing; keeps only truthy mask events.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "struct",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true),
                ),
                returnType = kt5,
                description = """Chains a struct onto this [PatternMapperFn]; restructures using the mask's timing.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "struct",
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true, description = """Patterns whose truthy events define the new rhythmic structure."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that restructures the source pattern using the mask's timing.""",
                returnDoc = """A [PatternMapperFn] that reshapes the source pattern to the mask's rhythm.""",
                samples = listOf(
                    KlangCodeSample(code = """s("hh").apply(struct("x ~ x x"))    // via mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "structAll" to KlangSymbol(
        name = "structAll",
        category = "structural",
        tags = listOf("structAll", "struct", "mask", "rhythm", "structure", "timing"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "structAll",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true, description = """Patterns that defines the rhythmic structure."""),
                ),
                returnType = kt2,
                description = """Like [struct], but keeps all source events overlapping the mask — including falsy ones.

 While [struct] filters to only truthy mask events, `structAll` uses the mask purely for timing
 without filtering by value. Useful when the mask defines structure but all events should pass.""",
                returnDoc = """The source pattern reshaped to the mask's rhythm, with all overlapping events kept.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c e g").structAll("x x")   // all chord notes kept within each x window""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c e").structAll("x x x x") // both c and e kept within each mask window""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "structAll",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true),
                ),
                returnType = kt2,
                description = """Like [structAll] on a string pattern; keeps all events overlapping the mask.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "structAll",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true),
                ),
                returnType = kt5,
                description = """Chains a structAll onto this [PatternMapperFn]; reshapes keeping all overlapping events.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "structAll",
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true, description = """Patterns that defines the rhythmic structure."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that reshapes the source using the mask, keeping all overlapping events.""",
                returnDoc = """A [PatternMapperFn] that reshapes the source keeping all overlapping events.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c e g").apply(structAll("x x"))   // via mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "stut" to KlangSymbol(
        name = "stut",
        category = "structural",
        tags = listOf("stut", "echo", "delay", "decay", "reverb", "effect"),
        aliases = listOf("echo"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "stut",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "times", type = kt10, description = """Number of layers including the original."""),
                    KlangParam(name = "delay", type = kt10, description = """Time offset per echo in cycles."""),
                    KlangParam(name = "decay", type = kt10, description = """Gain multiplier per echo (0.0–1.0)."""),
                ),
                returnType = kt2,
                description = """Alias for [echo] — superimposes delayed and decayed copies of the pattern.""",
                returnDoc = """A stacked pattern of the original plus decayed, delayed echoes.""",
                samples = listOf(
                    KlangCodeSample(code = """n("0").stut(4, 0.5, 0.5)  // 4 echoes, half-cycle spacing, halving gain""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("hh").stut(3, 0.125, 0.8)  // hi-hat with 2 trailing echoes""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "stut",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "times", type = kt10, description = """Number of layers including the original."""),
                    KlangParam(name = "delay", type = kt10, description = """Time offset per echo in cycles."""),
                    KlangParam(name = "decay", type = kt10, description = """Gain multiplier per echo (0.0–1.0)."""),
                ),
                returnType = kt2,
                description = """Alias for [echo] applied to a mini-notation string.""",
                returnDoc = """A stacked pattern of the original plus decayed, delayed echoes.""",
                samples = listOf(
                    KlangCodeSample(code = """"hh".stut(3, 0.125, 0.8).s()  // hi-hat with 2 trailing echoes""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "stut",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "times", type = kt10),
                    KlangParam(name = "delay", type = kt10),
                    KlangParam(name = "decay", type = kt10),
                ),
                returnType = kt5,
                description = """Chains a stut onto this [PatternMapperFn]; alias for [PatternMapperFn.echo].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "stut",
                params = listOf(
                    KlangParam(name = "times", type = kt10, description = """Number of layers including the original."""),
                    KlangParam(name = "delay", type = kt10, description = """Time offset per echo in cycles."""),
                    KlangParam(name = "decay", type = kt10, description = """Gain multiplier per echo (0.0–1.0)."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that is an alias for [echo] — superimposes delayed and decayed copies.""",
                returnDoc = """A [PatternMapperFn] that applies the echo effect to the source.""",
                samples = listOf(
                    KlangCodeSample(code = """s("hh").apply(stut(3, 0.125, 0.8))  // via mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "stutWith" to KlangSymbol(
        name = "stutWith",
        category = "structural",
        tags = listOf("stutWith", "echoWith", "delay", "transform", "layers", "effect"),
        aliases = listOf("echoWith", "stutwith", "echowith"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "stutWith",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "times", type = kt10, description = """Number of layers including the original."""),
                    KlangParam(name = "delay", type = kt10, description = """Time offset per layer in cycles."""),
                    KlangParam(name = "transform", type = kt5, description = """Function applied cumulatively to each successive layer."""),
                ),
                returnType = kt2,
                description = """Alias for [echoWith] — superimposes cumulatively-transformed layers.""",
                returnDoc = """A stacked pattern where each layer has the transform applied one more time.""",
                samples = listOf(
                    KlangCodeSample(code = """n("0").stutWith(4, 0.125, x => x.add(2))  // stut alias with additive transform""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("hh").stutWith(3, 0.25, x => x.gain(0.7))  // quieter copies""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "stutWith",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "times", type = kt10),
                    KlangParam(name = "delay", type = kt10),
                    KlangParam(name = "transform", type = kt5),
                ),
                returnType = kt2,
                description = """Alias for [echoWith].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "stutwith" to KlangSymbol(
        name = "stutwith",
        category = "structural",
        tags = listOf("stutwith", "echoWith", "stutWith", "delay", "transform", "layers"),
        aliases = listOf("echoWith", "stutWith", "echowith"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "stutwith",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "times", type = kt10, description = """Number of layers including the original."""),
                    KlangParam(name = "delay", type = kt10, description = """Time offset per layer in cycles."""),
                    KlangParam(name = "transform", type = kt5, description = """Function applied cumulatively to each successive layer."""),
                ),
                returnType = kt2,
                description = """Alias for [echoWith] — superimposes cumulatively-transformed layers.""",
                returnDoc = """A stacked pattern where each layer has the transform applied one more time.""",
                samples = listOf(
                    KlangCodeSample(code = """n("0").stutwith(4, 0.125, x => x.add(2))  // lowercase alias""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("sd").stutwith(3, 0.25, x => x.speed(1.5))  // each copy 50% faster""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "stutwith",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "times", type = kt10),
                    KlangParam(name = "delay", type = kt10),
                    KlangParam(name = "transform", type = kt5),
                ),
                returnType = kt2,
                description = """Alias for [echoWith].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "sub" to KlangSymbol(
        name = "sub",
        category = "arithmetic",
        tags = listOf("sub", "subtract", "arithmetic", "math", "offset"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "sub",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "amount", type = kt7, description = """The value to subtract. May be a number, string mini-notation, or a [SprudelPattern]."""),
                ),
                returnType = kt2,
                description = """Subtracts [amount] from every numeric value in the pattern.

 Only the raw event `value` is affected — `note`, `soundIndex`, and all other voice properties
 remain unchanged. Supports control patterns: pass a mini-notation string or another
 [SprudelPattern] as [amount] to modulate the offset per cycle or event.""",
                returnDoc = """A new pattern with each numeric value decreased by [amount].""",
                samples = listOf(
                    KlangCodeSample(code = """seq("10 20").sub(5).scale("c3:major").n()  // n values become 5 and 15""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """seq("10").sub("<0 5>").scale("c3:major").n()  // subtract 0 or 5 alternately each cycle""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sub",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "amount", type = kt7, description = """The value to subtract. May be a number, string mini-notation, or a [SprudelPattern]."""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern, then subtracts [amount] from every numeric value.

 Only the raw event `value` is affected — `note`, `soundIndex`, and other voice properties
 remain unchanged.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """"10 20".sub(5).scale("c3:major").n()  // n values become 5 and 15""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sub",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "amount", type = kt7, description = """The value to subtract. May be a number, string mini-notation, or a [SprudelPattern]."""),
                ),
                returnType = kt5,
                description = """Chains a subtraction onto this [PatternMapperFn], subtracting [amount] from every numeric value in the result.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """seq("10 20").apply(mul(2).sub(3)).scale("c1:major").n()  // (10*2)-3=17, (20*2)-3=37""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sub",
                receiver = kt8,
                params = listOf(
                    KlangParam(name = "amount", type = kt7, description = """The operand. May be a number, string mini-notation, or a [SprudelPattern]."""),
                ),
                returnType = kt5,
                description = """First step of a mapper chain on a field accessor: `freq.sub(...)` reads the field, then subtracts [amount].""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c e g a").bpf(freq.sub(50))""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "sub",
                params = listOf(
                    KlangParam(name = "amount", type = kt7, description = """The value to subtract. May be a number, string mini-notation, or a [SprudelPattern]."""),
                ),
                returnType = kt5,
                description = """Creates a [PatternMapperFn] that subtracts [amount] from every numeric value in a pattern.

 Only the raw event `value` is affected — `note`, `soundIndex`, and other voice properties
 remain unchanged. Use with [SprudelPattern.apply] to apply the subtraction to an existing pattern.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """seq("10 20").apply(sub(5)).scale("c3:major").n()  // n values become 5 and 15""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    )
)

private fun generatedSprudelDocsChunk35() = mapOf(

    "superimpose" to KlangSymbol(
        name = "superimpose",
        category = "structural",
        tags = listOf("superimpose", "layer", "stack", "transform"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "superimpose",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "transforms", type = kt5, isVararg = true, description = """Functions applied to produce the additional layers."""),
                ),
                returnType = kt2,
                description = """Layers one or more transformed copies of this pattern on top of itself.

 Stacks the original pattern with the result of applying each [transforms] to it.
 Unlike [off], the copies are not time-shifted — all layers start at the same position.""",
                returnDoc = """The original pattern stacked with its transformed copy.""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd").superimpose(x => x.fast(2))                         // double-speed layer on top""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c e g").superimpose(x => x.transpose(7), x => x.transpose(12))  // fifth and octave stacked""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "superimpose",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "transforms", type = kt5, isVararg = true),
                ),
                returnType = kt2,
                description = """Layers a transformed copy of this string pattern on top of itself.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "superimpose",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "transforms", type = kt5, isVararg = true),
                ),
                returnType = kt5,
                description = """Chains a superimpose onto this [PatternMapperFn]; layers a transformed copy on top.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "superimpose",
                params = listOf(
                    KlangParam(name = "transforms", type = kt5, isVararg = true, description = """Functions applied to produce the additional layers."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that layers a transformed copy of the source on top of itself.""",
                returnDoc = """A [PatternMapperFn] that stacks the source with its transformed copy.""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd").apply(superimpose(x => x.fast(2)))   // via mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "swing" to KlangSymbol(
        name = "swing",
        category = "tempo",
        tags = listOf("swing", "swingBy", "shuffle", "rhythm", "timing", "groove"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "swing",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "n", type = kt7, description = """Number of subdivisions per cycle."""),
                ),
                returnType = kt2,
                description = """Shorthand for `swingBy(1/3, n)` — classic jazz swing feel.

 Applies a 1/3 swing amount across `n` subdivisions per cycle. Equivalent to
 `swingBy(1/3, n)`, creating the characteristic "long-short" groove.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """s("hh*8").swing(4)                  // classic swing on hi-hats, 4 subdivisions""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c d e f g a b c").swing(2)    // swing feel on a melody, 2 subdivisions""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "swing",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "n", type = kt7),
                ),
                returnType = kt2,
                description = """Shorthand for `swingBy(1/3, n)` — classic jazz swing feel.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "swing",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "n", type = kt7),
                ),
                returnType = kt5,
                description = """Chains a swing operation onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "swing",
                params = listOf(
                    KlangParam(name = "n", type = kt7),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that applies classic jazz swing feel.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "swingBy" to KlangSymbol(
        name = "swingBy",
        category = "tempo",
        tags = listOf("swingBy", "swing", "shuffle", "rhythm", "timing", "groove"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "swingBy",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "swing", type = kt7, description = """Swing amount in the range -1 to 1."""),
                    KlangParam(name = "n", type = kt7, description = """Number of subdivisions per cycle."""),
                ),
                returnType = kt2,
                description = """Creates a swing or shuffle rhythm by adjusting event timing and duration within subdivisions.

 Divides each cycle into `n` subdivisions. Within each subdivision, events are split into
 two groups — first half gets `(1 + swing) / 2` of the slot duration, second half gets
 `(1 - swing) / 2`. This creates a natural rhythmic feel without overlapping events.

 - Positive swing (e.g. 1/3): "long-short" pattern — classic jazz swing
 - Negative swing (e.g. -1/3): "short-long" pattern — reverse swing
 - Zero swing: equal durations (no effect)""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """s("hh*8").swingBy(1/3, 4)               // classic swing on hi-hats, 4 subdivisions""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c d e f").swingBy(-0.25, 2)       // reverse swing on notes, 2 subdivisions""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "swingBy",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "swing", type = kt7),
                    KlangParam(name = "n", type = kt7),
                ),
                returnType = kt2,
                description = """Creates a swing rhythm with custom amount; see `swingBy` for details.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "swingBy",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "swing", type = kt7),
                    KlangParam(name = "n", type = kt7),
                ),
                returnType = kt5,
                description = """Chains a swingBy operation onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "swingBy",
                params = listOf(
                    KlangParam(name = "swing", type = kt7),
                    KlangParam(name = "n", type = kt7),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that creates a swing or shuffle rhythm.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "tag" to KlangSymbol(
        name = "tag",
        category = "structural",
        tags = listOf("tag", "tags", "visualization", "metadata"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "tag",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "name", type = kt3, description = """The tag to add. Taken literally — not parsed as mini-notation."""),
                ),
                returnType = kt2,
                description = """Tags every event of this pattern with a semantic name, e.g. for visualizations to know which
 instrument an event belongs to.

 Tags accumulate as a set: chaining adds (`.tag("a").tag("b")` → both), duplicates are ignored,
 and there is NO ordering guarantee. Outer tags join inner ones, so parts keep their identity
 inside a tagged group. Tags ride on the scheduled voice data (UI signal stream and wire) and
 never change the sound.""",
                returnDoc = """A new pattern whose events carry the tag.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3 e3 g3").tag("guitar1")   // every event carries "guitar1"""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """stack(
  s("bd*4").tag("drums"),
  note("c2 g2").tag("bass")
).tag("band")                     // events carry {"drums","band"} resp. {"bass","band"}""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "tag",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "name", type = kt3, description = """The tag to add. Taken literally — not parsed as mini-notation."""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern and tags every event with a semantic name.""",
                returnDoc = """A new pattern whose events carry the tag.""",
                samples = listOf(
                    KlangCodeSample(code = """"c3 e3 g3".tag("lead").note()     // tag the string pattern's events""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "tag",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "name", type = kt3, description = """The tag to add. Taken literally — not parsed as mini-notation."""),
                ),
                returnType = kt5,
                description = """Chains a tag operation onto this [PatternMapperFn].""",
                returnDoc = """A mapper that additionally tags the pattern it is applied to.""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd*4").apply(tag("drums").tag("kit"))   // both tags accumulate""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "tag",
                params = listOf(
                    KlangParam(name = "name", type = kt3, description = """The tag to add. Taken literally — not parsed as mini-notation."""),
                ),
                returnType = kt5,
                description = """Creates a [PatternMapperFn] that tags every event of the input pattern.""",
                returnDoc = """A mapper that tags the pattern it is applied to.""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd*4").apply(tag("drums"))     // tag via a mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "take" to KlangSymbol(
        name = "take",
        category = "structural",
        tags = listOf("take", "slice", "truncate", "steps", "cycle"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "take",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "n", type = kt7, description = """Number of steps to keep from the start."""),
                ),
                returnType = kt2,
                description = """Keeps only the first `n` steps of this pattern, stretched to fill the cycle.""",
                returnDoc = """A pattern containing only the first `n` steps, stretched to fill one cycle.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c d e f").take(2)  // keeps "c d", stretched to fill the cycle""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("bd sd hh cp").take(3)  // keeps first 3 sounds""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "take",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "n", type = kt7),
                ),
                returnType = kt2,
                description = """Keeps the first `n` steps of this string pattern, stretched to fill the cycle.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "take",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "n", type = kt7),
                ),
                returnType = kt5,
                description = """Chains a take onto this [PatternMapperFn]; keeps only the first `n` steps.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "take",
                params = listOf(
                    KlangParam(name = "n", type = kt7, description = """Number of steps to keep from the start."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that keeps only the first `n` steps of the source.""",
                returnDoc = """A [PatternMapperFn] that truncates the source to `n` steps.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c d e f").apply(take(2))  // via mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "timeCat" to KlangSymbol(
        name = "timeCat",
        category = "structural",
        tags = listOf("stepcat", "sequence", "timing", "proportional", "duration"),
        aliases = listOf("stepcat", "timecat", "s_cat"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "timeCat",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "segments", type = kt7, isVararg = true),
                ),
                returnType = kt2,
                description = """Alias for [stepcat]. Prepends this pattern (weight 1) and arranges all segments in one cycle.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c").timeCat([3, note("e g")])  // "c" takes 1/4, "e g" takes 3/4""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "timeCat",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "segments", type = kt7, isVararg = true),
                ),
                returnType = kt2,
                description = """Alias for [stepcat]. Parses this string and arranges all segments proportionally in one cycle.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """"c".timeCat([3, "e g"]).note()  // "c" takes 1/4, "e g" takes 3/4""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "timeCat",
                params = listOf(
                    KlangParam(name = "segments", type = kt7, isVararg = true, description = """Pairs of `[duration, pattern]`, or bare patterns (weight defaults to 1)."""),
                ),
                returnType = kt2,
                description = """Alias for [stepcat]. Concatenates weighted patterns into exactly one cycle.""",
                returnDoc = """A pattern with all segments proportionally distributed within one cycle""",
                samples = listOf(
                    KlangCodeSample(code = """timeCat([1, "a"], [3, "b"]).note()  // "a" takes 1/4, "b" takes 3/4""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "timeLoop" to KlangSymbol(
        name = "timeLoop",
        category = "structural",
        tags = listOf("timeLoop", "loop", "repeat", "cycle", "ostinato", "window"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "timeLoop",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "duration", type = kt7, description = """The loop window length in cycles. Must be greater than zero."""),
                ),
                returnType = kt2,
                description = """Loops this pattern within a fixed window of `duration` cycles, tiling it indefinitely.

 Unlike [fast] or [slow], `timeLoop` does not stretch or compress events — it freezes the
 segment `[0, duration]` of this pattern and tiles it. Events outside the window are never
 played. Useful for creating ostinato figures or locking a long sequence to a shorter loop.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3 d3 e3 f3 g3 a3 b3 c4").timeLoop(2)   // loop first 2 cycles of an 8-note run""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("bd sd hh oh").timeLoop(0.5)                 // stutter a 4-beat pattern into 2-beat loops""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "timeLoop",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "duration", type = kt7, description = """The loop window length in cycles. Must be greater than zero."""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern and loops it within a fixed window of `duration` cycles.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """"c3 d3 e3 f3".timeLoop(0.5)   // loop the first half-cycle of a 4-note sequence""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "timeLoop",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "duration", type = kt7, description = """The loop window length in cycles. Must be greater than zero."""),
                ),
                returnType = kt5,
                description = """Chains a timeLoop operation onto this [PatternMapperFn], looping the result within `duration` cycles.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """seq("0.2 0.4").apply(mul(2).timeLoop(0.5))   // mul doubles, then loop within 0.5 cycles""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "timeLoop",
                params = listOf(
                    KlangParam(name = "duration", type = kt7, description = """The loop window length in cycles. Must be greater than zero."""),
                ),
                returnType = kt5,
                description = """Creates a [PatternMapperFn] that loops its input within a fixed window of `duration` cycles.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3 d3 e3 f3 g3 a3 b3 c4").apply(timeLoop(2))   // loop the first 2 cycles of an 8-note run""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("bd sd hh oh").apply(timeLoop(0.5))                 // stutter a 4-beat pattern into 2-beat loops""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "timecat" to KlangSymbol(
        name = "timecat",
        category = "structural",
        tags = listOf("stepcat", "sequence", "timing", "proportional", "duration"),
        aliases = listOf("stepcat", "timeCat", "s_cat"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "timecat",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "segments", type = kt7, isVararg = true),
                ),
                returnType = kt2,
                description = """Alias for [stepcat]. Prepends this pattern (weight 1) and arranges all segments in one cycle.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c").timecat([3, note("e g")])  // "c" takes 1/4, "e g" takes 3/4""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "timecat",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "segments", type = kt7, isVararg = true),
                ),
                returnType = kt2,
                description = """Alias for [stepcat]. Parses this string and arranges all segments proportionally in one cycle.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """"c".timecat([3, "e g"]).note()  // "c" takes 1/4, "e g" takes 3/4""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "timecat",
                params = listOf(
                    KlangParam(name = "segments", type = kt7, isVararg = true, description = """Pairs of `[duration, pattern]`, or bare patterns (weight defaults to 1)."""),
                ),
                returnType = kt2,
                description = """Alias for [stepcat]. Concatenates weighted patterns into exactly one cycle.""",
                returnDoc = """A pattern with all segments proportionally distributed within one cycle""",
                samples = listOf(
                    KlangCodeSample(code = """timecat([1, "a"], [3, "b"]).note()  // "a" takes 1/4, "b" takes 3/4""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    )
)

private fun generatedSprudelDocsChunk36() = mapOf(

    "transpose" to KlangSymbol(
        name = "transpose",
        category = "tonal",
        tags = listOf("transpose", "pitch shift", "semitones", "interval", "pitch"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "transpose",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "amount", type = kt7, description = """The amount to transpose by, either as a number of semitones or an interval name."""),
                ),
                returnType = kt2,
                description = """Transposes a pattern by a number of semitones or an interval name.

 Shifts all note pitches by the given amount. Numeric arguments are treated as semitones;
 string arguments can be interval names (e.g. `"P5"` for a perfect fifth).""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c4 e4 g4").transpose(7)       // transpose up a perfect fifth""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c4 e4").transpose("<0 12>")   // alternate: no transpose vs octave up per cycle""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "transpose",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "amount", type = kt7),
                ),
                returnType = kt2,
                description = """Transposes a string pattern by a number of semitones or interval name.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "transpose",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "amount", type = kt7),
                ),
                returnType = kt5,
                description = """Chains a transpose step onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "transpose",
                params = listOf(
                    KlangParam(name = "amount", type = kt7),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that transposes each event by the given semitones or interval name.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "tremolo" to KlangSymbol(
        name = "tremolo",
        category = "effects",
        tags = listOf("tremolo", "depth", "rate", "shape"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "tremolo",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "depth", type = kt6, isOptional = true, defaultDoc = """null""", description = """Depth, 0 to 1. The stage is built only above 0.""", uitools = listOf("SprudelTremoloEditor", "SprudelTremoloSequenceEditor")),
                    KlangParam(name = "rate", type = kt6, isOptional = true, defaultDoc = """null""", description = """LFO rate in Hz. [beatRate] follows the tempo."""),
                    KlangParam(name = "shape", type = kt6, isOptional = true, defaultDoc = """null""", description = """LFO waveform: `sine`, `triangle`, `square`, `sawtooth`, `ramp`.""", uitools = listOf("SprudelWaveformEditor", "SprudelWaveformSequenceEditor")),
                ),
                returnType = kt2,
                description = """The tremolo: depth, rate and waveform.

 Unlike the phaser above it, the tremolo runs per voice: every note gets
 its own LFO, so two notes on one orbit can wobble at different rates. The LFO is the oscillator
 of that shape; the square, sawtooth and ramp get a 16 ms soft edge, so they pulse without clicking.

 Every slot is independent and patternable; an omitted slot keeps its value, a named slot takes
 a mapper (`tremolo(rate = mul(2))`), and the numeric slots read back as `tremolo.depth` and `tremolo.rate`.
 With no argument at all, the pattern's own values are reinterpreted as `depth`.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3").s("saw").tremolo(0.6, 4)                                     // depth and rate""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c3").s("saw").tremolo(0.6, 4).tremolo(rate = mul("<1 2>"))         // twice as fast every other bar""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c3 e3").s("saw").tremolo("0.3 0.9", 4).gain(tremolo.depth)         // deeper, louder""", type = KlangCodeSampleType.PLAYABLE)
                ),
                uitools = listOf("SprudelTremoloEditor"),
                library = "sprudel"
            ),
            KlangCallable(
                name = "tremolo",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "depth", type = kt6, isOptional = true, defaultDoc = """null""", uitools = listOf("SprudelTremoloEditor", "SprudelTremoloSequenceEditor")),
                    KlangParam(name = "rate", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "shape", type = kt6, isOptional = true, defaultDoc = """null""", uitools = listOf("SprudelWaveformEditor", "SprudelWaveformSequenceEditor")),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern, then applies [tremolo].""",
                returnDoc = """""",
                samples = emptyList(),
                uitools = listOf("SprudelTremoloEditor"),
                library = "sprudel"
            ),
            KlangCallable(
                name = "tremolo",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "depth", type = kt6, isOptional = true, defaultDoc = """null""", uitools = listOf("SprudelTremoloEditor", "SprudelTremoloSequenceEditor")),
                    KlangParam(name = "rate", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "shape", type = kt6, isOptional = true, defaultDoc = """null""", uitools = listOf("SprudelWaveformEditor", "SprudelWaveformSequenceEditor")),
                ),
                returnType = kt5,
                description = """Chains a [tremolo] step onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                uitools = listOf("SprudelTremoloEditor"),
                library = "sprudel"
            )
        )
    ),

    "tweak" to KlangSymbol(
        name = "tweak",
        category = "structural",
        tags = listOf("tweak", "tweaks", "modifier", "metadata"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "tweak",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "name", type = kt3, description = """The tweak to attach. Taken literally — not parsed as mini-notation."""),
                ),
                returnType = kt2,
                description = """Attaches a tweak name to every event of this pattern. It only marks: the transform the name
 refers to is bound later by `tweaks(...)`, and a name nothing binds stays inert.

 Tweaks accumulate as a LIST, unlike [tag]: they apply in the order attached and a repeated name
 applies twice. The usual place to attach one is mini-notation (`note("c3 e3{swell}")`); this
 function is for marking a whole pattern at once.""",
                returnDoc = """A new pattern whose events carry the tweak name.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3 e3 g3").tweak("swell")   // every event carries "swell"""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "tweak",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "name", type = kt3, description = """The tweak to attach. Taken literally — not parsed as mini-notation."""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern and attaches a tweak name to every event.""",
                returnDoc = """A new pattern whose events carry the tweak name.""",
                samples = listOf(
                    KlangCodeSample(code = """"c3 e3 g3".tweak("swell").note()""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "tweak",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "name", type = kt3, description = """The tweak to attach. Taken literally — not parsed as mini-notation."""),
                ),
                returnType = kt5,
                description = """Chains a tweak marking onto this [PatternMapperFn].""",
                returnDoc = """A mapper that additionally marks the pattern it is applied to.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3 e3").apply(tweak("swell").tweak("bend"))   // both names accumulate, in this order""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "tweak",
                params = listOf(
                    KlangParam(name = "name", type = kt3, description = """The tweak to attach. Taken literally — not parsed as mini-notation."""),
                ),
                returnType = kt5,
                description = """Creates a [PatternMapperFn] that attaches a tweak name to every event of the input pattern.""",
                returnDoc = """A mapper that marks the pattern it is applied to.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3 e3").apply(tweak("swell"))""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "tweaks" to KlangSymbol(
        name = "tweaks",
        category = "structural",
        tags = listOf("tweak", "tweaks", "modifier"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "tweaks",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "defs", type = kt18, description = """Object literal mapping each tweak name to a transform, e.g. `{ swell: x => x.gain(1.1) }`."""),
                ),
                returnType = kt2,
                description = """Binds tweak names to transforms and applies them to the events carrying those names.

 Names are attached upstream, in mini-notation or via [tweak]; this is where they finally mean
 something. Tweaks apply **in the order written on the event**, not in the order this map declares
 them, and a name repeated on an event applies twice.

 A name nothing binds passes through **untouched and unstripped**, so an inner `tweaks(...)` and an
 outer one compose without either knowing about the other. Applying does not consume the name
 either: two calls binding the same name both apply.

 Placement matters. A tweak applies where this call sits in the chain, so anything after it still
 overrides: put it last when the tweak should win.""",
                returnDoc = """A new pattern with the bound tweaks applied.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3 e3{swell} g3{swell bend}").tweaks({
    swell: x => x.adsr(attack = 0.3).gain(1.1),
    bend:  x => x.transpose(-2).accelerate(0.5),
})""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "tweaks",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "defs", type = kt18, description = """Object literal mapping each tweak name to a transform."""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern, then binds and applies tweaks.""",
                returnDoc = """A new pattern with the bound tweaks applied.""",
                samples = listOf(
                    KlangCodeSample(code = """"c3 e3{swell}".tweaks({ swell: x => x.gain(1.1) }).note()""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "tweaks",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "defs", type = kt18, description = """Object literal mapping each tweak name to a transform."""),
                ),
                returnType = kt5,
                description = """Chains a tweak binding onto this [PatternMapperFn].""",
                returnDoc = """A mapper that additionally applies the bound tweaks.""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "tweaks",
                params = listOf(
                    KlangParam(name = "defs", type = kt18, description = """Object literal mapping each tweak name to a transform."""),
                ),
                returnType = kt5,
                description = """Creates a [PatternMapperFn] that binds and applies tweaks to the input pattern.""",
                returnDoc = """A mapper that applies the bound tweaks.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3 e3{swell}").apply(tweaks({ swell: x => x.gain(1.1) }))""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "undegrade" to KlangSymbol(
        name = "undegrade",
        category = "random",
        tags = listOf("undegrade", "undegradeBy", "random", "inverse", "probability"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "undegrade",
                receiver = kt0,
                params = emptyList(),
                returnType = kt2,
                description = """Keeps events with 50% probability. Inverse of `degrade` — shorthand for `undegradeBy(0.5)`.""",
                returnDoc = """A pattern keeping roughly half its events each cycle (complement of [degrade]).""",
                samples = listOf(
                    KlangCodeSample(code = """s("hh*8").undegrade()               // ~half the events play (complement of degrade)""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "undegrade",
                receiver = kt3,
                params = emptyList(),
                returnType = kt2,
                description = """Keeps events with 50% probability. Shorthand for `undegradeBy(0.5)`.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "undegrade",
                receiver = kt4,
                params = emptyList(),
                returnType = kt5,
                description = """Chains an undegrade (50% keep) onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "undegrade",
                params = emptyList(),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that keeps events with 50% probability (inverse of [degrade]).""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """s("hh*8").apply(undegrade())        // ~half the events play via mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "undegradeBy" to KlangSymbol(
        name = "undegradeBy",
        category = "random",
        tags = listOf("undegradeBy", "random", "inverse", "keep", "probability"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "undegradeBy",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "prob", type = kt7, description = """Keep probability in [0, 1]; 0 = remove all, 1 = keep all."""),
                ),
                returnType = kt2,
                description = """Inverse of `degradeBy`: keeps events that `degradeBy` would remove, and vice versa.

 `undegradeBy(x)` keeps an event with probability `x` (0 = nothing kept, 1 = everything kept).
 When paired with `degradeBy` using the same seed, the two are perfectly complementary.""",
                returnDoc = """A pattern keeping only the events that `degradeBy(1-x)` would remove.""",
                samples = listOf(
                    KlangCodeSample(code = """s("hh*8").undegradeBy(0.2)                   // only ~20% of hits play""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("hh*10").layer(
  x => x.degradeBy(0.2).pan(0),
  x => x.undegradeBy(0.8).pan(1)
)                                             // complementary panning layers""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "undegradeBy",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "prob", type = kt7),
                ),
                returnType = kt2,
                description = """Inverse of `degradeBy`: keeps events that `degradeBy` would remove (0 = none, 1 = all).""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "undegradeBy",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "prob", type = kt7),
                ),
                returnType = kt5,
                description = """Chains an undegradeBy onto this [PatternMapperFn]; keeps events at the given probability.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "undegradeBy",
                params = listOf(
                    KlangParam(name = "prob", type = kt7, description = """Keep probability in [0, 1]."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that keeps only events `degradeBy` would remove.""",
                returnDoc = """A [PatternMapperFn] that is the complement of [degradeBy].""",
                samples = listOf(
                    KlangCodeSample(code = """s("hh*8").apply(undegradeBy(0.2))    // ~20% of hits play via mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "undegradeByWith" to KlangSymbol(
        name = "undegradeByWith",
        category = "random",
        tags = listOf("undegradeByWith", "random", "inverse", "custom", "probability"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "undegradeByWith",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "withPat", type = kt7, description = """Custom random-value pattern (values in [0, 1])."""),
                    KlangParam(name = "prob", type = kt7, description = """Threshold; event kept when `withPat >= (1 - prob)`."""),
                ),
                returnType = kt2,
                description = """Inverse of `degradeByWith` using a custom random-value pattern.

 Keeps an event when `withPat >= (1 - x)`, which is complementary to `degradeByWith`.""",
                returnDoc = """A pattern that is the complement of `degradeByWith(withPat, prob)`.""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd*8").undegradeByWith(randCycle, 0.5)   // cycle-level complement of degradeByWith""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "undegradeByWith",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "withPat", type = kt7),
                    KlangParam(name = "prob", type = kt7),
                ),
                returnType = kt2,
                description = """Inverse of `degradeByWith` using a custom random-value pattern.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "undegradeByWith",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "withPat", type = kt7),
                    KlangParam(name = "prob", type = kt7),
                ),
                returnType = kt5,
                description = """Chains an undegradeByWith onto this [PatternMapperFn] using a custom randomness source.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "undegradeByWith",
                params = listOf(
                    KlangParam(name = "withPat", type = kt7, description = """Custom random-value pattern (values in [0, 1])."""),
                    KlangParam(name = "prob", type = kt7, description = """Threshold; event kept when `withPat >= (1 - prob)`."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that is the inverse of `degradeByWith`.""",
                returnDoc = """A [PatternMapperFn] that is the complement of [degradeByWith].""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd*8").apply(undegradeByWith(randCycle, 0.5))  // cycle-level complement via mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "uni" to KlangSymbol(
        name = "uni",
        category = "dynamics",
        tags = listOf("uni", "unison"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "uni",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "voices", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "spread", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "pan", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt2,
                description = """`uni`, the short name of [unison]: the same door, use whichever reads better.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3 e3").s("supersaw").uni(5, 0.3)""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "uni",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "voices", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "spread", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "pan", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern, then applies [uni].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "uni",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "voices", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "spread", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "pan", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt5,
                description = """Chains a [uni] step onto this [PatternMapperFn] (see [SprudelPattern.uni]).""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    )
)

private fun generatedSprudelDocsChunk37() = mapOf(

    "unison" to KlangSymbol(
        name = "unison",
        category = "dynamics",
        tags = listOf("unison", "voices", "spread", "pan"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "unison",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "voices", type = kt6, isOptional = true, defaultDoc = """null""", description = """Voices. Typically 1 to 16."""),
                    KlangParam(name = "spread", type = kt6, isOptional = true, defaultDoc = """null""", description = """Detune spread in semitones."""),
                    KlangParam(name = "pan", type = kt6, isOptional = true, defaultDoc = """null""", description = """Stereo spread, 0 to 1. Reserved, not read yet."""),
                ),
                returnType = kt2,
                description = """Unison: voice count, detune spread and stereo spread.

 Stacks detuned copies of the oscillator per voice; `spread` is the
 detune in semitones, `pan` the stereo width.

 Every slot is independent and patternable; an omitted slot keeps its value, a named slot takes
 a mapper (`unison(spread = mul(2))`), and the numeric slots read back as `unison.voices`, `unison.spread`, `unison.pan`.
 With no argument at all, the pattern's own values are reinterpreted as `voices`.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3 e3").s("supersaw").unison(5, 0.3)                              // five voices, a third of a semitone apart""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c3 e3").s("supersaw").unison(5, 0.3).unison(spread = mul("<1 3>"))   // wider every other bar""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c3 e3").s("supersaw").unison("3 7", 0.2).gain(unison.voices.mul(0.1))   // more voices, louder""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "unison",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "voices", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "spread", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "pan", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern, then applies [unison].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "unison",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "voices", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "spread", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "pan", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt5,
                description = """Chains a [unison] step onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "unit" to KlangSymbol(
        name = "unit",
        category = "sampling",
        tags = listOf("unit", "time unit", "cycles", "sample", "timing"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "unit",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "value", type = kt7, description = """Time unit string — `"c"` for cycles, `"s"` for seconds."""),
                ),
                returnType = kt2,
                description = """Sets the time unit used for sample playback duration.

 Determines how [speed] and other timing-related parameters are interpreted. The value
 `"c"` (cycles) makes the sample stretch or compress to fit the pattern's cycle timing.
 Used internally by [loopAt] and [loopAtCps].""",
                returnDoc = """A pattern with the time unit set.""",
                samples = listOf(
                    KlangCodeSample(code = """s("breaks").unit("c").slow(2)     // stretch sample to fill 2 cycles""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("breaks").speed(0.5).unit("c")  // half-speed in cycle units""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "unit",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "value", type = kt7),
                ),
                returnType = kt2,
                description = """Sets the time unit for sample playback on a string pattern.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "unit",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "value", type = kt7),
                ),
                returnType = kt5,
                description = """Chains a unit onto this [PatternMapperFn]; sets the time unit for sample playback.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "unit",
                params = listOf(
                    KlangParam(name = "value", type = kt7, description = """Time unit string — `"c"` for cycles, `"s"` for seconds."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that sets the time unit for sample playback.""",
                returnDoc = """A [PatternMapperFn] that sets the unit field on the source pattern.""",
                samples = listOf(
                    KlangCodeSample(code = """s("breaks").apply(unit("c")).slow(2)   // via mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "vel" to KlangSymbol(
        name = "vel",
        category = "dynamics",
        tags = listOf("vel", "velocity", "volume", "midi", "dynamics"),
        aliases = listOf("velocity"),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "vel",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "amount", type = kt6, isOptional = true, defaultDoc = """null""", description = """Velocity, multiplied into the gain."""),
                ),
                returnType = kt2,
                description = """Alias for [velocity]: the velocity of each event, multiplied into the gain.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c d e f").gain(0.5).vel("0.5 2.0")   // gain is multiplied by velocity""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c*4").vel(saw.range(0.25, 1.0).slow(4))   // crescendo pattern over 4 cycles""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "vel",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "amount", type = kt6, isOptional = true, defaultDoc = """null""", description = """Velocity, multiplied into the gain."""),
                ),
                returnType = kt2,
                description = """Alias for [velocity]. Sets the velocity (gain multiplier) for each event in this pattern.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """"c*4".vel("<0.3 0.6 0.9 1.0>").note()  // crescendo pattern""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "vel",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "amount", type = kt6, isOptional = true, defaultDoc = """null""", description = """Velocity, multiplied into the gain."""),
                ),
                returnType = kt5,
                description = """Alias for [velocity]. Creates a chained [PatternMapperFn] that sets the velocity after the previous mapper.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c*4").apply(vel("<0.3 0.6 0.9>").gain(0.8))  // velocity + gain chained""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "velocity" to KlangSymbol(
        name = "velocity",
        category = "dynamics",
        tags = listOf("velocity", "vel", "volume", "midi", "dynamics"),
        aliases = listOf("vel"),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "velocity",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "amount", type = kt6, isOptional = true, defaultDoc = """null""", description = """Velocity, multiplied into the gain."""),
                ),
                returnType = kt2,
                description = """Sets the velocity of each event, per voice.

 Velocity is multiplied into `gain`, so `gain(0.5).velocity(2)` ends up at 1. Keep `gain` for the
 level of the line and `velocity` for the accents inside it.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c d e f").gain(0.5).velocity("0.5 2.0")  // gain is multiplied by velocity""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c*4").velocity("<0.3 0.6 0.9 1.0>")  // crescendo pattern""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c*4").velocity(saw.range(0.25, 1.0).slow(4))  // crescendo pattern over 4 cycles""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "velocity",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "amount", type = kt6, isOptional = true, defaultDoc = """null""", description = """Velocity, multiplied into the gain."""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern and sets the velocity (gain multiplier) for each event.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """"c*4".velocity("<0.3 0.6 0.9 1.0>").note()  // crescendo pattern""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "velocity",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "amount", type = kt6, isOptional = true, defaultDoc = """null""", description = """Velocity, multiplied into the gain."""),
                ),
                returnType = kt5,
                description = """Creates a chained [PatternMapperFn] that sets the velocity after the previous mapper.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c*4").apply(velocity("<0.3 0.6 0.9>").gain(0.8))  // velocity + gain chained""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "vib" to KlangSymbol(
        name = "vib",
        category = "tonal",
        tags = listOf("vib", "vibrato"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "vib",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "rate", type = kt6, isOptional = true, defaultDoc = """null""", description = """LFO rate in Hz."""),
                    KlangParam(name = "semitones", type = kt6, isOptional = true, defaultDoc = """null""", description = """Depth in semitones."""),
                    KlangParam(name = "rangeFrom", type = kt6, isOptional = true, defaultDoc = """null""", description = """Where the LFO's -1 lands, in the -1..1 language of `range`, raw (default -1)."""),
                    KlangParam(name = "rangeTo", type = kt6, isOptional = true, defaultDoc = """null""", description = """Where the LFO's +1 lands, in the -1..1 language of `range`, raw (default 1)."""),
                    KlangParam(name = "phase", type = kt6, isOptional = true, defaultDoc = """null""", description = """Where the wobble starts, a fraction of one cycle; 0 is mid-swing, rising (default 0)."""),
                ),
                returnType = kt2,
                description = """`vib`, the short name of [vibrato]: the same door, use whichever reads better.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c4 e4").s("saw").vib(5, 0.5)""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "vib",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "rate", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "semitones", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "rangeFrom", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "rangeTo", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "phase", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern, then applies [vib].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "vib",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "rate", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "semitones", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "rangeFrom", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "rangeTo", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "phase", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt5,
                description = """Chains a [vib] step onto this [PatternMapperFn] (see [SprudelPattern.vib]).""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "vibrato" to KlangSymbol(
        name = "vibrato",
        category = "tonal",
        tags = listOf("vibrato", "rate", "semitones", "range", "phase"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "vibrato",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "rate", type = kt6, isOptional = true, defaultDoc = """null""", description = """LFO rate in Hz."""),
                    KlangParam(name = "semitones", type = kt6, isOptional = true, defaultDoc = """null""", description = """Depth in semitones."""),
                    KlangParam(name = "rangeFrom", type = kt6, isOptional = true, defaultDoc = """null""", description = """Where the LFO's -1 lands, in the -1..1 language of `range`, raw (default -1)."""),
                    KlangParam(name = "rangeTo", type = kt6, isOptional = true, defaultDoc = """null""", description = """Where the LFO's +1 lands, in the -1..1 language of `range`, raw (default 1)."""),
                    KlangParam(name = "phase", type = kt6, isOptional = true, defaultDoc = """null""", description = """Where the wobble starts, a fraction of one cycle; 0 is mid-swing, rising (default 0)."""),
                ),
                returnType = kt2,
                description = """Vibrato: LFO rate in Hz, depth in semitones, where the swing sits, and where the LFO starts.

 A pitch wobble on the note per voice: the rate is how fast, the depth
 how far. A rate of 3 Hz is gentle, 5 standard, 7 nervous; a depth of 0.2 semitones is subtle,
 0.5 expressive, 1 a wide wobble.

 `rangeFrom` and `rangeTo` place the swing, in the -1..1 language of `range`: the LFO's -1 lands on `rangeFrom`, its
 +1 on `rangeTo`, and the depth scales that. Unset, they are -1 and 1, a wobble both ways around the note;
 `rangeFrom = 0, rangeTo = 1` swings only upward, as a guitarist bends a fretted string. Raw, no clamp: `rangeTo = 2`
 swings twice the depth upward, `rangeFrom = 1, rangeTo = -1` turns the wobble upside down. `phase` is where in its
 cycle the wobble starts, a fraction of one cycle: 0 (unset) in the middle of the swing, rising, which is the note
 only for a swing centred on it (the default); 0.25 at its top; 0.5 in the middle, falling; 0.75 at its bottom. So an
 upward-only vibrato starts on the note at `phase = 0.75` (at 0 it would start a quarter of its depth sharp), a
 downward-only one at 0.25. It wraps (1.25 is 0.25).

 Every slot is independent and patternable; an omitted slot keeps its value, a named slot takes
 a mapper (`vibrato(semitones = mul(2))`), and the numeric slots read back as `vibrato.rate`, `vibrato.semitones`,
 `vibrato.rangeFrom`, `vibrato.rangeTo`, `vibrato.phase`. With no argument at all, the pattern's own values are
 reinterpreted as `rate`.

 The door fills the vibrato stage of `classic()` (the `vibrato.*` slots), the Ignitor `vibrato` node, whose
 `range(from, to)` and `phase` builder knobs these are; an instrument without `classic()` ignores it, like the other
 `classic()` doors. The depth is the switch: a call without it (`vib(4)`, `vib(rangeFrom = 0)`) switches nothing on.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c4 e4").s("saw").vibrato(5, 0.5)                                  // a singing vibrato""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c4 e4").s("saw").vibrato(5, 0.5).vibrato(rate = mul("1 1.5"))     // the second note wobbles faster""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c4 e4").s("saw").vibrato(rate = 5, semitones = 0.5, rangeFrom = 0, rangeTo = 1, phase = 0.75)   // a guitar's vibrato: from the note, only ever up""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c4 e4").s("saw").vibrato(rate = 4, semitones = 0.7, phase = "0 0.5")   // the second note starts its wobble falling""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c4 e4").s("saw").vibrato("3 7", 0.5).penv(vibrato.rate)           // an onset blip as many semitones wide as the rate""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "vibrato",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "rate", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "semitones", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "rangeFrom", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "rangeTo", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "phase", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern, then applies [vibrato].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "vibrato",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "rate", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "semitones", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "rangeFrom", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "rangeTo", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "phase", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt5,
                description = """Chains a [vibrato] step onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "voicing" to KlangSymbol(
        name = "voicing",
        category = "tonal",
        tags = listOf("voicing", "voice leading", "chord", "harmony", "rank", "range"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "voicing",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "rank", type = kt6, isOptional = true, defaultDoc = """null""", description = """Which candidate voicing to pick: `0` = best (default), `1` = second-best, etc. Floored, then clamped to the candidate count. [PatternLike], sampled per event."""),
                    KlangParam(name = "low", type = kt6, isOptional = true, defaultDoc = """null""", description = """Bottom of the voicing range as a note name (e.g. `"C3"`). [PatternLike], sampled per event. Default: `"C3"`."""),
                    KlangParam(name = "high", type = kt6, isOptional = true, defaultDoc = """null""", description = """Top of the voicing range as a note name (e.g. `"C5"`). [PatternLike], sampled per event. Default: `"C5"`."""),
                ),
                returnType = kt2,
                description = """Expands chord patterns into voiced notes using voice leading.

 Converts each event carrying a chord name (set via [chord]) into a stack of notes that
 form the chord, applying smooth voice leading to minimise large jumps between chords.

 All three parameters are optional and accept any [PatternLike] — constants, mininotation
 patterns, or continuous control patterns. They are sampled per chord event, so range and
 rank can vary in time.

 - `rank` picks which candidate voicing to use: `0` (default) is the best fit by voice
   leading, `1` is the second-best, etc. Out-of-range values clamp to the last available
   candidate; non-integer values are floored.
 - `low` and `high` set the search-range bottom and top as note-name strings (`"C3"`,
   `"E5"`, …). When omitted, the default range is `"C3"` to `"C5"`.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """chord("C:major Am:minor F:major G:major").voicing()                                // best voicing (rank = 0), default range""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """chord("C:major Am:minor F:major G:major").voicing(rank = 1)                        // second-best every event""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """chord("<C Am F G>").voicing(rank = "<0 1 0 2>")                                    // rank varies per cycle""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """chord("<C Am F G>").voicing(rank = sine.range(0, 3).segment(4))                    // rank from a control pattern""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """chord("Cmaj7 Am7 Fmaj7").voicing(low = "C3", high = "C5")                          // explicit fixed range""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """chord("<C F G C>").voicing(low = "<C3 D3 E3 F3>", high = "<C5 D5 E5 F5>")          // range slides up per cycle""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """chord("Dm7 G7").voicing(rank = 1, low = "C3", high = "C5")                         // second-best, in C3–C5""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "voicing",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "rank", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "low", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "high", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt2,
                description = """Expands chord events in a string pattern into voiced notes with voice leading.

 See [SprudelPattern.voicing] for the meaning of [rank], [low], and [high].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "voicing",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "rank", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "low", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "high", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt5,
                description = """Chains a voicing step onto this [PatternMapperFn].

 See [SprudelPattern.voicing] for the meaning of [rank], [low], and [high].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "voicing",
                params = listOf(
                    KlangParam(name = "rank", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "low", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "high", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that applies voicing to chord events.

 See [SprudelPattern.voicing] for the meaning of [rank], [low], and [high].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "vowel" to KlangSymbol(
        name = "vowel",
        category = "effects",
        tags = listOf("vowel", "wet", "floor"),
        aliases = listOf(),
        scope = KlangScope.ORBIT,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "vowel",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "wet", type = kt6, isOptional = true, defaultDoc = """null""", description = """How much of the orbit runs through the filter, 0 to 1."""),
                    KlangParam(name = "vowel", type = kt6, isOptional = true, defaultDoc = """null""", description = """Vowel name, see the list above. A prefix picks a voice type, `tenor:a`."""),
                    KlangParam(name = "floor", type = kt6, isOptional = true, defaultDoc = """null""", description = """Minimum dry share kept in the mix, 0 to 1."""),
                ),
                returnType = kt2,
                description = """The vowel formant filter: the vowel, its mix and its dry floor.

 Shapes the orbit like a mouth. One formant filter per orbit bus, so
 ALL of it, the vowel included, is set once for everyone by the orbit's owning voice.

 `wet` here is a mix (and `floor` how much of the dry stays under it): the filter processes the
 whole orbit mix. The `wet` of `reverb` and `delay` reads differently: it is how much of the orbit
 goes INTO them, a send, and their sound is added on top of the dry. Give a
 pattern its own vowel by giving it its own orbit.

 Vowels: `a`, `e`, `i`, `o`, `u`, the umlauts `ae`/`ä`, `oe`/`ö`, `ue`/`ü`, and the diphthongs
 `ei`, `au`, `eu`/`äu`. A prefix picks a voice type, `tenor:a`.

 Every slot is independent and patternable; an omitted slot keeps its value, a named slot takes
 a mapper (`vowel(floor = mul(2))`), and the numeric slots read back as `vowel.wet`, `vowel.floor`. `vowel` is a name and has no reader.
 With no argument at all, the pattern's own values are reinterpreted as `wet`
 (`seq("<0.2 0.5>").vowel()`); a value that is not a number writes nothing.

 `wet` comes first, as on every door that has one. The vowel is the second parameter, so a vowel
 alone is written by name: `vowel(vowel = "a")`.

 Naming a vowel sets the whole stage: `wet` and `floor` take their shared defaults, 0.5 and 0.2,
 unless an earlier call already set them, so `vowel(vowel = "a")` is as audible as it always was.
 Naming `wet` or `floor` alone does NOT invent a vowel, because the vowel is what switches the
 filter on. `vowel(vowel = "none")` switches it off again.

 Slots apply in order, `wet` first. A wet MAPPER in the same call as the vowel therefore maps a
 wet that is not set yet, which does nothing: `vowel(mul(2), "a")` on a fresh note is wet 0.5,
 the vowel's default. To double the wet, map it in a later call, once it is set:
 `vowel(vowel = "a").vowel(wet = mul(2))` is wet 1.0.

 All three reach a DECLARED orbit chain as chain slots, the vowel as the index of its name in the
 vowel catalogue (`vowel.vowel`, 0 = none), so the same call works whether the orbit declares a
 chain or runs the historical one, down to the sample.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3 e3").s("saw").vowel(0.8, "a")                                   // an open ah""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c3 e3").s("saw").vowel(0.8, "a e i o").vowel(wet = mul("<1 0.5>"))   // half as vocal every other bar""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c3 e3").s("saw").vowel("<0.2 0.9>", "o").reverb(wet = vowel.wet, size = 4)   // as much reverb as vowel""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "vowel",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "wet", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "vowel", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "floor", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern, then applies [vowel].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "vowel",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "wet", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "vowel", type = kt6, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "floor", type = kt6, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt5,
                description = """Chains a [vowel] step onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    )
)

private fun generatedSprudelDocsChunk38() = mapOf(

    "wchoose" to KlangSymbol(
        name = "wchoose",
        category = "random",
        tags = listOf("wchoose", "weighted", "random", "probability", "selection"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "wchoose",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true),
                ),
                returnType = kt2,
                description = """Uses this pattern (range 0–1) as a weighted selector over the given value/weight pairs.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "wchoose",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true),
                ),
                returnType = kt2,
                description = """Uses this string pattern as a weighted selector over the given value/weight pairs.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "wchoose",
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true, description = """`[value, weight]` pairs — higher weight means more likely selection."""),
                ),
                returnType = kt2,
                description = """Chooses randomly from the given values according to relative weights.

 Each choice is a `[value, weight]` pair. Higher weights make that value more likely.
 Uses `rand` as the selector so choices vary within a cycle.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c2 g2 d2 f1").s(wchoose(["sine", 10], ["triangle", 1]))""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s(wchoose(["bd", 8], ["sd", 2], ["hh", 5])).fast(8)""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "wchooseCycles" to KlangSymbol(
        name = "wchooseCycles",
        category = "random",
        tags = listOf("wchooseCycles", "weighted", "random", "cycle", "wrandcat"),
        aliases = listOf("wrandcat"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "wchooseCycles",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true),
                ),
                returnType = kt2,
                description = """Picks a weighted random value once per cycle.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "wchooseCycles",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true),
                ),
                returnType = kt2,
                description = """Picks a weighted random value once per cycle.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "wchooseCycles",
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true, description = """`[value, weight]` pairs — higher weight means more likely selection. One is chosen per cycle."""),
                ),
                returnType = kt2,
                description = """Picks one of the given values at random each cycle according to relative weights.

 Like `chooseCycles` but each choice can have a different probability. The entire cycle
 plays the same chosen value. Each choice is a `[value, weight]` pair.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """wchooseCycles(["bd", 10], ["hh", 1]).s().fast(8)   // bd much more likely""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "when" to KlangSymbol(
        name = "when",
        category = "conditional",
        tags = listOf("when", "conditional", "binary", "gate", "transform"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "when",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "condition", type = kt7, description = """A pattern whose values determine when to apply [transform]."""),
                    KlangParam(name = "transform", type = kt5, description = """The function to apply when [condition] is truthy."""),
                ),
                returnType = kt2,
                description = """Conditionally applies [transform] to every event whose position in the cycle falls within a
 truthy region of [condition].

 The [condition] pattern is sampled at each event's time. If the sampled value is truthy
 (non-zero), [transform] is applied; otherwise the event plays unchanged.

 A common idiom is to use binary patterns (`0`/`1`) as the condition — for example a pattern
 created with [struct] or a slow alternation like `pure(1).slowcat(pure(0))`.""",
                returnDoc = """A new pattern that conditionally applies [transform].""",
                samples = listOf(
                    KlangCodeSample(code = """note("c d e f").when(pure(1).struct("t ~ t ~"), x => x.add(12))""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("bd sd").when("<1 0>", x => x.fast(2))""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "when",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "condition", type = kt7, description = """A pattern whose values determine when to apply [transform]. Zero is falsy; any other value is truthy."""),
                    KlangParam(name = "transform", type = kt5, description = """The function to apply when [condition] is truthy."""),
                ),
                returnType = kt2,
                description = """Parses this string as a pattern, then applies [transform] whenever [condition] is truthy.""",
                returnDoc = """A new pattern that conditionally applies [transform].""",
                samples = listOf(
                    KlangCodeSample(code = """"c d e f".when("1 0 1 0", x => x.add(12)).note()""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "when",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "condition", type = kt7, description = """A pattern whose values determine when to apply [transform]."""),
                    KlangParam(name = "transform", type = kt5, description = """The function to apply when [condition] is truthy."""),
                ),
                returnType = kt5,
                description = """Chains a conditional transform onto this [PatternMapperFn], applying [transform] whenever [condition] is truthy.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3 d3").apply(firstOf(4, x => x.rev()).when("1 0", x => x.add(12)))""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "when",
                params = listOf(
                    KlangParam(name = "condition", type = kt7, description = """A pattern whose values determine when to apply [transform]. Zero is falsy; any other value is truthy."""),
                    KlangParam(name = "transform", type = kt5, description = """The function to apply when [condition] is truthy."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that conditionally applies [transform] to events where [condition] is truthy.

 Use the returned mapper as a transform argument or apply it to a pattern via `.apply(...)`.""",
                returnDoc = """A [PatternMapperFn] that conditionally applies [transform].""",
                samples = listOf(
                    KlangCodeSample(code = """note("c d e f").apply(when("1 0 1 0", x => x.add(12)))""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c d e f").firstOf(4, when("1 0 1 0", x => x.add(12)))""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "withSeed" to KlangSymbol(
        name = "withSeed",
        category = "random",
        tags = listOf("withSeed", "seed", "random", "reproducible"),
        aliases = listOf("seed"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "withSeed",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "n", type = kt7, description = """Seed value — any integer-compatible pattern or literal."""),
                ),
                returnType = kt2,
                description = """Alias for [seed]. Sets the random seed for reproducible random operations.""",
                returnDoc = """A pattern whose random operations are pinned to the given seed.""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "withSeed",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "n", type = kt7),
                ),
                returnType = kt2,
                description = """Alias for [seed] on a string pattern.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "withSeed",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "n", type = kt7),
                ),
                returnType = kt5,
                description = """Chains a withSeed (alias for [seed]) onto this [PatternMapperFn].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "withSeed",
                params = listOf(
                    KlangParam(name = "n", type = kt7),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] — alias for [seed] — that pins all random operations to the given seed.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "within" to KlangSymbol(
        name = "within",
        category = "structural",
        tags = listOf("within", "window", "time", "conditional", "transform"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "within",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "start", type = kt10, description = """Start of the window (0.0 to 1.0, must be less than `end`)."""),
                    KlangParam(name = "end", type = kt10, description = """End of the window (0.0 to 1.0)."""),
                    KlangParam(name = "transform", type = kt5, description = """[PatternMapperFn] applied to the events inside the window."""),
                ),
                returnType = kt2,
                description = """Applies a transformation to the portion of the pattern that falls within a time window.

 Events inside `[start, end)` are extracted, transformed, then stacked back with the untouched events
 outside the window. The window bounds must satisfy `0.0 <= start < end <= 1.0`.""",
                returnDoc = """The pattern with the windowed portion transformed, stacked with the unaffected portion.""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd hh cp").within(0.0, 0.5, x => x.fast(2))  // double-speed in first half""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c d e f").within(0.25, 0.75, x => x.transpose(12))  // octave up in the middle""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "within",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "start", type = kt10, description = """Start of the window (0.0 to 1.0, must be less than `end`)."""),
                    KlangParam(name = "end", type = kt10, description = """End of the window (0.0 to 1.0)."""),
                    KlangParam(name = "transform", type = kt5, description = """[PatternMapperFn] applied to the events inside the window."""),
                ),
                returnType = kt2,
                description = """Applies a transformation to the portion of this string-parsed pattern that falls within a time window.""",
                returnDoc = """The pattern with the windowed portion transformed, stacked with the unaffected portion.""",
                samples = listOf(
                    KlangCodeSample(code = """"bd sd hh cp".within(0.0, 0.5, x => x.fast(2)).s()  // double-speed in first half""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "within",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "start", type = kt10),
                    KlangParam(name = "end", type = kt10),
                    KlangParam(name = "transform", type = kt5),
                ),
                returnType = kt5,
                description = """Chains a within onto this [PatternMapperFn]; applies `transform` to events in the time window of the result.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "within",
                params = listOf(
                    KlangParam(name = "start", type = kt10, description = """Start of the window (0.0 to 1.0, must be less than `end`)."""),
                    KlangParam(name = "end", type = kt10, description = """End of the window (0.0 to 1.0)."""),
                    KlangParam(name = "transform", type = kt5, description = """[PatternMapperFn] applied to the events inside the window."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that applies a transformation to the portion of the source pattern
 that falls within a time window.""",
                returnDoc = """A [PatternMapperFn] that applies `transform` to events in `[start, end)`.""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd hh cp").apply(within(0.0, 0.5, x => x.fast(2)))  // via mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "wrandcat" to KlangSymbol(
        name = "wrandcat",
        category = "random",
        tags = listOf("wrandcat", "wchooseCycles", "weighted", "random", "cycle"),
        aliases = listOf("wchooseCycles"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "wrandcat",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true),
                ),
                returnType = kt2,
                description = """Alias for [wchooseCycles].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "wrandcat",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true),
                ),
                returnType = kt2,
                description = """Alias for [wchooseCycles].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "wrandcat",
                params = listOf(
                    KlangParam(name = "args", type = kt7, isVararg = true, description = """`[value, weight]` pairs — higher weight means more likely selection. One is chosen per cycle."""),
                ),
                returnType = kt2,
                description = """Alias for [wchooseCycles].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "zoom" to KlangSymbol(
        name = "zoom",
        category = "structural",
        tags = listOf("zoom", "window", "time", "stretch", "slice"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangCallable(
                name = "zoom",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "start", type = kt7, description = """Start of the zoom window (0.0 to 1.0). Can be a pattern string."""),
                    KlangParam(name = "end", type = kt7, description = """End of the zoom window (0.0 to 1.0). Can be a pattern string."""),
                ),
                returnType = kt2,
                description = """Plays a portion of this pattern within a time window, stretching it to fill a full cycle.

 The window `[start, end]` is zoomed in on — events within that portion are stretched to fill the cycle.
 Both `start` and `end` can be pattern strings for dynamic zooming (e.g. `"<0 0.25>"`).""",
                returnDoc = """The zoomed portion of the pattern stretched to one full cycle.""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd hh sd hh").zoom(0.0, 0.5)   // plays only first half, stretched to full cycle""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c d e f").zoom(0.25, 0.75)  // plays middle two notes, stretched to full cycle""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            ),
            KlangCallable(
                name = "zoom",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "start", type = kt7),
                    KlangParam(name = "end", type = kt7),
                ),
                returnType = kt2,
                description = """Plays a portion of this string pattern within a time window, stretched to fill a cycle.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "zoom",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "start", type = kt7),
                    KlangParam(name = "end", type = kt7),
                ),
                returnType = kt5,
                description = """Chains a zoom onto this [PatternMapperFn]; plays a window of the result stretched to one cycle.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            ),
            KlangCallable(
                name = "zoom",
                params = listOf(
                    KlangParam(name = "start", type = kt7, description = """Start of the zoom window (0.0 to 1.0)."""),
                    KlangParam(name = "end", type = kt7, description = """End of the zoom window (0.0 to 1.0)."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that plays a portion of the source, stretching it to fill a cycle.""",
                returnDoc = """A [PatternMapperFn] that zooms the source into the given window.""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd hh sd hh").apply(zoom(0.0, 0.5))   // via mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    )
)

private fun generatedSprudelDocsObjects() = mapOf(

    "sine" to KlangSymbol(
        name = "sine",
        category = "continuous",
        tags = listOf("sine", "oscillator", "lfo", "continuous", "wave"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "sine",
                type = kt20,
                description = """Sine oscillator: unscaled continuous values in `0..1`.

 Starts at `0.5` at phase 0, rises to `1.0` at the quarter cycle, falls back through `0.5`
 at the half cycle, reaches `0.0` at three-quarters, and returns to `0.5` at cycle end.
 Use [range] to map it to a target range, or call it: `sine(200, 2000)` is `sine.range(200, 2000)`.
 For a swing centred on 0 use `sine(-1, 1)`.""",
                samples = listOf(
                    KlangCodeSample(code = """sine.range(200, 2000).freq().segment(128)  // sinusoidal frequency sweep""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("a!8").adsr(0.2, 1.0, 1.0, 0.2).gain(sine.slow(4))  // gain modulation""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel",
            ),
            KlangCallable(
                name = "sine",
                params = listOf(
                    KlangParam(name = "from", type = kt21, isOptional = true, defaultDoc = """null""", description = """Required. The value where the signal is at its low end."""),
                    KlangParam(name = "to", type = kt21, isOptional = true, defaultDoc = """null""", description = """Required. The value where the signal is at its high end."""),
                ),
                returnType = kt2,
                description = """The shorthand for [range]: `sine(from, to)` is exactly `sine.range(from, to)`.

 Both values are required; `sine` alone is the signal itself, swinging between `0` and `1`.""",
                returnDoc = """The signal swinging between [from] and [to].""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3*8").s("saw").lpf(sine(400, 2000).slow(4))  // the filter opens and closes over four cycles""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "cosine" to KlangSymbol(
        name = "cosine",
        category = "continuous",
        tags = listOf("cosine", "oscillator", "lfo", "continuous", "wave"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "cosine",
                type = kt22,
                description = """Cosine oscillator: unscaled continuous values in `0..1`. It is `sine.early(0.25)`, exactly.

 [sine] a quarter cycle earlier: starts at `1.0` at phase 0, falls to `0.5` at the
 quarter cycle, reaches `0.0` at the half cycle, and rises back to `1.0` at cycle end.
 It is built that way, so `sine` is the one source of the wave and the two never drift apart.
 Use [range] to map it to a target range, or call it: `cosine(200, 2000)` is `cosine.range(200, 2000)`.""",
                samples = listOf(
                    KlangCodeSample(code = """cosine.range(200, 2000).freq().segment(128)  // cosine frequency sweep""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("a!8").adsr(0.2, 1.0, 1.0, 0.2).pan(cosine.slow(4))  // stereo panning with cosine""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel",
            ),
            KlangCallable(
                name = "cosine",
                params = listOf(
                    KlangParam(name = "from", type = kt21, isOptional = true, defaultDoc = """null""", description = """Required. The value where the signal is at its low end."""),
                    KlangParam(name = "to", type = kt21, isOptional = true, defaultDoc = """null""", description = """Required. The value where the signal is at its high end."""),
                ),
                returnType = kt2,
                description = """The shorthand for [range]: `cosine(from, to)` is exactly `cosine.range(from, to)`.

 Both values are required; `cosine` alone is the signal itself, swinging between `0` and `1`.""",
                returnDoc = """The signal swinging between [from] and [to].""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3*8").s("saw").pan(cosine(0.2, 0.8).slow(2))  // pans between left and right""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "saw" to KlangSymbol(
        name = "saw",
        category = "continuous",
        tags = listOf("saw", "sawtooth", "oscillator", "lfo", "continuous", "wave"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "saw",
                type = kt23,
                description = """Sawtooth oscillator: unscaled continuous values in `0..1`.

 Resets to `0.0` at the start of each cycle and rises linearly to `1.0` by the end.
 Use [range] to map it to a target range, or call it: `saw(200, 2000)` is `saw.range(200, 2000)`.""",
                samples = listOf(
                    KlangCodeSample(code = """saw.range(200, 2000).freq()  // linearly rising frequency sweep per cycle""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """saw.range(0.0, 0.8).gain()  // linearly increasing gain per cycle""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel",
            ),
            KlangCallable(
                name = "saw",
                params = listOf(
                    KlangParam(name = "from", type = kt21, isOptional = true, defaultDoc = """null""", description = """Required. The value where the signal is at its low end."""),
                    KlangParam(name = "to", type = kt21, isOptional = true, defaultDoc = """null""", description = """Required. The value where the signal is at its high end."""),
                ),
                returnType = kt2,
                description = """The shorthand for [range]: `saw(from, to)` is exactly `saw.range(from, to)`.

 Both values are required; `saw` alone is the signal itself, swinging between `0` and `1`.""",
                returnDoc = """The signal swinging between [from] and [to].""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3*8").s("saw").lpf(saw(300, 3000))  // the filter opens across every cycle""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "tri" to KlangSymbol(
        name = "tri",
        category = "continuous",
        tags = listOf("tri", "triangle", "oscillator", "lfo", "continuous", "wave"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "tri",
                type = kt24,
                description = """Triangle oscillator: unscaled continuous values in `0..1`.

 Rises linearly `0→1` in the first half of the cycle then falls `1→0` in the second half.
 Use [range] to map it to a target range, or call it: `tri(200, 2000)` is `tri.range(200, 2000)`.""",
                samples = listOf(
                    KlangCodeSample(code = """tri.range(200, 2000).freq().segment(128)  // triangular frequency oscillation""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """tri.range(0.2, 0.9).gain().segment(128)  // triangular amplitude tremolo""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel",
            ),
            KlangCallable(
                name = "tri",
                params = listOf(
                    KlangParam(name = "from", type = kt21, isOptional = true, defaultDoc = """null""", description = """Required. The value where the signal is at its low end."""),
                    KlangParam(name = "to", type = kt21, isOptional = true, defaultDoc = """null""", description = """Required. The value where the signal is at its high end."""),
                ),
                returnType = kt2,
                description = """The shorthand for [range]: `tri(from, to)` is exactly `tri.range(from, to)`.

 Both values are required; `tri` alone is the signal itself, swinging between `0` and `1`.""",
                returnDoc = """The signal swinging between [from] and [to].""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3*8").s("saw").lpf(tri(400, 2400).slow(2))  // the filter rises and falls evenly""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "square" to KlangSymbol(
        name = "square",
        category = "continuous",
        tags = listOf("square", "oscillator", "lfo", "continuous", "wave", "gate"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "square",
                type = kt25,
                description = """Square oscillator: unscaled continuous values alternating `0` / `1`.

 Produces `0.0` for the first half of each cycle and `1.0` for the second half (50 % duty cycle).
 Use [range] to map those two levels to any pair of values, or call it: `square(200, 800)` is
 `square.range(200, 800)`.""",
                samples = listOf(
                    KlangCodeSample(code = """square.range(200, 800).freq().segment(128)  // frequency alternates between two values""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """square.range(0.0, 1.0).gain().segment(128)  // alternates between silence and full volume""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel",
            ),
            KlangCallable(
                name = "square",
                params = listOf(
                    KlangParam(name = "from", type = kt21, isOptional = true, defaultDoc = """null""", description = """Required. The value where the signal is at its low end."""),
                    KlangParam(name = "to", type = kt21, isOptional = true, defaultDoc = """null""", description = """Required. The value where the signal is at its high end."""),
                ),
                returnType = kt2,
                description = """The shorthand for [range]: `square(from, to)` is exactly `square.range(from, to)`.

 Both values are required; `square` alone is the signal itself, swinging between `0` and `1`.""",
                returnDoc = """The signal swinging between [from] and [to].""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3*8").s("saw").lpf(square(500, 3000))  // dark for half a cycle, bright for the other half""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "perlin" to KlangSymbol(
        name = "perlin",
        category = "continuous",
        tags = listOf("perlin", "noise", "random", "smooth", "continuous", "lfo"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "perlin",
                type = kt26,
                description = """Continuous Perlin noise: smoothly varying unscaled values in `0..1`.

 Each instantiation is seeded independently, producing different-but-deterministic smooth curves.
 Perlin noise transitions gradually between values, making it ideal for organic modulation.
 Use [range] to map it to a target range, or call it: `perlin(200, 2000)` is `perlin.range(200, 2000)`.""",
                samples = listOf(
                    KlangCodeSample(code = """perlin.range(200, 2000).freq().segment(128)  // smooth random frequency drift""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """perlin.range(0.2, 0.9).gain().segment(128)  // smooth random gain modulation""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel",
            ),
            KlangCallable(
                name = "perlin",
                params = listOf(
                    KlangParam(name = "from", type = kt21, isOptional = true, defaultDoc = """null""", description = """Required. The value where the signal is at its low end."""),
                    KlangParam(name = "to", type = kt21, isOptional = true, defaultDoc = """null""", description = """Required. The value where the signal is at its high end."""),
                ),
                returnType = kt2,
                description = """The shorthand for [range]: `perlin(from, to)` is exactly `perlin.range(from, to)`.

 Both values are required; `perlin` alone is the signal itself, swinging between `0` and `1`.""",
                returnDoc = """The signal swinging between [from] and [to].""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3*8").s("saw").lpf(perlin(400, 2000).slow(8))  // the filter wanders, smoothly""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "berlin" to KlangSymbol(
        name = "berlin",
        category = "continuous",
        tags = listOf("berlin", "noise", "random", "sawtooth", "continuous", "lfo"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "berlin",
                type = kt27,
                description = """Continuous Berlin noise: sawtooth-textured unscaled values in `0..1`.

 Like [perlin] but built from sawtooth waves, giving a harsher, more angular quality.
 The sawtooth construction makes it a characterful, surprisingly musical modulation source.
 Use [range] to map it to a target range, or call it: `berlin(200, 2000)` is `berlin.range(200, 2000)`.""",
                samples = listOf(
                    KlangCodeSample(code = """berlin.range(200, 2000).freq().segment(128)  // sawtooth-textured random frequency""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """berlin.range(0.2, 0.9).gain().segment(128)  // sawtooth-textured gain variation""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel",
            ),
            KlangCallable(
                name = "berlin",
                params = listOf(
                    KlangParam(name = "from", type = kt21, isOptional = true, defaultDoc = """null""", description = """Required. The value where the signal is at its low end."""),
                    KlangParam(name = "to", type = kt21, isOptional = true, defaultDoc = """null""", description = """Required. The value where the signal is at its high end."""),
                ),
                returnType = kt2,
                description = """The shorthand for [range]: `berlin(from, to)` is exactly `berlin.range(from, to)`.

 Both values are required; `berlin` alone is the signal itself, swinging between `0` and `1`.""",
                returnDoc = """The signal swinging between [from] and [to].""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3*8").s("saw").lpf(berlin(400, 2000).slow(4))  // the filter wanders in rough steps""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "adsr" to KlangSymbol(
        name = "adsr",
        category = "dynamics",
        tags = listOf("adsr", "attack", "decay", "sustain", "release", "envelope", "accessor"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "adsr",
                type = kt28,
                description = """The amplitude envelope of each event: `adsr(attack, decay, sustain, release)` sets it, and its
 four slots can be read back as `adsr.attack`, `adsr.decay`, `adsr.sustain`, `adsr.release`.

 Each slot is independent: an omitted slot keeps its value, a mapper on a slot applies to that
 slot (`adsr(attack = mul(2))`), and a read comes after whatever set the slot in the chain.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3 e3").s("saw").adsr("0.05 0.3", 0.2, 0.7).adsr(release = adsr.attack)   // symmetric envelope""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c3 e3").s("saw").adsr("0.05 0.3", 0.2, 0.7, 0.4).lpf(adsr.attack.mul(8000))   // slower attack, brighter""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel",
            ),
            KlangCallable(
                name = "adsr",
                params = listOf(
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null""", description = """Attack time in seconds."""),
                    KlangParam(name = "decay", type = kt6, isOptional = true, defaultDoc = """null""", description = """Decay time in seconds."""),
                    KlangParam(name = "sustain", type = kt6, isOptional = true, defaultDoc = """null""", description = """Sustain level, 0 to 1."""),
                    KlangParam(name = "release", type = kt6, isOptional = true, defaultDoc = """null""", description = """Release time in seconds."""),
                ),
                returnType = kt5,
                description = """Creates a [PatternMapperFn] that sets the ADSR envelope parameters for each event.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3*4").s("sine").apply(adsr(0.01, 0.1, 0.5, 0.2))""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "adsrCurves" to KlangSymbol(
        name = "adsrCurves",
        category = "dynamics",
        tags = listOf("adsr", "curve", "envelope", "shape"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "adsrCurves",
                type = kt29,
                description = """The `adsrCurves` object: `adsrCurves(attack, decay, release)` sets the stage curves by name.
 The slots are names, not numbers, so the object carries the setter only and no readers
 (maintainer decision, 2026-09-07).""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3 e3 g3").s("supersaw").adsr(0.01, 0.2, 0.7, 0.5).apply(adsrCurves("square", "exponential", "scurve"))""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel",
            ),
            KlangCallable(
                name = "adsrCurves",
                params = listOf(
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the attack stage."""),
                    KlangParam(name = "decay", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the decay stage."""),
                    KlangParam(name = "release", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the release stage."""),
                ),
                returnType = kt5,
                description = """The setter, see [SprudelPattern.adsrCurves].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "compressor" to KlangSymbol(
        name = "compressor",
        category = "dynamics",
        tags = listOf("compressor", "accessor"),
        aliases = listOf(),
        scope = KlangScope.ORBIT,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "compressor",
                type = kt30,
                description = """The `compressor` object: `compressor(...)` sets the slots, and each numeric slot reads back as a child,
 `compressor.threshold`, `compressor.ratio`, `compressor.knee`, `compressor.attack`, `compressor.release`.""",
                samples = emptyList(),
                library = "sprudel",
            ),
            KlangCallable(
                name = "compressor",
                params = listOf(
                    KlangParam(name = "threshold", type = kt6, isOptional = true, defaultDoc = """null""", description = """Level in dB where compression starts, such as -20."""),
                    KlangParam(name = "ratio", type = kt6, isOptional = true, defaultDoc = """null""", description = """Compression ratio. 4 means 4:1 above the threshold."""),
                    KlangParam(name = "knee", type = kt6, isOptional = true, defaultDoc = """null""", description = """Knee width in dB. 0 is hard, 6 and above soft."""),
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null""", description = """Attack in seconds."""),
                    KlangParam(name = "release", type = kt6, isOptional = true, defaultDoc = """null""", description = """Release in seconds."""),
                ),
                returnType = kt5,
                description = """The setter, see [SprudelPattern.compressor].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "cull" to KlangSymbol(
        name = "cull",
        category = "dynamics",
        tags = listOf("cull", "accessor"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "cull",
                type = kt32,
                description = """The silence-culling window of each event, in seconds, as a value other setters can read.

 Bare `cull` reads what the chain has set so far, so it comes after whatever set the field.
 Call it, `cull(...)`, to set the field; a mapper argument applies to the field.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3 e3").cull(0.05).cull(mul("1 4"))          // the second note gets a four times wider window""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel",
            ),
            KlangCallable(
                name = "cull",
                params = listOf(
                    KlangParam(name = "seconds", type = kt6, isOptional = true, defaultDoc = """null""", description = """The window in seconds; the release must stay silent this long before the voice ends."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that sets the silence-culling window.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3 e3").apply(cull(0.2))                    // set the window via mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "gain" to KlangSymbol(
        name = "gain",
        category = "dynamics",
        tags = listOf("gain", "accessor"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "gain",
                type = kt33,
                description = """The gain of each event, as a value other setters can read.

 Bare `gain` reads what the chain has set so far, so it comes after whatever set the field
 (`gain(...)`, `adsr(...)`, an alias). Call it, `gain(...)`, to set the field; a mapper argument applies to the field.""",
                samples = listOf(
                    KlangCodeSample(code = """s("hh*8").gain("0.4 1").gain(mul(perlin.seg(8).range(0.8, 1.2)))   // humanised levels""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c e g").gain("0.9 0.6 0.3").velocity(gain)                      // velocity follows gain""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel",
            ),
            KlangCallable(
                name = "gain",
                params = listOf(
                    KlangParam(name = "amount", type = kt6, isOptional = true, defaultDoc = """null""", description = """Level multiplier, 1 leaves the event as it is."""),
                ),
                returnType = kt5,
                description = """Creates a [PatternMapperFn] that sets the gain for each event in a pattern.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """s("hh hh hh hh").apply(gain("1.0 0.75 0.5 0.25"))""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "pregain" to KlangSymbol(
        name = "pregain",
        category = "dynamics",
        tags = listOf("pregain", "accessor"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "pregain",
                type = kt34,
                description = """How hard each event is played into its instrument, as a value other setters can read.

 Bare `pregain` reads what the chain has set so far, so it comes after whatever set the slot
 (`pregain(...)`, `ignitorParam("pregain", ...)`). Call it, `pregain(...)`, to set the slot; a mapper
 argument applies to the slot, and on an event that has none it does nothing, so set one first.""",
                samples = listOf(
                    KlangCodeSample(code = """let amp = Ignitor.saw().pregain().distort(0.5).lowpass(2500).classic()
note("c3 e3").sound(amp).pregain(1).pregain(mul("1 0.5")).gain(0.3)   // the second note softer in""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """let amp = Ignitor.saw().pregain().distort(0.5).lowpass(2500).classic()
note("c3 e3").sound(amp).pregain("1 0.5").gain(pregain.mul(0.3))      // and quieter out with it""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel",
            ),
            KlangCallable(
                name = "pregain",
                params = listOf(
                    KlangParam(name = "amount", type = kt6, isOptional = true, defaultDoc = """null""", description = """How hard the note is played in, 1 leaves the instrument at its own level."""),
                ),
                returnType = kt5,
                description = """Creates a [PatternMapperFn] that sets how hard each event is played into its instrument.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "pan" to KlangSymbol(
        name = "pan",
        category = "dynamics",
        tags = listOf("pan", "accessor"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "pan",
                type = kt35,
                description = """The stereo position of each event, as a value other setters can read.

 Bare `pan` reads what the chain has set so far, so it comes after whatever set the field
 (`pan(...)`, `adsr(...)`, an alias). Call it, `pan(...)`, to set the field; a mapper argument applies to the field.""",
                samples = listOf(
                    KlangCodeSample(code = """s("hh*8").pan("0 0.25 0.5 0.75 1 0.75 0.5 0.25").pan(add(perlin.seg(8).range(-0.1, 0.1)))   // a little drift""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c e g").pan("0.2 0.5 0.8").gain(pan)                             // louder to the right""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel",
            ),
            KlangCallable(
                name = "pan",
                params = listOf(
                    KlangParam(name = "amount", type = kt6, isOptional = true, defaultDoc = """null""", description = """Pan position, 0 left to 1 right."""),
                ),
                returnType = kt5,
                description = """Creates a [PatternMapperFn] that sets the pan for each event in a pattern.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd hh sd cp").apply(pan("0 0.33 0.66 1"))  // left to right""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "velocity" to KlangSymbol(
        name = "velocity",
        category = "dynamics",
        tags = listOf("velocity", "accessor"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "velocity",
                type = kt36,
                description = """The velocity of each event, as a value other setters can read.

 Bare `velocity` reads what the chain has set so far, so it comes after whatever set the field
 (`velocity(...)`, `adsr(...)`, an alias). Call it, `velocity(...)`, to set the field; a mapper argument applies to the field.""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd").velocity("1 0.5").velocity(mul(0.8))                        // scale the accents""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c e g").velocity("0.9 0.6 0.3").lpf(velocity.mul(4000))          // softer notes are darker""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel",
            ),
            KlangCallable(
                name = "velocity",
                params = listOf(
                    KlangParam(name = "amount", type = kt6, isOptional = true, defaultDoc = """null""", description = """Velocity, multiplied into the gain."""),
                ),
                returnType = kt5,
                description = """Create a [PatternMapperFn] that sets the velocity (gain multiplier) for each event in a pattern.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c*4").apply(velocity("<0.3 0.6 0.9 1.0>"))  // crescendo pattern""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "orbit" to KlangSymbol(
        name = "orbit",
        category = "dynamics",
        tags = listOf("orbit", "accessor"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "orbit",
                type = kt37,
                description = """The orbit (effect bus) of each event, as a value other setters can read.

 Bare `orbit` reads what the chain has set so far, so it comes after whatever set the field
 (`orbit(...)` or an alias). Call it, `orbit(...)`, to set the field; a mapper argument applies
 to the field.

 Aliases: `o`.""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd").orbit(0).orbit(add("0 1"))                                    // the snare on orbit 1""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("bd sd").orbit("0 1").reverb(orbit.mul(0.3), 4)                    // more reverb on the higher orbit""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel",
            ),
            KlangCallable(
                name = "orbit",
                params = listOf(
                    KlangParam(name = "index", type = kt6, isOptional = true, defaultDoc = """null""", description = """The orbit index to route events to."""),
                ),
                returnType = kt5,
                description = """Creates a [PatternMapperFn] that routes events to the given audio output orbit.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd sd").apply(orbit(1))   // send drums to orbit 1""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "duck" to KlangSymbol(
        name = "duck",
        category = "dynamics",
        tags = listOf("duck", "accessor"),
        aliases = listOf(),
        scope = KlangScope.ORBIT,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "duck",
                type = kt38,
                description = """The `duck` object: `duck(...)` sets the slots, and each numeric slot reads back as a child,
 `duck.orbit`, `duck.depth`, `duck.attack`.""",
                samples = emptyList(),
                library = "sprudel",
            ),
            KlangCallable(
                name = "duck",
                params = listOf(
                    KlangParam(name = "orbit", type = kt6, isOptional = true, defaultDoc = """null""", description = """Orbit index whose voices trigger the duck."""),
                    KlangParam(name = "depth", type = kt6, isOptional = true, defaultDoc = """null""", description = """Depth, 0 for none, 1 for full silence."""),
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null""", description = """Recovery time in seconds after the trigger stops."""),
                ),
                returnType = kt5,
                description = """The setter, see [SprudelPattern.duck].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "unison" to KlangSymbol(
        name = "unison",
        category = "dynamics",
        tags = listOf("unison", "accessor"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "unison",
                type = kt39,
                description = """The `unison` object: `unison(...)` sets the slots, and each numeric slot reads back as a child,
 `unison.voices`, `unison.spread`, `unison.pan`.""",
                samples = emptyList(),
                library = "sprudel",
            ),
            KlangCallable(
                name = "unison",
                params = listOf(
                    KlangParam(name = "voices", type = kt6, isOptional = true, defaultDoc = """null""", description = """Voices. Typically 1 to 16."""),
                    KlangParam(name = "spread", type = kt6, isOptional = true, defaultDoc = """null""", description = """Detune spread in semitones."""),
                    KlangParam(name = "pan", type = kt6, isOptional = true, defaultDoc = """null""", description = """Stereo spread, 0 to 1. Reserved, not read yet."""),
                ),
                returnType = kt5,
                description = """The setter, see [SprudelPattern.unison].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "density" to KlangSymbol(
        name = "density",
        category = "dynamics",
        tags = listOf("density", "accessor"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "density",
                type = kt40,
                description = """The noise density of each event (`dust`; 0..1, mapped to grains per second), as a value
 other setters can read.

 Bare `density` reads what the chain has set so far, so it comes after whatever set the field
 (`density(...)` or an alias). Call it, `density(...)`, to set the field; a mapper argument applies
 to the field.

 Aliases: `d`.""",
                samples = listOf(
                    KlangCodeSample(code = """s("dust*2").density(0.3).density(add("0 0.4"))                           // the second grain cloud denser""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("dust*2").density("0.2 0.8").gain(density)                             // denser, louder""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel",
            ),
            KlangCallable(
                name = "density",
                params = listOf(
                    KlangParam(name = "amount", type = kt6, isOptional = true, defaultDoc = """null""", description = """The oscillator density."""),
                ),
                returnType = kt5,
                description = """Parses this string as a pattern and sets the oscillator or noise density.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """"a".apply(density(0.2)).s("dust").note()   // 40 noise events per second""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "body" to KlangSymbol(
        name = "body",
        category = "effects",
        tags = listOf("body", "accessor"),
        aliases = listOf(),
        scope = KlangScope.ORBIT,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "body",
                type = kt41,
                description = """The `body` object: `body(...)` sets the slots, and each numeric slot reads back as a child,
 `body.wet`, `body.floor`.""",
                samples = emptyList(),
                library = "sprudel",
            ),
            KlangCallable(
                name = "body",
                params = listOf(
                    KlangParam(name = "wet", type = kt6, isOptional = true, defaultDoc = """null""", description = """How much of the orbit runs through the body, 0 to 1."""),
                    KlangParam(name = "material", type = kt6, isOptional = true, defaultDoc = """null""", description = """Material name, see the list at [SprudelPattern.body]."""),
                    KlangParam(name = "floor", type = kt6, isOptional = true, defaultDoc = """null""", description = """Minimum dry share kept in the mix, 0 to 1."""),
                ),
                returnType = kt5,
                description = """The setter, see [SprudelPattern.body].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "delay" to KlangSymbol(
        name = "delay",
        category = "effects",
        tags = listOf("delay", "accessor"),
        aliases = listOf(),
        scope = KlangScope.ORBIT,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "delay",
                type = kt42,
                description = """The `delay` object: `delay(...)` sets the slots, and each numeric slot reads back as a child,
 `delay.wet`, `delay.time`, `delay.feedback`, `delay.cap`.""",
                samples = emptyList(),
                library = "sprudel",
            ),
            KlangCallable(
                name = "delay",
                params = listOf(
                    KlangParam(name = "wet", type = kt6, isOptional = true, defaultDoc = """null""", description = """How much of the orbit goes into the delay, 0 to 1, default 0.25. Orbit-wide."""),
                    KlangParam(name = "time", type = kt6, isOptional = true, defaultDoc = """null""", description = """Delay time in seconds, default 0.25. Orbit-wide."""),
                    KlangParam(name = "feedback", type = kt6, isOptional = true, defaultDoc = """null""", description = """Feedback, 0 to 1, default 0.3. Above 1 builds up. Orbit-wide."""),
                    KlangParam(name = "cap", type = kt6, isOptional = true, defaultDoc = """null""", description = """Ceiling the repeats may not exceed, default 1. Orbit-wide."""),
                ),
                returnType = kt5,
                description = """The setter, see [SprudelPattern.delay].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "distort" to KlangSymbol(
        name = "distort",
        category = "effects",
        tags = listOf("distort", "accessor"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "distort",
                type = kt43,
                description = """The `distort` object: `distort(...)` sets the slots, and the numeric slot reads back as a child,
 `distort.amount`.""",
                samples = emptyList(),
                library = "sprudel",
            ),
            KlangCallable(
                name = "distort",
                params = listOf(
                    KlangParam(name = "amount", type = kt6, isOptional = true, defaultDoc = """null""", description = """Drive, 0 is clean, 1 is heavy. Higher is allowed."""),
                    KlangParam(name = "shape", type = kt6, isOptional = true, defaultDoc = """null""", description = """Transfer curve by name, for example `tube`."""),
                ),
                returnType = kt5,
                description = """The setter, see [SprudelPattern.distort].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "crush" to KlangSymbol(
        name = "crush",
        category = "effects",
        tags = listOf("crush", "accessor"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "crush",
                type = kt44,
                description = """The `crush` object: `crush(...)` sets the slot, and it reads back as a child, `crush.bits`.""",
                samples = emptyList(),
                library = "sprudel",
            ),
            KlangCallable(
                name = "crush",
                params = listOf(
                    KlangParam(name = "bits", type = kt6, isOptional = true, defaultDoc = """null""", description = """Bit depth. Fewer bits are harsher, typically 1 to 16."""),
                ),
                returnType = kt5,
                description = """The setter, see [SprudelPattern.crush].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "coarse" to KlangSymbol(
        name = "coarse",
        category = "effects",
        tags = listOf("coarse", "accessor"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "coarse",
                type = kt45,
                description = """The `coarse` object: `coarse(...)` sets the slot, and it reads back as a child, `coarse.factor`.""",
                samples = emptyList(),
                library = "sprudel",
            ),
            KlangCallable(
                name = "coarse",
                params = listOf(
                    KlangParam(name = "factor", type = kt6, isOptional = true, defaultDoc = """null""", description = """Sample rate divisor, 1 is off, higher is coarser."""),
                ),
                returnType = kt5,
                description = """The setter, see [SprudelPattern.coarse].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "phaser" to KlangSymbol(
        name = "phaser",
        category = "effects",
        tags = listOf("phaser", "accessor"),
        aliases = listOf(),
        scope = KlangScope.ORBIT,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "phaser",
                type = kt46,
                description = """The `phaser` object: `phaser(...)` sets the slots, and each numeric slot reads back as a child,
 `phaser.rate`, `phaser.wet`, `phaser.center`, `phaser.sweep`, `phaser.floor`.""",
                samples = emptyList(),
                library = "sprudel",
            ),
            KlangCallable(
                name = "phaser",
                params = listOf(
                    KlangParam(name = "wet", type = kt6, isOptional = true, defaultDoc = """null""", description = """Depth, 0 to 1. Engages above 0.01."""),
                    KlangParam(name = "rate", type = kt6, isOptional = true, defaultDoc = """null""", description = """LFO rate in Hz."""),
                    KlangParam(name = "center", type = kt6, isOptional = true, defaultDoc = """null""", description = """Centre frequency of the sweep, Hz."""),
                    KlangParam(name = "sweep", type = kt6, isOptional = true, defaultDoc = """null""", description = """Sweep range around the centre, Hz."""),
                    KlangParam(name = "floor", type = kt6, isOptional = true, defaultDoc = """null""", description = """Minimum dry share kept in the mix, 0 to 1."""),
                ),
                returnType = kt5,
                description = """The setter, see [SprudelPattern.phaser].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "tremolo" to KlangSymbol(
        name = "tremolo",
        category = "effects",
        tags = listOf("tremolo", "accessor"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "tremolo",
                type = kt47,
                description = """The `tremolo` object: `tremolo(...)` sets the slots, and each numeric slot reads back as a child,
 `tremolo.depth`, `tremolo.rate`.""",
                samples = emptyList(),
                library = "sprudel",
            ),
            KlangCallable(
                name = "tremolo",
                params = listOf(
                    KlangParam(name = "depth", type = kt6, isOptional = true, defaultDoc = """null""", description = """Depth, 0 to 1. The stage is built only above 0."""),
                    KlangParam(name = "rate", type = kt6, isOptional = true, defaultDoc = """null""", description = """LFO rate in Hz. [beatRate] follows the tempo."""),
                    KlangParam(name = "shape", type = kt6, isOptional = true, defaultDoc = """null""", description = """LFO waveform: `sine`, `triangle`, `square`, `sawtooth`, `ramp`."""),
                ),
                returnType = kt5,
                description = """The setter, see [SprudelPattern.tremolo].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "reverb" to KlangSymbol(
        name = "reverb",
        category = "effects",
        tags = listOf("reverb", "accessor"),
        aliases = listOf(),
        scope = KlangScope.ORBIT,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "reverb",
                type = kt48,
                description = """The `reverb` object: `reverb(...)` sets the slots, and each numeric slot reads back as a child,
 `reverb.wet`, `reverb.size`, `reverb.lowpass`.""",
                samples = emptyList(),
                library = "sprudel",
            ),
            KlangCallable(
                name = "reverb",
                params = listOf(
                    KlangParam(name = "wet", type = kt6, isOptional = true, defaultDoc = """null""", description = """How much of the orbit goes into the room, 0 to 1, default 0.25. Orbit-wide."""),
                    KlangParam(name = "size", type = kt6, isOptional = true, defaultDoc = """null""", description = """Tail length, about 0 to 10, default 5; above 10 is bounded at 10. Orbit-wide."""),
                    KlangParam(name = "lowpass", type = kt6, isOptional = true, defaultDoc = """null""", description = """Lowpass on the tail, Hz. Lower is darker. Unset by default. Orbit-wide."""),
                ),
                returnType = kt5,
                description = """The setter, see [SprudelPattern.reverb].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "vowel" to KlangSymbol(
        name = "vowel",
        category = "effects",
        tags = listOf("vowel", "accessor"),
        aliases = listOf(),
        scope = KlangScope.ORBIT,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "vowel",
                type = kt49,
                description = """The `vowel` object: `vowel(...)` sets the slots, and each numeric slot reads back as a child,
 `vowel.wet`, `vowel.floor`.""",
                samples = emptyList(),
                library = "sprudel",
            ),
            KlangCallable(
                name = "vowel",
                params = listOf(
                    KlangParam(name = "wet", type = kt6, isOptional = true, defaultDoc = """null""", description = """How much of the orbit runs through the filter, 0 to 1."""),
                    KlangParam(name = "vowel", type = kt6, isOptional = true, defaultDoc = """null""", description = """Vowel name, see the list at [SprudelPattern.vowel]. A prefix picks a voice type, `tenor:a`."""),
                    KlangParam(name = "floor", type = kt6, isOptional = true, defaultDoc = """null""", description = """Minimum dry share kept in the mix, 0 to 1."""),
                ),
                returnType = kt5,
                description = """The setter, see [SprudelPattern.vowel].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "bpf" to KlangSymbol(
        name = "bpf",
        category = "effects",
        tags = listOf("bpf", "accessor"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "bpf",
                type = kt50,
                description = """The `bpf` object: `bpf(...)` sets the slots, and each slot reads back as a child,
 `bpf.freq`, `bpf.q`, `bpf.env`, `bpf.attack`, `bpf.decay`, `bpf.sustain`, `bpf.release`.""",
                samples = emptyList(),
                library = "sprudel",
            ),
            KlangCallable(
                name = "bpf",
                params = listOf(
                    KlangParam(name = "freq", type = kt6, isOptional = true, defaultDoc = """null""", description = """Centre frequency in Hz."""),
                    KlangParam(name = "q", type = kt6, isOptional = true, defaultDoc = """null""", description = """Resonance, higher narrows the band."""),
                    KlangParam(name = "env", type = kt6, isOptional = true, defaultDoc = """null""", description = """Envelope depth in semitones."""),
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null""", description = """Envelope attack in seconds."""),
                    KlangParam(name = "decay", type = kt6, isOptional = true, defaultDoc = """null""", description = """Envelope decay in seconds."""),
                    KlangParam(name = "sustain", type = kt6, isOptional = true, defaultDoc = """null""", description = """Envelope sustain, 0 to 1."""),
                    KlangParam(name = "release", type = kt6, isOptional = true, defaultDoc = """null""", description = """Envelope release in seconds."""),
                ),
                returnType = kt5,
                description = """The setter, see [SprudelPattern.bpf].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "bpfCurves" to KlangSymbol(
        name = "bpfCurves",
        category = "effects",
        tags = listOf("bpf", "curve", "envelope", "shape", "filter envelope"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "bpfCurves",
                type = kt51,
                description = """The `bpfCurves` object: `bpfCurves(attack, decay, release)` sets the bandpass filter envelope's stage curves
 by name. The slots are names, not numbers, so the object carries the setter only and no readers
 (the `adsrCurves` rule).""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3*4").s("saw").bpf(freq = 600, q = 4, env = 24, decay = 0.25, sustain = 0).apply(bpfCurves(decay = "cube"))""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel",
            ),
            KlangCallable(
                name = "bpfCurves",
                params = listOf(
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the attack stage."""),
                    KlangParam(name = "decay", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the decay stage."""),
                    KlangParam(name = "release", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the release stage."""),
                ),
                returnType = kt5,
                description = """The setter, see [SprudelPattern.bpfCurves].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "hpf" to KlangSymbol(
        name = "hpf",
        category = "effects",
        tags = listOf("hpf", "accessor"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "hpf",
                type = kt52,
                description = """The `hpf` object: `hpf(...)` sets the slots, and each slot reads back as a child,
 `hpf.freq`, `hpf.q`, `hpf.passes`, `hpf.env`, `hpf.attack`, `hpf.decay`, `hpf.sustain`, `hpf.release`.""",
                samples = emptyList(),
                library = "sprudel",
            ),
            KlangCallable(
                name = "hpf",
                params = listOf(
                    KlangParam(name = "freq", type = kt6, isOptional = true, defaultDoc = """null""", description = """Cutoff in Hz."""),
                    KlangParam(name = "q", type = kt6, isOptional = true, defaultDoc = """null""", description = """Resonance, higher emphasises the cutoff."""),
                    KlangParam(name = "passes", type = kt6, isOptional = true, defaultDoc = """null""", description = """Cascade count, 1 to 16."""),
                    KlangParam(name = "env", type = kt6, isOptional = true, defaultDoc = """null""", description = """Envelope depth in semitones."""),
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null""", description = """Envelope attack in seconds."""),
                    KlangParam(name = "decay", type = kt6, isOptional = true, defaultDoc = """null""", description = """Envelope decay in seconds."""),
                    KlangParam(name = "sustain", type = kt6, isOptional = true, defaultDoc = """null""", description = """Envelope sustain, 0 to 1."""),
                    KlangParam(name = "release", type = kt6, isOptional = true, defaultDoc = """null""", description = """Envelope release in seconds."""),
                ),
                returnType = kt5,
                description = """The setter, see [SprudelPattern.hpf].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "hpfCurves" to KlangSymbol(
        name = "hpfCurves",
        category = "effects",
        tags = listOf("hpf", "curve", "envelope", "shape", "filter envelope"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "hpfCurves",
                type = kt53,
                description = """The `hpfCurves` object: `hpfCurves(attack, decay, release)` sets the highpass filter envelope's stage curves
 by name. The slots are names, not numbers, so the object carries the setter only and no readers
 (the `adsrCurves` rule).""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3*4").s("saw").hpf(freq = 200, env = 24, decay = 0.2, sustain = 0).apply(hpfCurves(decay = "linear"))""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel",
            ),
            KlangCallable(
                name = "hpfCurves",
                params = listOf(
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the attack stage."""),
                    KlangParam(name = "decay", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the decay stage."""),
                    KlangParam(name = "release", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the release stage."""),
                ),
                returnType = kt5,
                description = """The setter, see [SprudelPattern.hpfCurves].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "lpf" to KlangSymbol(
        name = "lpf",
        category = "effects",
        tags = listOf("lpf", "accessor"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "lpf",
                type = kt54,
                description = """The `lpf` object: `lpf(...)` sets the slots, and each slot reads back as a child,
 `lpf.freq`, `lpf.q`, `lpf.passes`, `lpf.env`, `lpf.attack`, `lpf.decay`, `lpf.sustain`, `lpf.release`.""",
                samples = emptyList(),
                library = "sprudel",
            ),
            KlangCallable(
                name = "lpf",
                params = listOf(
                    KlangParam(name = "freq", type = kt6, isOptional = true, defaultDoc = """null""", description = """Cutoff in Hz."""),
                    KlangParam(name = "q", type = kt6, isOptional = true, defaultDoc = """null""", description = """Resonance, higher emphasises the cutoff."""),
                    KlangParam(name = "passes", type = kt6, isOptional = true, defaultDoc = """null""", description = """Cascade count, 1 to 16."""),
                    KlangParam(name = "env", type = kt6, isOptional = true, defaultDoc = """null""", description = """Envelope depth in semitones."""),
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null""", description = """Envelope attack in seconds."""),
                    KlangParam(name = "decay", type = kt6, isOptional = true, defaultDoc = """null""", description = """Envelope decay in seconds."""),
                    KlangParam(name = "sustain", type = kt6, isOptional = true, defaultDoc = """null""", description = """Envelope sustain, 0 to 1."""),
                    KlangParam(name = "release", type = kt6, isOptional = true, defaultDoc = """null""", description = """Envelope release in seconds."""),
                ),
                returnType = kt5,
                description = """The setter, see [SprudelPattern.lpf].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "lpfCurves" to KlangSymbol(
        name = "lpfCurves",
        category = "effects",
        tags = listOf("lpf", "curve", "envelope", "shape", "filter envelope"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "lpfCurves",
                type = kt55,
                description = """The `lpfCurves` object: `lpfCurves(attack, decay, release)` sets the lowpass filter envelope's stage curves
 by name. The slots are names, not numbers, so the object carries the setter only and no readers
 (the `adsrCurves` rule).""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3*4").s("saw").lpf(freq = 300, env = 24, decay = 0.3, sustain = 0.2).apply(lpfCurves(decay = "scurve"))""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel",
            ),
            KlangCallable(
                name = "lpfCurves",
                params = listOf(
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the attack stage."""),
                    KlangParam(name = "decay", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the decay stage."""),
                    KlangParam(name = "release", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the release stage."""),
                ),
                returnType = kt5,
                description = """The setter, see [SprudelPattern.lpfCurves].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "notch" to KlangSymbol(
        name = "notch",
        category = "effects",
        tags = listOf("notch", "accessor"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "notch",
                type = kt56,
                description = """The `notch` object: `notch(...)` sets the slots, and each slot reads back as a child,
 `notch.freq`, `notch.q`, `notch.env`, `notch.attack`, `notch.decay`, `notch.sustain`, `notch.release`.""",
                samples = emptyList(),
                library = "sprudel",
            ),
            KlangCallable(
                name = "notch",
                params = listOf(
                    KlangParam(name = "freq", type = kt6, isOptional = true, defaultDoc = """null""", description = """Centre frequency in Hz."""),
                    KlangParam(name = "q", type = kt6, isOptional = true, defaultDoc = """null""", description = """Resonance, higher narrows the notch."""),
                    KlangParam(name = "env", type = kt6, isOptional = true, defaultDoc = """null""", description = """Envelope depth in semitones."""),
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null""", description = """Envelope attack in seconds."""),
                    KlangParam(name = "decay", type = kt6, isOptional = true, defaultDoc = """null""", description = """Envelope decay in seconds."""),
                    KlangParam(name = "sustain", type = kt6, isOptional = true, defaultDoc = """null""", description = """Envelope sustain, 0 to 1."""),
                    KlangParam(name = "release", type = kt6, isOptional = true, defaultDoc = """null""", description = """Envelope release in seconds."""),
                ),
                returnType = kt5,
                description = """The setter, see [SprudelPattern.notch].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "notchCurves" to KlangSymbol(
        name = "notchCurves",
        category = "effects",
        tags = listOf("notch", "curve", "envelope", "shape", "filter envelope"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "notchCurves",
                type = kt57,
                description = """The `notchCurves` object: `notchCurves(attack, decay, release)` sets the notch filter envelope's stage curves
 by name. The slots are names, not numbers, so the object carries the setter only and no readers
 (the `adsrCurves` rule).""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3*4").s("saw").notch(freq = 800, q = 2, env = 24, decay = 0.3, sustain = 0).apply(notchCurves(decay = "linear"))""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel",
            ),
            KlangCallable(
                name = "notchCurves",
                params = listOf(
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the attack stage."""),
                    KlangParam(name = "decay", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the decay stage."""),
                    KlangParam(name = "release", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the release stage."""),
                ),
                returnType = kt5,
                description = """The setter, see [SprudelPattern.notchCurves].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "rand" to KlangSymbol(
        name = "rand",
        category = "random",
        tags = listOf("rand", "random", "continuous", "noise"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "rand",
                type = kt58,
                description = """Continuous random pattern producing values in the range 0–1.

 `rand` generates a unique pseudo-random value for each point in time. Use `range()` to re-map the
 output, or call it: `rand(0.5, 1)` is `rand.range(0.5, 1)`. Use `segment(n)` to discretise it into
 `n` steps per cycle. Any parameter that accepts a pattern takes it directly.""",
                samples = listOf(
                    KlangCodeSample(code = """s("hh*8").pan(rand)  // random panning for each hit""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c d e f").gain(rand.range(0.5, 1.0))  // random gain in 0.5–1.0""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel",
            ),
            KlangCallable(
                name = "rand",
                params = listOf(
                    KlangParam(name = "from", type = kt21, isOptional = true, defaultDoc = """null""", description = """Required. The value where the signal is at its low end."""),
                    KlangParam(name = "to", type = kt21, isOptional = true, defaultDoc = """null""", description = """Required. The value where the signal is at its high end."""),
                ),
                returnType = kt2,
                description = """The shorthand for [range]: `rand(from, to)` is exactly `rand.range(from, to)`.

 Both values are required; `rand` alone is the signal itself, between `0` and `1`.""",
                returnDoc = """The signal between [from] and [to].""",
                samples = listOf(
                    KlangCodeSample(code = """s("hh*8").gain(rand(0.4, 1))  // every hit at its own level""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "begin" to KlangSymbol(
        name = "begin",
        category = "sampling",
        tags = listOf("begin", "accessor"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "begin",
                type = kt59,
                description = """The sample start position of each event (0..1), as a value other setters can read.

 Bare `begin` reads what the chain has set so far, so it comes after whatever set the field
 (`begin(...)` or an alias). Call it, `begin(...)`, to set the field; a mapper argument applies
 to the field.""",
                samples = listOf(
                    KlangCodeSample(code = """s("breaks*4").begin(0.25).begin(mul("1 2 1 3"))                         // start points that jump""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("breaks*2").begin("0 0.5").end(begin.add(0.25))                      // a quarter of the sample from each start""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel",
            ),
            KlangCallable(
                name = "begin",
                params = listOf(
                    KlangParam(name = "pos", type = kt6, isOptional = true, defaultDoc = """null""", description = """Start position in [0, 1]."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that sets the sample start position (0–1).""",
                returnDoc = """A [PatternMapperFn] that sets the begin field on the source pattern.""",
                samples = listOf(
                    KlangCodeSample(code = """s("breaks").apply(begin(0.5))     // via mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "end" to KlangSymbol(
        name = "end",
        category = "sampling",
        tags = listOf("end", "accessor"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "end",
                type = kt60,
                description = """The sample end position of each event (0..1), as a value other setters can read.

 Bare `end` reads what the chain has set so far, so it comes after whatever set the field
 (`end(...)` or an alias). Call it, `end(...)`, to set the field; a mapper argument applies
 to the field.""",
                samples = listOf(
                    KlangCodeSample(code = """s("breaks*4").end(0.5).end(mul(perlin.seg(4).range(0.5, 1)))           // the cut point wanders""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("breaks*2").end("0.5 1").begin(end.sub(0.25))                        // start a quarter before each end""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel",
            ),
            KlangCallable(
                name = "end",
                params = listOf(
                    KlangParam(name = "pos", type = kt6, isOptional = true, defaultDoc = """null""", description = """End position in [0, 1]."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that sets the sample end position (0–1).""",
                returnDoc = """A [PatternMapperFn] that sets the end field on the source pattern.""",
                samples = listOf(
                    KlangCodeSample(code = """s("breaks").apply(end(0.5))     // via mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "speed" to KlangSymbol(
        name = "speed",
        category = "sampling",
        tags = listOf("speed", "accessor"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "speed",
                type = kt61,
                description = """The playback speed of each event, as a value other setters can read.

 Bare `speed` reads what the chain has set so far, so it comes after whatever set the field
 (`speed(...)` or an alias). Call it, `speed(...)`, to set the field; a mapper argument applies
 to the field.""",
                samples = listOf(
                    KlangCodeSample(code = """s("breaks*4").speed(1).speed(mul("1 0.5 1 2"))                           // normal, half, normal, double""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """s("breaks*2").speed("0.5 2").gain(speed.mul(0.4))                      // faster is louder""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel",
            ),
            KlangCallable(
                name = "speed",
                params = listOf(
                    KlangParam(name = "rate", type = kt6, isOptional = true, defaultDoc = """null""", description = """Speed multiplier; 1 = normal, 2 = double, 0.5 = half; negative only sounds with `begin` set (backwards to the start)."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that sets the sample playback speed.""",
                returnDoc = """A [PatternMapperFn] that sets the speed field on the source pattern.""",
                samples = listOf(
                    KlangCodeSample(code = """s("breaks").apply(speed(2))       // double speed via mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "cut" to KlangSymbol(
        name = "cut",
        category = "sampling",
        tags = listOf("cut", "accessor"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "cut",
                type = kt62,
                description = """The cut group of each event, as a value other setters can read.

 Bare `cut` reads what the chain has set so far, so it comes after whatever set the field
 (`cut(...)` or an alias). Call it, `cut(...)`, to set the field; a mapper argument applies
 to the field.""",
                samples = listOf(
                    KlangCodeSample(code = """s("hh*4").cut(1).cut(add("0 1 0 1"))                                    // two cut groups, alternating""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """stack(s("hh*4").cut(1), s("oh*2").cut(2)).gain(cut.mul(0.4))            // the cut group sets the level""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel",
            ),
            KlangCallable(
                name = "cut",
                params = listOf(
                    KlangParam(name = "group", type = kt6, isOptional = true, defaultDoc = """null""", description = """Cut group number; 0 = no choke."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that assigns the sample to a cut group.""",
                returnDoc = """A [PatternMapperFn] that sets the cut field on the source pattern.""",
                samples = listOf(
                    KlangCodeSample(code = """s("hh*4").apply(cut(1))         // assign to cut group 1 via mapper""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "fm" to KlangSymbol(
        name = "fm",
        category = "synthesis",
        tags = listOf("fm", "accessor"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "fm",
                type = kt63,
                description = """The `fm` object: `fm(...)` sets the slots, and each numeric slot reads back as a child,
 `fm.depth`, `fm.ratio`, `fm.attack`, `fm.decay`, `fm.sustain`, `fm.release`.""",
                samples = emptyList(),
                library = "sprudel",
            ),
            KlangCallable(
                name = "fm",
                params = listOf(
                    KlangParam(name = "depth", type = kt6, isOptional = true, defaultDoc = """null""", description = """Modulation depth in Hz."""),
                    KlangParam(name = "ratio", type = kt6, isOptional = true, defaultDoc = """null""", description = """The modulator's frequency as a multiple of the note."""),
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null""", description = """Modulation envelope attack in seconds."""),
                    KlangParam(name = "decay", type = kt6, isOptional = true, defaultDoc = """null""", description = """Modulation envelope decay in seconds."""),
                    KlangParam(name = "sustain", type = kt6, isOptional = true, defaultDoc = """null""", description = """Modulation envelope sustain, 0 to 1."""),
                    KlangParam(name = "release", type = kt6, isOptional = true, defaultDoc = """null""", description = """Modulation envelope release in seconds, after the note ends."""),
                ),
                returnType = kt5,
                description = """The setter, see [SprudelPattern.fm].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "analog" to KlangSymbol(
        name = "analog",
        category = "tonal",
        tags = listOf("analog", "accessor"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "analog",
                type = kt64,
                description = """How analog each event is (the `analog` character), as a value other setters can read.

 Bare `analog` reads what the chain has set so far, so it comes after whatever set the field
 (`analog(...)`). Call it, `analog(...)`, to set the field; a mapper argument applies to the field.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3 e3").s("supersaw").analog(2).analog(mul("1 3"))                 // the second note drifts more""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c3 e3").s("supersaw").analog("1 4").unison(spread = analog.div(20))       // more drift, wider""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel",
            ),
            KlangCallable(
                name = "analog",
                params = listOf(
                    KlangParam(name = "character", type = kt6, isOptional = true, defaultDoc = """null""", description = """How analog, a character scale: `0` is ideal, `1` to `8` usual, `10` strong."""),
                ),
                returnType = kt5,
                description = """Creates a [PatternMapperFn] that sets how analog the sound is.""",
                returnDoc = """A [PatternMapperFn] that sets analog drift.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3 e3").apply(analog(4))""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "duty" to KlangSymbol(
        name = "duty",
        category = "tonal",
        tags = listOf("duty", "accessor"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "duty",
                type = kt65,
                description = """The pulse duty cycle of each event, as a value other setters can read.

 Bare `duty` reads what the chain has set so far, so it comes after whatever set the field
 (`duty(...)`). Call it, `duty(...)`, to set the field; a mapper argument applies to the field.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3 e3").s("pulze").duty(0.5).duty(mul("1 0.5"))                    // the second note thinner""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c3 e3").s("pulze").duty("0.2 0.5").pan(duty)                      // wider pulse, further right""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel",
            ),
            KlangCallable(
                name = "duty",
                params = listOf(
                    KlangParam(name = "width", type = kt6, isOptional = true, defaultDoc = """null""", description = """The share of each cycle the wave is high, 0 to 1 (default 0.5, a square)."""),
                ),
                returnType = kt5,
                description = """Creates a [PatternMapperFn] that sets the pulse duty cycle.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "onepole" to KlangSymbol(
        name = "onepole",
        category = "tonal",
        tags = listOf("onepole", "accessor"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "onepole",
                type = kt66,
                description = """The one-pole lowpass cutoff of each event, as a value other setters can read.

 Bare `onepole` reads what the chain has set so far, so it comes after whatever set the field
 (`onepole(...)`). Call it, `onepole(...)`, to set the field; a mapper argument applies to the field.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3 e3").s("saw").onepole(2000).onepole(mul("1 2"))                // the second note brighter""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c3 e3").s("saw").onepole("1000 4000").lpf(onepole.mul(2))         // the SVF an octave above the one-pole""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel",
            ),
            KlangCallable(
                name = "onepole",
                params = listOf(
                    KlangParam(name = "freq", type = kt6, isOptional = true, defaultDoc = """null""", description = """The one-pole cutoff in Hz. 0 = no filter; lower = warmer/darker."""),
                ),
                returnType = kt5,
                description = """Creates a [PatternMapperFn] that sets the oscillator one-pole lowpass.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c d e f").apply(onepole("<12000 3700 1700>"))  // stepwise darker""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "legato" to KlangSymbol(
        name = "legato",
        category = "tonal",
        tags = listOf("legato", "accessor"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "legato",
                type = kt67,
                description = """The legato (duration scaling) of each event, as a value other setters can read.

 Bare `legato` reads what the chain has set so far, so it comes after whatever set the field
 (`legato(...)` or an alias). Call it, `legato(...)`, to set the field; a mapper argument applies
 to the field.

 Aliases: `clip`.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3 e3 g3 a3").legato(0.8).legato(mul("1 1.5 1 0.5"))               // long, longer, long, short""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c3 e3").legato("0.5 1.5").adsr(release = legato.mul(0.2))                 // release follows legato""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel",
            ),
            KlangCallable(
                name = "legato",
                params = listOf(
                    KlangParam(name = "amount", type = kt6, isOptional = true, defaultDoc = """null""", description = """Duration scaling factor. 1.0 = fill event slot exactly, 0.5 = staccato (half length), 1.5 = overlapping (legato), 2.0 = double length. Default: 1.0. Typical range: 0.1 to 2.0."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that sets the legato factor for each event.
 When called with no argument, reinterprets the current event value as a legato amount.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3 e3").apply(legato(1.5))   // mapper form""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "freq" to KlangSymbol(
        name = "freq",
        category = "tonal",
        tags = listOf("freq", "frequency", "Hz", "pitch", "accessor"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "freq",
                type = kt68,
                description = """The frequency of each event, as a value other setters can read.

 Bare `freq` reads the frequency `note()` (or `freq(hz)`) has set so far in the chain; it must
 therefore come AFTER the note in the chain. Call it, `freq(hz)`, to set the frequency.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c e g a").bpf(freq).sound("pink").bpf(q = 2.0)   // the wind whistles the melody""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c e g a").bpf(freq.mul(2))                     // bandpass one octave above the note""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel",
            ),
            KlangCallable(
                name = "freq",
                params = listOf(
                    KlangParam(name = "hz", type = kt6, isOptional = true, defaultDoc = """null""", description = """Frequency in Hz. Directly sets the pitch, bypassing note name resolution. 440 = A4, 261.63 = C4. Default: determined by note(). Range: 20 to 20000. A mapper (`mul(2)`, `add(50)`) is applied to the current frequency."""),
                ),
                returnType = kt5,
                description = """Sets the playback frequency in Hz directly, bypassing note name resolution.

 Overrides the computed frequency for each event. Useful for precise tuning or
 microtonal work where standard note names are insufficient. When called with no argument,
 reinterprets the current event value as a frequency in Hz. A mapper argument is applied to
 the frequency itself.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """"440 550 660".freq()         // A4, roughly C#5, roughly E5 by raw Hz""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c4 e4").freq(432)      // force all events to 432 Hz""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("a c e").freq(mul(perlin.seg(4).range(0.95, 1.05)))   // a novice violin player's intonation""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    ),

    "vibrato" to KlangSymbol(
        name = "vibrato",
        category = "tonal",
        tags = listOf("vibrato", "accessor"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "vibrato",
                type = kt69,
                description = """The `vibrato` object: `vibrato(...)` sets the slots, and each numeric slot reads back as a child,
 `vibrato.rate`, `vibrato.semitones`, `vibrato.rangeFrom`, `vibrato.rangeTo`, `vibrato.phase`.""",
                samples = emptyList(),
                library = "sprudel",
            ),
            KlangCallable(
                name = "vibrato",
                params = listOf(
                    KlangParam(name = "rate", type = kt6, isOptional = true, defaultDoc = """null""", description = """LFO rate in Hz."""),
                    KlangParam(name = "semitones", type = kt6, isOptional = true, defaultDoc = """null""", description = """Depth in semitones."""),
                    KlangParam(name = "rangeFrom", type = kt6, isOptional = true, defaultDoc = """null""", description = """Where the LFO's -1 lands, in the -1..1 language of `range`, raw (default -1)."""),
                    KlangParam(name = "rangeTo", type = kt6, isOptional = true, defaultDoc = """null""", description = """Where the LFO's +1 lands, in the -1..1 language of `range`, raw (default 1)."""),
                    KlangParam(name = "phase", type = kt6, isOptional = true, defaultDoc = """null""", description = """Where the wobble starts, a fraction of one cycle; 0 is mid-swing, rising (default 0)."""),
                ),
                returnType = kt5,
                description = """The setter, see [SprudelPattern.vibrato].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "penv" to KlangSymbol(
        name = "penv",
        category = "tonal",
        tags = listOf("penv", "accessor"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "penv",
                type = kt70,
                description = """The `penv` object: `penv(...)` sets the slots, and each slot reads back as a child,
 `penv.semitones`, `penv.attack`, `penv.decay`, `penv.sustain`, `penv.release`.""",
                samples = emptyList(),
                library = "sprudel",
            ),
            KlangCallable(
                name = "penv",
                params = listOf(
                    KlangParam(name = "semitones", type = kt6, isOptional = true, defaultDoc = """null""", description = """The pitch at the envelope's peak, in semitones."""),
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null""", description = """Attack in seconds."""),
                    KlangParam(name = "decay", type = kt6, isOptional = true, defaultDoc = """null""", description = """Decay in seconds."""),
                    KlangParam(name = "sustain", type = kt6, isOptional = true, defaultDoc = """null""", description = """Held share of `semitones` while the note is on; 0 is the note itself."""),
                    KlangParam(name = "release", type = kt6, isOptional = true, defaultDoc = """null""", description = """Release in seconds, back to the note after the note ends."""),
                ),
                returnType = kt5,
                description = """The setter, see [SprudelPattern.penv].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "penvCurves" to KlangSymbol(
        name = "penvCurves",
        category = "tonal",
        tags = listOf("penv", "curve", "envelope", "shape", "pitch envelope"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "penvCurves",
                type = kt71,
                description = """The `penvCurves` object: `penvCurves(attack, decay, release)` sets the pitch envelope's stage curves
 by name. The slots are names, not numbers, so the object carries the setter only and no readers
 (the `adsrCurves` rule).""",
                samples = listOf(
                    KlangCodeSample(code = """note("c2*4").s("sine").penv(24, 0.001, 0.08).apply(penvCurves("linear", "linear", "linear"))""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel",
            ),
            KlangCallable(
                name = "penvCurves",
                params = listOf(
                    KlangParam(name = "attack", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the attack stage."""),
                    KlangParam(name = "decay", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the decay stage."""),
                    KlangParam(name = "release", type = kt6, isOptional = true, defaultDoc = """null""", description = """Curve name for the release stage."""),
                ),
                returnType = kt5,
                description = """The setter, see [SprudelPattern.penvCurves].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "sprudel"
            )
        )
    ),

    "accelerate" to KlangSymbol(
        name = "accelerate",
        category = "tonal",
        tags = listOf("accelerate", "accessor"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "accelerate",
                type = kt72,
                description = """The pitch ramp of each event in semitones, as a value other setters can read.

 Bare `accelerate` reads what the chain has set so far, so it comes after whatever set the field
 (`accelerate(...)` or an alias). Call it, `accelerate(...)`, to set the field; a mapper argument applies
 to the field.""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd*4").accelerate(-2).accelerate(mul("1 2 1 4"))                       // deeper drops on every second hit""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c4 e4").accelerate("2 -2").pan(accelerate.mul(0.25).add(0.5))    // up goes right, down goes left""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel",
            ),
            KlangCallable(
                name = "accelerate",
                params = listOf(
                    KlangParam(name = "semitones", type = kt6, isOptional = true, defaultDoc = """null""", description = """Pitch bend in semitones. Typically -24 to 24."""),
                ),
                returnType = kt5,
                description = """Returns a [PatternMapperFn] that sets the playback acceleration (pitch ramp).
 When called with no argument, reinterprets the current event value as an acceleration amount.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """s("hh").apply(accelerate(24))  // mapper form""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel"
            )
        )
    )
)

private fun generatedSprudelDocsProperties() = mapOf(

    "not" to KlangSymbol(
        name = "not",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "not",
                type = kt5,
                description = """Applies logical NOT as a [PatternMapperFn], inverting each event's boolean value.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c d e f").degradeBy("1 0 1 0".apply(not))   // invert a degrade pattern into a gate""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel",
            )
        )
    ),

    "flipSign" to KlangSymbol(
        name = "flipSign",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "flipSign",
                type = kt5,
                description = """Flips the sign of numerical values as a [PatternMapperFn].""",
                samples = listOf(
                    KlangCodeSample(code = """"<[1 2 3 4] [-1 -2 -3 -4]>".apply(flipSign).scale("C4:major").n()""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel",
            )
        )
    ),

    "oneMinusValue" to KlangSymbol(
        name = "oneMinusValue",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "oneMinusValue",
                type = kt5,
                description = """Calculates `1.0 - value` as a [PatternMapperFn].""",
                samples = emptyList(),
                library = "sprudel",
            )
        )
    ),

    "abs" to KlangSymbol(
        name = "abs",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "abs",
                type = kt5,
                description = """Applies absolute-value as a [PatternMapperFn], making every numeric value non-negative.""",
                samples = listOf(
                    KlangCodeSample(code = """seq("-3 -1 0 2").apply(abs)   // becomes: 3 1 0 2""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel",
            )
        )
    ),

    "time" to KlangSymbol(
        name = "time",
        category = "continuous",
        tags = listOf("time", "continuous", "linear", "ramp"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "time",
                type = kt2,
                description = """Continuous ramp — current cycle time, increases linearly by `1.0` per cycle.

 At cycle `n`, the value equals `n + fraction_of_cycle`. Useful as a time-dependent modulation
 source or for creating patterns that evolve over many cycles. Use [range] or [rangex] to map
 it to a target parameter range.""",
                samples = listOf(
                    KlangCodeSample(code = """time.range(100.0, 255.0).freq().segment(128)  // linearly rising frequency per cycle""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """time.rangex(100.0, 2000.0).freq().segment(128)  // exponentially rising frequency over time""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel",
            )
        )
    ),

    "cps" to KlangSymbol(
        name = "cps",
        category = "continuous",
        tags = listOf("cps", "tempo", "playback speed", "continuous"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "cps",
                type = kt2,
                description = """Returns the cycles per second at which playback is currently running as a continuous pattern.""",
                samples = listOf(
                    KlangCodeSample(code = """sound("sd").delay(wet = 0.25, time = pure(1/8).div(cps), feedback = 0.5)  // Delay time based in CPS""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel",
            )
        )
    ),

    "rpm" to KlangSymbol(
        name = "rpm",
        category = "continuous",
        tags = listOf("rpm", "tempo", "revolutions per minute", "continuous"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "rpm",
                type = kt2,
                description = """Returns the current revolutions per minute as a continuous pattern (RPM = CPS × 60).""",
                samples = listOf(
                    KlangCodeSample(code = """sound("sd").delay(wet = 0.25, time = pure(1).div(rpm), feedback = 0.5)  // Delay time based in RPM""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel",
            )
        )
    ),

    "bpm" to KlangSymbol(
        name = "bpm",
        category = "continuous",
        tags = listOf("bpm", "tempo", "beats per minute", "continuous"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "bpm",
                type = kt2,
                description = """Returns the current beats per minute as a continuous pattern (assuming 4/4 time, 4 beats per cycle).""",
                samples = listOf(
                    KlangCodeSample(code = """sound("sd").delay(wet = 0.15, time = pure(60).div(bpm), feedback = 0.33)  // Delay time based in BPM""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel",
            )
        )
    ),

    "timeOfDay" to KlangSymbol(
        name = "timeOfDay",
        category = "continuous",
        tags = listOf("timeOfDay", "time", "clock", "continuous"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "timeOfDay",
                type = kt2,
                description = """Returns the current time of day as a linear value: `0.0` (midnight) → `0.5` (noon) → `1.0` (midnight).""",
                samples = listOf(
                    KlangCodeSample(code = """s("hh*8").gain(timeOfDay)         // gain rises through the day""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c4").lpf(timeOfDay.range(200, 4000))  // filter opens as the day progresses""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel",
            )
        )
    ),

    "sineOfDay" to KlangSymbol(
        name = "sineOfDay",
        category = "continuous",
        tags = listOf("sineOfDay", "time", "sine", "clock", "continuous"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "sineOfDay",
                type = kt2,
                description = """Returns the current time of day as a sine wave: `0.0` (midnight) → `1.0` (noon) → `0.0` (midnight).""",
                samples = listOf(
                    KlangCodeSample(code = """s("hh*8").gain(sineOfDay)         // gain peaks at noon""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c4").vibrato(sineOfDay.range(0, 8))  // vibrato rises and falls with the sun""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel",
            )
        )
    ),

    "timeOfNight" to KlangSymbol(
        name = "timeOfNight",
        category = "continuous",
        tags = listOf("timeOfNight", "time", "clock", "night", "continuous"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "timeOfNight",
                type = kt2,
                description = """Returns the current time of night (inverse of [timeOfDay]): `1.0` (midnight) → `0.0` (noon) → `1.0` (midnight).""",
                samples = listOf(
                    KlangCodeSample(code = """s("hh*8").gain(timeOfNight)       // gain is highest at midnight""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c4").lpf(timeOfNight.range(200, 4000))  // filter opens at night""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel",
            )
        )
    ),

    "sineOfNight" to KlangSymbol(
        name = "sineOfNight",
        category = "continuous",
        tags = listOf("sineOfNight", "time", "sine", "night", "clock", "continuous"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "sineOfNight",
                type = kt2,
                description = """Returns the current time of night as a sine wave: `1.0` (midnight) → `0.0` (noon) → `1.0` (midnight).""",
                samples = listOf(
                    KlangCodeSample(code = """s("hh*8").gain(sineOfNight)       // gain peaks at midnight""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """note("c4").vibrato(sineOfNight.range(0, 8))  // vibrato is strongest at night""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel",
            )
        )
    ),

    "comp" to KlangSymbol(
        name = "comp",
        category = "dynamics",
        tags = listOf("comp", "compressor", "accessor"),
        aliases = listOf(),
        scope = KlangScope.ORBIT,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "comp",
                type = kt30,
                description = """Alias of [compressor]: the same object under its short name.""",
                samples = emptyList(),
                library = "sprudel",
            )
        )
    ),

    "vel" to KlangSymbol(
        name = "vel",
        category = "dynamics",
        tags = listOf("vel", "velocity", "accessor"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "vel",
                type = kt36,
                description = """Alias of [velocity]: the same accessor under another name.""",
                samples = emptyList(),
                library = "sprudel",
            )
        )
    ),

    "o" to KlangSymbol(
        name = "o",
        category = "dynamics",
        tags = listOf("o", "orbit", "accessor"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "o",
                type = kt37,
                description = """Alias of [orbit]: the same accessor under another name.""",
                samples = emptyList(),
                library = "sprudel",
            )
        )
    ),

    "uni" to KlangSymbol(
        name = "uni",
        category = "dynamics",
        tags = listOf("uni", "unison", "accessor"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "uni",
                type = kt39,
                description = """Alias of [unison]: the same object under its short name.""",
                samples = emptyList(),
                library = "sprudel",
            )
        )
    ),

    "d" to KlangSymbol(
        name = "d",
        category = "dynamics",
        tags = listOf("d", "density", "accessor"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "d",
                type = kt40,
                description = """Alias of [density]: the same accessor under another name.""",
                samples = emptyList(),
                library = "sprudel",
            )
        )
    ),

    "bandpass" to KlangSymbol(
        name = "bandpass",
        category = "effects",
        tags = listOf("bandpass", "bpf.freq", "accessor"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "bandpass",
                type = kt50,
                description = """Alias of [bpf]: the same object under its long name.""",
                samples = emptyList(),
                library = "sprudel",
            )
        )
    ),

    "highpass" to KlangSymbol(
        name = "highpass",
        category = "effects",
        tags = listOf("highpass", "hpf.freq", "accessor"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "highpass",
                type = kt52,
                description = """Alias of [hpf]: the same object under its long name.""",
                samples = emptyList(),
                library = "sprudel",
            )
        )
    ),

    "lowpass" to KlangSymbol(
        name = "lowpass",
        category = "effects",
        tags = listOf("lowpass", "lpf.freq", "accessor"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "lowpass",
                type = kt54,
                description = """Alias of [lpf]: the same object under its long name.""",
                samples = emptyList(),
                library = "sprudel",
            )
        )
    ),

    "randCycle" to KlangSymbol(
        name = "randCycle",
        category = "random",
        tags = listOf("randCycle", "random", "cycle", "hold", "step"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "randCycle",
                type = kt2,
                description = """Continuous random pattern that holds a constant value for each full cycle.

 All events within the same cycle get the same random value; adjacent cycles get
 different values. Useful for cycle-level random decisions (e.g. `someCyclesBy`).
 Equivalent to `rand.segment(1)`.""",
                samples = listOf(
                    KlangCodeSample(code = """s("bd*8").degradeByWith(randCycle, 0.5)   // entire cycle either plays or drops""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel",
            )
        )
    ),

    "brand" to KlangSymbol(
        name = "brand",
        category = "random",
        tags = listOf("brand", "brandBy", "binary", "random", "gate"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "brand",
                type = kt2,
                description = """Binary random pattern with 50% probability — outputs 0 or 1 with equal chance.

 Shorthand for `brandBy(0.5)`. Use it wherever you need a random on/off gate signal.""",
                samples = listOf(
                    KlangCodeSample(code = """s("hh*8").gain(brand)               // each hi-hat randomly at full or zero gain""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel",
            )
        )
    ),

    "silence" to KlangSymbol(
        name = "silence",
        category = "continuous",
        tags = listOf("silence", "rest", "empty", "quiet"),
        aliases = listOf("rest", "nothing"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "silence",
                type = kt2,
                description = """An empty pattern that produces no events.

 Use `silence` wherever a [SprudelPattern] argument is required but nothing should play.
 It is the identity element for [stack] and acts as a rest in sequencing functions like [cat].""",
                samples = listOf(
                    KlangCodeSample(code = """seq("c3", silence, "e3", "g3").note()  // rest on the second step""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """cat(s("bd sd"), silence)  // phrase followed by a silent cycle""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel",
            )
        )
    ),

    "rest" to KlangSymbol(
        name = "rest",
        category = "continuous",
        tags = listOf("rest", "silence", "empty", "quiet"),
        aliases = listOf("silence", "nothing"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "rest",
                type = kt2,
                description = """An empty pattern that produces no events. Alias for [silence].""",
                samples = listOf(
                    KlangCodeSample(code = """seq("c3", rest, "e3", "g3").note()  // rest on the second step""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """cat(s("bd sd"), rest)  // phrase followed by a silent cycle""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel",
            )
        )
    ),

    "nothing" to KlangSymbol(
        name = "nothing",
        category = "continuous",
        tags = listOf("nothing", "silence", "rest", "empty", "quiet"),
        aliases = listOf("silence", "rest"),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "nothing",
                type = kt2,
                description = """An empty pattern that produces no events. Alias for [silence].""",
                samples = listOf(
                    KlangCodeSample(code = """seq("c3", nothing, "e3", "g3").note()  // rest on the second step""", type = KlangCodeSampleType.PLAYABLE),
                    KlangCodeSample(code = """cat(s("bd sd"), nothing)  // phrase followed by a silent cycle""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "sprudel",
            )
        )
    ),

    "clip" to KlangSymbol(
        name = "clip",
        category = "tonal",
        tags = listOf("clip", "legato", "accessor"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "clip",
                type = kt67,
                description = """Alias of [legato]: the same accessor under another name.""",
                samples = emptyList(),
                library = "sprudel",
            )
        )
    ),

    "vib" to KlangSymbol(
        name = "vib",
        category = "tonal",
        tags = listOf("vib", "vibrato", "accessor"),
        aliases = listOf(),
        scope = KlangScope.VOICE,
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "vib",
                type = kt69,
                description = """Alias of [vibrato]: the same object under its short name.""",
                samples = emptyList(),
                library = "sprudel",
            )
        )
    )
)

private fun generatedSprudelDocsMemberProperties() = mapOf(

    "amount" to KlangSymbol(
        name = "amount",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "amount",
                owner = kt43,
                type = kt73,
                description = """The amount slot of each event, as a value other setters can read.""",
                library = "sprudel",
            )
        )
    ),

    "attack" to KlangSymbol(
        name = "attack",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "attack",
                owner = kt28,
                type = kt73,
                description = """The attack time of each event, as a value other setters can read.""",
                library = "sprudel",
            ),
            KlangProperty(
                name = "attack",
                owner = kt30,
                type = kt73,
                description = """The attack slot of each event, as a value other setters can read.""",
                library = "sprudel",
            ),
            KlangProperty(
                name = "attack",
                owner = kt38,
                type = kt73,
                description = """The attack slot of each event, as a value other setters can read.""",
                library = "sprudel",
            ),
            KlangProperty(
                name = "attack",
                owner = kt50,
                type = kt73,
                description = """The attack slot of each event, as a value other setters can read.""",
                library = "sprudel",
            ),
            KlangProperty(
                name = "attack",
                owner = kt52,
                type = kt73,
                description = """The attack slot of each event, as a value other setters can read.""",
                library = "sprudel",
            ),
            KlangProperty(
                name = "attack",
                owner = kt54,
                type = kt73,
                description = """The attack slot of each event, as a value other setters can read.""",
                library = "sprudel",
            ),
            KlangProperty(
                name = "attack",
                owner = kt56,
                type = kt73,
                description = """The attack slot of each event, as a value other setters can read.""",
                library = "sprudel",
            ),
            KlangProperty(
                name = "attack",
                owner = kt63,
                type = kt73,
                description = """The attack slot of each event, as a value other setters can read.""",
                library = "sprudel",
            ),
            KlangProperty(
                name = "attack",
                owner = kt70,
                type = kt73,
                description = """The attack slot of each event, as a value other setters can read.""",
                library = "sprudel",
            )
        )
    ),

    "bits" to KlangSymbol(
        name = "bits",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "bits",
                owner = kt44,
                type = kt73,
                description = """The bits slot of each event, as a value other setters can read.""",
                library = "sprudel",
            )
        )
    ),

    "cap" to KlangSymbol(
        name = "cap",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "cap",
                owner = kt42,
                type = kt73,
                description = """The cap slot of each event, as a value other setters can read.""",
                library = "sprudel",
            )
        )
    ),

    "center" to KlangSymbol(
        name = "center",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "center",
                owner = kt46,
                type = kt73,
                description = """The center slot of each event, as a value other setters can read.""",
                library = "sprudel",
            )
        )
    ),

    "decay" to KlangSymbol(
        name = "decay",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "decay",
                owner = kt28,
                type = kt73,
                description = """The decay time of each event, as a value other setters can read.""",
                library = "sprudel",
            ),
            KlangProperty(
                name = "decay",
                owner = kt50,
                type = kt73,
                description = """The decay slot of each event, as a value other setters can read.""",
                library = "sprudel",
            ),
            KlangProperty(
                name = "decay",
                owner = kt52,
                type = kt73,
                description = """The decay slot of each event, as a value other setters can read.""",
                library = "sprudel",
            ),
            KlangProperty(
                name = "decay",
                owner = kt54,
                type = kt73,
                description = """The decay slot of each event, as a value other setters can read.""",
                library = "sprudel",
            ),
            KlangProperty(
                name = "decay",
                owner = kt56,
                type = kt73,
                description = """The decay slot of each event, as a value other setters can read.""",
                library = "sprudel",
            ),
            KlangProperty(
                name = "decay",
                owner = kt63,
                type = kt73,
                description = """The decay slot of each event, as a value other setters can read.""",
                library = "sprudel",
            ),
            KlangProperty(
                name = "decay",
                owner = kt70,
                type = kt73,
                description = """The decay slot of each event, as a value other setters can read.""",
                library = "sprudel",
            )
        )
    ),

    "depth" to KlangSymbol(
        name = "depth",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "depth",
                owner = kt38,
                type = kt73,
                description = """The depth slot of each event, as a value other setters can read.""",
                library = "sprudel",
            ),
            KlangProperty(
                name = "depth",
                owner = kt47,
                type = kt73,
                description = """The depth slot of each event, as a value other setters can read.""",
                library = "sprudel",
            ),
            KlangProperty(
                name = "depth",
                owner = kt63,
                type = kt73,
                description = """The depth slot of each event, as a value other setters can read.""",
                library = "sprudel",
            )
        )
    ),

    "env" to KlangSymbol(
        name = "env",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "env",
                owner = kt50,
                type = kt73,
                description = """The env slot of each event, as a value other setters can read.""",
                library = "sprudel",
            ),
            KlangProperty(
                name = "env",
                owner = kt52,
                type = kt73,
                description = """The env slot of each event, as a value other setters can read.""",
                library = "sprudel",
            ),
            KlangProperty(
                name = "env",
                owner = kt54,
                type = kt73,
                description = """The env slot of each event, as a value other setters can read.""",
                library = "sprudel",
            ),
            KlangProperty(
                name = "env",
                owner = kt56,
                type = kt73,
                description = """The env slot of each event, as a value other setters can read.""",
                library = "sprudel",
            )
        )
    ),

    "factor" to KlangSymbol(
        name = "factor",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "factor",
                owner = kt45,
                type = kt73,
                description = """The factor slot of each event, as a value other setters can read.""",
                library = "sprudel",
            )
        )
    ),

    "feedback" to KlangSymbol(
        name = "feedback",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "feedback",
                owner = kt42,
                type = kt73,
                description = """The feedback slot of each event, as a value other setters can read.""",
                library = "sprudel",
            )
        )
    ),

    "floor" to KlangSymbol(
        name = "floor",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "floor",
                owner = kt41,
                type = kt73,
                description = """The floor slot of each event, as a value other setters can read.""",
                library = "sprudel",
            ),
            KlangProperty(
                name = "floor",
                owner = kt46,
                type = kt73,
                description = """The floor slot of each event, as a value other setters can read.""",
                library = "sprudel",
            ),
            KlangProperty(
                name = "floor",
                owner = kt49,
                type = kt73,
                description = """The floor slot of each event, as a value other setters can read.""",
                library = "sprudel",
            )
        )
    ),

    "freq" to KlangSymbol(
        name = "freq",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "freq",
                owner = kt50,
                type = kt73,
                description = """The freq slot of each event, as a value other setters can read.""",
                library = "sprudel",
            ),
            KlangProperty(
                name = "freq",
                owner = kt52,
                type = kt73,
                description = """The freq slot of each event, as a value other setters can read.""",
                library = "sprudel",
            ),
            KlangProperty(
                name = "freq",
                owner = kt54,
                type = kt73,
                description = """The freq slot of each event, as a value other setters can read.""",
                library = "sprudel",
            ),
            KlangProperty(
                name = "freq",
                owner = kt56,
                type = kt73,
                description = """The freq slot of each event, as a value other setters can read.""",
                library = "sprudel",
            )
        )
    ),

    "knee" to KlangSymbol(
        name = "knee",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "knee",
                owner = kt30,
                type = kt73,
                description = """The knee slot of each event, as a value other setters can read.""",
                library = "sprudel",
            )
        )
    ),

    "lowpass" to KlangSymbol(
        name = "lowpass",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "lowpass",
                owner = kt48,
                type = kt73,
                description = """The lowpass slot of each event, as a value other setters can read.""",
                library = "sprudel",
            )
        )
    ),

    "orbit" to KlangSymbol(
        name = "orbit",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "orbit",
                owner = kt38,
                type = kt73,
                description = """The orbit slot of each event, as a value other setters can read.""",
                library = "sprudel",
            )
        )
    ),

    "pan" to KlangSymbol(
        name = "pan",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "pan",
                owner = kt39,
                type = kt73,
                description = """The pan slot of each event, as a value other setters can read.""",
                library = "sprudel",
            )
        )
    ),

    "passes" to KlangSymbol(
        name = "passes",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "passes",
                owner = kt52,
                type = kt73,
                description = """The passes slot of each event, as a value other setters can read.""",
                library = "sprudel",
            ),
            KlangProperty(
                name = "passes",
                owner = kt54,
                type = kt73,
                description = """The passes slot of each event, as a value other setters can read.""",
                library = "sprudel",
            )
        )
    ),

    "phase" to KlangSymbol(
        name = "phase",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "phase",
                owner = kt69,
                type = kt73,
                description = """The phase slot (where the wobble starts, in cycles) of each event, as a value other setters can read.""",
                library = "sprudel",
            )
        )
    ),

    "q" to KlangSymbol(
        name = "q",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "q",
                owner = kt50,
                type = kt73,
                description = """The q slot of each event, as a value other setters can read.""",
                library = "sprudel",
            ),
            KlangProperty(
                name = "q",
                owner = kt52,
                type = kt73,
                description = """The q slot of each event, as a value other setters can read.""",
                library = "sprudel",
            ),
            KlangProperty(
                name = "q",
                owner = kt54,
                type = kt73,
                description = """The q slot of each event, as a value other setters can read.""",
                library = "sprudel",
            ),
            KlangProperty(
                name = "q",
                owner = kt56,
                type = kt73,
                description = """The q slot of each event, as a value other setters can read.""",
                library = "sprudel",
            )
        )
    ),

    "rangeFrom" to KlangSymbol(
        name = "rangeFrom",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "rangeFrom",
                owner = kt69,
                type = kt73,
                description = """The rangeFrom slot (where the LFO's -1 lands) of each event, as a value other setters can read.""",
                library = "sprudel",
            )
        )
    ),

    "rangeTo" to KlangSymbol(
        name = "rangeTo",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "rangeTo",
                owner = kt69,
                type = kt73,
                description = """The rangeTo slot (where the LFO's +1 lands) of each event, as a value other setters can read.""",
                library = "sprudel",
            )
        )
    ),

    "rate" to KlangSymbol(
        name = "rate",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "rate",
                owner = kt46,
                type = kt73,
                description = """The rate slot of each event, as a value other setters can read.""",
                library = "sprudel",
            ),
            KlangProperty(
                name = "rate",
                owner = kt47,
                type = kt73,
                description = """The rate slot of each event, as a value other setters can read.""",
                library = "sprudel",
            ),
            KlangProperty(
                name = "rate",
                owner = kt69,
                type = kt73,
                description = """The rate slot of each event, as a value other setters can read.""",
                library = "sprudel",
            )
        )
    ),

    "ratio" to KlangSymbol(
        name = "ratio",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "ratio",
                owner = kt30,
                type = kt73,
                description = """The ratio slot of each event, as a value other setters can read.""",
                library = "sprudel",
            ),
            KlangProperty(
                name = "ratio",
                owner = kt63,
                type = kt73,
                description = """The ratio slot of each event, as a value other setters can read.""",
                library = "sprudel",
            )
        )
    ),

    "release" to KlangSymbol(
        name = "release",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "release",
                owner = kt28,
                type = kt73,
                description = """The release time of each event, as a value other setters can read.""",
                library = "sprudel",
            ),
            KlangProperty(
                name = "release",
                owner = kt30,
                type = kt73,
                description = """The release slot of each event, as a value other setters can read.""",
                library = "sprudel",
            ),
            KlangProperty(
                name = "release",
                owner = kt50,
                type = kt73,
                description = """The release slot of each event, as a value other setters can read.""",
                library = "sprudel",
            ),
            KlangProperty(
                name = "release",
                owner = kt52,
                type = kt73,
                description = """The release slot of each event, as a value other setters can read.""",
                library = "sprudel",
            ),
            KlangProperty(
                name = "release",
                owner = kt54,
                type = kt73,
                description = """The release slot of each event, as a value other setters can read.""",
                library = "sprudel",
            ),
            KlangProperty(
                name = "release",
                owner = kt56,
                type = kt73,
                description = """The release slot of each event, as a value other setters can read.""",
                library = "sprudel",
            ),
            KlangProperty(
                name = "release",
                owner = kt63,
                type = kt73,
                description = """The release slot of each event, as a value other setters can read.""",
                library = "sprudel",
            ),
            KlangProperty(
                name = "release",
                owner = kt70,
                type = kt73,
                description = """The release slot of each event, as a value other setters can read.""",
                library = "sprudel",
            )
        )
    ),

    "semitones" to KlangSymbol(
        name = "semitones",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "semitones",
                owner = kt69,
                type = kt73,
                description = """The semitones slot (the depth) of each event, as a value other setters can read.""",
                library = "sprudel",
            ),
            KlangProperty(
                name = "semitones",
                owner = kt70,
                type = kt73,
                description = """The semitones slot of each event, as a value other setters can read.""",
                library = "sprudel",
            )
        )
    ),

    "size" to KlangSymbol(
        name = "size",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "size",
                owner = kt48,
                type = kt73,
                description = """The size slot of each event, as a value other setters can read.""",
                library = "sprudel",
            )
        )
    ),

    "spread" to KlangSymbol(
        name = "spread",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "spread",
                owner = kt39,
                type = kt73,
                description = """The spread slot of each event, as a value other setters can read.""",
                library = "sprudel",
            )
        )
    ),

    "sustain" to KlangSymbol(
        name = "sustain",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "sustain",
                owner = kt28,
                type = kt73,
                description = """The sustain level of each event, as a value other setters can read.""",
                library = "sprudel",
            ),
            KlangProperty(
                name = "sustain",
                owner = kt50,
                type = kt73,
                description = """The sustain slot of each event, as a value other setters can read.""",
                library = "sprudel",
            ),
            KlangProperty(
                name = "sustain",
                owner = kt52,
                type = kt73,
                description = """The sustain slot of each event, as a value other setters can read.""",
                library = "sprudel",
            ),
            KlangProperty(
                name = "sustain",
                owner = kt54,
                type = kt73,
                description = """The sustain slot of each event, as a value other setters can read.""",
                library = "sprudel",
            ),
            KlangProperty(
                name = "sustain",
                owner = kt56,
                type = kt73,
                description = """The sustain slot of each event, as a value other setters can read.""",
                library = "sprudel",
            ),
            KlangProperty(
                name = "sustain",
                owner = kt63,
                type = kt73,
                description = """The sustain slot of each event, as a value other setters can read.""",
                library = "sprudel",
            ),
            KlangProperty(
                name = "sustain",
                owner = kt70,
                type = kt73,
                description = """The sustain slot of each event, as a value other setters can read.""",
                library = "sprudel",
            )
        )
    ),

    "sweep" to KlangSymbol(
        name = "sweep",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "sweep",
                owner = kt46,
                type = kt73,
                description = """The sweep slot of each event, as a value other setters can read.""",
                library = "sprudel",
            )
        )
    ),

    "threshold" to KlangSymbol(
        name = "threshold",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "threshold",
                owner = kt30,
                type = kt73,
                description = """The threshold slot of each event, as a value other setters can read.""",
                library = "sprudel",
            )
        )
    ),

    "time" to KlangSymbol(
        name = "time",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "time",
                owner = kt42,
                type = kt73,
                description = """The time slot of each event, as a value other setters can read.""",
                library = "sprudel",
            )
        )
    ),

    "voices" to KlangSymbol(
        name = "voices",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "voices",
                owner = kt39,
                type = kt73,
                description = """The voices slot of each event, as a value other setters can read.""",
                library = "sprudel",
            )
        )
    ),

    "wet" to KlangSymbol(
        name = "wet",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("sprudel"),
        variants = listOf(
            KlangProperty(
                name = "wet",
                owner = kt41,
                type = kt73,
                description = """The wet slot of each event, as a value other setters can read.""",
                library = "sprudel",
            ),
            KlangProperty(
                name = "wet",
                owner = kt42,
                type = kt73,
                description = """The wet slot of each event, as a value other setters can read.""",
                library = "sprudel",
            ),
            KlangProperty(
                name = "wet",
                owner = kt46,
                type = kt73,
                description = """The wet slot of each event, as a value other setters can read.""",
                library = "sprudel",
            ),
            KlangProperty(
                name = "wet",
                owner = kt48,
                type = kt73,
                description = """The wet slot of each event, as a value other setters can read.""",
                library = "sprudel",
            ),
            KlangProperty(
                name = "wet",
                owner = kt49,
                type = kt73,
                description = """The wet slot of each event, as a value other setters can read.""",
                library = "sprudel",
            )
        )
    )
)

/** Generated documentation for the 'sprudel' library. */
val generatedSprudelDocs: Map<String, KlangSymbol> = buildMap {
    // Use putOrMerge so chunked emissions (e.g. a member-property variant and a
    // same-name extension method) merge their variants instead of overwriting.
    generatedSprudelDocsObjects().values.forEach(::putOrMerge)
    generatedSprudelDocsProperties().values.forEach(::putOrMerge)
    generatedSprudelDocsMemberProperties().values.forEach(::putOrMerge)
    generatedSprudelDocsChunk0().values.forEach(::putOrMerge)
    generatedSprudelDocsChunk1().values.forEach(::putOrMerge)
    generatedSprudelDocsChunk2().values.forEach(::putOrMerge)
    generatedSprudelDocsChunk3().values.forEach(::putOrMerge)
    generatedSprudelDocsChunk4().values.forEach(::putOrMerge)
    generatedSprudelDocsChunk5().values.forEach(::putOrMerge)
    generatedSprudelDocsChunk6().values.forEach(::putOrMerge)
    generatedSprudelDocsChunk7().values.forEach(::putOrMerge)
    generatedSprudelDocsChunk8().values.forEach(::putOrMerge)
    generatedSprudelDocsChunk9().values.forEach(::putOrMerge)
    generatedSprudelDocsChunk10().values.forEach(::putOrMerge)
    generatedSprudelDocsChunk11().values.forEach(::putOrMerge)
    generatedSprudelDocsChunk12().values.forEach(::putOrMerge)
    generatedSprudelDocsChunk13().values.forEach(::putOrMerge)
    generatedSprudelDocsChunk14().values.forEach(::putOrMerge)
    generatedSprudelDocsChunk15().values.forEach(::putOrMerge)
    generatedSprudelDocsChunk16().values.forEach(::putOrMerge)
    generatedSprudelDocsChunk17().values.forEach(::putOrMerge)
    generatedSprudelDocsChunk18().values.forEach(::putOrMerge)
    generatedSprudelDocsChunk19().values.forEach(::putOrMerge)
    generatedSprudelDocsChunk20().values.forEach(::putOrMerge)
    generatedSprudelDocsChunk21().values.forEach(::putOrMerge)
    generatedSprudelDocsChunk22().values.forEach(::putOrMerge)
    generatedSprudelDocsChunk23().values.forEach(::putOrMerge)
    generatedSprudelDocsChunk24().values.forEach(::putOrMerge)
    generatedSprudelDocsChunk25().values.forEach(::putOrMerge)
    generatedSprudelDocsChunk26().values.forEach(::putOrMerge)
    generatedSprudelDocsChunk27().values.forEach(::putOrMerge)
    generatedSprudelDocsChunk28().values.forEach(::putOrMerge)
    generatedSprudelDocsChunk29().values.forEach(::putOrMerge)
    generatedSprudelDocsChunk30().values.forEach(::putOrMerge)
    generatedSprudelDocsChunk31().values.forEach(::putOrMerge)
    generatedSprudelDocsChunk32().values.forEach(::putOrMerge)
    generatedSprudelDocsChunk33().values.forEach(::putOrMerge)
    generatedSprudelDocsChunk34().values.forEach(::putOrMerge)
    generatedSprudelDocsChunk35().values.forEach(::putOrMerge)
    generatedSprudelDocsChunk36().values.forEach(::putOrMerge)
    generatedSprudelDocsChunk37().values.forEach(::putOrMerge)
    generatedSprudelDocsChunk38().values.forEach(::putOrMerge)
}
